// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../wwwroot/fe/img/icons/check-white.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../../wwwroot/fe/img/icons/check.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../../../wwwroot/fe/img/celebration.jpg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../../../../wwwroot/fe/img/color-star-orangestroke.svg");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../../../../wwwroot/fe/img/okr-suggestion.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#metric-preview .view-in-alignment:after {
  position: absolute;top: 0;bottom: 0;left: 0;right: 0;
}
.modal.medium.clone .modal-dialog {
  width: 500px;
}
.modal.clone .modal-dialog .modal-content {
  padding: 38px 50px;
}
#clone .clone-p {
  padding: 9px 10px;
}
#clone .grey-border {
  border: 1px solid #c0cbdd;
  box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);
  border-radius: 4px;
}
#clone .title {
  font-size: 30px;
  color: #0d232f;
  font-weight: 700 !important;
}
#clone .gh-font-icon-help {
  color: #7485a2;
}
#clone .gh-select .dropdown-menu ul li.disabled:hover {
  cursor: not-allowed;
}
#clone ui-checkbox label {
  margin: 0;
  font-weight: inherit;
}
.accordion-info {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #617294;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.additional-info-position {
  flex-basis: 100%;
}
cascading-metric-form .bg-red-20 {
  background: #ffd8d8;
}
cascading-metric-form .cascading-kr {
  background: #f1f3f8;
}
cascading-metric-form .cascading-kr .title {
  margin-right: 38px;
  min-width: 218px;
  max-width: 218px;
  color: #0d232f;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
cascading-metric-form .all-child-mr-24px > * {
  margin-right: 24px;
}
cascading-metric-form .all-child-mr-24px > :last-child {
  margin-right: 0;
}
cascading-metric-form .grid-cell {
  padding: 8px 9px;
  border: 1px solid #c0cbdd;
  border-radius: 4px;
  box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1);
}
cascading-metric-form .total-contribution {
  background: #e5f2ff;
  width: 416px;
}
cascading-metric-form .total-contribution.good {
  background: #e3fcef;
}
cascading-metric-form .bolder {
  font-weight: 700;
  color: #021421;
}
cascading-metric-form .user-selector-dropdown {
  width: 390px;
}
cascading-metric-form .user-selector-dropdown .autocomplete {
  margin-top: 0px;
}
cascading-metric-contributor .p-abs-icon {
  position: absolute;
  left: 9px;
  top: 11px;
}
cascading-metric-contributor input[name="metricName"] {
  padding-left: 32px;
}
cascading-metric-contributor .dropdown-menu {
  max-height: 332px;
  overflow: auto;
}
cascading-metric-contributor .dropdown-menu li {
  padding: 9px 12px 9px 8px;
  cursor: pointer;
}
cascading-metric-contributor .dropdown-menu li:hover {
  background: #f1f3f8;
}
cascading-metric-contributor .dropdown-menu li.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
cascading-metric-contributor .dropdown-menu li.b-top {
  border-top: 1px solid #d8dfea;
}
cascading-metric-contributor .dropdown-menu li.group-title {
  color: #7485a2;
  text-transform: uppercase;
  cursor: auto;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  user-select: none;
  height: 38px;
}
cascading-metric-contributor .dropdown-menu li.group-title:hover {
  background: transparent;
}
cascading-metric-contributor .dropdown-menu li.metric-item {
  padding-left: 40px;
}
cascading-metric-contributor .empty-owner {
  background-color: #f1f3f8;
  color: #617294;
}
.affix-input .gh-dynamic-input-group {
  height: 38px;
}
.affix-input .gh-dynamic-input-group .gh-dynamic-suffix,
.affix-input .gh-dynamic-input-group .gh-dynamic-prefix {
  border: 1px solid #c0cbdd;
  color: #445573;
}
.affix-input .gh-dynamic-input-group .gh-dynamic-suffix {
  border-left: none;
  line-height: 38px;
}
.affix-input .gh-dynamic-input-group .gh-dynamic-prefix {
  border-right: none;
  line-height: 38px;
}
.affix-input .gh-dynamic-input-group .dynamic-format {
  background: #f1f3f8;
}
.affix-input .gh-input-text-v2.with-error {
  border-color: #da555d;
}
.affix-input .gh-input-text-v2 .dynamic-prefix {
  border-radius: 0 4px 4px 0;
}
.affix-input .gh-input-text-v2 .dynamic-suffix {
  border-radius: 4px 0 0 4px;
}
.snapshot-comment {
  font-size: 1.04em;
  color: #6f8393;
  line-height: 1.6em;
}
.snapshot-comment .snapshot-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #2e4354;
  font-weight: 500;
}
.snapshot-comment .snapshot-title .update-value {
  font-weight: 700;
}
.snapshot-comment .snapshot-title .gh-badge {
  position: relative;
  top: -5px;
  left: 5px;
  padding: 4px 4px 2px 3px;
  line-height: 0.8em;
  font-size: 0.7em;
  font-style: italic;
  font-weight: 700;
  cursor: help;
}
.snapshot-comment .snapshot-title .gh-badge.locked::before {
  content: "+";
  font-style: italic;
}
.gh-box-section.box-header {
  padding: 0px;
}
.gh-box-section.box-header .assignee-date-container {
  display: inline-block;
  padding: 10px;
}
.gh-box-section.box-header .assignee-date-container .gh-icon {
  vertical-align: middle;
}
.gh-box-section.box-header .confidence-attainment-container {
  float: right;
}
.gh-box-section.box-header .confidence-attainment-container .current-attainment,
.gh-box-section.box-header .confidence-attainment-container .confidence-value {
  display: inline-block;
  padding: 10px 10px;
}
.gh-box-section.box-header .confidence-attainment-container .current-attainment {
  font-weight: 700;
  border-left: 1px solid #eee;
}
.gh-box-section.box-header .confidence-attainment-container .confidence-overflow {
  display: block;
  padding: 0px;
  text-align: right;
}
.gh-box-section.box-header .confidence-attainment-container .attainment-border {
  border-left: none;
}
@media (min-width: 980px) {
  .gh-box-section.box-header .confidence-attainment-container {
    max-width: 220px;
  }
}
@media (max-width: 980px) {
  .gh-box-section.box-header .confidence-attainment-container {
    max-width: 400px;
  }
}
.delete-checkin-update,
.edit-checkin-update {
  color: #d1d5d8;
  margin-left: auto;
}
.delete-checkin-update:hover,
.edit-checkin-update:hover {
  color: #9aa3a9;
  cursor: pointer;
}
.checkin-update-note-container {
  position: relative;
  border-top: 1px solid #eef0f4;
  padding-top: 10px;
  padding-bottom: 3px;
  display: flex;
  align-items: center;
}
.checkin-update-note-container .nc-icon-mini.icon {
  vertical-align: top;
  padding-top: 5px;
}
.checkin-update-note-container .checkin-update-note {
  width: 80%;
  display: inline-block;
  padding-left: 15px;
}
.checkin-update-note-container .checkin-update-note p {
  font-weight: 400;
}
.checkin-update-note-container .gh-icon {
  position: absolute;
}
.checkin-update-note-container rich-text-editor {
  margin: 0;
}
.checkin-update-note-container rich-text-editor .ql-editor {
  padding-top: 0;
}
.metric-indicator-container {
  width: 1025px;
}
@media all and (max-width: 1025px) {
  .metric-indicator-container {
    width: 95vw;
  }
}
#metric-preview #dynamic-metric-wizard {
  width: 100%;
  max-width: unset;
}
#metric-preview .metric-content-container {
  max-width: 1025px;
}
#metric-preview .metric-content-container .metric-content-sub-container {
  min-width: 469px;
  padding: 0px 15px;
}
#metric-preview .metric-content-container .gh-siv-top-bar.modal-top .gh-siv-top-bar-labels ui-button {
  width: 32px;
  color: #021421;
}
#metric-preview .metric-content-container .gh-siv-top-bar.modal-top #gh-modal-view-in-alignment-button {
  margin-right: 10px;
  width: 32px;
  color: #021421;
}
#metric-preview .scrollable-with-left-overflow {
  margin-left: -200px;
  padding-left: 200px;
  overflow-y: auto;
}
#metric-preview .custom-fields-two-columns.confidence-shown {
  position: absolute;
  margin-top: 180px;
}
#metric-preview .helper-quotes {
  position: relative;
}
#metric-preview .helper-quotes::before {
  position: relative;
  top: 0;
  right: 0;
  content: '"';
}
#metric-preview .helper-quotes::after {
  position: relative;
  top: 0;
  left: 0;
  content: '"';
}
#metric-preview .helper-mr-5 {
  margin-right: 5px;
}
#metric-preview .helper-d-inline-block {
  display: inline-block;
}
#metric-preview .helper-word-break {
  word-break: break-word;
}
#metric-preview .width-100 {
  width: 100%;
}
#metric-preview .gh-fe.validation {
  font-size: 0.9em;
  margin: 0px 0px 10px 0px;
}
#metric-preview .row {
  padding: 33px 10px 33px 40px;
  margin: 0px;
}
#metric-preview .gh-empty-module {
  margin-top: 50px;
}
#metric-preview .gh-siv-section {
  margin-top: 60px;
  margin-bottom: 0;
}
#metric-preview .gh-siv-section.kr-details {
  margin-top: 0px;
}
#metric-preview .gh-siv-section .gh-siv-row-name,
#metric-preview .gh-siv-section .gh-siv-row-content {
  word-break: break-word;
}
#metric-preview .gh-siv-section .gh-siv-row-name.readonly,
#metric-preview .gh-siv-section .gh-siv-row-content.readonly {
  flex: none;
  cursor: not-allowed;
}
#metric-preview .gh-siv-section .dynamic-kr-details {
  margin-bottom: 20px;
}
#metric-preview .gh-siv-section .dynamic-kr-details span.with-more-items {
  align-items: center;
  margin: 7px 0px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .dynamic-kr-details-header {
  color: #96a1bb;
  font-size: 13px;
  line-height: 18px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details {
  background-color: #f9fbff;
  border-radius: 7px;
  color: #51617a;
  font-size: 13px;
  line-height: 18px;
  padding: 10px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .filters {
  margin: 0px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .insight-usage {
  margin: 10px 0px 0px 0px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .filters p,
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .insight-usage p {
  margin: 0px;
}
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .filters ul li,
#metric-preview .gh-siv-section .dynamic-kr-details .gh-siv-item-details .insight-usage ul li {
  margin-left: 20px;
  list-style: disc;
  padding: 2px 0px;
}
#metric-preview .task-due-date {
  width: 22%;
}
#metric-preview .task-due-date .due-date {
  display: flex;
  padding: 2px 5px;
  align-items: center;
}
#metric-preview .task-due-date .remove {
  position: relative;
  display: inline-block;
  margin: 0 0 0 10px;
}
#metric-preview .kr-header {
  display: flex;
  position: relative;
  padding: 0px 15px;
  margin-bottom: 20px;
}
#metric-preview .kr-header .kr-title {
  width: 650px;
}
#metric-preview .kr-header .kr-title input {
  text-overflow: ellipsis;
}
#metric-preview .kr-header .kr-title input[readonly] {
  color: #7485a2;
  background-color: #f1f3f8;
  cursor: not-allowed;
}
#metric-preview .kr-header .kr-title input[readonly]::placeholder {
  color: #9dabc5;
}
#metric-preview .kr-header .gh-fe.validation {
  margin-left: 6px;
}
#metric-preview .kr-header .kr-btn-group {
  margin: 0 30px auto auto;
}
#metric-preview .kr-header .kr-btn-group ui-button:first-of-type {
  margin-right: 10px;
}
#metric-preview .gh-box .comments .gh-box-section {
  position: relative;
  padding-left: 48px;
}
#metric-preview .gh-box .comments .gh-box-section .date {
  font-weight: 700;
}
#metric-preview .line {
  border-left: 3px solid #eef0f4;
  padding-left: 30px;
}
#metric-preview .gh-box {
  position: relative;
}
#metric-preview .gh-box:before {
  content: "";
  width: 14px;
  height: 14px;
  background: #eef0f4;
  border: 4px solid #fff;
  border-radius: 7px;
  position: absolute;
  left: -40px;
  top: 15px;
}
#metric-preview .gh-box .gh-box-section {
  padding: 10px 10px 5px 10px;
}
#metric-preview .date {
  padding-left: 5px;
  font-weight: 500;
  font-size: 0.85em;
  color: #2e4354;
}
#metric-preview .date .late {
  font-size: 1em;
  color: #ff5f5f;
}
#metric-preview .gh-siv-clickable span {
  color: #7989a0;
  font-size: 13px;
  line-height: 18px;
}
#metric-preview .gh-siv-clickable .section-toggle {
  display: inline-block;
  color: #7989a0;
  margin-right: 5px;
}
#metric-preview .gh-siv-clickable .section-toggle span {
  font-size: 10px;
}
#metric-preview .session-title {
  color: #96a1bb;
}
#metric-preview .filters,
#metric-preview .insight-usage {
  margin-top: 20px;
}
#metric-preview dropdown-actions-menu .gh-actions-menu {
  min-width: 180px;
}
#metric-preview .insight-details .assignee-picture {
  position: absolute;
}
#metric-preview a.insight-name {
  display: block;
  margin-left: 20px;
  cursor: pointer;
}
#metric-preview .jreactions-comment-wrapper.gh-ml-4 {
  margin-left: 0;
}
#metric-preview .jreactions-comment-wrapper .dropdown-menu {
  left: -200px;
}
#metric-preview .no-permissions {
  display: flex;
  position: relative;
  background: #75a2f7;
  border-radius: 10px;
  padding: 10px;
  align-items: center;
  margin-left: -10px;
}
#metric-preview .no-permissions span {
  font-family: "SF Pro Text", "Helvetica Neue", "SegoeUI", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #021421;
}
#metric-preview .gh-siv-editable-markdown-preview.disabled {
  background-color: inherit;
}
#metric-preview .gh-siv-editable-markdown-preview.disabled:hover {
  border: 1px solid transparent;
  box-shadow: none;
}
#metric-preview .view-in-alignment {
  margin-right: 24px;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  color: rgba(46, 67, 84, 0.3);
  cursor: pointer;
}
#metric-preview .view-in-alignment:after {
  content: "";
  border-radius: 4px;
}
#metric-preview .view-in-alignment:focus {
  box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1), 0px 0px 0px 2px #75a2f7;
}
#metric-preview .view-in-alignment:focus:after {
  border: 1px solid #75a2f7;
}
#metric-preview .view-in-alignment:active {
  box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1);
}
#metric-preview .view-in-alignment:active:after {
  border: 2px solid #9bbeff;
}
#metric-preview rich-text-editor.in-metric-view {
  width: 100%;
  min-height: 34px;
  margin-top: -6px;
  margin-bottom: 10px;
}
#metric-preview .parent-info {
  padding-left: 12px;
}
#metric-preview .tracked-automatically {
  margin-left: 13px;
}
.badges-text-confidence .gh-clickable {
  margin: 15px;
  opacity: 0.5;
}
.badges-text-confidence .gh-clickable:hover {
  opacity: 0.7;
}
.badges-text-confidence .gh-clickable.twa-3x {
  opacity: 1;
}
.badges-text-confidence .gh-badge.text-confidence {
  color: #fff;
  padding: 8px 15px;
  font-weight: 700 !important;
  margin: 15px 8px;
  border-radius: 15px;
  border: 10px solid #fff;
}
.badges-text-confidence .gh-badge.text-confidence.gh-active-range {
  opacity: 1;
  border: 10px solid #eef0f4;
}
body .bad .metric-trend-chart .ct-series-b .ct-area {
  fill: #ff5f5f;
}
body .bad .metric-trend-chart .ct-series-b .ct-line {
  stroke: #ff5f5f;
}
body .bad .metric-trend-chart .ct-series-c .ct-point {
  stroke: #ff5f5f;
}
body .bad .metric-trend-chart .ct-series-c .ct-line {
  stroke: #ff5f5f;
}
body .metric-trend-chart {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
}
body .metric-trend-chart .ct-grid {
  stroke-dasharray: 3px;
  stroke: rgba(0, 0, 0, 0.1);
}
body .metric-trend-chart .ct-label {
  white-space: nowrap !important;
  font-size: 0.8em;
  font-weight: 400;
  color: #2e4354;
}
body .metric-trend-chart .ct-series-a .ct-point {
  stroke-width: 6px;
  stroke: #9dabc5;
}
body .metric-trend-chart .ct-series-a .ct-line {
  stroke: #ddd;
  stroke-dasharray: 5px;
  stroke-width: 2px;
}
body .metric-trend-chart .ct-series-a .ct-line.ct-line-anti-kr {
  stroke: #0052cc;
  stroke-dasharray: none;
  stroke-width: 2px;
}
body .metric-trend-chart .ct-series-b .ct-area {
  fill: #1cb987;
}
body .metric-trend-chart .ct-series-b .ct-point {
  stroke-width: 8px;
}
body .metric-trend-chart .ct-series-b .ct-line {
  stroke: #1cb987;
  stroke-width: 1px;
  stroke-dasharray: 5px;
}
body .metric-trend-chart .ct-series-c .ct-point {
  stroke-width: 0;
  stroke: #1cb987;
}
body .metric-trend-chart .ct-series-c .ct-point:last-child {
  stroke-width: 8px;
}
body .metric-trend-chart .ct-series-c .ct-line {
  stroke: #1cb987;
  stroke-width: 2px;
}
body .metric-trend-chart .ct-chart-line .hard-deadline {
  stroke: #50ace5;
  stroke-width: 2px;
  stroke-dasharray: 5px;
  stroke-dashoffset: 5px;
}
body .metric-trend-chart .soft-deadline {
  stroke: #ffbd5e;
  stroke-width: 2px;
  stroke-dasharray: 5px;
  stroke-dashoffset: 5px;
}
body .metric-trend-chart .hard-deadline-label,
body .metric-trend-chart .soft-deadline-label,
body .metric-trend-chart .hard-deadline-position-label,
body .metric-trend-chart .soft-deadline-position-label {
  position: absolute;
  display: block;
  font-size: 11px;
  text-shadow: 0 0px 1px #eef0f4;
  padding-left: 50px;
}
body .metric-trend-chart .hard-deadline-label {
  font-weight: 500;
  top: 50px;
  color: #0052cc;
}
body .metric-trend-chart .hard-deadline-position-label {
  top: 64px;
  color: #0052cc;
}
body .metric-trend-chart .soft-deadline-label {
  font-weight: 500;
  top: 20px;
  color: #ffbd5e;
}
body .metric-trend-chart .soft-deadline-position-label {
  top: 34px;
  color: #ffbd5e;
}
body .metric-trend-chart .chartist-tooltip-meta {
  margin-left: 5px;
  padding: 4px 4px 2px 3px;
  line-height: 0.8em;
  font-size: 0.7em;
  font-style: italic;
  font-weight: 700;
}
@media all and (max-width: 991px) {
  #metric-preview .confidence-level-trend-chart-title {
    width: 100%;
  }
  #metric-preview .custom-fields-two-columns.confidence-shown {
    position: relative;
    margin-top: 180px;
  }
}
#metric-preview .confidence-level-trend-chart {
  position: relative;
}
.confidence-level-trend-chart-title {
  margin-left: 40%;
  margin-top: 20px;
  color: #96a1a9;
}
.update-history-comments-title {
  text-align: center;
  margin-bottom: 16px;
  color: #96a1a9;
}
.metric-confidence-level-trend-chart {
  width: 100%;
  height: 150px;
}
.metric-confidence-level-trend-chart .ct-area,
.metric-confidence-level-trend-chart .ct-line {
  pointer-events: none;
}
.metric-confidence-level-trend-chart .ct-series-a .ct-line {
  stroke: #ddd;
  stroke-width: 2px;
}
.metric-confidence-level-trend-chart .ct-series-a .ct-point {
  stroke: #ddd;
  stroke-width: 5px;
  stroke-linecap: round;
}
.metric-confidence-level-trend-chart .ct-series-b .ct-line {
  stroke: #1cb987;
  stroke-width: 2px;
}
.metric-confidence-level-trend-chart .ct-series-b .ct-point {
  stroke: #1cb987;
  stroke-width: 5px;
  stroke-linecap: round;
}
.metric-confidence-level-trend-chart .ct-label {
  white-space: nowrap !important;
  font-size: 0.8em;
  font-weight: 400;
}
.metric-confidence-level-trend-chart .ct-grids .ct-grid {
  stroke: #ddd;
}
.goals-bulk-actions.sidebar-modal.modal {
  width: 40%;
  right: 0;
  left: auto;
}
.goals-bulk-actions + .modal-backdrop.in {
  display: none;
}
.create-dnd-tag-error {
  color: #da555d;
}
okr-workflow {
  display: block;
  margin-top: -1px;
}
okr-workflow .workflow-bar {
  padding: 0 40px;
  height: 46px;
}
okr-workflow .workflow-bar .workflow-btn {
  margin-left: 10px;
  margin-right: 0px;
}
okr-workflow .workflow-bar.draft {
  background: #f5f5fb;
}
okr-workflow .workflow-bar.in-review {
  background: #f5e5fd;
}
okr-workflow .workflow-bar.approved {
  background: #01837b;
}
okr-workflow .workflow-bar.needs-reviewers {
  background: #ffddaf;
}
okr-workflow .workflow-bar .workflow-status-label {
  font-size: 12px;
  font-weight: 500;
}
okr-workflow .workflow-bar .workflow-status-label .draft {
  color: #7989a0;
}
okr-workflow .workflow-bar .workflow-status-label .in-review {
  color: #914de7;
}
okr-workflow .workflow-bar .workflow-status-label .approved {
  color: #18c191;
}
okr-workflow .workflow-bar .workflow-status-label .needs-reviewers {
  color: #8a6116;
}
okr-workflow .workflow-bar .workflow-status-label .draft,
okr-workflow .workflow-bar .workflow-status-label .in-review,
okr-workflow .workflow-bar .workflow-status-label .needs-reviewers {
  margin-right: 5px;
}
okr-workflow .workflow-bar .workflow-status-label .draft-tooltip {
  background: #dbe1ea;
}
okr-workflow .workflow-bar .workflow-status-label .in-review-tooltip {
  background: #ead0ff;
}
okr-workflow .workflow-bar .workflow-status-label .needs-reviewers-tooltip {
  background: #eec301;
}
okr-workflow .workflow-bar .workflow-status-label .draft-tooltip,
okr-workflow .workflow-bar .workflow-status-label .in-review-tooltip,
okr-workflow .workflow-bar .workflow-status-label .needs-reviewers-tooltip {
  display: inline-block;
  height: 10px;
  width: 10px;
  padding-right: 0.5px;
  border-radius: 50%;
  font-size: 8px;
  text-align: center;
  color: #fff;
  cursor: help;
}
okr-workflow .workflow-bar .workflow-status-label .df-aic {
  display: flex;
  align-items: center;
}
okr-workflow .workflow-bar .workflow-reviewers {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 375px;
  cursor: pointer;
}
okr-workflow .workflow-bar .workflow-reviewers > * {
  margin-right: 5px;
}
okr-workflow .workflow-bar .workflow-reviewers > :last-child {
  margin-right: 0px;
}
okr-workflow .workflow-bar .workflow-reviewers .fake-reviewer .icon {
  font-size: 10px;
  padding: 4px;
  border-radius: 50%;
  border: 1px solid #000000;
}
okr-workflow .workflow-bar .workflow-reviewers .gh-siv-owner-icon {
  position: relative;
}
okr-workflow .workflow-bar .show-hide-reviewers {
  font-size: 12px;
  line-height: 14px;
}
okr-workflow .workflow-bar .gh-b.needs-reviewers {
  color: #fff;
  background: #c05717;
}
.timeline {
  float: left;
  width: 100%;
  padding-left: 30px;
}
.timeline .strong {
  font-weight: 500;
  color: #384758;
}
.mention-container {
  position: relative;
  top: 15px;
  left: 4%;
  width: 92%;
}
.mention-container [ui-mention] {
  min-height: 100px;
  width: 100%;
  background: none;
  position: relative;
  margin-bottom: 20px;
  z-index: 2;
  box-sizing: content-box;
}
.mention-container .mention-highlight {
  white-space: pre-wrap;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-weight: 300;
  color: rgba(0, 0, 0, 0);
  font-size: 15px;
  line-height: 24px;
  z-index: 1;
}
.mention-container .mention-highlight span {
  border-radius: 5px;
  background-color: rgba(80, 172, 229, 0.1);
  padding: 2px;
  margin-left: -2px;
}
.mentioned .dropdown {
  display: inline-block;
  position: relative;
}
.mentioned .dropdown .dropdown-toggle {
  color: #0052cc;
}
.mentioned .dropdown .dropdown-toggle:before {
  content: "@";
}
.mentioned .dropdown .dropdown-toggle:hover {
  color: #0048b3;
  cursor: pointer;
}
.mentioned .dropdown .dropdown-menu {
  padding: 20px 20px 20px 70px;
  min-width: 340px;
  margin-left: -30px;
  text-align: left;
}
.mentioned .dropdown .dropdown-menu h3 {
  margin-top: 0 !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  margin-bottom: 8px !important;
  color: #2e4354;
}
.mentioned .dropdown .dropdown-menu h4 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #87a6bc;
}
.moments {
  position: relative;
}
.moments:before {
  content: "Now";
  position: absolute;
  left: -12px;
  width: 22px;
  height: 22px;
  border-radius: 15px;
  top: -25px;
  text-transform: uppercase;
  opacity: 0.2;
  font-size: 12px;
  font-weight: bold;
}
.moments .moment {
  width: 100%;
  float: left;
  position: relative;
  padding: 0 0 0 60px;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}
.moments .moment .content {
  border-bottom: 1px solid #eee;
  padding: 0 0 30px 0;
  color: #5e768a;
  font-size: 1em;
}
.moments .moment .content a {
  cursor: pointer;
}
.moments .moment .content strong {
  font-weight: 500;
  color: #405d75;
}
.moments .moment .content .status {
  display: inline-block;
  padding: 2px 6px;
  font-weight: 500;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: 3px;
  background: #eef0f4;
  color: #2e4354;
}
.moments .moment .content .status.inprogress {
  background: #0052cc;
  color: #fff;
}
.moments .moment .content .status.done {
  background: #1cb987;
  color: #fff;
}
.moments .moment .content .gh-tag-label:hover {
  background: inherit;
  cursor: default;
  color: inherit;
}
.moments .moment .content .gh-tags .tag {
  margin-bottom: -5px;
  height: auto;
  padding-left: 8px;
  float: none;
}
.moments .moment:before {
  display: block;
  content: "";
  left: 0%;
  height: 100%;
  position: absolute;
  width: 3px;
  background: #eef0f4;
}
.moments .moment .owner-and-time {
  padding-top: 40px;
  position: relative;
}
.moments .moment .owner-and-time .dot {
  position: absolute;
  left: -69px;
  width: 22px;
  height: 22px;
  border-radius: 15px;
  background: #eef0f4;
  border: 4px solid #fff;
  top: 55px;
}
.moments .moment .owner-and-time.goal .dot {
  background: #a9d6f2;
}
.moments .moment .owner-and-time.task .dot {
  background: #56e5b8;
}
.moments .moment .owner-and-time.metric .dot {
  background: #ffe7c4;
}
.moments .moment .owner-and-time .owner {
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  margin-right: 10px;
}
.moments .moment .owner-and-time .time {
  display: inline-block;
  color: rgba(46, 67, 84, 0.25);
  font-size: 0.8em;
}
.moments .moment .linked-objectives-modified .previous-current-p {
  margin: 10px 0 0;
  font-weight: 500;
}
.moments .moment .linked-objectives-modified .timeline-toggle-details-btn {
  display: block;
  border: none;
  font-size: 0.85em;
  padding: 0;
  font-weight: 400;
  color: #0052cc;
}
.moments .moment .linked-objectives-modified .gh-icon.tiny {
  top: 2.5px;
}
.moments .moment .linked-objectives-modified .linked-goal-name {
  margin-left: 3px;
}
.moments .moment .linked-objectives-modified .linked-goal-name:hover {
  cursor: pointer;
}
.moments .moment .assignee {
  margin-top: 3px;
}
.load-more-moments {
  position: relative;
  border-left: 3px solid #eef0f4;
  width: 75%;
  padding: 20px 0 0px 60px;
  float: left;
}
.load-more-moments .stop {
  position: absolute;
  left: -15px;
  width: 30px;
  height: 3px;
  background: #eef0f4;
  bottom: 0;
}
.load-more-moments .link {
  font-weight: 500;
  font-size: 1.1em;
}
.load-more-moments .icon {
  position: absolute;
  left: -20px;
  bottom: -10px;
  background: #eef0f4;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
}
#cloned-or-moved-metric-success .gh-empty-module-title .checkmark {
  background: #fff;
}
#cloned-or-moved-metric-success .gh-empty-module-title .checkmark .icon {
  color: #1cb987;
  font-size: 55px;
}
#cloned-or-moved-metric-success .gh-empty-module-title .done {
  color: #000000;
}
#cloned-or-moved-metric-success .success-msg {
  opacity: 0.5;
  font-size: 15px;
}
#cloned-or-moved-metric-success .gh-empty-module.goal {
  cursor: pointer;
  display: table;
  border: 2px solid #eef0f4;
  border-radius: 5px;
  margin-top: 20px;
  padding: 8px 15px;
}
#cloned-or-moved-metric-success .gh-empty-module.goal .goal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
#cloned-or-moved-metric-success .gh-empty-module.goal .goal-wrapper .goal {
  min-width: 80px;
  display: flex;
}
#cloned-or-moved-metric-success .gh-empty-module.goal .goal-wrapper .gh-icon {
  margin-right: 10px;
}
#confirm-clone-or-move .gh-empty-module img {
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 30px;
}
#submission .goal {
  background: #f4fafd;
  padding: 40px;
}
#submission .goal .goal-title {
  font-size: 1.4em;
  position: relative;
  padding-left: 25px;
  display: flex;
  justify-content: space-between;
}
#submission .goal .goal-title .gh-icon {
  position: absolute;
  left: 0;
  top: 5px;
}
#submission .goal .metric {
  font-size: 1.2em;
  position: relative;
  padding-left: 25px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
#submission .goal .metric .gh-icon {
  position: absolute;
  left: 0;
  top: 5px;
}
#submission .goal .name {
  padding: 5px;
  position: relative;
  bottom: 5px;
  background: none;
  border: 1px solid transparent;
  width: 95%;
}
#submission .goal .name:hover {
  border: 1px solid #96a1a9;
  border-radius: 3px;
}
#submission .goal .edit-icon {
  cursor: pointer;
}
#submission .goal .edit-icon .nc-icon-outline {
  font-size: 20px;
}
#submission .conditions {
  margin-bottom: 40px;
}
#submission .conditions .condition {
  margin-top: 20px;
  position: relative;
  padding-left: 20px;
}
#submission .conditions .condition .description {
  font-size: 0.9em;
  color: #9aa3a9;
}
#submission .conditions .condition input {
  position: absolute;
  left: 0;
  top: 0;
}
#submission .conditions .condition ui-checkbox {
  position: relative;
  left: -20px;
}
#submission .conditions .condition ui-checkbox.required:before {
  content: "*";
  position: absolute;
  left: -15px;
  top: 3px;
  font-size: 25px;
  color: #0052cc;
}
#stat-view-tags {
  padding: 5px 40px;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  gap: 5px;
}
.compact-tags * {
  outline: none !important;
  box-shadow: none !important;
}
.compact-tags .autocomplete {
  max-width: 300px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 10px;
  border: 0;
  box-shadow: 0px 4px 22px rgba(135, 166, 188, 0.5) !important;
}
.compact-tags .autocomplete .suggestion-list .suggestion-item {
  font-size: 14px;
  padding: 7px 15px;
  color: #87a6bc;
}
.compact-tags .autocomplete .suggestion-list .suggestion-item.selected {
  color: #fff;
  background: #1cb987;
}
.compact-tags .tags {
  background: none;
  padding: 0;
  border: none;
  box-shadow: none;
}
.compact-tags .tags .input {
  background: none;
  border: 2px solid #c8d7e1;
  border-radius: 4px;
  min-width: 180px;
  color: #2e4354;
  font-size: 12px;
  height: 30px;
  background: #fff;
}
.compact-tags .tags .input::placeholder {
  color: #87a6bc;
  font-style: italic;
}
.compact-tags .tags .input:focus {
  border-color: #0052cc;
}
.compact-tags .tags .tag-item {
  background: #0052cc;
  color: #fff;
  font-size: 12px;
  padding: 0 22px 0 10px;
  border: 0;
  position: relative;
  height: 30px;
  line-height: 30px;
}
.compact-tags .tags .tag-item.selected {
  background: #ff5f5f;
}
.compact-tags .tags .tag-item .icon {
  color: #fff;
}
.compact-tags .tags .tag-item .ui-1_simple-remove {
  position: absolute;
  right: 5px;
  top: 9px;
  cursor: pointer;
}
.compact-tags .tags .tag-item .ui-1_simple-remove:hover {
  opacity: 0.6;
}
#update-metric,
#update-metric-note {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
}
@media all and (min-width: 1200px) {
  #update-metric,
  #update-metric-note {
    max-height: fit-content;
  }
}
#update-metric .title,
#update-metric-note .title {
  color: #021421;
  margin-bottom: 36px;
}
#update-metric .title .metric-name-container,
#update-metric-note .title .metric-name-container {
  display: flex;
  margin-top: 8px;
}
#update-metric .title .metric-name-container gh-icon,
#update-metric-note .title .metric-name-container gh-icon {
  display: flex;
  align-items: center;
}
#update-metric .title .metric-name-container .metric-name,
#update-metric-note .title .metric-name-container .metric-name {
  display: inline-block;
  width: 100%;
  word-wrap: break-word;
}
#update-metric .title .owners,
#update-metric-note .title .owners {
  margin-top: 10px;
}
#update-metric .title .info,
#update-metric-note .title .info {
  margin-top: 10px;
  font-size: 14px;
  color: #445573;
}
#update-metric .alerts,
#update-metric-note .alerts {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-bottom: 36px;
}
#update-metric .alerts:empty,
#update-metric-note .alerts:empty {
  display: none;
}
#update-metric .overflow-visible,
#update-metric-note .overflow-visible {
  overflow: visible !important;
}
#update-metric .form,
#update-metric-note .form {
  margin-right: -24px;
  padding-right: 24px;
}
@media all and (min-width: 1200px) {
  #update-metric .form,
  #update-metric-note .form {
    flex-grow: 1;
    min-height: 30vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
#update-metric .form .form-row,
#update-metric-note .form .form-row {
  margin-bottom: 16px;
}
#update-metric .form .form-row .section-name,
#update-metric-note .form .form-row .section-name {
  display: flex;
}
#update-metric .form .form-row .section-name.center,
#update-metric-note .form .form-row .section-name.center {
  align-items: center;
}
#update-metric .form .form-row .section-field.current-value-field,
#update-metric-note .form .form-row .section-field.current-value-field {
  display: flex;
  align-items: center;
}
#update-metric .form .form-row .section-field.current-value-field .current-value,
#update-metric-note .form .form-row .section-field.current-value-field .current-value {
  font-size: 16px;
  font-weight: 600;
}
#update-metric .form .form-row .section-field.current-value-field .info-popover,
#update-metric-note .form .form-row .section-field.current-value-field .info-popover {
  margin-left: 5px;
  opacity: 0.75;
}
#update-metric .form .form-row .section-field.target-value,
#update-metric-note .form .form-row .section-field.target-value {
  height: 36px;
}
#update-metric .form .form-row .section-field.rich-text-editor .remove-mention-btn,
#update-metric-note .form .form-row .section-field.rich-text-editor .remove-mention-btn {
  color: #0057d7;
  cursor: pointer;
}
#update-metric .form .form-row .section-field.rich-text-editor .mentioned,
#update-metric-note .form .form-row .section-field.rich-text-editor .mentioned {
  font-size: 12px;
}
#update-metric .form .form-row .section-field.rich-text-editor .mentioned ui-avatar,
#update-metric-note .form .form-row .section-field.rich-text-editor .mentioned ui-avatar {
  background: #7485a2;
  margin-left: -2px;
  box-shadow: 0 0 0 2px #fff;
  border-radius: 50%;
  cursor: pointer;
}
#update-metric .form .form-row .section-field.rich-text-editor .mentioned .gh-mention,
#update-metric-note .form .form-row .section-field.rich-text-editor .mentioned .gh-mention {
  margin-left: -2px;
  padding-left: 4px;
}
#update-metric .form .form-row .section-field.rich-text-editor .mentioned .show-more-mentions,
#update-metric-note .form .form-row .section-field.rich-text-editor .mentioned .show-more-mentions {
  margin-left: 0;
}
#update-metric .form .form-row.custom-fields editable-custom-fields,
#update-metric-note .form .form-row.custom-fields editable-custom-fields {
  width: 100%;
}
#update-metric .form .form-row.custom-fields editable-custom-fields .gh-siv-row .gh-siv-row-name,
#update-metric-note .form .form-row.custom-fields editable-custom-fields .gh-siv-row .gh-siv-row-name {
  width: 33.33%;
}
#update-metric .form .form-row.custom-fields editable-custom-fields .gh-siv-row .gh-siv-row-name .cf-name,
#update-metric-note .form .form-row.custom-fields editable-custom-fields .gh-siv-row .gh-siv-row-name .cf-name {
  font-size: 14px;
}
#update-metric .form .form-row.custom-fields editable-custom-fields .gh-siv-row-content,
#update-metric-note .form .form-row.custom-fields editable-custom-fields .gh-siv-row-content {
  margin-left: 12px;
}
#update-metric .form .form-row.update-date,
#update-metric-note .form .form-row.update-date {
  margin-bottom: 0;
}
#update-metric .form .form-row.update-date .section-name,
#update-metric-note .form .form-row.update-date .section-name {
  padding-top: 9px;
}
#update-metric .button-row,
#update-metric-note .button-row {
  margin-top: 36px;
}
#update-metric .button-row .buttons,
#update-metric-note .button-row .buttons {
  display: flex;
  column-gap: 10px;
}
#update-metric.update-kr-note-form .title .description-row,
#update-metric-note.update-kr-note-form .title .description-row {
  display: flex;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 18px;
}
#update-metric.update-kr-note-form .title .description-row .kr-description,
#update-metric-note.update-kr-note-form .title .description-row .kr-description {
  margin-left: 10px;
}
#update-metric.update-kr-note-form .mentioned .remove-mention-btn,
#update-metric-note.update-kr-note-form .mentioned .remove-mention-btn {
  color: #0057d7;
  cursor: pointer;
}
#update-metric.update-kr-note-form .button-row,
#update-metric-note.update-kr-note-form .button-row {
  display: flex;
  column-gap: 10px;
  margin-top: 36px;
}
#update-metric .mentioned,
#update-metric-note .mentioned {
  margin-top: 5px;
  line-height: 20px;
  color: #9aa3a9;
  text-align: left;
}
#update-metric .mentioned .gh-mention,
#update-metric-note .mentioned .gh-mention {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: relative;
  margin-left: 5px;
  margin-bottom: 5px;
}
#update-metric .mentioned .gh-mention .tooltip,
#update-metric-note .mentioned .gh-mention .tooltip {
  min-width: 150px;
}
#update-metric .mentioned .gh-mention img,
#update-metric-note .mentioned .gh-mention img {
  max-width: 100%;
  border-radius: 20px;
}
#update-metric .mentioned .gh-mention.removable:hover,
#update-metric-note .mentioned .gh-mention.removable:hover {
  cursor: pointer;
}
#update-metric .mentioned .gh-mention.removable:hover:before,
#update-metric-note .mentioned .gh-mention.removable:hover:before {
  position: absolute;
  left: 0px;
  top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 15px;
  content: "\\ea5c";
  background: rgba(135, 166, 188, 0.3);
  color: #fff;
  text-align: center;
  display: block;
  font: normal normal normal 11px/1 "Nucleo Mini";
  line-height: 20px;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
}
#update-metric .mentioned .pointer,
#update-metric-note .mentioned .pointer {
  cursor: pointer;
}
#update-metric .kr-current-value,
#update-metric-note .kr-current-value {
  font-size: 1.2em;
  font-weight: 500;
  padding: 40px 0;
}
#update-metric .kr-current-value .non-manual-kr-update,
#update-metric-note .kr-current-value .non-manual-kr-update {
  font-size: 0.8em;
  font-weight: 400;
}
#update-metric .kr-current-value .format,
#update-metric-note .kr-current-value .format {
  font-weight: 500;
  font-size: 1.1em;
}
#update-metric .kr-update-lead,
#update-metric-note .kr-update-lead {
  position: relative;
  display: flex;
  margin-bottom: 30px;
}
#update-metric .kr-update-lead .kr-description,
#update-metric-note .kr-update-lead .kr-description {
  margin-top: 5px;
  color: #9aa3a9;
  font-size: 1em;
}
#update-metric .kr-update-lead .kr-title,
#update-metric-note .kr-update-lead .kr-title {
  font-size: 1.4em;
  font-weight: 500;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
}
#update-metric .kr-update-lead .picture,
#update-metric-note .kr-update-lead .picture {
  position: absolute;
  left: 0;
  top: 0;
}
#update-metric .kr-update-lead .picture img,
#update-metric-note .kr-update-lead .picture img {
  max-width: 40px;
  border-radius: 5px;
}
#update-metric .custom-fields-section p,
#update-metric-note .custom-fields-section p {
  margin-bottom: 25px;
}
#update-metric .custom-fields-section .textarea-wrapper,
#update-metric-note .custom-fields-section .textarea-wrapper {
  min-height: 59px;
}
#update-metric .custom-fields-section .textarea-wrapper textarea,
#update-metric-note .custom-fields-section .textarea-wrapper textarea {
  min-height: 59px;
  margin-bottom: 20px;
}
.create-goal {
  background: rgba(46, 67, 84, 0.2);
}
.create-goal .modal-body {
  min-width: 370px;
}
.create-goal .modal-dialog .modal-content {
  overflow: visible;
}
.create-goal .modal-dialog {
  display: flex;
  justify-content: center;
}
.create-goal .modal-dialog .modal-content {
  max-width: 1054px;
  min-height: initial;
  padding: 0;
  overflow: visible;
  box-shadow: unset;
}
.create-goal-form-container {
  position: relative;
  box-shadow: 0px 4px 10px rgba(68, 85, 115, 0.3);
  z-index: 1;
  width: 662px;
  background-color: #fff;
}
.create-goal-form-container .effectiveness-indicator-wrapper {
  top: 15px;
  right: 60px;
}
#goal-form {
  max-width: 660px;
  margin: 0 auto;
}
#goal-form .gh-selected-artefact {
  display: flex;
  flex-direction: column;
}
#goal-form .gh-selected-artefact .gh-icon {
  top: 12px;
}
#goal-form .gh-selected-artefact .remove {
  top: 12px;
}
#goal-form .gh-typeahead.okr ul {
  width: 100%;
}
#goal-form .mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 4;
}
#goal-form .mask.limit {
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  padding: 100px 60px 0 60px;
  font-weight: 300;
  background: rgba(46, 67, 84, 0.8);
}
#goal-form .timeframe {
  border-bottom: 1px solid #eee;
  padding-top: 20px;
  position: relative;
  height: 100px;
  margin-bottom: 20px;
}
#goal-form .timeframe input {
  position: absolute;
  right: 0;
  opacity: 0;
  width: 40px;
  height: 60px;
  z-index: 2;
  top: 20px;
  cursor: pointer;
}
#goal-form .timeframe .cal {
  position: absolute;
  right: 0;
  font-size: 24px;
  color: #2e4354;
  top: 40px;
  cursor: pointer;
}
#goal-form .timeframe .datebox {
  position: relative;
  padding-left: 45px;
  width: 50%;
  float: left;
  padding-top: 20px;
  height: 80px;
}
#goal-form .timeframe .sep {
  position: absolute;
  left: 50%;
  margin-left: -30px;
  color: #ccc;
  top: 40px;
}
#goal-form .timeframe .label {
  font-size: 11px;
  position: absolute;
  left: 0;
  top: 0;
  text-transform: uppercase;
  color: rgba(46, 67, 84, 0.3);
}
#goal-form .timeframe .day {
  font-size: 30px;
  font-weight: 100;
  color: #1cb987;
  position: absolute;
  top: 16px;
  left: 5px;
}
#goal-form .timeframe .month-year {
  font-size: 13px;
  font-weight: 400;
  color: rgba(46, 67, 84, 0.5);
}
#goal-form .timeframe .weekday {
  font-size: 11px;
  font-weight: 300;
  color: rgba(46, 67, 84, 0.5);
}
#goal-form .form-actions {
  margin-top: 30px;
}
#goal-form .form-actions .btn {
  margin-right: 20px;
}
#goal-form .goal-form .form .gh-fg {
  border: 0;
}
#goal-form .goal-form .form .team-assignee-forbidden-msg {
  font-size: 0.9em;
  color: #ffbd5e;
}
#goal-form .goal-form .progress-calculation .default-label {
  color: #96a1a9;
  font-style: italic;
  margin-left: 10px;
}
#goal-form .goal-form .edit-session .gh-select .sessions-list ul li .gh-icon {
  top: 5px;
  left: 2px;
}
#goal-form .goal-form .edit-session .gh-select .sessions-list ul li .option-title {
  display: inline-block;
  margin-left: 18px;
  font-weight: 400;
}
#goal-form .goal-form .edit-session .gh-select .sessions-list ul li .subtitle {
  margin-left: 38px;
  margin-top: 5px;
  color: #9aa3a9;
}
#goal-form .goal-form .edit-session .gh-selected-artefact {
  min-height: 69px;
}
#goal-form .goal-form .edit-session .gh-selected-artefact::before {
  top: 25px;
  color: #c0c7cb;
}
#goal-form .goal-form .edit-session .alert {
  margin-top: 80px;
}
#goal-form .goal-form .form-actions {
  padding-top: 40px;
  padding-bottom: 40px;
  border-top: 2px solid #eee;
}
#goal-form .goal-form .privacy-container {
  display: flex;
  justify-content: flex-end;
}
#goal-form .goal-form .privacy-container .privacy-wrapper {
  display: flex;
}
#goal-form .goal-form .privacy-container .privacy-wrapper .no-border {
  border-bottom: none;
  padding-top: 10px !important;
  flex: 1;
}
#goal-form .editable-custom-fields {
  padding-top: 30px;
  margin-top: 30px;
  border-top: 2px solid #eef0f4;
}
#goal-form .editable-custom-fields .gh-siv-row-name {
  font-size: 1.2em;
  color: #2e4354;
  width: 33.33%;
}
#goal-form.simple-form .gh-f-title {
  font-size: 30px;
  line-height: 34px;
}
#goal-form.simple-form .gh-fg {
  padding-top: 10px;
  padding-left: 7px;
}
#goal-form.simple-form .gh-input-info {
  padding-right: 0px !important;
}
#goal-form.simple-form .section-name {
  top: 0;
  margin-bottom: 5px;
}
#goal-form.simple-form .section-name span.label-text {
  display: inline-block;
  position: relative;
  font-family: "SF Pro Text", "Helvetica Neue", "SegoeUI", sans-serif;
  color: #51618a;
  font-weight: 500;
  font-size: 12px;
}
#goal-form.simple-form .section-name span.label-text .gh-b-input-info {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  border-radius: 9px;
  line-height: 18px;
  border: 1px solid #9dabc5;
  text-align: center;
  color: #9dabc5;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
}
#goal-form.simple-form .section-name span.label-text .gh-b-input-info.green {
  background-color: #65c59b;
  border-color: #65c59b;
  color: #fff;
}
#goal-form.simple-form input {
  border-radius: 4px;
  border: 1px solid #c0cbdd;
  box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);
  font-family: "SF Pro Text", "Helvetica Neue", "SegoeUI", sans-serif;
  font-size: 14px;
  color: #0d232f;
  transition: 0.3s all ease-in-out;
}
#goal-form.simple-form input::placeholder {
  font-family: "SF Pro Text", "Helvetica Neue", "SegoeUI", sans-serif;
  font-size: 14px;
  color: #8393ae;
}
#goal-form.simple-form input:focus {
  border: 1px solid #75a2f7;
  box-shadow: 0px 0px 0px 2px #d3eaff, inset 0px 1px 2px rgba(90, 127, 158, 0.2);
}
#goal-form.simple-form .gh-fe {
  text-align: left;
}
#goal-form.simple-form .form-actions {
  margin-top: 0;
  border-top: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
#goal-form.simple-form .form-actions .gh-b {
  border-radius: 38px;
  padding: 7px 25px;
  margin-left: 5px;
}
.workflow-stats {
  padding: 0 40px;
}
.workflow-stats .stat-row .stat-card {
  margin: 15px 15px;
  padding: 40px;
  border-radius: 5px;
  box-shadow: 1px 1px 2px 2px #eee;
  background: #fff;
}
.workflow-stats .stat-row .stat-card .header {
  margin-bottom: 50px;
}
.workflow-stats .stat-row .stat-card .header .title {
  margin-bottom: 10px;
  padding-right: 15px;
  font-size: 25px;
  font-weight: 500;
}
.workflow-stats .stat-row .stat-card .header .percentage {
  text-align: right;
}
.workflow-stats .stat-row .stat-card .header .percentage .value {
  padding-left: 15px;
  font-size: 60px;
  line-height: 60px;
  color: #1cb987;
  font-weight: 500;
}
.workflow-stats .stat-row .stat-card .header .description {
  color: #96a1a9;
  font-size: 16px;
  letter-spacing: 0.03em;
}
.workflow-stats .stat-row .stat-card .clickable-stats {
  padding: 15px 0px;
  border-bottom: 2px solid #eee;
}
.workflow-stats .stat-row .stat-card .clickable-stats:last-child {
  border: 0;
}
.workflow-stats .stat-row .stat-card .clickable-stats .stat-description {
  font-size: 16px;
  color: #2e4354;
}
.workflow-stats .stat-row .stat-card .clickable-stats .stat-description.clickable {
  cursor: pointer;
  color: #0052cc;
}
.workflow-stats .stat-row .stat-card .clickable-stats .stat-description.clickable:hover {
  color: #50ace5;
  text-decoration: underline;
}
.workflow-stats .stat-row .stat-card .clickable-stats .value {
  text-align: right;
  font-size: 25px;
  line-height: 25px;
}
.workflow-stats .stat-row .stat-card .clickable-stats.approved .value {
  color: #1cb987;
}
.workflow-stats .stat-row .stat-card .clickable-stats.pending .value {
  color: #221c74;
}
.workflow-stats .stat-row .stat-card .clickable-stats.draft .value {
  color: #96a1a9;
}
.workflow-stats .stat-row.goals .stat-card {
  min-height: 385px;
}
.workflow-stats .stat-row.users .stat-card {
  min-height: 310px;
}
.workflow-stats .stat-row.users .stat-card .header {
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 2px solid #eee;
  line-height: 60px;
  font-size: 60px;
  font-weight: 500;
}
.workflow-stats .stat-row.users .stat-card .sub-title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}
.workflow-stats .stat-row.users .stat-card .description {
  color: #96a1a9;
  font-size: 16px;
  letter-spacing: 0.03em;
}
.workflow-stats .stat-row.users .stat-card .go-to-link {
  margin-top: 20px;
  font-size: 16px;
  color: #0052cc;
  cursor: pointer;
}
.workflow-stats .stat-row.users .stat-card .go-to-link:hover {
  color: #50ace5;
  text-decoration: underline;
}
.workflow-stats .stat-row.users .stat-card.reviewers-pending .header,
.workflow-stats .stat-row.users .stat-card.owners-draft .header {
  color: #ffbd5e;
}
.workflow-stats .stat-row.users .stat-card.average-speed .header {
  color: #96a1a9;
}
.workflow-stats .stat-row.users .stat-card.average-speed .header .units {
  color: #b2bac0;
  font-size: 30px;
  font-weight: 400;
  letter-spacing: 0.03em;
}
.workflow-review-actions .gh-fa {
  padding-top: 40px;
  border-top: 2px solid #eee;
}
.workflow-review-actions rich-text-editor ul.ql-mention-list {
  width: 100%;
}
.inspect-goals-workflow .title {
  margin-bottom: 40px;
}
.inspect-assignees-workflow .title {
  margin-bottom: 20px;
}
.inspect-assignees-workflow .nudge-people {
  margin-bottom: 40px;
}
.inspect-goals-workflow,
.inspect-assignees-workflow {
  padding-bottom: 20px;
}
.inspect-goals-workflow .title,
.inspect-assignees-workflow .title {
  font-size: 2em;
  font-weight: 400;
}
.inspect-goals-workflow .gh-empty-module .gh-empty-module-title,
.inspect-assignees-workflow .gh-empty-module .gh-empty-module-title {
  margin-bottom: 40px;
}
.inspect-goals-workflow table,
.inspect-assignees-workflow table {
  width: 100%;
}
.inspect-goals-workflow table tr,
.inspect-assignees-workflow table tr {
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.inspect-goals-workflow table tr:first-child,
.inspect-assignees-workflow table tr:first-child {
  font-size: 1.2em;
  border: 0;
}
.inspect-goals-workflow table tr:first-child th,
.inspect-assignees-workflow table tr:first-child th {
  padding-left: 15px;
  padding-bottom: 10px;
  font-weight: 500;
}
.inspect-goals-workflow table tr:first-child th:first-child,
.inspect-assignees-workflow table tr:first-child th:first-child {
  padding-left: 0px;
}
.inspect-goals-workflow table tr td,
.inspect-assignees-workflow table tr td {
  vertical-align: top;
  padding: 10px 15px 10px 10px;
  border-right: 1px solid #eee;
}
.inspect-goals-workflow table tr td:first-child,
.inspect-assignees-workflow table tr td:first-child {
  padding-left: 0px;
}
.inspect-goals-workflow table tr td:last-child,
.inspect-assignees-workflow table tr td:last-child {
  border-right: 0;
}
.inspect-goals-workflow .goals-reviewers-list,
.inspect-assignees-workflow .goals-reviewers-list,
.inspect-goals-workflow .assignees-goals-list,
.inspect-assignees-workflow .assignees-goals-list {
  width: 100%;
}
.inspect-goals-workflow .goals-reviewers-list .header .okrs,
.inspect-assignees-workflow .goals-reviewers-list .header .okrs,
.inspect-goals-workflow .assignees-goals-list .header .okrs,
.inspect-assignees-workflow .assignees-goals-list .header .okrs {
  width: 70%;
}
.inspect-goals-workflow .goals-reviewers-list .header .approval-status,
.inspect-assignees-workflow .goals-reviewers-list .header .approval-status,
.inspect-goals-workflow .assignees-goals-list .header .approval-status,
.inspect-assignees-workflow .assignees-goals-list .header .approval-status {
  width: 30%;
}
.inspect-goals-workflow .goals-reviewers-list .header .assignee-header,
.inspect-assignees-workflow .goals-reviewers-list .header .assignee-header,
.inspect-goals-workflow .assignees-goals-list .header .assignee-header,
.inspect-assignees-workflow .assignees-goals-list .header .assignee-header {
  width: 40%;
}
.inspect-goals-workflow .goals-reviewers-list .header .goals-header,
.inspect-assignees-workflow .goals-reviewers-list .header .goals-header,
.inspect-goals-workflow .assignees-goals-list .header .goals-header,
.inspect-assignees-workflow .assignees-goals-list .header .goals-header {
  width: 60%;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info {
  position: relative;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name {
  margin-left: 4px;
  font-size: 1.2em;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name {
  color: #0052cc;
  cursor: pointer;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name:hover,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal-name:hover,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name:hover,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .goal-name:hover,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name:hover,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .goal-name:hover,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .goal-name:hover,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .goal-name:hover,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name:hover,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .goal-name:hover,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name:hover,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .goal-name:hover,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name:hover,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .goal-name:hover,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name:hover,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .goal-name:hover {
  color: #50ace5;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .owner-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .owner-name,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name {
  margin-left: 24px;
  color: #b2bac0;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name .owner-full-name::before,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name .owner-full-name::before,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name .owner-full-name::before {
  content: ", ";
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-goals-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name .owner-full-name:first-of-type::before,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .assignee-info .owner-name .owner-full-name:first-of-type::before {
  content: none;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .goal,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .goal,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .goal,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .goal,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .goal,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .goal {
  margin-bottom: 10px;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal:last-child,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .goal-info .goal:last-child,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .goal-info .goal:last-child,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .goal-info .goal:last-child,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .goal-info .goal:last-child,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .goal-info .goal:last-child,
.inspect-goals-workflow .assignees-goals-list .assignee-details .goal-info .goal:last-child,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .goal-info .goal:last-child {
  margin-bottom: 0;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status {
  padding-bottom: 0px;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .reviewers-inline,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .reviewers-inline,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status .reviewers-inline,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status .reviewers-inline,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status .reviewers-inline,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status .reviewers-inline,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status .reviewers-inline,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status .reviewers-inline {
  position: relative;
  float: left;
  margin-right: 15px;
  margin-bottom: 10px;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .icon,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .icon,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status .icon,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status .icon,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status .icon,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status .icon,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status .icon,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status .icon {
  font-size: 12px;
  padding: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #000000;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top {
  padding: 7px 0;
  margin-top: -6px;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-inner,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-inner,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-inner,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-inner,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top .tooltip-inner,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top .tooltip-inner,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top .tooltip-inner,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top .tooltip-inner {
  background-color: #283d5c;
  padding: 4px 8px;
  font-size: 14px;
  box-shadow: 0px 4px 12px rgba(63, 87, 110, 0.2);
  border-radius: 0;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-goals-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top .tooltip-arrow,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .reviewers-status .tooltip.top .tooltip-arrow {
  border-top-color: #283d5c;
  border-width: 7px 7px 0;
  bottom: 0;
  left: 50%;
  margin-left: -7px;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .show-hide-reviewers,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .show-hide-reviewers,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .show-hide-reviewers,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .show-hide-reviewers,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .show-hide-reviewers,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .show-hide-reviewers,
.inspect-goals-workflow .assignees-goals-list .assignee-details .show-hide-reviewers,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .show-hide-reviewers {
  float: left;
  width: 100%;
  text-align: left;
  color: #0052cc;
  font-size: 0.9em;
  cursor: pointer;
}
.inspect-goals-workflow .goals-reviewers-list .goal-reviewers .show-hide-reviewers:hover,
.inspect-assignees-workflow .goals-reviewers-list .goal-reviewers .show-hide-reviewers:hover,
.inspect-goals-workflow .assignees-goals-list .goal-reviewers .show-hide-reviewers:hover,
.inspect-assignees-workflow .assignees-goals-list .goal-reviewers .show-hide-reviewers:hover,
.inspect-goals-workflow .goals-reviewers-list .assignee-details .show-hide-reviewers:hover,
.inspect-assignees-workflow .goals-reviewers-list .assignee-details .show-hide-reviewers:hover,
.inspect-goals-workflow .assignees-goals-list .assignee-details .show-hide-reviewers:hover,
.inspect-assignees-workflow .assignees-goals-list .assignee-details .show-hide-reviewers:hover {
  color: #50ace5;
  text-decoration: underline;
}
.goals-container .gh-ui-actions-dd .toggle {
  color: #214c6b;
}
#session-tree-selector .session-tree-selector {
  margin-top: 1px;
  padding: 4px;
}
#session-tree-selector tree-selector {
  max-height: 200px;
  box-shadow: 0px 5px 10px 0px rgba(9, 30, 66, 0.25);
}
#session-tree-selector tree-selector .branch {
  padding: 0;
}
#session-tree-selector tree-selector .branch .leading-node {
  margin-top: 0;
  padding: 8px 24px 8px 18px;
  cursor: pointer;
  border-radius: 2px;
}
#session-tree-selector tree-selector .branch .leading-node:hover {
  background: #e5f2ff;
}
#session-tree-selector tree-selector .branch .leading-node .expand-collapse {
  display: none;
}
#session-tree-selector tree-selector .branch .leading-node label.title {
  font-weight: 300;
  color: #021421;
  width: 100%;
}
#session-tree-selector tree-selector .branch .leading-node.active {
  position: relative;
  background: #0057d7;
}
#session-tree-selector tree-selector .branch .leading-node.active .session-title {
  color: #fff;
}
#session-tree-selector tree-selector .branch .leading-node.active label.title {
  color: #fff;
}
#session-tree-selector tree-selector .branch .leading-node.active:before {
  content: "";
  position: absolute;
  right: 8px;
  top: 0;
  bottom: 0;
  width: 12px;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
}
#session-tree-selector tree-selector .branch .sub-tree {
  margin-left: 0;
}
#session-tree-selector tree-selector .branch .branch {
  margin-left: 0;
  border-radius: 2px;
}
#session-search-results {
  max-height: 200px;
  overflow-y: auto;
}
#session-search-results .session-not-found {
  padding: 8px 4px 8px 14px;
}
#session-search-results .session-not-found .error-message {
  color: #021421;
}
#session-search-results .session-list {
  padding: 4px;
}
#session-search-results .session-list .session-item {
  padding: 8px 32px 8px 14px;
  border-radius: 2px;
}
#session-search-results .session-list .session-item .session-color {
  display: inline-block;
  margin-right: 5px;
  height: 10px;
  width: 10px;
  background-color: #f7a600;
  border-radius: 5px;
  vertical-align: middle;
}
#session-search-results .session-list .session-item .session-title {
  display: inline-block;
  vertical-align: middle;
  max-width: 340px;
  width: 100%;
  overflow: hidden;
  font-weight: 300;
  color: #021421;
}
#session-search-results .session-list .session-item .session-active {
  display: inline-block;
  position: absolute;
  right: 8px;
  top: auto;
  bottom: auto;
}
#session-search-results .session-list .session-item .session-active .gh-icon-check-white {
  display: flex;
  align-items: center;
  justify-content: center;
}
#session-search-results .session-list .session-item .session-active .gh-icon.small:before {
  position: static;
  width: 12px;
  height: 9px;
}
.editable-custom-fields .cf-dropdown .dropdown-menu {
  max-width: 400px;
  max-height: 230px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Track */
  /* Handle */
}
.editable-custom-fields .cf-dropdown .dropdown-menu::-webkit-scrollbar {
  width: 7px;
  border-radius: 10px;
}
.editable-custom-fields .cf-dropdown .dropdown-menu::-webkit-scrollbar-track {
  background: #ffffff;
}
.editable-custom-fields .cf-dropdown .dropdown-menu::-webkit-scrollbar-thumb {
  background: #c0cbdd;
  border-radius: 10px;
}
.editable-custom-fields .cf-dropdown .dropdown-menu li .cf-dropdown-btn {
  max-width: 100%;
}
.editable-custom-fields .cf-dropdown .dropdown-menu li .cf-dropdown-btn span {
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.modal-top .ui-label {
  opacity: 0.9;
  font-weight: 600;
}
#goal-details {
  display: flex;
  flex-direction: column;
  padding: 0 67px 0 40px;
}
#goal-details .gh-siv-row {
  position: relative;
}
#goal-details .contextual-button {
  position: absolute;
  bottom: 18px;
  left: 120px;
}
#goal-details .goal-privacy {
  flex: none !important;
}
#goal-details .goal-privacy .gh-select-toggle {
  display: flex;
  height: 24px;
  border: none;
  background: #f4f6fa;
  border-radius: 20px;
  padding: 4px 30px 4px 8px;
}
#goal-details .goal-privacy .gh-select-toggle:before {
  font-family: "Nucleo Mini";
  content: "\\e926";
  top: 9px;
  right: 25px;
  color: #7989a0;
  font-size: 8px;
}
#goal-details .goal-privacy .gh-select-toggle .gh-icon {
  margin-right: 6px;
}
#goal-details .goal-privacy .gh-select-toggle .selected-item-text {
  align-self: center;
  font-size: 12px;
  line-height: 16px;
}
#goal-details .goal-privacy .dropdown-menu {
  min-width: 125px;
}
#goal-details .goal-privacy .dropdown-menu ul {
  padding: 3px 0px;
}
#goal-details .goal-privacy .dropdown-menu ul li {
  padding: 8px 0px 8px 13px;
  border: 0;
  font-size: 12px;
  line-height: 16px;
}
#goal-details .goal-privacy .dropdown-menu ul li:hover {
  background-color: #edf4ff;
}
#goal-details .goal-privacy .dropdown-menu ul li .gh-icon {
  margin-right: 6px;
}
#goal-details .goal-privacy .dropdown-menu ul li.active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-position: 100px;
  background-size: 14px;
}
#goal-details .goal-attainment .number {
  font-size: 24px;
  line-height: 24px;
  font-weight: 500;
}
#goal-details .goal-attainment .color {
  width: 24px;
  height: 24px;
  border-radius: 15px;
}
#goal-details .task-due-date {
  color: #aab6cb;
  font-size: 12px;
  line-height: 20px;
  width: 15%;
  cursor: pointer;
}
#goal-details .task-due-date .due-date {
  padding: 0;
}
#goal-details .task-due-date .due-date.grey {
  color: #aab6cb;
}
#goal-details .task-due-date .due-date.green {
  color: #65c59b;
}
#goal-details .task-due-date .due-date.red {
  color: #c57e65;
}
#goal-details .task-due-date .due-date .remove {
  display: inline-block;
  margin-top: 4px;
}
#goal-details .task-due-date .due-date .remove.grey {
  color: #aab6cb;
}
#goal-details .task-due-date .uib-datepicker-popup {
  left: 0 !important;
}
#goal-details .okr-task-section .task-due-date {
  width: 17% !important;
  position: relative;
  margin-right: 40px;
}
#goal-details .okr-task-section .task-due-date .due-date .remove {
  margin-top: 6px;
}
#goal-details .dropdown-menu.white-space-init {
  white-space: initial;
}
#goal-details tags-input[disabled] .tags .input {
  background-color: inherit;
  cursor: not-allowed;
}
#goal-details parent-okr-selector {
  width: 75%;
  margin-top: -9px;
  margin-left: -12px;
}
#goal-details parent-okr-selector .tags .tag-item {
  background: none;
}
#goal-details parent-okr-selector .tag-list {
  padding-left: 3px;
}
#goal-details .parent-selector-container {
  width: 75%;
}
.contributor .contributor-pad {
  fill: white;
}
.contributor .contributor-separator {
  fill: #eee;
}
.contributor.matched .contributor-separator {
  fill: #ffc25f;
}
.contributor.unmatched {
  opacity: 0.5;
}
.contributor .contributor-progress-bar {
  width: 9%;
  padding-top: 7px;
}
.contributor .contributor-attainment {
  width: 10%;
  text-align: left;
}
.contributor .kr-a11y-description {
  opacity: 0;
  background: transparent;
  width: 0;
  height: 0;
}
.separator {
  margin: 40px 0;
  height: 10px;
  background: rgba(238, 240, 244, 0.5);
}
.single-goal-skeleton {
  padding: 30px;
}
.single-goal-skeleton > ui-skeleton {
  padding: 30px 0;
}
.single-goal-skeleton .single-goal-skeleton-row {
  display: flex;
  gap: 10px;
  padding: 50px 0;
}
.modal-left-close-button {
  left: 30px;
}
.single-goal {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
}
.single-goal .available-actions #view-in-alignment-button {
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.single-goal .available-actions #view-in-alignment-button .view-in-alignment {
  height: 24px;
  width: 24px;
  border-radius: 4px;
  color: rgba(46, 67, 84, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.single-goal .available-actions dropdown-actions-menu .gh-actions-menu {
  min-width: 250px;
  max-width: 300px;
}
.single-goal .available-actions dropdown-actions-menu .gh-actions-menu .actions .action.to-marketplace .gh-b {
  margin: 0;
  padding: 5px 10px;
  letter-spacing: 0;
}
.single-goal .indicator-holder {
  clear: both;
  width: 100%;
  float: left;
}
.single-goal .gh-siv-section .gh-siv-section-item .contributor-action-button .fake-update-button {
  width: 78px;
}
.single-goal .gh-siv-section .gh-siv-section-item .contributor-action-button .fake-update-btn {
  width: 67px;
}
.single-goal .goal-main-info ui-input-text-field {
  margin-left: -10px;
  flex-direction: column;
}
.single-goal .goal-main-info ui-input-text-field .ui-input-text-field {
  width: 100%;
  display: flex;
  align-items: center;
}
.single-goal .goal-main-info ui-input-text-field .ui-input-text-field input {
  text-overflow: ellipsis;
}
.single-goal .goal-main-info ui-input-text-field .ui-input-text-field input[readonly] {
  color: #7485a2;
  background-color: #f1f3f8;
  cursor: not-allowed;
}
.single-goal .goal-main-info ui-input-text-field .ui-input-text-field input[readonly]::placeholder {
  color: #9dabc5;
}
.single-goal .goal-main-info .session-selector-container {
  position: relative;
  width: 75%;
  bottom: 8px;
}
.single-goal .goal-main-info .session-selector-container .session-disabled-for-edit {
  position: relative;
  width: 100%;
  top: 8px;
  left: 5px;
}
.single-goal .goal-main-info .session-selector-container .session-disabled-for-edit .session-color {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-right: 4px;
}
.single-goal .goal-main-info .parent-selector-container {
  position: relative;
  width: 100%;
  height: 36px;
  bottom: 8px;
}
.single-goal .goal-main-info goal-tags .host .tags {
  padding-left: 9px;
  margin-right: 12px;
}
.single-goal .goal-metrics {
  width: 100%;
}
.single-goal .goal-metrics td {
  vertical-align: top;
}
.single-goal .goal-metrics td.metric-confidence {
  padding-left: 15px;
  padding-right: 15px;
}
.single-goal .goal-metrics td.metric-owner {
  padding-right: 10px;
}
.single-goal .goal-metrics .goal-metric {
  position: relative;
  padding: 12px 0 0;
}
.single-goal .goal-metrics .goal-metric .gh-b {
  border-radius: 15px;
  padding: 0 5px;
  letter-spacing: -0.02em;
}
.single-goal .goal-metrics .goal-metric.bottom-row > td {
  padding-bottom: 10px;
  border-bottom: 1px solid #eef0f4;
}
.single-goal .goal-metrics .goal-metric.bottom-row:last-child > td {
  border-bottom: 0;
}
.single-goal .goal-metrics .goal-metric.top-row > td {
  padding-top: 20px;
}
.single-goal .goal-metrics .goal-metric.type-boolean .metric-attainment {
  top: 18px;
}
.single-goal .goal-metrics .goal-metric .picture img {
  max-width: 20px;
  border-radius: 3px;
}
.single-goal .goal-metrics .goal-metric .metric-title {
  font-size: 1.18em;
  letter-spacing: -0.02em;
  line-height: 1.32em;
  padding-bottom: 12px;
}
.single-goal .goal-metrics .goal-metric .metric-title a {
  color: #3d6eb6;
}
.single-goal .goal-metrics .goal-metric .metric-title a:hover {
  color: #0052cc;
}
.single-goal .goal-metrics .goal-metric .gh-custom-fields {
  margin-top: 10px;
}
.single-goal .goal-metrics .goal-metric .metric-description {
  padding-bottom: 10px;
  font-size: 0.9em;
  word-break: break-word;
  color: #9aa3a9;
  font-family: Arial, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.single-goal .goal-metrics .goal-metric .metric-description + .gh-custom-fields {
  margin-top: 0px;
}
.single-goal .goal-metrics .goal-metric .metric-progress {
  position: relative;
  margin-top: 9px;
  width: 100%;
}
.single-goal .goal-metrics .goal-metric .metric-progress .metric-target {
  font-size: 13px;
  margin-bottom: 6px;
  color: #96a1a9;
  float: left;
  width: 100%;
}
.single-goal .goal-metrics .goal-metric .metric-progress .gh-b {
  position: absolute;
  right: 10px;
  top: 15px;
}
.single-goal .goal-metrics .goal-metric .metric-attainment {
  color: #2e4354;
  font-size: 1em;
  font-weight: 500;
  padding-left: 5px;
}
.single-goal .goal-metrics .goal-metric .metric-attainment.coloring {
  right: 135px;
  width: 10px;
  height: 10px;
  top: 17px;
  border-radius: 20px;
}
.single-goal .goal-metrics .goal-metric:hover .metric-bar-holder .time-progress-holder .pointer-label {
  display: block;
}
.single-goal-content-container {
  width: 800px;
}
.scrollable-with-left-overflow {
  margin-left: -200px;
  padding-left: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.metric-target-and-timeleft {
  float: left;
  width: 100%;
}
.metric-target-and-timeleft .timeleft {
  font-size: 0.9em;
  color: rgba(46, 67, 84, 0.6);
  font-weight: 400;
}
.metric-target-and-timeleft .metric-bar-target {
  font-size: 12px;
  display: block;
  text-align: left;
  color: #7989a0;
  max-width: 250px;
}
.metric-bar-holder,
.goal-bar-holder {
  position: relative;
  width: 100%;
  float: left;
  background: repeating-linear-gradient(45deg, #fff, #fff 4px, #f9f9f9 3px, #f3f3f3 7px);
}
.metric-bar-holder .time-progress-holder,
.goal-bar-holder .time-progress-holder {
  position: absolute;
  left: 0;
  top: 0px;
  height: 6px;
  width: 100%;
}
.metric-bar-holder .time-progress-holder .soft-deadline,
.goal-bar-holder .time-progress-holder .soft-deadline {
  position: absolute;
  top: 0px;
  left: 0;
  min-width: 10px;
  height: 6px;
  background: rgba(255, 189, 94, 0.2);
  border-radius: 8px;
  z-index: 4;
}
.metric-bar-holder .time-progress-holder .soft-deadline .drop,
.goal-bar-holder .time-progress-holder .soft-deadline .drop {
  position: absolute;
  right: 2px;
  top: -1px;
  width: 8px;
  height: 8px;
  background: #ffd291;
  border-radius: 5px;
}
.metric-bar-holder .time-progress-holder .soft-deadline .drop:hover,
.goal-bar-holder .time-progress-holder .soft-deadline .drop:hover {
  opacity: 1;
}
.metric-bar-holder .time-progress-holder .soft-deadline .tooltip,
.goal-bar-holder .time-progress-holder .soft-deadline .tooltip {
  min-width: 150px;
}
.metric-bar-holder .time-progress-holder .pointer-label,
.goal-bar-holder .time-progress-holder .pointer-label {
  display: none;
  position: absolute;
  top: -24px;
  font-size: 11px;
  font-weight: 400;
  color: #8290ae;
}
.metric-bar-holder .time-progress-holder .time-progress,
.goal-bar-holder .time-progress-holder .time-progress {
  position: absolute;
  left: 0;
  top: -9px;
  width: 100%;
  height: 6px;
  overflow: hidden;
}
.metric-bar-holder .time-progress-holder .time-progress .pointer,
.goal-bar-holder .time-progress-holder .time-progress .pointer {
  position: absolute;
  top: 0px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #dfe2ea;
  margin-left: -1px;
}
.metric-bar-holder .metric-bar,
.goal-bar-holder .metric-bar,
.metric-bar-holder .goal-bar,
.goal-bar-holder .goal-bar {
  height: 6px;
  background: #eee;
  border-radius: 3px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
}
.metric-bar-holder .metric-bar .metric-bar-progress,
.goal-bar-holder .metric-bar .metric-bar-progress,
.metric-bar-holder .goal-bar .metric-bar-progress,
.goal-bar-holder .goal-bar .metric-bar-progress,
.metric-bar-holder .metric-bar .goal-bar-progress,
.goal-bar-holder .metric-bar .goal-bar-progress,
.metric-bar-holder .goal-bar .goal-bar-progress,
.goal-bar-holder .goal-bar .goal-bar-progress {
  height: 6px;
  position: absolute;
  max-width: 100%;
  border-radius: 3px;
  left: 0;
  top: 0;
  background: #0048b3;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}
.metric-bar-holder .metric-bar .metric-bar-progress:before,
.goal-bar-holder .metric-bar .metric-bar-progress:before,
.metric-bar-holder .goal-bar .metric-bar-progress:before,
.goal-bar-holder .goal-bar .metric-bar-progress:before,
.metric-bar-holder .metric-bar .goal-bar-progress:before,
.goal-bar-holder .metric-bar .goal-bar-progress:before,
.metric-bar-holder .goal-bar .goal-bar-progress:before,
.goal-bar-holder .goal-bar .goal-bar-progress:before {
  position: absolute;
  right: 2px;
  top: 0;
  height: 6px;
  border-radius: 10px;
  width: 6px;
  background: rgba(255, 255, 255, 0.4);
  content: "";
}
.metric-bar-holder .metric-bar .metric-bar-progress.negative,
.goal-bar-holder .metric-bar .metric-bar-progress.negative,
.metric-bar-holder .goal-bar .metric-bar-progress.negative,
.goal-bar-holder .goal-bar .metric-bar-progress.negative,
.metric-bar-holder .metric-bar .goal-bar-progress.negative,
.goal-bar-holder .metric-bar .goal-bar-progress.negative,
.metric-bar-holder .goal-bar .goal-bar-progress.negative,
.goal-bar-holder .goal-bar .goal-bar-progress.negative {
  background: #ff5f5f;
}
.gh-siv-editable-markdown {
  margin-top: -6px;
  margin-bottom: 10px;
  width: 100%;
  position: relative;
  min-height: 40px;
}
.gh-siv-editable-markdown.width-60 {
  width: 60px;
}
.gh-siv-editable-markdown .gh-siv-editable-markdown-preview {
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: text;
  min-height: inherit;
  line-height: 26px;
}
.gh-siv-editable-markdown .gh-siv-editable-markdown-preview.not-focused {
  visibility: hidden;
}
.gh-siv-editable-markdown .gh-siv-editable-markdown-preview:hover {
  border: 1px solid #8393ae;
  box-shadow: inset 0 1px 3px rgba(90, 127, 158, 0.1);
}
.gh-siv-row-content goal-tags,
.gh-siv-row-content .tags-input-container {
  width: 100%;
  height: 100%;
}
.gh-siv-row-content goal-tags.ng-empty .host .tags:before,
.gh-siv-row-content .tags-input-container.ng-empty .host .tags:before {
  position: absolute;
  content: "-";
  left: 1px;
  top: 8px;
}
.gh-siv-row-content goal-tags.ng-empty .host .tags.focused,
.gh-siv-row-content .tags-input-container.ng-empty .host .tags.focused {
  padding: 6px;
}
.gh-siv-row-content goal-tags.ng-empty .host .tags.focused:before,
.gh-siv-row-content .tags-input-container.ng-empty .host .tags.focused:before {
  content: "";
}
.gh-siv-row-content goal-tags .autocomplete,
.gh-siv-row-content .tags-input-container .autocomplete {
  padding: 0;
  border: 0;
  box-shadow: 0 2px 15px rgba(0, 56, 81, 0.25);
}
.gh-siv-row-content goal-tags .autocomplete .suggestion-list .suggestion-item,
.gh-siv-row-content .tags-input-container .autocomplete .suggestion-list .suggestion-item {
  font-size: 14px;
  color: #003851;
}
.gh-siv-row-content goal-tags .autocomplete .suggestion-list .suggestion-item.selected,
.gh-siv-row-content .tags-input-container .autocomplete .suggestion-list .suggestion-item.selected {
  background: #f5f5fb;
}
.gh-siv-row-content goal-tags .autocomplete .suggestion-list .suggestion-item.selected:after,
.gh-siv-row-content .tags-input-container .autocomplete .suggestion-list .suggestion-item.selected:after {
  content: "Press Tab to select";
  color: #a9c3d7;
  font-size: 12px;
  float: right;
}
.gh-siv-row-content goal-tags .host,
.gh-siv-row-content .tags-input-container .host {
  margin: 0;
}
.gh-siv-row-content goal-tags .host .tags,
.gh-siv-row-content .tags-input-container .host .tags {
  box-shadow: none;
  margin: -8px 0 0 -12px;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid transparent;
}
.gh-siv-row-content goal-tags .host .tags.focused,
.gh-siv-row-content .tags-input-container .host .tags.focused {
  border: 1px solid #37b9ff;
}
.gh-siv-row-content goal-tags .host .tags:hover,
.gh-siv-row-content .tags-input-container .host .tags:hover {
  border: 1px solid #a9c3d7;
  box-shadow: inset 0 1px 3px rgba(90, 127, 158, 0.1);
}
.gh-siv-row-content goal-tags .host .tags .input:before,
.gh-siv-row-content .tags-input-container .host .tags .input:before {
  content: "+";
}
.gh-siv-row-content goal-tags .host .tags .tag-list .tag-item,
.gh-siv-row-content .tags-input-container .host .tags .tag-list .tag-item {
  border: 0;
  border-radius: 20px;
  padding: 0px 10px;
  position: relative;
  color: #7989a0;
  font-size: 13px;
  background: #eeeff8;
}
.gh-siv-row-content goal-tags .host .tags .tag-list .tag-item.selected,
.gh-siv-row-content .tags-input-container .host .tags .tag-list .tag-item.selected {
  background: #e8f4ff;
}
.gh-siv-row-content goal-tags .host .tags .tag-list .tag-item:hover .remove-button,
.gh-siv-row-content .tags-input-container .host .tags .tag-list .tag-item:hover .remove-button {
  display: block;
}
.gh-siv-row-content goal-tags .host .tags .tag-list .tag-item .remove-button,
.gh-siv-row-content .tags-input-container .host .tags .tag-list .tag-item .remove-button {
  position: absolute;
  right: -3px;
  top: -3px;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 17px;
  display: none;
  border-radius: 10px;
  font-size: 8px;
  background: #aab6cb;
  color: #fff;
}
.gh-siv-row-content goal-tags .host .tags .tag-list .tag-item .remove-button:hover,
.gh-siv-row-content .tags-input-container .host .tags .tag-list .tag-item .remove-button:hover {
  background: #7989a0;
}
.gh-siv-row-content.session-selector-dropdown-wrapper {
  position: relative;
}
.gh-siv-row-content.session-selector-dropdown-wrapper .dropdown-container {
  position: absolute;
  top: -6px;
}
.gh-siv-row-content.session-selector-dropdown-wrapper .dropdown-container:hover {
  border: 1px solid #a9c3d7;
  box-shadow: inset 0 1px 3px rgba(90, 127, 158, 0.1);
  cursor: pointer;
}
.gh-siv-row-content user-selector {
  margin-top: -6px;
}
.gh-siv-row-content user-selector .tags {
  padding-left: 7px;
}
.gh-siv-row-content people-selector {
  margin-top: -9px;
}
.gh-siv-row-content rich-text-editor {
  display: block;
  width: 100%;
  min-height: 40px;
  margin-top: -10px;
  margin-bottom: 12px;
}
.gh-siv-row-content goal-privacy-button {
  margin-top: -7px;
  position: relative;
  left: -3px;
}
.gh-siv-row-content okr-design-score {
  margin-top: 2px;
}
.gh-siv-row-content date-picker-legacy {
  position: relative;
  top: -12px;
}
.gh-siv-row-content goal-tags {
  position: relative;
  top: -13px;
  left: 1px;
}
.gh-siv-row-content.suggestion-card-description pi-text-card,
.gh-siv-row-content.suggestion-card-description pi-loading-card,
.gh-siv-row-content.suggestion-card-description pi-error-card,
.gh-siv-row-content.suggestion-card-description pi-feedback-card,
.gh-siv-row-content.suggestion-card-description pi-loading-card-v2,
.gh-siv-row-content.suggestion-card-description pi-clickable-error-card {
  position: relative;
  top: -10px;
}
.gh-siv-row-content.suggestion-card-tags pi-loading-card,
.gh-siv-row-content.suggestion-card-tags quantive-plus-suggestion-card-tags,
.gh-siv-row-content.suggestion-card-tags pi-error-card,
.gh-siv-row-content.suggestion-card-tags pi-feedback-card,
.gh-siv-row-content.suggestion-card-tags pi-loading-card-v2,
.gh-siv-row-content.suggestion-card-tags pi-clickable-error-card {
  position: relative;
  top: -13px;
}
#goal-timeline .title {
  position: relative;
  display: inline-block;
}
#goal-timeline .title h1 {
  position: relative;
  margin-bottom: 15px;
  line-height: 1.4em;
  font-size: 2.6em;
  font-weight: 500;
  color: #2e4354;
}
#goals {
  width: 100%;
}
#goals.loading {
  opacity: 0.6;
}
#goals .dropdown-menu-right {
  left: 0;
  right: auto;
}
#goals .checkbox-disabled {
  pointer-events: none;
}
.bulk-delete-warning-banner {
  background-color: #75a2f7;
  color: #021421;
  gap: 10px;
}
.bulk-delete-warning-banner .banner-icon {
  color: #0057d7;
}
.bulk-delete-warning-banner .text-base,
.bulk-delete-warning-banner .text-xs {
  line-height: 19px;
}
.empty-module-v2 {
  margin-top: 160px;
  width: 352px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
}
#metrics-in-danger {
  width: 100%;
}
#metrics-in-danger .color-dot {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
}
#metrics-in-danger tr th {
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #87a6bc;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
#metrics-in-danger tr td {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
#metrics-in-danger tr td.metric-title a {
  font-size: 16px;
  font-weight: 400;
}
#metrics-in-danger tr td.metric-title .metric-type {
  font-size: 11px;
  line-height: 18px;
  color: #87a6bc;
}
#metrics-in-danger tr td.target,
#metrics-in-danger tr td.actual {
  font-size: 16px;
  font-weight: 300;
}
#metrics-in-danger tr td.metric-attainment {
  text-align: right;
  font-size: 20px;
  font-weight: 700;
}
#metrics-in-danger tr td.metric-attainment.bad {
  color: #ff5f5f;
}
#metrics-in-danger tr td.metric-attainment.good {
  color: #1cb987;
}
#inspect-stats-goals {
  width: 100%;
}
#inspect-stats-goals .color-dot {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
}
#inspect-stats-goals tr th {
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #87a6bc;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
#inspect-stats-goals tr td {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
#inspect-stats-goals tr td.goal-name-and-due a {
  font-size: 16px;
  font-weight: 400;
}
#inspect-stats-goals tr td.goal-name-and-due .due {
  font-size: 11px;
  line-height: 18px;
  color: #87a6bc;
}
#inspect-stats-goals tr td.goal-progress {
  text-align: right;
  font-size: 20px;
  color: #1cb987;
  font-weight: 700;
}
#inspect-stats-goals tr td.metrics {
  text-align: right;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  body #main {
    padding: 0;
  }
  body .master-container {
    padding: 0;
  }
  body .navigation {
    display: none !important;
  }
  body #goals-nested {
    top: 0;
    padding: 0;
    margin-top: 0;
    overflow: visible;
  }
  body #goals-nested .root-level {
    width: 98%;
  }
  body #goals-nested .goal {
    border: 1px solid #ddd;
    padding: 10px 10px 10px 55px;
    min-height: 80px;
  }
  body #goals-nested .goal .goal-attainment {
    font-weight: 700;
  }
  body #goals-nested .goal .goal-name {
    font-weight: 700;
  }
  body #goals-nested .goal .goal-avatar {
    width: 30px;
    height: 30px;
    top: 15px;
    left: 10px;
  }
  body #goals-nested .goal .dropdown {
    display: none;
  }
  body #goals-nested .goal .toggle-goal {
    display: none;
  }
}
#goals-nested {
  position: fixed;
  top: 65px;
  bottom: 0;
  left: var(--left-nav-width);
  right: 0;
  padding-top: 60px;
  overflow: scroll;
  padding-bottom: 100px;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}
#goals-nested .root-level {
  padding-left: 0;
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}
#goals-nested .root-level .tree-level {
  padding-left: 30px;
}
#goals-nested .root-level .top > goal-list-node > #goal-node > .goal {
  display: none;
}
#goals-nested .goal {
  border-radius: 7px;
  box-shadow: 0 2px 5px rgba(46, 67, 84, 0.15);
  background: #fff;
  margin-bottom: 5px;
}
#goals-nested .goal.obfuscated {
  background-image: repeating-linear-gradient(45deg, #f4f5f8, #f4f5f8 10px, #fff 10px, #fff 20px);
}
#goals-nested .goal.grayout {
  opacity: 0.4;
}
#goals-nested .goal.matched {
  border-style: solid;
  border-color: #ffc25f;
}
#goals-nested .goal:hover {
  box-shadow: 0 2px 5px rgba(46, 67, 84, 0.25);
}
#goals-nested .goal .goal-content {
  padding: 12px 22px 12px 15px;
}
#goals-nested .goal .goal-metrics:hover {
  color: #2e4354;
  cursor: pointer;
}
#goals-nested .goal .goal-tags {
  display: inline-flex;
}
#goals-nested .goal .goal-tags .tag {
  background: #f1f3f8;
  color: #283d5c;
  padding: 2px 10px 4px;
  border-radius: 20px;
  margin-right: 2px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
}
#goals-nested .goal .goal-tags .tag-badge {
  background: #8393ae;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 11px;
  line-height: 20px;
  font-weight: 700;
  align-self: center;
}
#goals-nested .goal .metrics {
  margin: 0px 22px 0px 45px;
}
#goals-nested .goal .metrics .metric {
  padding: 11px 0px;
  border-top: 1px solid #d8e1ee;
}
#goals-nested .goal .metrics .metric .metric-icon {
  margin-right: 6px;
}
#goals-nested .goal .metrics .metric .metric-attainment {
  text-align: right;
  width: 65px;
}
#goals-nested .goal .metrics .metric .metric-name {
  font-size: 13px;
  color: #021421;
}
#goals-nested .goal .metrics .metric .metric-name:hover {
  color: #003a7b;
  text-decoration: underline;
}
#goals-nested .goal .metrics .metric .metric-attainment {
  font-size: 12px;
  line-height: 16px;
}
#goals-nested .goal .dropdown .dropdown-toggle {
  color: #9dabc5;
  margin-left: 10px;
}
#goals-nested .goal .dropdown .dropdown-toggle:hover {
  color: #2e4354;
}
#goals-nested .goal .dropdown .dropdown-menu {
  margin-left: -130px;
}
#goals-nested .goal .dropdown .dropdown-menu ul li {
  width: 100%;
  display: block;
  margin: 2px 0px;
  padding: 0px 10px 0px 23px;
  cursor: pointer;
  font-size: 13px;
  line-height: 2.5em;
}
#goals-nested .goal .dropdown .dropdown-menu ul li:hover,
#goals-nested .goal .dropdown .dropdown-menu ul li :active {
  background: #eff7fe;
  color: #2e4354;
}
#goals-nested .goal .dropdown .dropdown-menu ul li.warn {
  color: #ff5f5f !important;
}
#goals-nested .goal .goal-name {
  color: #021421;
  font-size: 15px;
  line-height: 16px;
  display: block;
}
#goals-nested .goal .goal-name:hover {
  color: #003a7b;
  text-decoration: underline;
}
#goals-nested .goal .goal-name .gh-badge {
  padding: 2px 5px;
  line-height: 15px;
  font-size: 12px;
  position: relative;
  top: -4px;
  margin-right: 8px;
}
#goals-nested .goal .toggle-goal {
  position: absolute;
  left: -35px;
  top: 18px;
}
#goals-nested .goal .toggle-goal .icon-expand-goal,
#goals-nested .goal .toggle-goal .icon-collapse-goal {
  width: 24px;
  height: 24px;
  text-align: center;
  color: #fff;
  border-radius: 100%;
  font-size: 16px;
}
#goals-nested .goal .toggle-goal .icon-collapse-goal {
  background: #c0cbdd;
}
#goals-nested .goal .toggle-goal .icon-expand-goal {
  background: #75a2f7;
}
#goals-nested .goal .toggle-goal .count {
  position: absolute;
  top: 13px;
  right: -7px;
  text-align: center;
  line-height: 14px;
  background: #003a7b;
  color: #fff;
  font-size: 11px;
  padding: 1px 4px;
  min-width: 16px;
  border-radius: 100%;
}
#goals-nested .goal .toggle-goal:hover .icon {
  background: rgba(135, 166, 188, 0.25);
}
#goals-nested .goal avatars img {
  vertical-align: unset;
}
#goals-nested .goal .goal-icon {
  margin-right: 10px;
}
#goals-nested .goal .upload-icon {
  margin: 0 8px;
}
#goals-nested .goal .goal-avatar {
  margin-right: 10px;
}
#goals-nested .goal .goal-avatar img {
  max-width: 35px;
  border-radius: 100%;
}
#goals-nested .goal .attainment {
  width: 65px;
  height: 36px;
  text-align: end;
}
#goals-nested .goal .attainment .goal-attainment {
  font-size: 16px;
  line-height: 20px;
}
#goals-nested .goal .attainment .goal-attainment .color {
  width: 25px;
  height: 25px;
  border-radius: 30px;
}
#goals-nested .goal .attainment .goal-aggregated-progress {
  color: rgba(46, 67, 84, 0.5);
  font-size: 12px;
  line-height: 16px;
}
#goals-nested .goal .attainment .goal-aggregated-progress.color {
  width: 16px;
  border-radius: 8px;
  margin-right: 5px;
  height: 16px;
}
#goals-nested .goal .goal-assignee {
  color: #96a1a9;
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  color: #283d5c;
}
#goals-nested .goal .metrics-count {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #617294;
}
#nested-view-tree {
  height: 100%;
  width: 100%;
  padding: 10px 20px;
  max-width: 1400px;
  margin: auto;
}
#nested-view-tree.with-expand-icon {
  padding-left: 80px;
}
#nested-view-tree ul {
  margin-bottom: 0px;
}
.alignment-nested-indicator-container {
  position: absolute;
  top: 60px;
  right: 100px;
}
#tasks-switch-view {
  position: relative;
  width: 100%;
  padding: 0 40px;
}
#tasks-switch-view a {
  color: #9aa3a9;
  margin-left: 15px;
}
#tasks-switch-view a:hover {
  cursor: pointer;
  color: #0052cc;
}
#tasks-switch-view [class^="gh-font-icon-"],
#tasks-switch-view [class*=" gh-font-icon-"] {
  position: relative;
  top: 0.5px;
  margin-right: 4px;
  opacity: 0.6;
  font-size: 12px;
}
.custom-fields-two-columns .gh-custom-fields .gh-custom-field {
  width: 100%;
  float: left;
}
.custom-fields-two-columns .gh-custom-fields .gh-custom-field .gh-custom-field-title {
  width: 35%;
  float: left;
  padding-right: 20px;
}
.custom-fields-two-columns .gh-custom-fields .gh-custom-field .gh-custom-field-content {
  word-break: break-word;
  float: left;
  width: 65%;
  padding: 0;
}
.gh-custom-fields {
  font-size: 16px;
  width: 100%;
  clear: both;
}
.gh-custom-fields .gh-custom-field {
  width: 100%;
  padding: 10px 0 5px 0;
  border-top: 1px solid #eef0f4;
}
.gh-custom-fields .gh-custom-field .gh-input-info .gh-b-input-info {
  display: inline-block;
  position: relative;
  top: -2px;
  right: 0;
}
.gh-custom-fields .gh-custom-field:last-child td {
  border-bottom: 0;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-title h3 {
  font-size: 0.9em;
  font-weight: 500;
  line-height: 1.3em;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-title p {
  font-size: 0.8em;
  color: #96a1a9;
  -webkit-font-smoothing: antialiased;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-title p .help-tip {
  width: 16px;
  height: 16px;
  background: #eef0f4;
  border-radius: 100%;
  font-size: 0.9em;
  line-height: 16px;
  text-align: center;
  color: #87a6bc;
  display: inline-block;
  font-weight: 700;
  cursor: help;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-title p .help-tip:hover {
  background: #cfd5e0;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content {
  padding: 10px 0 0 0;
  width: 100%;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .not-entered {
  font-size: 0.9em;
  font-weight: 400;
  color: #96a1a9;
  position: relative;
  display: inline-block;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .custom-field-assignee {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 0;
  margin: 0 6px 6px 0;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .custom-field-assignee .picture {
  width: 20px;
  height: 20px;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .custom-field-assignee .picture img {
  max-width: 100%;
  border-radius: 3px;
  margin-top: -2px;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .objective {
  position: relative;
  padding-left: 30px;
  font-size: 0.9em;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .details-wrapper {
  font-size: 0.9em;
  font-weight: 400;
  color: #96a1a9;
  position: relative;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .details-wrapper .form-group label {
  font-weight: 500;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .details-wrapper p {
  margin-bottom: 10px;
  word-break: break-word;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .details-wrapper p:last-child {
  margin-bottom: 0;
  padding-top: 10px;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .multiselect .item:after {
  content: ", ";
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .multiselect .item:last-child:after {
  content: "";
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .field-checkbox {
  display: inline-block;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .field-checkbox .icon {
  width: 16px;
  display: inline-block;
  height: 16px;
  font-size: 16px;
  text-align: center;
  line-height: 16px;
  color: #1cb987;
  border-radius: 100%;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .field-checkbox .icon + .icon {
  display: none;
  color: #9aa3a9;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .field-checkbox.negative .icon {
  display: none;
}
.gh-custom-fields .gh-custom-field .gh-custom-field-content .field-checkbox.negative .icon + .icon {
  display: block;
}
#custom-field .gh-font-icon-help {
  position: absolute;
  top: 10px;
  right: 5px;
  color: white;
  font-size: 1.5em;
}
#metrics-limit-reached {
  text-align: center;
  font-size: 16px;
  line-height: 26px;
  font-weight: 300;
}
#metrics-limit-reached .main-icon {
  font-size: 100px;
  color: rgba(135, 166, 188, 0.15);
  margin-bottom: 20px;
}
#metrics-limit-reached .btn {
  margin-top: 20px;
}
.create-metric .modal-dialog {
  overflow-y: hidden;
}
.create-metric .create-metric-form-container {
  position: relative;
  box-shadow: 0px 4px 10px rgba(68, 85, 115, 0.3);
  z-index: 1;
  width: 662px;
  min-height: 320px;
  background-color: #fff;
}
.create-metric .create-metric-form-container .close-btn-wrapper {
  position: absolute;
  top: 20px;
  right: 20px;
}
.create-metric .create-metric-form-container .close-btn-wrapper ui-button {
  width: 32px;
  color: #445573;
}
.create-metric .effectiveness-indicator-wrapper {
  top: 15px;
  right: 60px;
}
#create-form .milestones-info {
  position: relative;
}
#create-form .milestones-info .milestones-popover {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(0%, -50%);
}
#create-form .button-wrapper {
  display: flex;
  gap: 12px;
}
#create-form .form-actions {
  margin-top: 17px;
}
#create-form .form-actions button:focus {
  box-shadow: 0px 0px 0px 1px #fff, 0px 0px 0px 2px #0057d7;
}
#create-form .form-actions button.gh-accent:focus {
  border: none;
}
#create-form .form-actions button.secondary {
  border-color: #0057d7;
}
#create-form .form-actions ui-button {
  margin-right: 10px;
}
#create-form #parent-selector-content {
  flex-direction: column;
}
#create-form #parent-selector-content .parent-selector-container {
  width: inherit;
  max-height: 40px;
}
#create-form #parent-selector-content #alignment-attention-info {
  margin-top: 8px;
  padding: 5px 4px 5px 4px;
  background: #d3eaff;
  border-radius: 4px;
}
#create-form #parent-selector-content #alignment-attention-info .gh-font-icon-info {
  color: #0057d7 !important;
  font-size: 18px;
  align-items: center;
  margin-left: 6px !important;
  margin-right: 4px;
}
#create-form .critical-slider:not(.gh-no-padding) {
  padding-right: 27px;
}
#create-form .critical-slider:not(.gh-no-margin) {
  margin-bottom: 18px;
}
#create-form .critical-slider.disabled {
  margin-bottom: 0px;
}
#create-form .critical-slider.disabled .slider-label {
  color: #7485a2;
}
#create-form .session-selector-container {
  width: inherit;
}
#create-form .session-selector-container .ant-select-selector {
  border: 1px solid #c0cbdd;
  box-shadow: 0px 1px 1px rgba(90, 128, 158, 0.1);
}
#create-form .back {
  margin-left: 20px;
}
#create-form .row.gh-mb-0 {
  margin-bottom: 0px !important;
}
#create-form .percentage {
  color: #ffffff;
  margin-top: 3px;
  font-size: 12px;
  font-family: Arial, sans-serif;
}
#create-form .percentage.negative {
  color: #ff5f5f;
}
#create-form .percentage.negative:before {
  content: "";
}
#create-form .gh-f-title-medium {
  font-weight: 700 !important;
  font-size: 30px;
  line-height: 30px;
  letter-spacing: 0.005em;
  color: #021421;
  margin-bottom: 26px;
}
#create-form .gh-input-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 !important;
}
#create-form .gh-input-info > :first-child {
  flex: 1;
  min-width: 0;
}
#create-form .gh-input-info > .dropdown {
  min-height: 40px;
}
#create-form .gh-input-info .unit-format-container {
  overflow: auto;
}
#create-form .gh-input-info .gh-select-v2 .dropdown-menu ul li p {
  opacity: 0.75;
}
#create-form .gh-input-info people-selector .ant-select {
  min-height: 40px;
}
#create-form .gh-input-info .helper-text {
  font-family: "SF Pro Text", sans-serif;
  color: #445573;
  font-size: 12px;
  padding-top: 4px;
}
#create-form .ant-select-selection-placeholder,
#create-form .gh-input-text::placeholder,
#create-form .mentioned-placeholder {
  font-size: 14px;
  color: #445573;
  font-style: unset;
}
#create-form .gh-input-text {
  padding: 10px;
}
#create-form .gh-input-text::placeholder {
  color: #445573;
}
#create-form .gh-font-icon-help {
  color: #9dabc5;
  margin-left: 10px;
}
#create-form .gh-font-icon-help.metric-deadline-help {
  align-self: flex-start;
  margin-top: 12px;
}
#create-form .gh-font-icon-info,
#create-form icon-with-popover {
  color: #9dabc5;
  font-size: 17px;
  margin-left: 9px;
  margin-right: -2px;
}
#create-form .info-text {
  flex: 1;
  align-items: center;
}
#create-form .info-text p {
  font-family: "SF Pro Text", sans-serif;
  font-size: 12px;
  color: #283d5c;
  margin-bottom: 0;
}
#create-form .gh-input-text,
#create-form .gh-input-text-v2,
#create-form .gh-select,
#create-form .gh-dynamic-group {
  height: 36px;
}
#create-form .alignment {
  min-height: 36px;
}
#create-form .gh-select {
  padding: 0px 15px;
  border-radius: 4px;
}
#create-form .gh-select:hover {
  cursor: pointer;
}
#create-form .gh-select.disabled {
  background: #eef0f4;
}
#create-form .gh-select.disabled:hover {
  cursor: initial;
}
#create-form .gh-select.disabled .gh-font-icon-arrow-down-small {
  display: none;
}
#create-form .gh-input-text,
#create-form .gh-select,
#create-form .selected-insight,
#create-form user-selector .tags {
  font-size: 15px;
}
#create-form user-selector .tags {
  padding-left: 7px;
}
#create-form user-selector .tags .input {
  margin: 0;
  padding-left: 0;
  font-size: inherit;
}
#create-form user-selector .tags .input::placeholder {
  color: #617294;
  opacity: 1;
  /* Firefox */
}
#create-form .required-fields {
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 160%;
  color: #445573;
}
#create-form .format-subtitles {
  font-weight: 400 !important;
  font-size: 14px;
  color: #021421;
}
#create-form .gh-f-large .gh-fg {
  border-bottom: 0;
  padding: 0;
}
#create-form .gh-f-large .gh-fg .row {
  margin-bottom: 17px;
}
#create-form .gh-f-large .gh-fg .row .section-name {
  font-weight: 400 !important;
  font-size: 14px;
  color: #021421;
  line-height: 36px;
}
#create-form .gh-f-large .gh-fg .gh-checkbox + label {
  color: #021421;
  font-size: 15px;
  font-weight: 400 !important;
}
#create-form .gh-siv-row .gh-siv-row-name {
  font-weight: 400 !important;
  font-size: 14px;
  color: #021421;
  padding-right: 10px;
}
#create-form .gh-siv-row .gh-siv-row-name:before {
  content: "";
}
#create-form .section-name.required:after,
#create-form .metric-title.required:after,
#create-form .gh-siv-row-name.required:after {
  content: "*";
  position: absolute;
}
#create-form .gh-fe {
  margin: 0;
}
#create-form .parent-goal .align span {
  color: #0057d7;
}
#create-form .parent-goal .align span:hover {
  border-bottom: none;
  color: #003a7b;
  cursor: pointer;
}
#create-form .mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 4;
}
#create-form .mask.limit {
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  padding: 100px 60px 0 60px;
  font-weight: 300;
  background: rgba(46, 67, 84, 0.8);
}
#create-form .current-session-wrapper {
  position: relative;
  padding: 1px;
}
#create-form .current-session-wrapper .dropdown-close-trigger {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
#create-form .current-session-wrapper .current-session {
  display: flex;
  padding: 2px;
  flex-direction: row;
  justify-content: flex-start;
  justify-items: center;
  margin: 1px;
  padding-right: 10px;
  padding-left: 10px;
  line-height: 24px;
  font-size: 14px;
  color: #0d232f;
}
#create-form .current-session-wrapper .current-session .gh-icon-wrapper {
  margin-right: 5px;
  vertical-align: middle;
}
#create-form .current-session-wrapper .current-session .current-session-color {
  display: inline-block;
  margin-right: 4px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  vertical-align: middle;
}
#create-form .current-session-wrapper .current-session .current-session-title {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  max-width: 350px;
}
#create-form .current-session-wrapper input {
  padding: 0px 10px;
  width: 100%;
  height: 100%;
  border: none;
}
#create-form .dropdown-menu-with-tooltip {
  width: calc(100% - 24px);
}
#create-form .dropdown-menu-sessions li {
  padding: 10px;
}
#create-form .dropdown-menu-sessions li:hover {
  background-color: #e5f2ff;
  cursor: pointer;
}
#create-form .dropdown-menu-sessions li.active {
  position: relative;
  background-color: #0057d7;
}
#create-form .dropdown-menu-sessions li.active .session-title {
  color: #fff;
}
#create-form user-selector.invalid .tags {
  border: 1px solid #da555d;
}
#create-form .critical-value-error {
  display: flex;
  justify-content: flex-end;
  margin-right: 25px;
}
#create-form div.insight-selector {
  padding-right: 25px;
}
#create-form .automation-section,
#create-form .description-section {
  margin-top: 17px;
}
#create-form .col-md-9.no-tooltip {
  width: calc(75% - 26px);
}
#session-form,
.goal-form {
  max-width: 660px;
  margin: 0 auto;
}
#session-form input::placeholder,
.goal-form input::placeholder,
#session-form textarea::placeholder,
.goal-form textarea::placeholder {
  letter-spacing: 0.02em;
  color: #96a1a9;
}
#session-form h2,
.goal-form h2 {
  font-size: 30px;
  font-weight: 300;
  margin-bottom: 5px;
}
#session-form h2 + p,
.goal-form h2 + p {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
#session-form .form-row,
.goal-form .form-row {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}
#session-form .form-row .input-lg,
.goal-form .form-row .input-lg {
  box-shadow: none;
  font-size: 14px;
  padding: 15px 15px;
}
#session-form .form-row .info,
.goal-form .form-row .info {
  font-size: 12px;
  line-height: 20px;
  color: #999;
  font-family: Arial, sans-serif;
  margin-top: 20px;
}
#session-form .reminder,
.goal-form .reminder {
  margin-top: 15px;
}
#session-form .reminder .calendar-holder,
.goal-form .reminder .calendar-holder {
  float: left;
  margin-right: 40px;
}
#session-form .reminder .calendar-holder h5,
.goal-form .reminder .calendar-holder h5 {
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 15px;
  text-align: center;
}
#session-form .reminder .asignee,
.goal-form .reminder .asignee {
  position: relative;
  padding-left: 45px;
  margin-top: 15px;
  height: 60px;
}
#session-form .reminder .asignee img,
.goal-form .reminder .asignee img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  position: absolute;
  left: 0;
  top: 0;
}
#session-form .reminder .asignee h4,
.goal-form .reminder .asignee h4 {
  font-weight: 300;
  font-size: 16px;
}
#session-form .reminder .asignee h5,
.goal-form .reminder .asignee h5 {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 5px;
}
#session-form .gh-f-large .gh-f-title-medium,
.goal-form .gh-f-large .gh-f-title-medium {
  margin-bottom: 15px;
}
#session-form .gh-f-large .gh-f-description p,
.goal-form .gh-f-large .gh-f-description p {
  margin: 0 0 5px 0;
}
#session-form .gh-f-large .gh-f-description p:first-child,
.goal-form .gh-f-large .gh-f-description p:first-child {
  margin-top: 0px;
}
#session-form .gh-f-large .gh-f-description p:last-child,
.goal-form .gh-f-large .gh-f-description p:last-child {
  margin-bottom: 0px;
}
#session-form .gh-f-large .gh-f-description p a,
.goal-form .gh-f-large .gh-f-description p a {
  color: #3d6eb6;
}
#session-form .gh-f-large .gh-f-description p a:hover,
.goal-form .gh-f-large .gh-f-description p a:hover {
  text-decoration: none;
  color: #50ace5;
}
#session-form .gh-f-large .gh-fg,
.goal-form .gh-f-large .gh-fg {
  padding: 20px 0px 0px 0px;
  border: 0;
}
#session-form .gh-f-large .gh-fg .row,
.goal-form .gh-f-large .gh-fg .row {
  margin-bottom: 20px;
}
#session-form .gh-f-large .gh-fg .row .tooltip,
.goal-form .gh-f-large .gh-fg .row .tooltip {
  width: 200px;
  white-space: normal;
}
#session-form .gh-f-large .gh-fg .row .gh-input-text,
.goal-form .gh-f-large .gh-fg .row .gh-input-text {
  min-width: 150px;
}
#session-form .gh-f-large .gh-fg .row .section-name,
.goal-form .gh-f-large .gh-fg .row .section-name {
  font-size: 1.2em;
  top: 10px;
}
#session-form .gh-f-large .gh-fg .row .section-name.required:before,
.goal-form .gh-f-large .gh-fg .row .section-name.required:before,
#session-form .gh-f-large .gh-fg .row .metric-title.required:before,
.goal-form .gh-f-large .gh-fg .row .metric-title.required:before {
  position: absolute;
  left: -20px;
  top: -4px;
  font-size: 25px;
  content: "*";
  color: #0052cc;
}
#session-form .gh-f-large .gh-fg .row .critical-slider,
.goal-form .gh-f-large .gh-fg .row .critical-slider {
  padding-right: 40px;
}
#session-form .gh-f-large .gh-fg .row .metric-deadline .gh-select .gh-select-toggle,
.goal-form .gh-f-large .gh-fg .row .metric-deadline .gh-select .gh-select-toggle,
#session-form .gh-f-large .gh-fg .row .metric-type .gh-select .gh-select-toggle,
.goal-form .gh-f-large .gh-fg .row .metric-type .gh-select .gh-select-toggle,
#session-form .gh-f-large .gh-fg .row .metric-format .gh-select .gh-select-toggle,
.goal-form .gh-f-large .gh-fg .row .metric-format .gh-select .gh-select-toggle {
  min-height: 40px;
}
#session-form .gh-f-large .gh-fg .row .metric-deadline .gh-select .gh-select-toggle::before,
.goal-form .gh-f-large .gh-fg .row .metric-deadline .gh-select .gh-select-toggle::before,
#session-form .gh-f-large .gh-fg .row .metric-type .gh-select .gh-select-toggle::before,
.goal-form .gh-f-large .gh-fg .row .metric-type .gh-select .gh-select-toggle::before,
#session-form .gh-f-large .gh-fg .row .metric-format .gh-select .gh-select-toggle::before,
.goal-form .gh-f-large .gh-fg .row .metric-format .gh-select .gh-select-toggle::before {
  top: 15px;
  color: #c0c7cb;
}
#session-form .gh-f-large .gh-fg .row .metric-format .gh-select .dropdown-menu ul li:last-child,
.goal-form .gh-f-large .gh-fg .row .metric-format .gh-select .dropdown-menu ul li:last-child {
  border-top: 1px solid #eee;
}
#session-form .gh-f-large .gh-fg .metric-title .gh-input-text::placeholder,
.goal-form .gh-f-large .gh-fg .metric-title .gh-input-text::placeholder {
  font-size: 1em;
}
#session-form .gh-f-large .gh-fg .gh-fe,
.goal-form .gh-f-large .gh-fg .gh-fe {
  text-align: right;
}
#session-form .gh-f-large .dropdown-menu ul li,
.goal-form .gh-f-large .dropdown-menu ul li {
  padding: 10px 15px;
  border: none;
  line-height: 1.4em;
}
#session-form .gh-f-large .dropdown-menu ul li.deadline-option,
.goal-form .gh-f-large .dropdown-menu ul li.deadline-option {
  border-bottom: 1px solid #eee;
}
#session-form .gh-f-large .dropdown-menu ul li.deadline-option:last-child,
.goal-form .gh-f-large .dropdown-menu ul li.deadline-option:last-child {
  border: none;
}
#session-form .gh-f-large .dropdown-menu ul li.deadline-option .option-title,
.goal-form .gh-f-large .dropdown-menu ul li.deadline-option .option-title {
  padding-bottom: 5px;
  font-size: 1.1em;
}
#session-form .gh-selected-artefact,
.goal-form .gh-selected-artefact {
  font-size: 16px;
}
#session-form .warning-msg-cascaded-kr,
.goal-form .warning-msg-cascaded-kr {
  color: #4c667b;
  font-size: 0.95em;
  margin-left: 2px;
  margin-top: 4px;
}
.format-metric-container .title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: 0.005em;
  color: #0d232f;
  margin-bottom: 30px;
}
.format-metric-container .preview-format {
  word-break: break-all;
}
.format-metric-container .preview-container {
  padding-bottom: 40px;
  text-align: center;
}
.format-metric-container .preview-container .description {
  padding-bottom: 15px;
  font-size: 1em;
  color: #445573;
}
.format-metric-container .insert-format-container .insert-text-unit {
  padding-bottom: 20px;
}
.format-metric-container .insert-format-container .insert-text-unit input::placeholder {
  letter-spacing: 0.02em;
  color: #96a1a9;
}
.format-metric-container .insert-format-container .gh-select .gh-select-toggle {
  height: 40px;
  font-size: 1.1em;
}
.format-metric-container .insert-format-container .gh-select .gh-select-toggle .current-selection {
  line-height: 23px;
}
.format-metric-container .insert-format-container .gh-select .gh-select-toggle::before {
  top: 15px;
  color: #2e4354;
}
.format-metric-container .insert-format-container .gh-select .dropdown-menu {
  width: 100%;
}
.format-metric-container .insert-format-container .gh-select .dropdown-menu ul li {
  padding: 12px 20px;
  border: none;
  line-height: 1.4em;
}
.format-metric-container .insert-format-container .gh-fa {
  position: relative;
  display: flex;
  justify-content: flex-start;
}
.format-metric-container .gh-radio-list-border .item {
  padding: 9px 35px 9px 20px;
}
.format-metric-container .gh-radio-list-border .item.checked .title {
  font-weight: normal;
  margin-bottom: 10px;
}
.format-metric-container .gh-radio-list-border .item .title {
  font-weight: normal;
  margin-bottom: 10px;
}
.format-metric-container .gh-radio-list-border .item .radio {
  top: 10px;
  left: 2px;
}
@media screen and (max-width: 980px) {
  #create-form .gh-f-large .gh-fg .row .section-name,
  .goal-form .gh-f-large .gh-fg .row .section-name {
    top: -5px;
  }
  .modal.large .modal-dialog {
    max-width: 95%;
  }
}
.form-help-popover {
  z-index: 1500;
}
#update-metric .ui-toggle-wrapper {
  margin-top: 10px;
}
#update-metric .ui-toggle-wrapper .slider-label {
  font-size: 14px;
  color: #445573;
}
#update-metric .ui-toggle-wrapper.true .toggle-label-right {
  color: #021421;
  font-weight: bold;
}
#update-metric .ui-toggle-wrapper.false .toggle-label-left {
  color: #021421;
  font-weight: bold;
}
.send-for-approval {
  margin: 10px 20px;
}
.send-for-approval .gh-two-column .gh-content-col.multiple-users .users-list.invalid .gh-fe {
  margin-top: 40px;
}
.send-for-approval .gh-two-column .gh-content-col.multiple-users .users-list.invalid .users-wrapper {
  margin-top: 20px;
  border: 2px solid #ff5f5f;
}
.send-for-approval .users-wrapper {
  position: relative;
  cursor: pointer;
}
.send-for-approval .users-wrapper:hover {
  background: #eee;
}
.send-for-approval .users-wrapper .users-selector-wrapper {
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
}
.send-for-approval .users-wrapper .users-selector-wrapper .select-users {
  height: 100%;
}
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.noUi-target {
  position: relative;
}
.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}
/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}
.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}
/* Offset direction
 */
.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}
/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  top: -100%;
  width: 0;
}
.noUi-horizontal .noUi-origin {
  height: 0;
}
.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}
.noUi-touch-area {
  height: 100%;
  width: 100%;
}
.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  -webkit-transition: transform 0.3s;
  transition: transform 0.3s;
}
.noUi-state-drag * {
  cursor: inherit !important;
}
/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 18px;
}
.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  right: -17px;
  top: -6px;
}
.noUi-vertical {
  width: 18px;
}
.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  right: -6px;
  bottom: -17px;
}
.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}
/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
}
.noUi-connects {
  border-radius: 3px;
}
.noUi-connect {
  background: #3FB8AF;
}
/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}
.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}
.noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}
.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}
/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #E8E7E6;
  left: 14px;
  top: 6px;
}
.noUi-handle:after {
  left: 17px;
}
.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}
.noUi-vertical .noUi-handle:after {
  top: 17px;
}
/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}
[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}
/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.noUi-pips {
  position: absolute;
  color: #999;
}
/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}
.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}
/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}
.noUi-marker-sub {
  background: #AAA;
}
.noUi-marker-large {
  background: #AAA;
}
/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}
.noUi-value-horizontal {
  -webkit-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
}
.noUi-rtl .noUi-value-horizontal {
  -webkit-transform: translate(50%, 50%);
  transform: translate(50%, 50%);
}
.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}
.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}
.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}
/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}
.noUi-value-vertical {
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  padding-left: 25px;
}
.noUi-rtl .noUi-value-vertical {
  -webkit-transform: translate(0, 50%);
  transform: translate(0, 50%);
}
.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}
.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}
.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}
.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}
.noUi-horizontal .noUi-tooltip {
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}
.noUi-vertical .noUi-tooltip {
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}
.noUi-horizontal .noUi-origin > .noUi-tooltip {
  -webkit-transform: translate(50%, 0);
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}
.noUi-vertical .noUi-origin > .noUi-tooltip {
  -webkit-transform: translate(0, -18px);
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}
#kr-update-box > form .gh-box-section > span {
  color: #96a1a9;
}
#kr-update-box > form .gh-fg-description {
  margin-right: 90px;
}
#kr-update-box > form .gh-border-top-0 {
  border-top: 0;
}
#kr-update-box > form .gh-siv-row-name {
  width: 40%;
  color: #2e4354;
}
#kr-update-box > form .cf-dropdown .dropdown-menu {
  max-height: 200px;
  max-width: 420px;
  overflow-y: scroll;
}
#kr-update-box > form .cf-dropdown .dropdown-menu li .cf-dropdown-btn {
  max-width: 100%;
}
#kr-update-box > form .cf-dropdown .dropdown-menu li .cf-dropdown-btn span {
  overflow-x: hidden;
  text-overflow: ellipsis;
}
#kr-update-box > form #slider.noUi-target {
  border-radius: unset;
  border: unset;
  box-shadow: unset;
  height: 4px;
  margin: 0 10px;
  margin-top: 2em;
  background: #eef0f4;
}
#kr-update-box > form #slider .noUi-handle {
  width: 26px;
  height: 26px;
  top: -12px;
  border: 4px solid #87a6bc;
  border-radius: 50%;
}
#kr-update-box > form #slider .noUi-handle.noUi-active {
  cursor: pointer;
  border: 13px solid #87a6bc;
}
#kr-update-box > form #slider .noUi-handle:hover {
  cursor: pointer;
  border: 13px solid #87a6bc;
}
#kr-update-box > form #slider .noUi-handle::before,
#kr-update-box > form #slider .noUi-handle::after {
  display: none;
}
.single-goal-selector-modal .modal-dialog {
  width: 1000px;
}
.single-goal-selector-modal .modal-dialog .modal-content {
  padding: 40px 47px;
}
#single-goal-selector .gh-modal-header {
  padding: 30px 40px 0px 40px;
  background: #fff;
}
#single-goal-selector .gh-modal-header .gh-modal-title {
  font-size: 1.5em;
}
#single-goal-selector .gh-modal-header .gh-modal-close-button.selector-close-btn {
  right: 30px;
  font-size: 28px;
}
#single-goal-selector .gh-modal-search {
  display: flex;
  align-items: center;
  height: 45px;
  margin-bottom: 25px;
  border-radius: 4px;
  border: 1px solid #3299ff;
}
#single-goal-selector .gh-modal-search .icon {
  font-size: 18px;
  margin: 0 13px;
  opacity: 0.8;
}
#single-goal-selector .gh-modal-search .search-text {
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  border: none;
  opacity: 0.7;
  margin-right: 5px;
}
#single-goal-selector .gh-modal-search .search-text:focus {
  outline: none;
}
#single-goal-selector .gh-modal-search .search-text:valid {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}
#single-goal-selector .gh-modal-search .gh-dropdown-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid #c6d5e1;
  margin-right: 10px;
}
#single-goal-selector .gh-modal-search .gh-dropdown-wrapper .dropdown-toggle {
  padding: 3px 7px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  color: #7989a0;
}
#single-goal-selector .gh-modal-search .gh-dropdown-wrapper .dropdown-toggle:hover {
  background: none;
  color: #2e4354;
}
#single-goal-selector .gh-modal-search .gh-dropdown-wrapper .dropdown-toggle .icon {
  margin: 0;
  font-size: 8px;
  position: relative;
  top: 1px;
  left: 3px;
}
#single-goal-selector .gh-modal-search .gh-dropdown-wrapper .dropdown-menu {
  min-width: 115px;
}
#single-goal-selector .gh-sessions .section .section-title {
  font-size: 13px;
  font-weight: 500;
  color: #7989a0;
  text-transform: uppercase;
}
#single-goal-selector .gh-sessions .section .gh-session {
  border-bottom: none;
  min-height: 35px;
  padding: 0px;
}
#single-goal-selector .gh-sessions .section .gh-session.margin-top {
  margin-top: 5px;
}
#single-goal-selector .gh-sessions .section .gh-session.border-top {
  border-top: 1px solid #eef0f4;
}
#single-goal-selector .gh-sessions .section .gh-session:hover {
  background: none;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session {
  min-height: 48px;
  border: 1px solid #fff;
  border-bottom: 1px solid #eef0f4;
  padding: 4px;
  gap: 12px;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session .gh-icon-wrapper {
  position: initial;
  width: 16px;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session .gh-session-title {
  font-weight: 500;
  width: 250px;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session .gh-session-range {
  max-width: 300px;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session .gh-icon {
  position: sticky;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session .select-btn {
  visibility: hidden;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):hover,
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):active,
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):focus {
  border: 1px solid #b1daff;
  border-radius: 4px;
  background: #f0fcff;
}
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):hover .select-btn,
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):active .select-btn,
#single-goal-selector .gh-sessions .section .gh-session .session-wrapper .session:not(.inactive):focus .select-btn {
  visibility: visible;
}
#single-goal-selector .gh-sessions .section .gh-goal {
  min-height: 48px;
  border: 1px solid #fff;
  border-bottom: 1px solid #eef0f4;
  padding: 4px;
  gap: 12px;
  position: relative;
}
#single-goal-selector .gh-sessions .section .gh-goal .toggler {
  position: absolute;
  left: -20px;
  cursor: pointer;
  top: 15px;
  font-size: 10px;
  color: #0052cc;
}
#single-goal-selector .gh-sessions .section .gh-goal .toggler.minus {
  color: #9aa3a9;
}
#single-goal-selector .gh-sessions .section .gh-goal .toggler:hover {
  opacity: 0.6;
}
#single-goal-selector .gh-sessions .section .gh-goal.margin-top {
  margin-top: 5px;
}
#single-goal-selector .gh-sessions .section .gh-goal.border-top {
  border-top: 1px solid #eef0f4;
}
#single-goal-selector .gh-sessions .section .gh-goal.unselectable {
  background: #effdf9;
  border: 1px solid #8fe7d2;
}
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:hover,
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:active,
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:focus {
  cursor: not-allowed;
  background: #effdf9;
  border: 1px solid #8fe7d2;
}
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:hover .select,
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:active .select,
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:focus .select {
  display: none;
}
#single-goal-selector .gh-sessions .section .gh-goal.unselectable:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  position: absolute;
  top: 14px;
  right: 15px;
  height: 15px;
  width: 20px;
}
#single-goal-selector .gh-sessions .section .gh-goal .select-btn {
  visibility: hidden;
}
#single-goal-selector .gh-sessions .section .gh-goal:hover,
#single-goal-selector .gh-sessions .section .gh-goal:active,
#single-goal-selector .gh-sessions .section .gh-goal:focus {
  border: 1px solid #b1daff;
  border-radius: 4px;
  background: #f0fcff;
}
#single-goal-selector .gh-sessions .section .gh-goal:hover .select-btn,
#single-goal-selector .gh-sessions .section .gh-goal:active .select-btn,
#single-goal-selector .gh-sessions .section .gh-goal:focus .select-btn {
  cursor: pointer;
  visibility: visible;
}
#single-goal-selector .gh-sessions .section .gh-goal .gh-goal-title {
  font-weight: 500;
  width: 300px;
}
#single-goal-selector .gh-sessions .section .gh-goal .gh-goal-session {
  color: #9aa3a9;
  font-size: 13px;
  width: 150px;
}
#single-goal-selector .gh-sessions .section .gh-goal .gh-badge.open {
  margin-right: 0px;
  margin-left: 5px;
}
#single-goal-selector .gh-empty-row .icon {
  top: 0;
}
.modal.move-okr .modal-content {
  padding: 38px 50px;
}
#move-objective .clone-p {
  padding: 9px 10px;
}
#move-objective .grey-border {
  border: 1px solid #c0cbdd;
  box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);
  border-radius: 4px;
}
#move-objective .title {
  font-size: 30px;
  color: #0d232f;
  font-weight: 700 !important;
}
#move-objective .gh-font-icon-help {
  color: #7485a2;
}
.gh-selected-artefact {
  padding: 10px 40px 10px 50px;
  position: relative;
  border: 2px solid #eef0f4;
  border-radius: 4px;
}
.gh-selected-artefact .remove {
  position: absolute;
  right: 15px;
  top: 20px;
  color: #9aa3a9;
  cursor: pointer;
}
.gh-selected-artefact .remove:hover {
  color: #ff5f5f;
}
.gh-selected-artefact .gh-icon {
  position: absolute;
  left: 15px;
  top: 15px;
}
.gh-selected-artefact .title {
  font-size: 1.1em;
  word-break: break-word;
}
.gh-selected-artefact .subtitle {
  font-size: 0.9em;
  color: #9aa3a9;
}
#create-form .alignment .gh-selected-artefact .gh-icon-wrapper .gh-icon {
  top: 0;
  display: flex;
  align-items: center;
  height: 100%;
}
#create-form .alignment .gh-selected-artefact .gh-icon-wrapper .gh-icon:before {
  position: static;
}
#create-form .alignment .gh-selected-artefact .remove {
  top: 0;
  margin: 0;
  height: 100%;
}
.fixed-width-task-status {
  width: 140px;
  text-align: right;
}
.grid-expanded .grid {
  position: absolute;
  min-width: 100%;
  border: 0;
  bottom: 0;
  top: 89px;
  padding-bottom: 0;
}
.grid-expanded .grid.bulk-delete-warning-banner-displayed {
  top: 165px;
}
.grid-expanded .grid.pb-75 {
  padding-bottom: 75px;
}
.container-fluid .grid-expanded {
  margin-left: 0;
  margin-right: 0;
}
.checkmark {
  text-align: center;
  background: #1cb987;
  border-radius: 100px;
  width: 70px;
  height: 70px;
  margin: 20px 0 10px 42%;
}
.checkmark .nc-icon-outline {
  margin-top: 13px;
  color: #fff;
  font-size: 50px;
}
@keyframes celebration {
  0% {
    background-position: 0 -150px;
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    background-position: 0 0px;
    opacity: 0;
  }
}
@keyframes celebration2 {
  0% {
    background-position: 0 -200px;
    opacity: 0;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    background-position: 0 -100px;
    opacity: 0;
  }
}
@keyframes celebration3 {
  0% {
    box-shadow: 0 0 0 #98efd4;
  }
  50% {
    box-shadow: 0 0 20px #56e5b8;
  }
  0% {
    box-shadow: 0 0 0 #98efd4;
  }
}
#tasks-kanban {
  position: fixed;
  left: 260px;
  right: 40px;
  top: 100px;
  bottom: 0;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  -webkit-font-smoothing: antialiased;
}
#tasks-kanban .content-wrapper {
  position: absolute;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
}
#tasks-kanban .dndPlaceholder {
  width: 100%;
  height: 60px;
  background: #e2e5ec;
  border: 1px dashed #d5dae4;
}
#tasks-kanban .dndDraggingSource {
  opacity: 0.5;
}
#tasks-kanban .tasks-column {
  margin-right: 30px;
  padding: 0px 40px 40px;
  flex: 1 1;
  background: #fafbfc;
  border-radius: 4px;
}
#tasks-kanban .tasks-column:last-of-type {
  margin-right: 0;
}
#tasks-kanban .tasks-column ul {
  min-height: calc(100% - 60px);
}
#tasks-kanban .tasks-column ul.dndDragover {
  background: #f1f3f6;
}
#tasks-kanban .tasks-column .column-title {
  position: relative;
  position: sticky;
  top: 0;
  left: 0;
  height: 60px;
  margin: 0 -10px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  background: #fafbfc;
  z-index: 1;
  font-weight: 500;
  color: #2e4354;
}
#tasks-kanban .tasks-column .column-title .newtask {
  position: absolute;
  right: 0;
  top: 0;
}
#tasks-kanban .tasks-column .column-title:before {
  content: "";
  height: 3px;
  width: 20px;
  margin-right: 10px;
  background: #87a6bc;
}
#tasks-kanban .tasks-column .column-title .count {
  margin-left: 10px;
  color: #87a6bc;
  font-weight: 400;
}
#tasks-kanban .tasks-column .column-title.inprogress:before {
  background: #0052cc;
}
#tasks-kanban .tasks-column .column-title.done:before {
  background: #1cb987;
}
#tasks-kanban .task {
  margin-bottom: 10px;
  padding: 15px;
  width: 100%;
  border-radius: 5px;
  position: relative;
  box-shadow: 0 3px 10px rgba(46, 67, 84, 0.05);
  background: #fff;
  border: 1px solid #eef0f4;
  display: flex;
  flex-direction: column;
}
#tasks-kanban .task.celebration {
  animation-name: celebration3;
  animation-duration: 1s;
}
#tasks-kanban .task.celebration:before {
  position: absolute;
  width: 100%;
  height: 100%;
  background: red;
  content: "";
  top: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 0 0;
  background-size: cover;
  animation-name: celebration;
  animation-duration: 1s;
}
#tasks-kanban .task.celebration:after {
  position: absolute;
  width: 100%;
  height: 100%;
  background: red;
  content: "";
  top: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 0 0;
  background-size: cover;
  animation-name: celebration2;
  animation-duration: 3s;
}
#tasks-kanban .task dropdown-actions-menu {
  position: absolute;
  right: 15px;
  top: 15px;
}
#tasks-kanban .task .gh-icon-task {
  position: absolute;
  left: 15px;
  top: 17px;
}
#tasks-kanban .task .task-assignee {
  color: #9aa3a9;
  position: relative;
  display: inline-block;
  margin: 10px 0;
}
#tasks-kanban .task .task-name {
  min-height: 20px;
  margin-bottom: 5px;
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 500;
}
#tasks-kanban .task .task-name a {
  color: #2e4354;
}
#tasks-kanban .task .task-name a:hover {
  color: #0052cc;
}
#tasks-kanban .task .task-description {
  color: #9aa3a9;
  font-size: 13px;
  margin-top: 5px;
  padding-left: 30px;
}
#tasks-kanban .task .task-goal {
  padding-top: 8px;
  border-top: 1px solid #eef0f4;
  position: relative;
  padding-left: 30px;
  margin-top: 8px;
  font-size: 0.9em;
}
#tasks-kanban .task .task-goal .gh-icon {
  position: absolute;
  left: 0;
  top: 8px;
}
#tasks-kanban .task .task-goal a {
  color: #9aa3a9;
}
#tasks-kanban .task .task-goal a:hover {
  color: #0052cc;
}
#tasks-kanban .date:hover {
  cursor: pointer;
}
#tasks-kanban .grey {
  color: #2f4454;
  opacity: 0.64;
  font-size: 13px;
}
#tasks-kanban .green {
  color: #65c59b;
  font-size: 13px;
}
#tasks-kanban .red {
  color: #c57e65;
  font-size: 13px;
}
#tasks-kanban .gh-typeahead .uib-typeahead-match {
  padding-left: 5px;
}
#tasks-kanban .gh-typeahead .uib-typeahead-match.active {
  background: #f5f5fb;
  cursor: pointer;
}
#tasks-list {
  position: fixed;
  left: 260px;
  right: 40px;
  top: 100px;
  bottom: 80px;
  overflow: auto;
}
#tasks-list.sidebar-collapsed {
  left: 100px;
}
#tasks-list #task-grid {
  margin-bottom: 0;
}
#tasks-list #task-grid .gh-row.task-skeleton-row .gh-row-columns .gh-cell {
  padding: 10px 20px 10px 6px;
  background: rgba(227, 232, 242, 0.5);
  background-clip: content-box;
}
#tasks-list #task-grid .gh-row.gh-row-header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  background: #fff;
  border-bottom: 1px solid #f2f4f6;
}
#tasks-list #task-grid .gh-row .gh-row-actions {
  display: inline-flex;
  top: 9px;
}
#tasks-list #task-grid .gh-cell {
  cursor: pointer;
}
#tasks-list #task-grid .gh-cell:nth-child(1) {
  width: 24%;
}
#tasks-list #task-grid .gh-cell:nth-child(2) {
  width: 10%;
}
#tasks-list #task-grid .gh-cell:nth-child(3) {
  width: 10%;
}
#tasks-list #task-grid .gh-cell:nth-child(4) {
  width: 23%;
}
#tasks-list #task-grid .gh-cell:nth-child(5) {
  width: 12%;
}
#tasks-list #task-grid .gh-cell:nth-child(6) {
  flex: 1;
  overflow: hidden;
}
#tasks-list #task-grid .gh-cell:nth-child(7) {
  width: 40px;
}
#tasks-list #task-grid .gh-cell .gh-select-toggle {
  border: none;
  padding: 0;
  font-size: 14px;
  display: block;
}
#tasks-list #task-grid .gh-cell .gh-select-toggle img.system-logo {
  opacity: 0;
  width: 20px;
}
#tasks-list #task-grid .gh-cell .gh-select-toggle:hover .system-logo {
  opacity: 1;
}
#tasks-list #task-grid .gh-cell .gh-select-toggle:before {
  content: none;
}
#tasks-list #task-grid .gh-cell .grey {
  color: #2f4454;
  opacity: 0.64;
}
#tasks-list #task-grid .gh-cell .grey:hover .remove {
  opacity: 1;
}
#tasks-list #task-grid .gh-cell .grey .remove {
  background: #2f4454;
}
#tasks-list #task-grid .gh-cell .green {
  color: #65c59b;
}
#tasks-list #task-grid .gh-cell .green:hover .remove {
  opacity: 1;
}
#tasks-list #task-grid .gh-cell .red {
  color: #c57e65;
}
#tasks-list #task-grid .gh-cell .red:hover .remove {
  opacity: 1;
}
#tasks-list #task-grid .gh-cell .red .remove {
  background: #c57e65;
}
#tasks-list #task-grid .gh-cell .remove {
  float: right;
  width: 12px;
  min-width: 12px;
  height: 12px;
  min-height: 12px;
  background: #65c59b;
  border-radius: 30px;
  margin-top: 13px;
  color: #fff;
  line-height: 8px;
  text-align: center;
  position: relative;
  opacity: 0;
  transform: rotate(45deg);
}
#tasks-list #task-grid .gh-cell .remove.red {
  background: #c57e65;
}
#tasks-list #task-grid .gh-cell .remove:after {
  content: "";
  position: absolute;
  left: 1px;
  top: 1px;
  width: 12px;
  height: 12px;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(#ffffff, #ffffff);
  background-size: 8px 2px, 2px 8px;
  background-position: 1px 4px, 4px 1px;
  background-repeat: no-repeat;
}
#tasks-list #task-grid .gh-cell .dropdown.calendar {
  width: 255px;
  z-index: 1;
  border: 1px solid #eef0f4;
}
#tasks-list #task-grid .gh-cell.with-icon.task-parent-okr {
  padding-right: 40px;
  display: flex;
}
#tasks-list #task-grid .gh-cell.with-icon.task-parent-okr .grid-icon {
  height: 20px;
  line-height: 20px;
  top: 9px;
}
#tasks-list #task-grid .gh-cell.with-icon.task-parent-okr .clip-text {
  padding-left: 5px;
}
#tasks-list #task-grid .gh-cell.with-icon.task-parent-okr:hover .remove {
  opacity: 0.64;
}
#tasks-list #task-grid .gh-cell.with-icon.task-parent-okr .remove {
  background: #2f4454;
}
#tasks-list #task-grid .gh-cell.with-icon .open [class^="gh-font-icon-"],
#tasks-list #task-grid .gh-cell.with-icon .open [class*=" gh-font-icon-"] {
  font-size: 0.9em;
}
#tasks-list #task-grid .gh-cell.overflow-visible {
  overflow: visible;
}
#tasks-list #task-grid .grid-input .users-input-container .host .tags {
  display: flex;
  overflow: clip;
}
@media all and (max-width: 1280px) {
  #tasks-list #task-grid .gh-cell:nth-child(1) {
    width: 30%;
  }
  #tasks-list #task-grid .gh-cell:nth-child(2) {
    width: 10%;
  }
  #tasks-list #task-grid .gh-cell:nth-child(3) {
    width: 10%;
  }
  #tasks-list #task-grid .gh-cell:nth-child(4) {
    width: 25%;
  }
  #tasks-list #task-grid .gh-cell:nth-child(5) {
    display: none;
  }
}
#tasks-list .dropdown-menu {
  will-change: filter;
}
#tasks-list .date-text {
  display: inline-block;
  width: 100%;
}
#tasks-list .date-text .remove {
  display: inline-block;
}
#tasks-list user-selector tags-input.users-input-container .autocomplete {
  min-width: 200px;
}
#tasks-list .f-c-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#tasks-list .f-c-sb span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#tasks-kanban.with-demo,
#tasks-list.with-demo {
  top: 150px;
}
#tasks-kanban.with-banner,
#tasks-list.with-banner {
  top: 170px;
}
#tasks-kanban .gh-row .gh-cell .clip-text .deleted-user,
#tasks-list .gh-row .gh-cell .clip-text .deleted-user {
  font-size: 90%;
}
#tasks-list #task-grid .gh-row.gh-row-header .create-task-inline .gh-font-icon-plus,
#tasks-kanban .column-title.todo .gh-font-icon-plus {
  margin-right: 7px;
  color: #616e7a;
}
#tasks-list #task-grid .gh-row.gh-row-header .create-task-inline .gh-font-icon-plus.color-black,
#tasks-kanban .column-title.todo .gh-font-icon-plus.color-black {
  color: #000000;
}
#tasks-list #task-grid .gh-row.gh-row-header .create-task-inline .gh-font-icon-plus.mr-28,
#tasks-kanban .column-title.todo .gh-font-icon-plus.mr-28 {
  margin-right: 28px;
}
#tasks-list #task-grid .gh-row.gh-row-header .create-task-inline .gh-font-icon-plus:hover,
#tasks-kanban .column-title.todo .gh-font-icon-plus:hover {
  color: #0457d7 !important;
  background: rgba(10, 119, 227, 0.1);
  border-radius: 3px;
}
.task-form-modal.modal.sidebar-modal .modal-dialog {
  min-width: 550px;
  width: 550px;
}
#single-task-view .pointer-events-none {
  pointer-events: none;
}
#single-task-view .gh-siv-row-name {
  width: 34%;
  margin-top: 10px;
}
#single-task-view .gh-siv-editable-markdown {
  margin: 0;
}
#single-task-view .gh-siv-editable-markdown .gh-siv-editable-markdown-preview {
  padding: 8px;
  color: #2f4454;
  opacity: 0.64;
}
#single-task-view .display-none {
  display: none;
}
#single-task-view .no-update-permissions:hover {
  cursor: initial;
  opacity: 1;
}
#single-task-view .parent-goal .goal-wrapper {
  display: flex;
  flex-direction: row;
  justify-items: center;
  width: 100%;
}
#single-task-view .parent-goal .gh-icon-wrapper {
  vertical-align: top;
}
#single-task-view .parent-goal .goal-name {
  display: inline-block;
  width: auto;
  margin-left: 0px;
  margin-top: 1px;
  word-break: break-word;
}
#single-task-view .parent-goal .goal-name.internal {
  cursor: pointer;
}
#single-task-view .parent-goal .placeholder-text {
  margin-left: 10px;
}
#single-task-view .parent-goal .remove-field {
  position: absolute;
  top: 1px;
  right: 0;
}
#single-task-view input:not([type="checkbox"]) {
  border: none;
  width: 100%;
  outline: none;
}
#single-task-view input:not([type="checkbox"])::placeholder {
  color: #b5d3e6;
}
#single-task-view input:not([type="checkbox"]):-ms-input-placeholder {
  color: #b5d3e6;
}
#single-task-view input:not([type="checkbox"])::-ms-input-placeholder {
  color: #b5d3e6;
}
#single-task-view .external-system {
  display: flex;
  align-items: center;
  gap: 5px;
}
#single-task-view .placeholder-text {
  width: 100%;
  color: #dfe2ea;
}
#single-task-view .remove-field {
  height: 14px;
  width: 14px;
  margin-right: 5px;
  font-size: 13px;
  color: #96a1a9;
  cursor: pointer;
}
#single-task-view .remove-field:hover {
  color: #7a8892;
  font-weight: 900;
}
#single-task-view .inline-remove {
  position: absolute;
  display: none;
  top: 50%;
  right: 10px;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  background: #96a1a9;
  border-radius: 30px;
  color: #fff;
  text-align: center;
  z-index: 4;
  cursor: pointer;
}
#single-task-view .inline-remove:after {
  content: "\\eaa3";
  line-height: 6px;
  color: #fff;
  font: normal normal 15px/1 "Nucleo Mini";
  position: absolute;
  left: -2px;
  top: -1px;
}
#single-task-view .inline-editable {
  position: relative;
}
#single-task-view .inline-editable:hover {
  background: #f0f8fd;
  opacity: 0.5;
}
#single-task-view .inline-editable:hover .inline-remove {
  display: block;
}
#single-task-view .inline-editable-no-hover {
  position: relative;
}
#single-task-view .multiline-non-editable {
  padding: 5px;
}
#single-task-view .multiline-editable {
  position: relative;
  border: 1px solid #fff;
  padding: 5px;
  word-break: break-word;
}
#single-task-view .multiline-editable:hover {
  outline: none;
  border: 1px solid #eef0f4;
}
#single-task-view .multiline-editable:hover .multiline-remove {
  display: block;
}
#single-task-view .title {
  font-size: 2em;
  font-weight: 500;
  outline: none;
  margin: 0px;
  padding: 5px;
  overflow-wrap: anywhere;
}
#single-task-view .with-border {
  border: 1px solid #eef0f4;
}
#single-task-view .with-background {
  background: #f4fafd;
}
#single-task-view .important {
  background-color: #ff5f5f;
}
#single-task-view .close-modal-btn {
  width: 20px;
  height: 20px;
  border: 1px solid #eef0f4;
  border-radius: 5px;
  background: none;
  font-size: 20px;
  color: #87a6bc;
  cursor: pointer;
}
#single-task-view .close-modal-btn:hover {
  border-color: #cfd5e0;
}
#single-task-view .task-title {
  position: relative;
  min-height: 40px;
  margin: 30px 0px;
  padding-left: 0px;
}
#single-task-view .task-title .gh-icon-wrapper {
  position: absolute;
  left: 0px;
  top: 5px;
}
#single-task-view .task-options-trigger {
  position: absolute;
  top: 40px;
  right: 40px;
}
#single-task-view .task-details .gh-box-section .section {
  margin: 10px 0;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .status {
  float: left;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container {
  float: right;
  margin-top: 3px;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .edit-due-date .select-toggle {
  position: relative;
  background: #f0f8fd;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .edit-due-date .dropdown-menu {
  min-width: unset;
  padding: 0px;
  top: 20px !important;
  left: -135px !important;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .system-logo {
  width: 20px;
  height: 20px;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container span.placeholder-text {
  padding-left: 5px;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .grey {
  color: #2f4454;
  opacity: 0.64;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .green {
  color: #65c59b;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .red {
  color: #c57e65;
}
#single-task-view .task-details .gh-box-section .section.status-and-due-date .gh-fg-content .due-date-container .remove-field {
  margin-left: 5px;
}
#single-task-view .task-details rich-text-editor {
  width: 100%;
  display: block;
  margin: 0;
}
#single-task-view .gh-box-section .section:last-child {
  border-bottom: none;
}
#single-task-view .gh-box-section .gh-fg {
  border-bottom: 0;
}
#single-task-view .gh-box-section .gh-box-section-header {
  font-weight: 400;
  color: #9aa3a9;
}
#single-task-view .gh-box-section .section {
  min-height: 40px;
}
#single-task-view .gh-box-section .section .gh-select-toggle {
  height: 30px;
  line-height: 30px;
  font-size: 1em;
}
#single-task-view .gh-box-section .section .gh-fg-title {
  display: inline-block;
  width: 34%;
  color: #51618a;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  vertical-align: top;
}
#single-task-view .gh-box-section .section .gh-fg-title.hover:hover {
  cursor: pointer;
}
#single-task-view .gh-box-section .section .gh-fg-content {
  position: relative;
  display: inline-block;
  width: 66%;
  min-height: 22px;
  vertical-align: top;
}
#single-task-view .gh-box-section .section .gh-fg-content.single-select .gh-input-select.gh-select-toggle {
  height: 32px;
  padding-top: 2px;
  padding-bottom: 2px;
}
#single-task-view .timeline-toggle {
  margin-left: 5px;
  vertical-align: bottom;
  font-size: 16px;
  color: #2e4354;
  cursor: pointer;
}
#single-task-view .timeline-toggle:hover {
  color: #7a8892;
  font-weight: 900;
}
#single-task-view .task-timeline .placeholder-text {
  padding-left: 6px;
}
#single-task-view .snapshot {
  padding: 5px 0 4px 0;
  border-top: 1px solid #eef0f4;
  position: relative;
}
#single-task-view .snapshot:first-child {
  border: none;
}
#single-task-view .snapshot .date {
  font-size: 0.8em;
  float: right;
  color: #9aa3a9;
}
#single-task-view .snapshot .status {
  padding: 3px 5px;
  background: #87a6bc;
  color: #fff;
  border-radius: 2px;
  font-size: 11px;
  font-weight: 700;
  margin-right: 5px;
}
#single-task-view .snapshot .status.inprogress {
  background: #0052cc;
}
#single-task-view .snapshot .status.done {
  background: #1cb987;
}
#single-task-view [contenteditable="true"]:empty:before {
  content: attr(data-placeholder);
  pointer-events: none;
  display: block;
  /* For Firefox */
  color: #b5d3e6;
}
.create-task-form .task-title input {
  height: 40px !important;
}
.create-task-form .task-owner tags-input {
  height: 40px;
}
.create-task-form .task-owner tags-input .tags {
  padding-top: 3px;
}
.create-task-form .task-owner tags-input .tags.focused input {
  padding-top: 6px;
}
.create-task-form .task-owner tags-input .tags .tag-list {
  max-width: 360px;
}
.create-task-form .task-status .dropdown {
  height: 40px;
}
.create-task-form .task-due-date .ant-picker-clear {
  right: 8px;
}
.create-task-form .task-linked-item parent-okr-selector tags-input.parent-input-container .host .tags .tag-list .tag-item {
  margin-top: 5px;
  margin-left: 5px;
}
.create-task-form .task-linked-item parent-okr-selector tags-input .tags input {
  height: 32px;
  max-width: 40px;
}
.create-task-form .task-linked-item parent-okr-selector tags-input .tags.focused input {
  max-width: 400px;
}
.create-task-form .task-linked-item parent-okr-selector tags-input.empty .tags input {
  max-width: 400px;
}
create-kanban-task-form form {
  margin: 10px 0;
  padding: 15px;
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(46, 67, 84, 0.05);
  background: #fff;
  border: 1px solid #eef0f4;
}
create-kanban-task-form form .gh-row {
  border-top: none;
  background: #fafbfc;
  margin: 10px 0;
}
create-kanban-task-form form .gh-row .gh-cell {
  width: 100%;
}
create-kanban-task-form form .gh-row .gh-cell .grid-icon {
  display: flex;
  align-items: center;
  height: 100%;
}
create-kanban-task-form form .gh-row .gh-cell .grid-icon .small:before {
  filter: grayscale();
}
create-kanban-task-form form .gh-row .gh-cell .grid-input {
  font-size: 17px;
}
create-kanban-task-form form .gh-row .gh-cell .grid-input.task-name {
  padding-left: 35px;
}
create-kanban-task-form form .gh-row .gh-cell .clip-text {
  padding-left: 5px;
  font-size: 17px;
}
create-kanban-task-form form .gh-row .gh-cell .clip-text.no-owner {
  color: #dfe2ea;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle {
  border: none;
  padding: 0;
  font-size: 14px;
  display: block;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle:before {
  content: none;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text {
  font-size: 17px;
  margin-left: 5px;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text .remove {
  position: absolute;
  top: 2px;
  right: -25px;
  font-size: 1.25em;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text .remove:hover .icon {
  font-weight: 900;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text .remove.grey {
  color: #2f4454;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text .remove.green {
  color: #65c59b;
}
create-kanban-task-form form .gh-row .gh-cell .gh-select-toggle .date-text .remove.red {
  color: #c57e65;
}
#hub-workflow .gh-workflow-session {
  margin: 30px 40px 30px 40px;
}
#hub-workflow .gh-workflow-session .header {
  position: relative;
  padding-left: 30px;
  -webkit-user-select: none;
  user-select: none;
}
#hub-workflow .gh-workflow-session .header .name {
  font-size: 1.1em;
  font-weight: 500;
  color: #000;
}
#hub-workflow .gh-workflow-session .header .gh-icon {
  position: absolute;
  left: 0;
  top: 0;
}
#hub-workflow .gh-workflow-session .gh-workflow-section {
  border-left: 3px solid #f9dfff;
  margin: 0 0 0 9px;
  padding: 15px 0 5px 30px;
}
#hub-workflow .gh-workflow-session .gh-workflow-section .workflow-section-title {
  font-weight: 700;
  font-size: 1.1em;
}
#hub-workflow .gh-workflow-session .gh-workflow-section .gh-badge {
  font-size: 10px;
  padding: 4px 5px 2px;
}
#hub-workflow .gh-workflow-session .gh-workflow-section .gh-dropdown {
  max-width: 100%;
}
#hub-workflow .gh-workflow-session .gh-workflow-section .gh-dropdown .toggle {
  font-size: 14px;
}
#hub-workflow .gh-workflow-session .gh-workflow-section .gh-dropdown .reviewer {
  position: relative;
  display: flex;
  align-items: center;
}
.status-icon-workflow {
  position: absolute;
  height: 9px;
  width: 9px;
  top: 15px;
  right: 0px;
  color: #fff;
  border-radius: 50%;
  font-size: 7px;
  padding-left: 1px;
}
.status-icon-workflow.approved {
  background: #18c191;
}
.status-icon-workflow.declined {
  background: #ffae49;
}
.status-icon-workflow.pending {
  background: #914de7;
}
.status-badge {
  display: inline-block;
}
.add-favorite,
.remove-favorite {
  padding: 8px 10px;
  max-height: 36px;
}
.add-favorite::before {
  font-family: "gh-font";
  content: "\\e938";
}
.add-favorite.goal-favorite::before {
  margin: 0 -2px 0 -5px;
}
.remove-favorite::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  vertical-align: middle;
}
.remove-favorite.goal-favorite::before {
  margin: 2px -2px 0 -6px;
}
.okr-suggestion-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.okr-suggestion-item::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  margin: 7px -3px 0 3px;
}
.popover.cf-popover {
  background-color: #283d5c;
  color: #fff;
  border-radius: 3px;
}
.popover.cf-popover > .arrow::after {
  border-right-color: #283d5c;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper {
  max-height: 300px;
  overflow-y: auto;
  position: relative;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper li:nth-child(3) {
  padding-top: 41px;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper .create-new-btn {
  text-decoration: none;
  border-bottom: 1px solid #e5e8ee;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  width: 65%;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper.scrollbar-styles::-webkit-scrollbar {
  width: 10px;
  height: 7px;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper.scrollbar-styles::-webkit-scrollbar-thumb {
  background-color: #96a1a9;
  border-radius: 20px;
}
#clone-sessions .dropdown-menu .session-dropdown-wrapper.scrollbar-styles::-webkit-scrollbar-track {
  background: none;
}
#clone-sessions .d-flex {
  display: flex;
  align-items: center;
}
#clone-sessions li .d-flex {
  padding: 7px 10px;
}
#clone-sessions .focused {
  background: #f1f3f8;
  cursor: pointer;
}
#clone-sessions li .d-flex:hover {
  background: #f1f3f8;
  cursor: pointer;
}
#clone-sessions .no-sessions {
  padding: 50px 25px 25px 0px;
  color: #9aa3a9;
  white-space: nowrap;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eef0f4;
}
#clone-sessions .no-sessions.icon {
  font-size: 30px;
  color: #eef0f4;
  margin-top: 20px;
}
#clone-sessions .disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
#clone-sessions .gh-title-small {
  font-size: 16px;
}
#clone-sessions .border-top {
  padding-top: 5px;
  border-top: 1px solid #e5e8ee;
}
#clone-sessions .data-clone-options .gh-checkbox-list.gh-checkbox-list-small {
  position: relative;
  margin: 4px 0px;
}
#clone-sessions .data-clone-options .gh-checkbox-list.gh-checkbox-list-small .item {
  font-size: 0;
  padding: 4px 0;
}
#clone-sessions .data-clone-options .gh-checkbox-list.gh-checkbox-list-small .gh-font-icon-help {
  color: #96a1a9;
  font-size: 16px;
  cursor: help;
  margin-left: 7px;
}
#clone-sessions .data-clone-options .gh-checkbox-list.gh-checkbox-list-small .title {
  font-size: 16px;
}
.goal-selector-node .goal {
  padding: 10px 0 10px 95px;
  border-bottom: 1px solid #eee;
  position: relative;
  font-size: 1.1em;
}
.goal-selector-node .goal:hover {
  background: #eef0f4;
}
.goal-selector-node .goal:hover .gh-b.gh-xs {
  display: block;
}
.goal-selector-node .goal:hover .goal-ui-button-display {
  display: block;
}
.goal-selector-node .goal:hover .goal-title-max-width {
  max-width: 550px;
}
.goal-selector-node .goal .gh-b.gh-xs {
  padding: 2px 5px;
  position: absolute;
  right: 10px;
  top: 8px;
  display: none;
}
.goal-selector-node .goal .gh-b.gh-xs.edit-conflict-item {
  display: block;
}
.goal-selector-node .goal .goal-ui-button-display {
  display: none;
}
.goal-selector-node .goal .goal-title-max-width {
  max-width: 635px;
}
.goal-selector-node .goal .current {
  opacity: 0.5;
}
.goal-selector-node .goal .toggler {
  position: absolute;
  left: 10px;
  cursor: pointer;
  top: 15px;
  font-size: 10px;
  color: #0052cc;
}
.goal-selector-node .goal .toggler.minus {
  color: #9aa3a9;
}
.goal-selector-node .goal .toggler:hover {
  opacity: 0.6;
}
.goal-selector-node .goal .gh-icon {
  position: absolute;
  left: 65px;
  top: 13px;
}
.goal-selector-node .child {
  padding-left: 20px;
}
#parent-child-session-selector {
  border-radius: 8px;
  float: left;
  width: 100%;
}
#parent-child-session-selector .session {
  float: left;
  width: 50%;
  padding: 15px;
  cursor: pointer;
  border-bottom: 3px solid #eef0f4;
}
#parent-child-session-selector .session:hover {
  border-bottom: 3px solid #cfd5e0;
}
#parent-child-session-selector .session.selected {
  border-bottom: 3px solid #1cb987;
}
#parent-child-session-selector .session .session-meta {
  color: #9aa3a9;
  display: inline;
}
#parent-child-session-selector .session .session-title {
  font-weight: 500;
  font-size: 1.1em;
}
#parent-child-session-selector .session .session-time {
  font-size: 0.9em;
  color: #9aa3a9;
}
#manage-sessions-gantt {
  position: relative;
  background: #fff;
  padding: 0 40px;
  margin-top: 60px;
}
#manage-sessions-gantt .toggle-archived-sessions {
  position: absolute;
  top: -40px;
  right: 40px;
}
#manage-sessions-gantt .session-level-holder .session.has-children {
  position: relative;
}
#manage-sessions-gantt .session {
  padding: 0 0 0 0;
  position: relative;
  background: #fff;
}
#manage-sessions-gantt .session.child .session-info {
  border-top: 0;
}
#manage-sessions-gantt .session.child .time {
  border-top: 0;
}
#manage-sessions-gantt .session dropdown-actions-menu {
  position: absolute;
  right: 10px;
  top: 12px;
}
#manage-sessions-gantt .session dropdown-actions-menu .gh-ui-actions-dd .toggle {
  color: #214c6b;
}
#manage-sessions-gantt .session .session-info {
  width: 450px;
  min-height: 68px;
  padding: 15px 0 15px 70px;
  position: relative;
  border-top: 1px solid #eef0f4;
}
#manage-sessions-gantt .session .session-info .session-icon {
  position: absolute;
  left: 12px;
  top: 15px;
}
#manage-sessions-gantt .session .session-info:hover {
  background: #eef0f4;
  border-right-color: #eef0f4;
}
#manage-sessions-gantt .session .session-info:hover + .time {
  background: #f4f5f8;
}
#manage-sessions-gantt .session .session-info.depth-1 a.title {
  font-weight: 600;
}
#manage-sessions-gantt .session a.title {
  color: #2e4354;
  font-size: 1em;
  cursor: pointer;
}
#manage-sessions-gantt .session a.title:hover {
  color: #0052cc;
}
#manage-sessions-gantt .session a.title .permission {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #ffbd5e;
  border-radius: 4px;
  margin-left: 4px;
  position: relative;
  top: -3px;
}
#manage-sessions-gantt .session .timeframe {
  color: #9aa3a9;
  font-size: 0.8em;
}
#manage-sessions-gantt .session .gh-badge {
  position: absolute;
  right: 40px;
  font-size: 0.75em;
  top: 15px;
  border-radius: 5px;
  padding: 2px 5px;
  font-weight: 500;
}
#manage-sessions-gantt .session .time {
  position: absolute;
  left: 450px;
  right: 0px;
  top: 0;
  height: 68px;
  border-top: 1px solid #eef0f4;
}
#manage-sessions-gantt .session .time .time-bar-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}
#manage-sessions-gantt .session .time .time-bar {
  height: 20px;
  border-radius: 13px;
  background: #0052cc;
}
#manage-sessions-gantt .session .time .time-bar.locked {
  background: #1cb987;
}
#manage-sessions-gantt .session .time .time-bar.closed {
  background: #87a6bc;
}
#session-form .session-color {
  top: 2px;
  height: 42px;
  line-height: 38px;
}
#session-form .parent-session .section-name {
  height: 62px;
  line-height: 62px;
}
#session-form .parent-session .gh-input-info .link {
  height: 62px;
  line-height: 62px;
  color: #3d6eb6;
}
#session-form .parent-session .gh-input-info .link:hover {
  border: 0;
  color: #50ace5;
  text-decoration: underline;
}
#session-form .parent-session .gh-input-info .gh-b-input-info {
  top: 22px;
}
#session-form .parent-session .gh-icon-wrapper {
  display: flex;
}
#session-form .gh-input-info .session-permissions {
  margin-top: 20px;
}
#session-form .gh-input-info .session-permissions .gh-note {
  padding: 0px;
}
.session-clone-modal.modal .modal-dialog .modal-content {
  overflow-y: visible;
  overflow-x: visible;
}
#manage-sessions-gantt .table-container {
  background: #fff;
  border: 1px solid #d8dfea;
  border-radius: 3px;
  display: flex;
  position: relative;
  overflow: auto;
  max-height: calc(100vh - 140px);
}
#manage-sessions-gantt .table-container .border-line {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  background: #fafbfc;
  border-bottom: 1px solid #d8dfea;
}
#manage-sessions-gantt .table-container .item-height {
  height: 68px;
}
#manage-sessions-gantt .table-container .sticky {
  background-color: white;
  border-right: 1px solid #d8dfea;
  box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);
  position: sticky;
  z-index: 2;
  left: 0;
  width: 450px;
  min-width: 450px;
  height: fit-content;
}
#manage-sessions-gantt .table-container .sticky-header {
  border-bottom: 1px solid #d8dfea;
  background-color: white;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 2;
}
#manage-sessions-gantt .table-container .session .session-info {
  border-top: none;
}
#manage-sessions-gantt .table-container .session .session-info.closed .title,
#manage-sessions-gantt .table-container .session .session-info.closed .timeframe,
#manage-sessions-gantt .table-container .session .session-info.closed .session-icon {
  opacity: 0.5;
}
#manage-sessions-gantt .table-container .session .title {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 80px;
  color: #021421;
}
#manage-sessions-gantt .table-container .session dropdown-actions-menu .gh-ui-actions-dd .toggle {
  color: #7485a2;
}
#manage-sessions-gantt .table-container .session dropdown-actions-menu .gh-ui-actions-dd .toggle:hover {
  background: inherit;
}
#manage-sessions-gantt .table-container .session .timeframe {
  color: #8393ae;
}
#manage-sessions-gantt .table-container .session .gh-badge {
  text-transform: uppercase;
  background: #e5f2ff;
  border-radius: 3px;
  color: #021421;
  font-weight: 700;
  opacity: 0.7;
}
#manage-sessions-gantt .table-container .session .gh-badge.closed {
  background: #f1f3f8;
}
#manage-sessions-gantt .table-container .session .gh-badge.locked {
  background: #e3fcef;
}
#manage-sessions-gantt .table-container .main-area {
  height: fit-content;
  position: relative;
}
#manage-sessions-gantt .table-container .items {
  position: relative;
}
#manage-sessions-gantt .table-container .item {
  position: relative;
}
#manage-sessions-gantt .table-container .time-bar-wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
#manage-sessions-gantt .table-container .time-bar {
  opacity: 0.8;
  height: 18px;
  border-radius: 9px;
  background: #0052cc;
  transition: 0.4s ease-in-out all;
}
#manage-sessions-gantt .table-container .time-bar:hover {
  opacity: 1;
}
#manage-sessions-gantt .table-container .time-bar.locked {
  background: #1cb987;
}
#manage-sessions-gantt .table-container .time-bar.closed {
  background: #87a6bc;
}
#manage-sessions-gantt .table-container .item:last-child {
  border-bottom: none;
}
#manage-sessions-gantt .table-container .today-marker {
  position: absolute;
  opacity: 0.5;
  top: 50px;
  bottom: 0;
  width: 2px;
  background: #8d73d9;
  z-index: 1;
  transition: 0.4s ease-in-out all;
}
#manage-sessions-gantt .table-container .today-marker:hover {
  box-shadow: 0 0 2px rgba(141, 115, 217, 0.6);
  opacity: 1;
}
#manage-sessions-gantt .table-container .timelines {
  background: #fafbfc;
  color: #617294;
  display: flex;
  position: sticky;
  width: fit-content;
  top: 0;
  z-index: 1;
}
#manage-sessions-gantt .table-container .time-period {
  border-bottom: 1px solid #d8dfea;
  height: 50px;
}
#manage-sessions-gantt .table-container .time-period:first-child .time-period-label:first-child {
  border-left: none;
}
#manage-sessions-gantt .table-container .time-period-top {
  position: relative;
}
#manage-sessions-gantt .table-container .time-period-top .time-period-label {
  width: auto;
  display: inline-block;
  left: 450px;
  position: sticky;
}
#manage-sessions-gantt .table-container .time-period-bottom {
  display: flex;
}
#manage-sessions-gantt .table-container .time-period-label {
  width: 60px;
  height: 25px;
  padding: 0 5px;
  border-left: 1px solid #d8dfea;
}
#manage-sessions-gantt .table-container .stripes {
  background: repeating-linear-gradient(90deg, #fff, #fff 60px, #fafbfc 60px, #fafbfc 120px);
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#approval-workflow-selection-form {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#approval-workflow-selection-form .modal-title {
  font-weight: 700;
  letter-spacing: 0.005em;
  color: #021421;
  margin-bottom: 16px;
}
#approval-workflow-selection-form .selection-info {
  font-weight: 400;
  color: #445573;
}
#approval-workflow-selection-form .workflow-selection {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  flex-wrap: wrap;
}
#approval-workflow-selection-form .accordion-top-border .accordion {
  border-top: 1px solid #d8e1ee;
}
#approval-workflow-selection-form .accordion-margin-bottom .accordion {
  margin-bottom: 30px;
}
#approval-workflow-selection-form .accordion {
  border-bottom: 1px solid #d8e1ee;
  font-weight: 400;
  color: #445573;
  /* Track */
  /* Handle */
}
#approval-workflow-selection-form .accordion ::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  border-radius: 10px;
}
#approval-workflow-selection-form .accordion ::-webkit-scrollbar-track {
  background: none;
}
#approval-workflow-selection-form .accordion ::-webkit-scrollbar-thumb {
  background: #c0cbdd;
  border-radius: 10px;
}
#approval-workflow-selection-form .accordion .accordion-name {
  padding: 18px 0;
}
#approval-workflow-selection-form .accordion .workflow-selection {
  overflow-x: auto;
  padding: 8px;
  margin: -8px -8px 8px -8px;
}
#approval-workflow-selection-form .arrow {
  transition: transform 0.1s;
}
#approval-workflow-selection-form .arrow-opened {
  transform: rotate(90deg);
}
#approval-workflow-selection-form .workflow-selection {
  color: #021421;
}
#approval-workflow-selection-form .workflow-selection .field {
  min-width: 265px;
  display: flex;
  margin-bottom: 8px;
}
#approval-workflow-selection-form .workflow-selection .field label {
  font-size: 14px;
  line-height: 19px;
  min-width: 215px;
  margin-right: 10px;
}
#approval-workflow-selection-form .workflow-selection .regular-font {
  font-weight: 400;
}
#create-s-form .required-fields {
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  color: #445573;
}
#create-s-form .workflow-approval-available-container .accordion:first-of-type {
  border-top: 1px solid #d8dfea;
}
#create-s-form .workflow-approval-available-container .accordion {
  border-bottom: 1px solid #d8dfea;
  padding: 18px 0;
}
#create-s-form .workflow-approval-available-container .accordion-section-name {
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  user-select: none;
  color: #445573;
  cursor: pointer;
}
#create-s-form .workflow-approval-available-container .accordion-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #617294;
  padding-left: 30px;
  margin-top: 2px;
}
#create-s-form .workflow-approval-available-container .arrow {
  transition: transform 0.1s;
}
#create-s-form .workflow-approval-available-container .arrow-opened {
  transform: rotate(90deg);
}
#create-s-form .workflow-approval-available-container .gh-radio-list-border {
  padding: 0;
}
#create-s-form .workflow-approval-available-container .gh-radio-list-border .item {
  margin: 0, -9px;
}
#create-s-form .workflow-approval-available-container .gh-radio-list-border .item .radio {
  left: 5px;
}
#create-s-form .workflow-approval-available-container .radio-info {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #7485a2;
  max-width: 400px;
}
#create-s-form .workflow-approval-available-container .modal-link {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #0057d7;
  cursor: pointer;
}
#create-s-form .workflow-approval-available-container .self-approve-label {
  font-weight: 400;
}
#create-s-form .workflow-approval-available-container .people-selector-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  max-width: 400px;
}
#create-s-form .workflow-approval-available-container .people-selector-text-error {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  max-width: 400px;
  color: #b14055;
}
#create-s-form .workflow-approval-available-container .people-selector-error .ant-select-selector {
  border-color: #da555d !important;
}
#create-s-form .workflow-approval-available-container .info-icon-warning {
  color: #bd6d0e;
}
#create-s-form .workflow-approval-available-container .people-selector-text-warning {
  color: #bd6d0e;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  max-width: 400px;
}
#create-s-form .gh-selected-artefact {
  display: inline-flex;
  width: 100%;
  gap: 5px;
  padding: 10px;
}
#create-s-form .gh-fg-description {
  margin-top: 4px;
  color: #445573;
  font-size: 12px;
  line-height: 16px;
}
#create-s-form .gh-fg-description a {
  text-decoration: underline;
}
#create-s-form .gh-fg-description a:focus {
  color: #0057d7;
}
#accordion-section {
  border-bottom: 1px solid #d8dfea;
  margin-top: -20px;
}
#accordion-section .customized-label {
  text-align: center;
  padding-left: 6px;
  padding-right: 6px;
  background-color: #e5f2ff;
  text-transform: uppercase;
  border-radius: 3px;
}
#accordion-section .customized-label .value {
  color: #021421;
  font-weight: 700;
  font-size: 11px;
  opacity: 0.7;
}
#accordion-section .section-name {
  line-height: initial;
}
#accordion-section button.default {
  height: 100%;
  background: inherit;
  border: none;
  text-align: left;
  padding: 0;
}
#accordion-section .settings-desc p {
  margin: 0;
}
#accordion-section .dropdown-menu ul li {
  padding: 0;
}
#accordion-section .dropdown-menu ul li button {
  width: 100%;
  padding: 10px;
}
#accordion-section .gh-font-icon-arrow-right-small.arrow.arrow-opened {
  transform: rotate(90deg);
}
.alignment-empty-module {
  margin-top: 160px;
}
.alignment-empty-module-mt-80 {
  margin-top: 80px;
}
.alignment-empty-module-v2 {
  margin-top: 160px;
  width: 352px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
}
#context-menu {
  padding: 7px 0;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 8;
  min-width: 220px;
}
#context-menu ul {
  margin-bottom: 0px;
}
#context-menu ul li {
  width: 100%;
  display: block;
  margin: 2px 0px;
  padding: 0px 10px 0px 23px;
  cursor: pointer;
  font-size: 13px;
  line-height: 2.5em;
}
#context-menu ul li:hover,
#context-menu ul li :active {
  background: #eff7fe;
  color: #2e4354;
}
#context-menu ul li.warn {
  color: #ff5f5f !important;
}
#context-menu ul li.dropdown-separator {
  margin: 5px 0;
  border-top: 1px solid #eee;
}
#context-menu ul hr {
  margin: 5px 0;
}
#shareable-overlay {
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 15;
  top: 0;
  height: 100%;
}
#shareable-overlay.ng-hide {
  opacity: 0;
}
#shareable-overlay.ng-hide-add,
#shareable-overlay.ng-hide-remove {
  transition: all linear 0.5s;
}
#overlay-message {
  position: fixed;
  width: 330px;
  color: #fff;
  left: 50%;
  bottom: 50%;
}
#overlay-message p {
  font-size: 1.6em;
  font-weight: 500;
  text-shadow: 0 1px 2px #000000;
}
#overlay-message img {
  position: absolute;
  left: -130px;
  top: 14px;
}
#overlay-glow {
  background: none;
  box-shadow: 0 6px 60px #1e88ca;
  position: fixed;
}
#overlay-top,
#overlay-bottom,
#overlay-left,
#overlay-right {
  background: #24445e;
  opacity: 0.7;
  position: fixed;
}
#overlay-top {
  top: 0;
  left: 0;
  width: 100%;
}
#overlay-bottom {
  bottom: 0;
  left: 0;
  width: 100%;
}
#overlay-left {
  left: 0;
}
#overlay-right {
  right: 0;
}
#pinned-item {
  position: fixed;
  left: calc(var(--left-nav-width) + 40px);
  background: #fff8ed;
  z-index: 5;
  width: 400px;
  bottom: 40px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ffdcab;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}
#pinned-item .note {
  font-size: 0.9;
  color: #b06800;
  margin-top: 15px;
}
#pinned-item .name {
  font-size: 1.1em;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#pinned-item .name .gh-icon {
  position: absolute;
  left: 0;
  top: 4px;
}
.alignment-tree-tooltip {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
  z-index: 10;
}
.alignment-tree-tooltip.progress-tooltip,
.alignment-tree-tooltip.goal-owner-name-tooltip {
  visibility: visible;
  background: black;
  color: #fff;
  padding: 3px 20px 3px 20px;
  border-radius: 5px;
  font-size: 0.9em;
}
.alignment-tree-tooltip.assignee-name-tooltip,
.alignment-tree-tooltip.contributor-owner-name-tooltip {
  visibility: visible;
  color: #9aa3a9;
}
.alignment-tree-tooltip.item-title-tooltip,
.alignment-tree-tooltip.owner-name-tooltip,
.alignment-tree-tooltip.contributor-title-tooltip {
  visibility: visible;
  position: absolute;
  padding: 5px 10px;
  border-radius: 3px;
  line-height: 20px;
  background: #283d5c;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.alignment-tree-tooltip.item-title-tooltip::after,
.alignment-tree-tooltip.owner-name-tooltip::after,
.alignment-tree-tooltip.contributor-title-tooltip::after {
  content: " ";
  width: 10px;
  height: 10px;
  transform: rotate(-45deg);
  background: #283d5c;
  position: absolute;
  top: -5px;
  left: 50%;
  margin-left: -5px;
}
.alignment-tree-tooltip.contributor-name-tooltip {
  visibility: visible;
  position: absolute;
  padding: 10px 5px;
  border-radius: 5px;
  line-height: 20px;
  background: #fff;
  text-align: center;
  color: #2e4354;
  font-size: 14px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.alignment-tree-tooltip.contributor-name-tooltip::after {
  content: " ";
  width: 10px;
  height: 10px;
  transform: rotate(-45deg);
  background: #fff;
  position: absolute;
  bottom: -4px;
  left: 50%;
  margin-left: -5px;
}
#alignment-tree-holder {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 500px;
  top: 40px;
}
#alignment-tree-holder .secondary-actions {
  position: absolute;
  top: auto;
  bottom: 34px;
  left: auto;
  right: 90px;
}
#alignment-tree-holder .secondary-actions .buttons-group {
  display: flex;
}
#alignment-tree-holder .secondary-actions .buttons-group button.action {
  border-radius: 0;
  margin-left: 0;
  margin-right: 0;
}
#alignment-tree-holder .secondary-actions .buttons-group button.action.first {
  border-radius: 4px 0 0 4px;
}
#alignment-tree-holder .secondary-actions .buttons-group button.action.last {
  border-radius: 0 4px 4px 0;
}
#alignment-tree-holder .secondary-actions .buttons-group button.action:focus {
  border: inherit;
  box-shadow: inherit;
}
#alignment-tree-holder .secondary-actions .action {
  height: 30px;
  overflow: hidden;
  box-shadow: 0px 1px 2px rgba(90, 127, 158, 0.2);
  border-radius: 4px;
}
#alignment-tree-holder .secondary-actions .action:not(:first-child) {
  margin-left: 8px;
}
#alignment-tree-holder .secondary-actions .action.single {
  width: 36px;
}
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-in,
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-out {
  width: 28px;
  height: 100%;
}
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-in {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-out {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
#alignment-tree-holder .secondary-actions .action.zoom-bar .ratio {
  width: 43px;
  height: 100%;
  font-size: 13px;
  font-weight: 500;
}
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-in:focus,
#alignment-tree-holder .secondary-actions .action.zoom-bar .zoom-out:focus,
#alignment-tree-holder .secondary-actions .action.zoom-bar .ratio:focus {
  box-shadow: inset 0px 1px 1px rgba(90, 127, 158, 0.1), inset 0px 0px 0px 2px #75a2f7;
}
#alignment-tree-holder .secondary-actions .clickable {
  border: 1px solid transparent;
  background: #fff;
  cursor: pointer;
}
#alignment-tree-holder .secondary-actions .clickable:hover {
  border: 1px solid #8393ae;
}
#alignment-tree-holder .secondary-actions .clickable:active,
#alignment-tree-holder .secondary-actions .clickable.toggled {
  border: 0;
  background: #d8e1ee;
  box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);
}
#alignment-tree-holder .secondary-actions .clickable:focus {
  border: 1px solid #75a2f7;
  box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1), 0px 0px 0px 2px #75a2f7;
}
#alignment-tree-holder .no-scrollbars,
#alignment-tree-holder.draggable.no-scrollbars {
  cursor: grab;
}
#alignment-tree-holder .no-scrollbars:active,
#alignment-tree-holder.draggable.no-scrollbars:active {
  cursor: grabbing;
}
#alignment-tree-holder.updating:after {
  content: "";
  display: block;
  width: 100%;
  background: #f4f7f9;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  opacity: 0.5;
}
#alignment-tree-holder .alignment-tree-indicator {
  display: block;
  position: fixed;
  width: 100px;
  height: 45px;
  bottom: 0px;
  left: 280px;
  z-index: 4;
  padding-left: 10px;
}
#alignment-tree-holder .owner .team-owner {
  width: 24px;
  height: 24px;
}
#alignment-tree-holder .team-avatar {
  display: block;
  padding: 1px;
  color: #fff;
  position: static;
}
#alignment-tree-holder .handle {
  display: none;
}
#alignment-tree-holder .handle:hover {
  opacity: 0.5;
  cursor: move;
}
#alignment-tree-holder .no-handle {
  display: none;
  font-size: 31px;
  transform: translate(-5px, 19px) rotate(45deg);
  fill: #b5bcc1;
}
#alignment-tree-holder .no-handle:hover {
  opacity: 0.5;
  cursor: move;
}
#alignment-tree-holder .dropzone circle {
  fill: rgba(255, 255, 255, 0.1);
  opacity: 0.5;
  stroke: #57749e;
  stroke-width: 2px;
  stroke-dasharray: 10;
  stroke-linecap: round;
}
#alignment-tree-holder .dropzone.active circle {
  fill: rgba(255, 255, 255, 0.1);
  opacity: 0.5;
  stroke: #09b180;
  stroke-width: 4px;
  stroke-dasharray: 0;
}
#alignment-tree-holder .main .pad {
  fill: #fff;
  stroke: #e0e4ea;
  stroke-width: 1px;
}
#alignment-tree-holder .main .item-pad {
  fill: #fff;
}
#alignment-tree-holder .main .item.matched .item-pad {
  stroke-width: 3px;
  stroke: #ffc25f;
}
#alignment-tree-holder .main .item.unmatched {
  opacity: 0.5;
}
#alignment-tree-holder .main .dropdown-toggler,
#alignment-tree-holder .main .contributor-dropdown-toggler {
  font-size: 18px;
  font-family: Georgia, Arial, sans-serif;
  letter-spacing: 0.01em;
  fill: #c8d1df;
}
#alignment-tree-holder .main .dropdown-toggler:hover,
#alignment-tree-holder .main .contributor-dropdown-toggler:hover {
  cursor: pointer;
  fill: #0052cc;
}
#alignment-tree-holder .main .node .goal-owner-name {
  font-size: 14px;
  fill: #96a1a9;
}
#alignment-tree-holder .main .node .item-owners-names {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400 !important;
  fill: #617294;
}
#alignment-tree-holder .main .node.pinned {
  opacity: 0.4;
}
#alignment-tree-holder .main .node .workflow-status-icon {
  font-size: 12px;
  color: #fff;
}
#alignment-tree-holder .main .node .workflow-status-icon span {
  position: static;
}
#alignment-tree-holder .main .node.show-more .goal-title text.goal-title-text {
  fill: #9aa3a9;
  font-weight: 600;
}
#alignment-tree-holder .main .node.show-more .goal-title text.goal-title-text:hover {
  fill: #7ea8c5;
}
#alignment-tree-holder .main .node .item-title-text,
#alignment-tree-holder .main .node .contributor-title-text {
  fill: #0d232f;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  -webkit-box-orient: vertical;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}
#alignment-tree-holder .main .node .item-title-text:hover,
#alignment-tree-holder .main .node .contributor-title-text:hover {
  cursor: pointer;
  fill: #003a7b;
  text-decoration: underline;
}
#alignment-tree-holder .main .node .contributor-title .contributor-title-text {
  font-weight: 400;
}
#alignment-tree-holder .main .node .item-title .item-title-text {
  font-weight: 500;
}
#alignment-tree-holder .main .node .goal-title .goal-title-text {
  fill: #2e4354;
  letter-spacing: -0.02em;
  font-family: "SF Pro Display", Arial, sans-serif;
  height: 100%;
  word-break: break-word;
  overflow: hidden;
}
#alignment-tree-holder .main .node .goal-title .goal-title-text:hover {
  cursor: pointer;
  fill: #0052cc;
}
#alignment-tree-holder .main .node .goal-title .goal-title-dots {
  position: fixed;
  bottom: 0px;
  right: 0px;
}
#alignment-tree-holder .main .node .goal-title .goal-title-dots::after {
  content: "...";
  position: fixed;
  bottom: 0px;
  right: 0px;
}
#alignment-tree-holder .main .node.matched .pad {
  stroke-width: 3px;
  stroke: #ffc25f;
}
#alignment-tree-holder .main .node.highlighted .pad {
  stroke-width: 5px;
  stroke: transparent;
}
#alignment-tree-holder .main .node.highlighted .session-color {
  display: none;
}
#alignment-tree-holder .main .node.unmatched {
  opacity: 0.5;
}
#alignment-tree-holder .main .node.shared .pad {
  stroke: #e0e4ea;
  stroke-width: 1px;
}
#alignment-tree-holder .main .node .contributors .team-owner {
  width: 16px;
  height: 16px;
}
#alignment-tree-holder .main .node .contributors .contributor-owner .contributor-owner-name {
  fill: #9aa3a9;
  display: none;
}
#alignment-tree-holder .main .node .contributors .contributor-owner .team-avatar .icon {
  display: block;
  padding: 1px;
  color: #fff;
}
#alignment-tree-holder .main .node .contributors .contributor-owner:hover .contributor-owner-name {
  display: block;
}
#alignment-tree-holder .main .node .contributors .faded {
  opacity: 0.5;
}
#alignment-tree-holder .main .node .private .private-dot {
  fill: #ffbd5e;
  cursor: help;
}
#alignment-tree-holder .main .node .private .private-badge {
  fill: #9aa3a9;
}
#alignment-tree-holder .main .node .private .private-text {
  transform: translate(10px, -9px);
  fill: #9aa3a9;
  display: none;
}
#alignment-tree-holder .main .node .private:hover .private-text {
  display: block;
}
#alignment-tree-holder .main.simplified .link {
  stroke: #aeb6c0;
  stroke-width: 8px;
}
#alignment-tree-holder .main.simplified .node .contributor > :not(.togglerEnter),
#alignment-tree-holder .main.simplified .node image,
#alignment-tree-holder .main.simplified .node .goal-title-text,
#alignment-tree-holder .main.simplified .node .item-title-text,
#alignment-tree-holder .main.simplified .node .contributor-title-text,
#alignment-tree-holder .main.simplified .node .aggregated-attainment,
#alignment-tree-holder .main.simplified .node .private-badge,
#alignment-tree-holder .main.simplified .node .owner {
  display: none;
}
#alignment-tree-holder .main.simplified .node.matched .pad,
#alignment-tree-holder .main.simplified .node.matched .item-pad {
  stroke-width: 20px;
}
#alignment-tree-holder .link {
  fill: none;
  stroke: #d0dae5;
  stroke-width: 3px;
}
#alignment-tree-holder .link2 {
  stroke: #d500f9;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
}
#alignment-tree-holder .link2.link3 {
  stroke-width: 4;
}
@keyframes dash {
  from {
    stroke-dashoffset: 400;
  }
  to {
    stroke-dashoffset: 1000;
  }
}
#alignment-tree-holder .dashed-link {
  stroke: #7485a2;
  stroke-width: 3;
  fill: none;
  stroke-dasharray: 8;
  -webkit-animation: dash 30s linear infinite;
  animation: dash 30s linear infinite;
}
#alignment-tree-holder .enabledDrag .handle {
  display: block;
}
#alignment-tree-holder .enabledDrag .no-handle {
  display: block;
}
#alignment-tree-holder .enabledDrag .node.show-more .no-handle {
  display: none;
}
#alignment-tree-holder .enabledDrag .node.show-more .handle {
  display: none;
}
#alignment-tree-holder text.contributor-owner-name {
  font-size: 11px;
  fill: #96a1a9;
}
#alignment-tree-holder text.contributor-name {
  font-size: 14px;
  font-family: "SF Pro Display", Arial, sans-serif;
  fill: #57749e;
}
#alignment-tree-holder text.contributor-name:hover {
  fill: #000;
  cursor: pointer;
}
#alignment-tree-holder text.contributor-attainment {
  font-size: 12px;
  line-height: 16px;
}
#alignment-tree-holder .node text:not(.nc-icon-outline) {
  font-family: "SF Pro Text", "Helvetica Neue", "SegoeUI", sans-serif;
}
#alignment-tree-holder .node .togglerEnter:hover {
  cursor: pointer;
  opacity: 0.6;
}
#alignment-tree-holder .node .togglerEnter text {
  font-size: 20px;
}
#alignment-tree-holder .node .togglerEnter .plus,
#alignment-tree-holder .node .togglerEnter .minus {
  display: none;
  fill: #57749e;
}
#alignment-tree-holder .node .togglerEnter .expander {
  fill: #57749e;
  opacity: 0.2;
}
#alignment-tree-holder .node .togglerEnter.expanded .minus {
  display: block;
}
#alignment-tree-holder .node .togglerEnter.collapsed .plus {
  display: block;
  fill: #fff;
  font-size: 13px;
  font-weight: bold;
}
#alignment-tree-holder .node .togglerEnter.collapsed .expander,
#alignment-tree-holder .node .togglerEnter.collapsed circle {
  opacity: 1;
}
#alignment-tree-holder .node .togglerEnter.hide {
  display: none;
}
body .alignment-container.demo-included #alignment-filters,
body .alignment-container.demo-included #alignment-tree-holder {
  top: 90px;
}
body .alignment-container grid-filtering-bar {
  position: relative;
  z-index: 1;
  width: fit-content;
  width: -moz-fit-content;
  background: #f4f7f9;
  border-radius: 0 0 10px 0;
}
body .alignment-container grid-filtering-bar button.action {
  background: #fff;
}
body .alignment-container #alignment-tree-holder {
  left: var(--left-nav-width);
  padding-top: 5px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu {
  min-width: 225px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes {
  display: flex;
  padding: 5px;
  border-bottom: 1px solid #d8e1ee;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li {
  flex: 1 1 0px;
  min-width: 0px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li:not(:first-child) {
  margin-left: 6px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button {
  flex-direction: column;
  justify-content: space-between;
  min-width: 100%;
  height: 102px;
  padding: 0 14px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button .text {
  margin-top: 7px;
  margin-bottom: 4px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  color: #617294;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button img {
  width: 75px;
  height: 60px;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button:hover .text,
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button:disabled .text {
  color: #021421;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button:not(:disabled):hover {
  border-color: #8393ae;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button:disabled {
  background: #f1f3f8;
  box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);
  cursor: not-allowed;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode ul.dropdown-menu .view-modes li button:focus {
  box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1), 0px 0px 0px 2px #75a2f7;
  border: 1px solid #75a2f7;
}
body .alignment-container grid-filtering-bar grid-settings.custom-menu.goals-alignment-view-mode li.include-metrics {
  padding: 12px 20px;
  white-space: nowrap;
}
body.hide-left-nav #alignment-tree-holder {
  left: 340px;
}
body.hide-left-nav .alignment-container #alignment-tree-holder {
  left: var(--left-nav-hidden-width);
}
body.no-left-nav .alignment-container #alignment-tree-holder {
  left: 0;
}
#alignment-tree-svg-holder {
  overflow: auto;
  height: 100%;
}
@keyframes located-item-glow {
  0% {
    box-shadow: 0px 0px 30px 10px rgba(172, 158, 242, 0.5);
  }
  100% {
    box-shadow: 0px 0px 30px 40px rgba(172, 158, 242, 0.1);
  }
}
.alignment-tooltip {
  opacity: 1 !important;
}
.alignment-tooltip strong {
  background: #445573;
  padding: 2px;
  border-radius: 2px;
}
.alignment-tooltip .tooltip-inner {
  padding: 4px;
  background: #283d5c;
}
.alignment-tooltip.top .tooltip-arrow {
  border-top-color: #283d5c;
}
.okr-node-container {
  width: 100%;
  height: 45px;
  min-width: 480px;
}
.okr-node-container .p-0 {
  padding: 0px;
}
.okr-node-container .okr-node {
  position: relative;
  height: 100%;
  background-color: #fff;
  border: 1px solid #d7e4ef;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.okr-node-container .okr-node.highlighted {
  box-shadow: 0px 0px 0px 2px #ffc25f inset;
}
.okr-node-container .okr-node.obfuscated {
  background-image: repeating-linear-gradient(45deg, #f4f5f8, #f4f5f8 10px, #fff 10px, #fff 20px);
}
.okr-node-container .okr-node.is-first-root {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.okr-node-container .okr-node.expanded {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0px !important;
}
.okr-node-container .okr-node.previous-expanded {
  border-top-left-radius: 4px;
}
.okr-node-container .okr-node.last-expanded-node {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.okr-node-container .okr-node .private-label {
  background-color: #ffc25f;
  border-radius: 25px;
  font-size: 11px;
  color: #fff;
  text-align: center;
  padding: 0px 10px;
  line-height: 15px;
  margin-top: 2px;
}
.okr-node-container .okr-node .dots-menu .gh-font-icon-menu {
  color: #617294;
  font-size: 16px;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu {
  padding: 3px;
  top: 13px;
  left: -94px;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu .dropdown-item {
  cursor: pointer;
  padding: 8px;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu .dropdown-item:hover {
  background-color: #e9f0f9;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu .dropdown-item.warn {
  color: #da555d;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu .dropdown-item.b-top {
  border-top: 1px solid #d7e4ef;
}
.okr-node-container .okr-node .dots-menu .dropdown-menu .dropdown-item.b-bottom {
  border-bottom: 1px solid #d7e4ef;
}
.okr-node-container .okr-node .gh-icon {
  min-width: 16px;
  min-height: 16px;
}
.okr-node-container .okr-node .info-container {
  max-width: 370px;
  margin-left: auto;
}
.okr-node-container .okr-node .info-container .avatars-two {
  display: none;
}
.okr-node-container .okr-node .info-container .avatars-five {
  padding-right: 10px;
  padding-left: 0px;
}
.okr-node-container .okr-node .info-container .confidence-badge {
  max-width: 82px;
  cursor: pointer;
}
.okr-node-container .okr-node .info-container .goal-aggregated-progress {
  color: rgba(46, 67, 84, 0.5);
  font-size: 10px;
  line-height: 16px;
  position: absolute;
  top: 4px;
  right: -10%;
  cursor: pointer;
}
.okr-node-container .okr-node .info-container .goal-aggregated-progress.color {
  width: 10px;
  border-radius: 8px;
  margin-right: 5px;
  height: 10px;
}
.okr-node-container .okr-node .info-container .goal-attainment,
.okr-node-container .okr-node .info-container .metric-attainment {
  font-size: 14px;
  line-height: 20px;
}
.okr-node-container .okr-node .info-container .goal-attainment .color,
.okr-node-container .okr-node .info-container .metric-attainment .color {
  width: 17px;
  height: 17px;
  border-radius: 30px;
}
.okr-node-container .okr-node .info-container .goal-attainment .text,
.okr-node-container .okr-node .info-container .metric-attainment .text {
  cursor: pointer;
}
.okr-node-container .okr-node .okr-name {
  cursor: pointer;
  color: #021421;
}
.okr-node-container .okr-node .okr-name:hover {
  color: #003a7b;
}
.okr-node-container .okr-node .expand-icon {
  position: absolute;
  top: 11px;
  left: -28px;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #8393ae;
  cursor: pointer;
}
.okr-node-container .okr-node .expand-icon.collapsed {
  background-color: #445573;
}
.okr-node-container .okr-node .expand-icon .icon {
  color: #fff;
  font-size: 16px;
}
.okr-node-container .okr-node.goal-node .workflow .icon {
  color: #fff;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  outline: 2px solid #fff;
  font-size: 9px;
  position: absolute;
  top: 8px;
  left: 8px;
}
.okr-node-container .okr-node.goal-node .workflow .approved .icon {
  background-color: #18c191;
}
.okr-node-container .okr-node.goal-node .workflow .in-review .icon {
  background-color: #8d73d9;
}
.okr-node-container .okr-node.goal-node .workflow .draft .icon {
  background-color: #7485a2;
}
@media (max-width: 1290px) {
  .okr-node-container .okr-node .info-container {
    max-width: 310px;
  }
  .okr-node-container .okr-node .info-container .confidence-badge {
    max-width: 72px;
  }
  .okr-node-container .okr-node .info-container .dots-menu .dropdown-menu {
    left: -104px;
  }
}
@media (max-width: 820px) {
  .okr-node-container .okr-node .info-container {
    max-width: 220px;
  }
  .okr-node-container .okr-node .info-container .avatars-two {
    display: block;
  }
  .okr-node-container .okr-node .info-container .avatars-five {
    display: none;
  }
  .okr-node-container .okr-node .info-container .confidence-badge {
    max-width: 45px;
  }
  .okr-node-container .okr-node .info-container .goal-attainment,
  .okr-node-container .okr-node .info-container .metric-attainment {
    font-size: 12px;
    line-height: 18px;
  }
}
.ink-80-tooltip.okr-name-tooltip {
  max-width: 300px;
}
.modal-overflow-x-unset .modal-dialog .modal-content {
  overflow-x: unset;
}
`, "",{"version":3,"sources":["webpack://./packages/webapp-legacy/src/okrs/metrics/less/metric.less","webpack://./packages/webapp-legacy/less/common/positioning.less","webpack://./packages/webapp-legacy/src/okrs/okrs.module.less","webpack://./packages/webapp-legacy/src/okrs/components/clone-okrs/clone-okrs.less","webpack://./packages/webapp-legacy/less/common/font-formatting.less","webpack://./packages/webapp-legacy/less/common/displaying.less","webpack://./packages/webapp-legacy/src/okrs/metrics/components/cascading-metric-form/cascading-metric-form.less","webpack://./packages/webapp-legacy/src/okrs/metrics/components/cascading-metric-form/cascading-metric-contributor.less","webpack://./packages/webapp-legacy/src/okrs/metrics/components/cascading-metric-values-affix-input/cascading-metric-values-affix-input.less","webpack://./packages/webapp-legacy/src/okrs/metrics/components/metric-snapshot-preview/metric-snapshot-preview.component.less","webpack://./packages/webapp-legacy/src/okrs/metrics/less/slider.less","webpack://./packages/webapp-legacy/src/okrs/metrics/module.less","webpack://./packages/webapp-legacy/src/goals/components/bulk-tag/bulk-tag.component.less","webpack://./packages/webapp-legacy/src/goals/components/okr-workflow/ork-workflow.component.less","webpack://./packages/webapp-legacy/src/goals/less/timeline.less","webpack://./node_modules/bootstrap/less/mixins/vendor-prefixes.less","webpack://./packages/webapp-legacy/src/goals/less/cloned-or-moved-metric-success.less","webpack://./packages/webapp-legacy/src/goals/less/confirm-clone-or-move.less","webpack://./packages/webapp-legacy/src/goals/less/submit-to-marketplace.less","webpack://./packages/webapp-legacy/src/goals/less/goals.less","webpack://./packages/webapp-legacy/src/goals/less/single-goal.less","webpack://./packages/webapp-legacy/src/goals/less/goal-timeline.less","webpack://./packages/webapp-legacy/src/goals/less/all-goals.less","webpack://./packages/webapp-legacy/src/goals/less/overview.less","webpack://./packages/webapp-legacy/src/goals/less/nested.less","webpack://./packages/webapp-legacy/src/goals/less/tasks.less","webpack://./packages/webapp-legacy/src/goals/less/custom-fields.less","webpack://./packages/webapp-legacy/src/goals/less/metric-form.less","webpack://./packages/webapp-legacy/src/goals/less/send-for-approval.less","webpack://./node_modules/ng-zorro-antd/style/color/tinyColor.less","webpack://./node_modules/nouislider/src/nouislider.core.less","webpack://./node_modules/nouislider/src/nouislider.pips.less","webpack://./node_modules/nouislider/src/nouislider.tooltips.less","webpack://./packages/webapp-legacy/src/goals/less/update-manual-metric.less","webpack://./packages/webapp-legacy/src/goals/less/single-goal-selector.less","webpack://./packages/webapp-legacy/src/goals/less/move-objective.less","webpack://./packages/webapp-legacy/src/goals/less/selected-artefact.less","webpack://./packages/webapp-legacy/src/goals/less/task-status.less","webpack://./packages/webapp-legacy/src/goals/goals.module.less","webpack://./packages/webapp-legacy/src/tasks/less/tasks.less","webpack://./packages/webapp-legacy/src/tasks/components/task-form.less","webpack://./packages/webapp-legacy/src/tasks/components/create-task-form/create-task-form.component.less","webpack://./packages/webapp-legacy/src/tasks/components/create-kanban-task-form/create-kanban-task-form.component.less","webpack://./packages/webapp-legacy/src/workflow/less/hub.less","webpack://./packages/webapp-legacy/src/workflow/less/status-icon-workflow.less","webpack://./packages/webapp-legacy/src/workflow/module.less","webpack://./packages/webapp-legacy/src/sessions/less/sessions.less","webpack://./packages/webapp-legacy/src/sessions/components/approval-workflow-selection-form/approval-workflow-selection-form.less","webpack://./packages/webapp-legacy/src/sessions/components/session-form/session-form.less","webpack://./packages/webapp-legacy/src/sessions/components/methodology-section/methodology-section.component.less","webpack://./packages/webapp-legacy/src/okrs/alignment-tree/states/alignment-tree.less","webpack://./packages/webapp-legacy/src/okrs/alignment-tree/components/nested-view-okr-node/nested-view-okr-node.less"],"names":[],"mappings":"AAoWI;ECzMF,kBAAA,CACA,MAAA,CACA,SAAA,CACA,OAAA,CACA,QAAA;AC7JF;ACFA;EACE,YAAA;ADIF;ACDA;EACE,kBAAA;ADGF;ACAA;EAEI,iBAAA;ADCJ;ACHA;EAMI,yBAAA;EACA,qDAAA;EACA,kBAAA;ADAJ;ACRA;EAYI,eAAA;EACA,cAAA;ECIF,2BAAA;AFJF;ACbA;EAkBI,cAAA;ADFJ;AGDE;EACE,mBAAA;AHGJ;ACnBA;EAkCI,SAAA;EACA,oBAAA;ADZJ;ACgBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EDdA,4BAA4B;ECe5B,aAAA;EACA,4BAAA;ADbF;ACgBA;EACE,gBAAA;ADdF;AI/CA;EAEI,mBAAA;AJgDJ;AIlDA;EAMI,mBAAA;AJ+CJ;AIrDA;EASM,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EFyBJ,gBAAA;EACA,mBAAA;EACA,uBAAA;AFuBF;AI9DA;EAiCM,kBAAA;AJgCN;AIjEA;EAqCM,eAAA;AJ+BN;AIpEA;EA0CI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;AJ6BJ;AI1EA;EAiDI,mBAAA;EACA,YAAA;AJ4BJ;AI1BI;EACE,mBAAA;AJ4BN;AIjFA;EA0DI,gBAAA;EACA,cAAA;AJ0BJ;AIrFA;EA+DI,YAAA;AJyBJ;AIxFA;EAkEM,eAAA;AJyBN;AK3FA;EAEI,kBAAA;EAEA,SAAA;EACA,SAAA;AL2FJ;AKhGA;EASI,kBAAA;AL0FJ;AKnGA;EAaI,iBAAA;EACA,cAAA;ALyFJ;AKvGA;EAiBM,yBAAA;EACA,eAAA;ALyFN;AKvFM;EACE,mBAAA;ALyFR;AKtFM;EACE,YAAA;EACA,mBAAA;ALwFR;AKrFM;EACE,6BAAA;ALuFR;AKpFM;EACE,cAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;ALsFR;AKpFQ;EACE,uBAAA;ALsFV;AKlFM;EACE,kBAAA;ALoFR;AKrIA;EAuDI,yBAAA;EACA,cAAA;ALiFJ;AMzIA;EAEI,YAAA;AN0IJ;AM5IA;;EAOI,yBAAA;EACA,cAAA;ANyIJ;AMjJA;EAaM,iBAAA;EACA,iBAAA;ANuIN;AMrJA;EAkBM,kBAAA;EACA,iBAAA;ANsIN;AMzJA;EAuBM,mBAAA;ANqIN;AMhII;EACE,qBAAA;ANkIN;AM/JA;EAiCM,0BAAA;ANiIN;AMlKA;EAqCM,0BAAA;ANgIN;AOrKA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;APuKF;AO1KA;EAMI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;APuKJ;AOjLA;EAaM,gBAAA;APuKN;AOpLA;EAiBM,kBAAA;EACA,SAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;APsKN;AOnKQ;EACE,YAAA;EACA,kBAAA;APqKV;AO9JA;EACE,YAAA;APgKF;AOjKA;EAII,qBAAA;EACA,aAAA;APgKJ;AOrKA;EAQM,sBAAA;APgKN;AOxKA;EAaI,YAAA;AP8JJ;AO3KA;;EAiBM,qBAAA;EACA,kBAAA;AP8JN;AOhLA;EAsBM,gBAAA;EACA,2BAAA;AP6JN;AOpLA;EA2BM,cAAA;EACA,YAAA;EACA,iBAAA;AP4JN;AOzLA;EAiCM,iBAAA;AP2JN;AOvJE;EAAA;IAEI,gBAAA;EPyJJ;AACF;AOtJE;EAAA;IAEI,gBAAA;EPwJJ;AACF;AOpJA;;EAEE,cAAA;EACA,iBAAA;APsJF;AOpJE;;EACE,cAAA;EACA,eAAA;APuJJ;AOnJA;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;APqJF;AO3JA;EAQI,mBAAA;EACA,gBAAA;APsJJ;AO/JA;EAYI,UAAA;EACA,qBAAA;EACA,kBAAA;APsJJ;AOpKA;EAiBM,gBAAA;APsJN;AOvKA;EAsBI,kBAAA;APoJJ;AO1KA;EA0BI,SAAA;APmJJ;AO7KA;EA6BM,cAAA;APmJN;AFhRA;EACE,aAAA;AEkRF;AFhRE;EAAA;IACE,WAAA;EEmRF;AACF;AFhRA;EAEI,WAAA;EACA,gBAAA;AEiRJ;AFpRA;EAOI,iBAAA;AEgRJ;AFvRA;EAUM,gBAAA;EACA,iBAAA;AEgRN;AF3RA;EAiBU,WAAA;EACA,cAAA;AE6QV;AF/RA;EAuBQ,kBAAA;EACA,WAAA;EACA,cAAA;AE2QR;AFpSA;EA+BI,mBAAA;EACA,mBAAA;EACA,gBAAA;AEwQJ;AFzSA;EAqCI,kBAAA;EACA,iBAAA;AEuQJ;AF7SA;EA0CI,kBAAA;AEsQJ;AFrQI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AEuQN;AFrQI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AEuQN;AF5TA;EA0DI,iBAAA;AEqQJ;AF/TA;EA8DI,qBAAA;AEoQJ;AFlUA;EAkEI,sBAAA;AEmQJ;AFrUA;EAsEI,WAAA;AEkQJ;AFxUA;EA0EI,gBAAA;EACA,wBAAA;AEiQJ;AF5UA;EA+EI,4BAAA;EACA,WAAA;AEgQJ;AFhVA;EAoFI,gBAAA;AE+PJ;AFnVA;EAwFI,gBAAA;EACA,gBAAA;AE8PJ;AF5PI;EACE,eAAA;AE8PN;AF1VA;;EAiGM,sBAAA;AE6PN;AF3PM;;EACE,UAAA;EACA,mBAAA;AE8PR;AFnWA;EA0GM,mBAAA;AE4PN;AFtWA;EA4GQ,mBAAA;EACA,eAAA;AE6PR;AF1WA;EAiHQ,cAAA;EACA,eAAA;EACA,iBAAA;AE4PR;AF/WA;EAuHQ,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AE2PR;AFvXA;EA+HU,WAAA;AE2PV;AF1XA;EAmIU,wBAAA;AE0PV;AF7XA;;EAyIY,WAAA;AEwPZ;AFjYA;;EA8Ic,iBAAA;EACA,gBAAA;EACA,gBAAA;AEuPd;AFvYA;EAyJI,UAAA;AEiPJ;AF1YA;EA4JM,aAAA;EACA,gBAAA;EACA,mBAAA;AEiPN;AF/YA;EAkKM,kBAAA;EACA,qBAAA;EACA,kBAAA;AEgPN;AFpZA;EAyKI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AE8OJ;AF1ZA;EA+KM,YAAA;AE8ON;AF7ZA;EAiLQ,uBAAA;AE+OR;AFhaA;EAqLQ,cAAA;EACA,yBAAA;EACA,mBAAA;AE8OR;AFraA;EA2LQ,cAAA;AE6OR;AFxaA;EAgMM,gBAAA;AE2ON;AF3aA;EAoMM,wBAAA;AE0ON;AF9aA;EAuMQ,kBAAA;AE0OR;AFjbA;EA8MM,kBAAA;EACA,kBAAA;AEsON;AFrbA;EAkNQ,gBAAA;AEsOR;AFxbA;EAuNI,8BAAA;EACA,kBAAA;AEoOJ;AF5bA;EA2NI,kBAAA;AEoOJ;AFlOI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AEoON;AF1cA;EA0OM,2BAAA;AEmON;AF7cA;EA+OI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AEiOJ;AFndA;EAqPM,cAAA;EACA,cAAA;AEiON;AFvdA;EA4PM,cAAA;EACA,eAAA;EACA,iBAAA;AE8NN;AF5dA;EAkQM,qBAAA;EACA,cAAA;EACA,iBAAA;AE6NN;AFjeA;EAuQQ,eAAA;AE6NR;AFpeA;EA6QI,cAAA;AE0NJ;AFveA;;EAkRI,gBAAA;AEyNJ;AF3eA;EAuRM,gBAAA;AEuNN;AF9eA;EA6RM,kBAAA;AEoNN;AF/MI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AEiNN;AF5MI;EACE,cAAA;AE8MN;AFzfA;EA+SM,YAAA;AE6MN;AF5fA;EAoTI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AE2MJ;AFrgBA;EA6TM,mEAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AE2MN;AFtMI;EACE,yBAAA;AEwMN;AFtMM;EACE,6BAAA;EACA,gBAAA;AEwMR;AFphBA;EAmVI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;AEoMJ;AFlMI;EACE,WAAA;EAEA,kBAAA;AEmMN;AFhMI;EACE,wEAAA;AEkMN;AFhMM;EACE,yBAAA;AEkMR;AF9LI;EACE,+CAAA;AEgMN;AF9LM;EACE,yBAAA;AEgMR;AF1LI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AE4LN;AFljBA;EA2XI,kBAAA;AE0LJ;AFrjBA;EA+XI,iBAAA;AEyLJ;AQlkBA;EAEI,YAAA;EACA,YAAA;ARmkBJ;AQjkBI;EACE,YAAA;ARmkBN;AQhkBI;EACE,UAAA;ARkkBN;AQ5kBA;EAeI,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ARgkBJ;AQ9jBI;EACE,UAAA;EACA,0BAAA;ARgkBN;ASjlBA;EAIQ,aAAA;ATglBR;ASplBA;EAQQ,eAAA;AT+kBR;ASvlBA;EAcQ,eAAA;AT4kBR;AS1lBA;EAkBQ,eAAA;AT2kBR;ASrkBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;ATukBF;AS3kBA;EAOI,qBAAA;EACA,0BAAA;ATukBJ;AS/kBA;EAYI,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ATskBJ;ASrlBA;EAoBM,iBAAA;EACA,eAAA;ATokBN;ASzlBA;EAyBM,YAAA;EACA,qBAAA;EACA,iBAAA;ATmkBN;ASjkBM;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;ATmkBR;ASnmBA;EAuCM,aAAA;AT+jBN;AStmBA;EA2CM,iBAAA;AT8jBN;ASzmBA;EA+CM,eAAA;EACA,iBAAA;EACA,qBAAA;AT6jBN;AS9mBA;EAuDM,eAAA;EACA,eAAA;AT0jBN;ASxjBM;EACE,iBAAA;AT0jBR;ASrnBA;EAgEM,eAAA;EACA,iBAAA;ATwjBN;ASznBA;EAuEM,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;ATqjBN;AS/nBA;EA+EI,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;ATmjBJ;ASroBA;;;;EAyFI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;ATkjBJ;AS/oBA;EAiGI,gBAAA;EACA,SAAA;EACA,cAAA;ATijBJ;ASppBA;EAuGI,SAAA;EACA,cAAA;ATgjBJ;ASxpBA;EA4GI,gBAAA;EACA,SAAA;EACA,cAAA;AT+iBJ;AS7pBA;EAkHI,SAAA;EACA,cAAA;AT8iBJ;ASjqBA;EAuHI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AT6iBJ;ASziBA;EACE;IACE,WAAA;ET2iBF;ESxiBA;IACE,kBAAA;IACA,iBAAA;ET0iBF;AACF;ASviBA;EACE,kBAAA;ATyiBF;AStiBA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;ATwiBF;ASriBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;ATuiBF;ASpiBA;EACE,WAAA;EACA,aAAA;ATsiBF;ASxiBA;;EAMI,oBAAA;ATsiBJ;AS5iBA;EAWM,YAAA;EACA,iBAAA;AToiBN;AShjBA;EAgBM,YAAA;EACA,iBAAA;EACA,qBAAA;ATmiBN;ASrjBA;EAwBM,eAAA;EACA,iBAAA;ATgiBN;ASzjBA;EA6BM,eAAA;EACA,iBAAA;EACA,qBAAA;AT+hBN;AS9jBA;EAoCI,8BAAA;EACA,gBAAA;EACA,gBAAA;AT6hBJ;ASnkBA;EA0CI,YAAA;AT4hBJ;AUhwBA;EACE,UAAA;EACA,QAAA;EACA,UAAA;AVkwBF;AU/vBA;EACE,aAAA;AViwBF;AU9vBA;EACE,cAAA;AVgwBF;AW3wBA;EACE,cAAA;EACA,gBAAA;AX6wBF;AW/wBA;EAKI,eAAA;EACA,YAAA;AX6wBJ;AWnxBA;EASM,iBAAA;EACA,iBAAA;AX6wBN;AW1wBI;EACE,mBAAA;AX4wBN;AWzwBI;EACE,mBAAA;AX2wBN;AWxwBI;EACE,mBAAA;AX0wBN;AWvwBI;EACE,mBAAA;AXywBN;AWnyBA;EA8BM,eAAA;EACA,gBAAA;AXwwBN;AWvyBA;EAkCQ,cAAA;AXwwBR;AW1yBA;EAsCQ,cAAA;AXuwBR;AW7yBA;EA0CQ,cAAA;AXswBR;AWhzBA;EA8CQ,cAAA;AXqwBR;AWnzBA;;;EAoDQ,iBAAA;AXowBR;AWxzBA;EAwDQ,mBAAA;AXmwBR;AW3zBA;EA4DQ,mBAAA;AXkwBR;AW9zBA;EAgEQ,mBAAA;AXiwBR;AWj0BA;;;EAsEQ,qBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AXgwBR;AW90BA;EAkFQ,aAAA;EACA,mBAAA;AX+vBR;AWl1BA;EAwFM,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AX6vBN;AWz1BA;EA+FQ,iBAAA;AX6vBR;AW51BA;EAmGQ,iBAAA;AX4vBR;AW/1BA;EAwGU,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AX0vBV;AWr2BA;EAgHQ,kBAAA;AXwvBR;AWx2BA;EAqHM,eAAA;EACA,iBAAA;AXsvBN;AWlvBM;EACE,WAAA;EACA,mBAAA;AXovBR;AYh3BA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AZk3BF;AYr3BA;EAMI,gBAAA;EACA,cAAA;AZk3BJ;AY92BA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AZg3BF;AYp3BA;EAOI,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;AZg3BJ;AY73BA;EAgBI,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AZg3BJ;AY14BA;EA6BM,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,iBAAA;AZg3BN;AY32BA;EAEI,qBAAA;EACA,kBAAA;AZ42BJ;AY/2BA;EAMM,cAAA;AZ42BN;AY12BM;EACE,YAAA;AZ42BR;AYz2BM;EACE,cAAA;EACA,eAAA;AZ22BR;AYz3BA;EAmBM,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AZy2BN;AY/3BA;EAyBQ,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,cAAA;AZy2BR;AYt4BA;EAiCQ,wBAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA;AZw2BR;AYl2BA;EACE,kBAAA;AZo2BF;AYl2BE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AZo2BJ;AYl3BA;EAkBI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;ECgFF,wBAAA;EACK,mBAAA;EACG,gBAAA;AboxBV;AY33BA;EAyBM,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AZq2BN;AYj4BA;EA+BQ,eAAA;AZq2BR;AYp4BA;EAmCQ,gBAAA;EACA,cAAA;AZo2BR;AYx4BA;EAyCQ,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AZk2BR;AYh2BQ;EACE,mBAAA;EACA,WAAA;AZk2BV;AY/1BQ;EACE,mBAAA;EACA,WAAA;AZi2BV;AY15BA;EA8DQ,mBAAA;EACA,eAAA;EACA,cAAA;AZ+1BR;AY/5BA;EAmEQ,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AZ+1BR;AY31BI;EACE,cAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AZ61BN;AY96BA;EAqFM,iBAAA;EACA,kBAAA;AZ41BN;AYl7BA;EAyFQ,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AZ41BR;AYz1BM;EAEI,mBAAA;AZ01BV;AYt1BM;EAEI,mBAAA;AZu1BV;AYn1BM;EAEI,mBAAA;AZo1BV;AYr8BA;EAsHQ,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AZk1BR;AY38BA;EA6HQ,qBAAA;EACA,6BAAA;EACA,gBAAA;AZi1BR;AYh9BA;EAqIQ,gBAAA;EACA,gBAAA;AZ80BR;AYp9BA;EA0IQ,cAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AZ60BR;AYz0BQ;EACE,UAAA;AZ20BV;AY/9BA;EAyJQ,gBAAA;AZy0BR;AYv0BQ;EACE,eAAA;AZy0BV;AYr+BA;EAkKM,eAAA;AZs0BN;AYj0BA;EACE,kBAAA;EACA,8BAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AZm0BF;AYx0BA;EAQI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AZm0BJ;AYh1BA;EAiBI,gBAAA;EACA,gBAAA;AZk0BJ;AYp1BA;EAsBI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AZi0BJ;AcjmCA;EAGM,gBAAA;AdimCN;AcpmCA;EAMQ,cAAA;EACA,eAAA;AdimCR;AcxmCA;EAYM,cAAA;Ad+lCN;Ac3mCA;EAgBI,YAAA;EACA,eAAA;Ad8lCJ;Ac1lCI;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Ad4lCN;AclmCI;EASI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;Ad4lCR;AcxmCI;EAeM,eAAA;EACA,aAAA;Ad4lCV;Ac5mCI;EAoBM,kBAAA;Ad2lCV;AepoCA;EAGM,qBAAA;EACA,gBAAA;EACA,mBAAA;AfooCN;AgBzoCA;EAEI,mBAAA;EACA,aAAA;AhB0oCJ;AgB7oCA;EAMM,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AhB0oCN;AgBppCA;EAaQ,kBAAA;EACA,OAAA;EACA,QAAA;AhB0oCR;AgBzpCA;EAoBM,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AhBwoCN;AgBjqCA;EA4BQ,kBAAA;EACA,OAAA;EACA,QAAA;AhBwoCR;AgBtqCA;EAmCM,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;AhBsoCN;AgBpoCM;EACE,yBAAA;EACA,kBAAA;AhBsoCR;AgBlrCA;EAiDM,eAAA;AhBooCN;AgBrrCA;EAoDQ,eAAA;AhBooCR;AgBxrCA;EA0DI,mBAAA;AhBioCJ;AgB3rCA;EA6DM,gBAAA;EACA,kBAAA;EACA,kBAAA;AhBioCN;AgBhsCA;EAkEQ,gBAAA;EACA,cAAA;AhBioCR;AgBpsCA;EAsEQ,kBAAA;EACA,OAAA;EACA,MAAA;AhBioCR;AgBzsCA;EA4EQ,kBAAA;EACA,WAAA;AhBgoCR;AgB7nCU;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AhB+nCZ;AiBrtCA;EACE,iBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AjButCF;AiBntCE;EACE,wBAAA;EACA,2BAAA;AjBqtCJ;AiBxtCA;EAOI,gBAAA;EACA,kHAAA;EACA,aAAA;EACA,SAAA;EACA,4DAAA;AjBotCJ;AiB/tCA;EAeQ,eAAA;EACA,iBAAA;EACA,cAAA;AjBmtCR;AiBjtCQ;EACE,WAAA;EACA,mBAAA;AjBmtCV;AiBxuCA;EA4BI,gBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AjB+sCJ;AiB9uCA;EAkCM,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AjB+sCN;AiB7sCM;EACE,cAAA;EACA,kBAAA;AjB+sCR;AiB5sCM;EACE,qBAAA;AjB8sCR;AiB/vCA;EAsDM,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EAEA,kBAAA;EACA,YAAA;EACA,iBAAA;AjB2sCN;AiBzsCM;EACE,mBAAA;AjB2sCR;AiB5wCA;EAqEQ,WAAA;AjB0sCR;AiB/wCA;EAyEQ,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AjBysCR;AiBvsCQ;EACE,YAAA;AjBysCV;AiBlsCA;;EAEE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AjBosCF;AiBlsCE;EAAA;;IACE,uBAAA;EjBssCF;AACF;AiB/sCA;;EAYI,cAAA;EACA,mBAAA;AjBusCJ;AiBptCA;;EAgBM,aAAA;EACA,eAAA;AjBwsCN;AiBztCA;;EAoBQ,aAAA;EACA,mBAAA;AjBysCR;AiB9tCA;;EAyBQ,qBAAA;EACA,WAAA;EACA,qBAAA;AjBysCR;AiBpuCA;;EAgCM,gBAAA;AjBwsCN;AiBxuCA;;EAoCM,gBAAA;EACA,eAAA;EACA,cAAA;AjBwsCN;AiB9uCA;;EA2CI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AjBusCJ;AiBrsCI;;EACE,aAAA;AjBwsCN;AiBzvCA;;EAsDI,4BAAA;AjBusCJ;AiB7vCA;;EAmEI,mBAAA;EACA,mBAAA;AjB8rCJ;AiBxsCI;EAAA;;IACE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EjB4sCJ;AACF;AiB3wCA;;EAuEM,mBAAA;AjBwsCN;AiB/wCA;;EA0EQ,aAAA;AjBysCR;AiBvsCQ;;EACE,mBAAA;AjB0sCV;AiBrsCQ;;EACE,aAAA;EACA,mBAAA;AjBwsCV;AiB1sCQ;;EAKI,eAAA;EACA,gBAAA;AjBysCZ;AiB/sCQ;;EAUI,gBAAA;EACA,aAAA;AjBysCZ;AiBrsCQ;;EACE,YAAA;AjBwsCV;AiBrsCQ;;EAEI,cAAA;EACA,eAAA;AjBusCZ;AiB1sCQ;;EAOI,eAAA;AjBusCZ;AiB9sCQ;;EAUM,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AjBwsCd;AiBttCQ;;EAkBM,iBAAA;EACA,iBAAA;AjBwsCd;AiB3tCQ;;EAuBM,cAAA;AjBwsCd;AiBjsCM;;EACE,WAAA;AjBosCR;AiBrsCM;;EAKM,aAAA;AjBosCZ;AiBzsCM;;EAQQ,eAAA;AjBqsCd;AiB7sCM;;EAcI,iBAAA;AjBmsCV;AiB/rCM;;EACE,gBAAA;AjBksCR;AiBnsCM;;EAII,gBAAA;AjBmsCV;AiB51CA;;EAgKI,gBAAA;AjBgsCJ;AiBh2CA;;EAmKM,aAAA;EACA,gBAAA;AjBisCN;AiB7rCE;;EAGM,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AjB8rCR;AiBpsCE;;EASQ,iBAAA;AjB+rCV;AiBxsCE;;EAgBM,cAAA;EACA,eAAA;AjB4rCR;AiB7sCE;;EAsBI,aAAA;EACA,gBAAA;EACA,gBAAA;AjB2rCN;AiB33CA;;EAqMI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AjB0rCJ;AiBl4CA;;EA2MM,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AjB2rCN;AiB34CA;;EAmNQ,gBAAA;AjB4rCR;AiB/4CA;;EAuNQ,eAAA;EACA,mBAAA;AjB4rCR;AiBxrCQ;;EACE,eAAA;AjB2rCV;AiBzrCU;;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,+CAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;AjB4rCZ;AiB36CA;;EAsPM,eAAA;AjByrCN;AiB/6CA;;EA2PI,gBAAA;EACA,gBAAA;EACA,eAAA;AjBwrCJ;AiBr7CA;;EAgQM,gBAAA;EACA,gBAAA;AjByrCN;AiB17CA;;EAqQM,gBAAA;EACA,gBAAA;AjByrCN;AiB/7CA;;EA2QI,kBAAA;EACA,aAAA;EACA,mBAAA;AjBwrCJ;AiBr8CA;;EAgRM,eAAA;EACA,cAAA;EACA,cAAA;AjByrCN;AiB38CA;;EAsRM,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AjByrCN;AiBl9CA;;EA6RM,kBAAA;EACA,OAAA;EACA,MAAA;AjByrCN;AiBx9CA;;EAkSQ,eAAA;EACA,kBAAA;AjB0rCR;AiB79CA;;EA4SM,mBAAA;AjBqrCN;AiBj+CA;;EAgTM,gBAAA;AjBqrCN;AiBr+CA;;EAmTQ,gBAAA;EACA,mBAAA;AjBsrCR;AiBhrCA;EACE,iCAAA;AjBkrCF;AiBnrCA;EAII,gBAAA;AjBkrCJ;AiBtrCA;EAOI,iBAAA;AjBkrCJ;AiBzrCA;EAWI,aAAA;EACA,uBAAA;AjBirCJ;AiB7rCA;EAeM,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;AjBirCN;AiB5qCA;EACE,kBAAA;EACA,+CAAA;EACA,UAAA;EAEA,YAAA;EACA,sBAAA;AjB6qCF;AiBnrCA;EASI,SAAA;EACA,WAAA;AjB6qCJ;AiBzqCA;EACE,gBAAA;EACA,cAAA;AjB2qCF;AiB7qCA;EAKI,aAAA;EACA,sBAAA;AjB2qCJ;AiBjrCA;EASM,SAAA;AjB2qCN;AiBprCA;EAaM,SAAA;AjB0qCN;AiBvrCA;EAmBM,WAAA;AjBuqCN;AiB1rCA;EAwBI,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AjBqqCJ;AiBnqCI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iCAAA;AjBqqCN;AiB5sCA;EA4CI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AjBmqCJ;AiBntCA;EAmDM,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AjBmqCN;AiB7tCA;EA8DM,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AjBkqCN;AiBruCA;EAuEM,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AjBiqCN;AiB7uCA;EAgFM,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AjBgqCN;AiBpvCA;EAwFM,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yBAAA;EACA,4BAAA;AjB+pCN;AiB5vCA;EAiGM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AjB8pCN;AiBpwCA;EA0GM,eAAA;EACA,gBAAA;EACA,4BAAA;AjB6pCN;AiBzwCA;EAgHM,eAAA;EACA,gBAAA;EACA,4BAAA;AjB4pCN;AiB9wCA;EAuHI,gBAAA;AjB0pCJ;AiBjxCA;EA0HM,kBAAA;AjB0pCN;AiBpxCA;EAiIQ,SAAA;AjBspCR;AiBvxCA;EAqIQ,gBAAA;EACA,cAAA;AjBqpCR;AiB3xCA;EA4IQ,cAAA;EACA,kBAAA;EACA,iBAAA;AjBkpCR;AiBhyCA;EAwJgB,QAAA;EACA,SAAA;AjB2oChB;AiBpyCA;EA6JgB,qBAAA;EACA,iBAAA;EACA,gBAAA;AjB0oChB;AiBzyCA;EAmKgB,iBAAA;EACA,eAAA;EACA,cAAA;AjByoChB;AiB9yCA;EA6KQ,gBAAA;AjBooCR;AiBloCQ;EACE,SAAA;EACA,cAAA;AjBooCV;AiBrzCA;EAsLQ,gBAAA;AjBkoCR;AiBxzCA;EA2LM,iBAAA;EACA,oBAAA;EACA,0BAAA;AjBgoCN;AiB7zCA;EAiMM,aAAA;EACA,yBAAA;AjB+nCN;AiBj0CA;EAqMQ,aAAA;AjB+nCR;AiBp0CA;EAwMU,mBAAA;EACA,4BAAA;EACA,OAAA;AjB+nCV;AiBz0CA;EAkNI,iBAAA;EACA,gBAAA;EACA,6BAAA;AjB0nCJ;AiB90CA;EAsNM,gBAAA;EACA,cAAA;EACA,aAAA;AjB2nCN;AiBvnCE;EAEI,eAAA;EACA,iBAAA;AjBwnCN;AiB3nCE;EAOI,iBAAA;EACA,iBAAA;AjBunCN;AiB/nCE;EAaI,6BAAA;AjBqnCN;AiBloCE;EAiBI,MAAA;EACA,kBAAA;AjBonCN;AiBtoCE;EAqBM,qBAAA;EACA,kBAAA;EACA,mEAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AjBonCR;AiB9oCE;EA6BQ,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AjBonCV;AiBlnCU;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AjBonCZ;AiBtqCE;EAyDI,kBAAA;EACA,yBAAA;EACA,qDAAA;EACA,mEAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AjBgnCN;AiB9mCM;EACE,mEAAA;EACA,eAAA;EACA,cAAA;AjBgnCR;AiB7mCM;EACE,yBAAA;EACA,8EAAA;AjB+mCR;AiBxrCE;EA+EI,gBAAA;AjB4mCN;AiB3rCE;EAmFI,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AjB2mCN;AiBjsCE;EAyFM,mBAAA;EACA,iBAAA;EACA,gBAAA;AjB2mCR;AiBrmCA;EACE,eAAA;AjBumCF;AiBxmCA;EAKM,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;AjBsmCN;AiB/mCA;EAYQ,mBAAA;AjBsmCR;AiBlnCA;EAeU,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AjBsmCV;AiBxnCA;EAsBU,iBAAA;AjBqmCV;AiB3nCA;EAyBY,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AjBqmCZ;AiBloCA;EAkCU,cAAA;EACA,eAAA;EACA,sBAAA;AjBmmCV;AiBvoCA;EAyCQ,iBAAA;EACA,6BAAA;AjBimCR;AiB/lCQ;EACE,SAAA;AjBimCV;AiB9oCA;EAiDU,eAAA;EACA,cAAA;AjBgmCV;AiB9lCU;EACE,eAAA;EACA,cAAA;AjBgmCZ;AiB9lCY;EACE,cAAA;EACA,0BAAA;AjBgmCd;AiB1pCA;EAgEU,iBAAA;EACA,eAAA;EACA,iBAAA;AjB6lCV;AiB1lCQ;EAEI,cAAA;AjB2lCZ;AiBvlCQ;EAEI,cAAA;AjBwlCZ;AiBplCQ;EAEI,cAAA;AjBqlCZ;AiB/kCI;EAEI,iBAAA;AjBglCR;AiB5kCI;EAEI,iBAAA;AjB6kCR;AiB/kCI;EAKM,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AjB6kCV;AiBvlCI;EAcM,mBAAA;EACA,eAAA;EACA,gBAAA;AjB4kCV;AiB5lCI;EAoBM,cAAA;EACA,eAAA;EACA,sBAAA;AjB2kCV;AiBjmCI;EA0BM,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AjB0kCV;AiBxkCU;EACE,cAAA;EACA,0BAAA;AjB0kCZ;AiBtkCQ;;EAGI,cAAA;AjBukCZ;AiBnkCQ;EAEI,cAAA;AjBokCZ;AiBtkCQ;EAKM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AjBokCd;AiB3jCA;EAEI,iBAAA;EACA,0BAAA;AjB4jCJ;AiB/jCA;EAOI,WAAA;AjB2jCJ;AiBvjCA;EAEI,mBAAA;AjBwjCJ;AiBpjCA;EAEI,mBAAA;AjBqjCJ;AiBvjCA;EAMI,mBAAA;AjBojCJ;AiBhjCA;;EAEE,oBAAA;AjBkjCF;AiBpjCA;;EAKI,cAAA;EACA,gBAAA;AjBmjCJ;AiBzjCA;;EAWM,mBAAA;AjBkjCN;AiB7jCA;;EAgBI,WAAA;AjBijCJ;AiBjkCA;;EAmBM,6BAAA;EACA,0BAAA;AjBkjCN;AiBhjCM;;EACE,gBAAA;EACA,SAAA;AjBmjCR;AiBrjCM;;EAKI,kBAAA;EACA,oBAAA;EACA,gBAAA;AjBojCV;AiBljCU;;EACE,iBAAA;AjBqjCZ;AiBrlCA;;EAsCQ,mBAAA;EACA,4BAAA;EACA,4BAAA;AjBmjCR;AiBjjCQ;;EACE,iBAAA;AjBojCV;AiBjjCQ;;EACE,eAAA;AjBojCV;AiBnmCA;;;;EAuDI,WAAA;AjBkjCJ;AiBzmCA;;;;EA2DQ,UAAA;AjBojCR;AiB/mCA;;;;EA+DQ,UAAA;AjBsjCR;AiBrnCA;;;;EAmEQ,UAAA;AjBwjCR;AiB3nCA;;;;EAuEQ,UAAA;AjB0jCR;AiBjoCA;;;;;;;;;;;;;;;;EA+EQ,kBAAA;AjBokCR;AiBnpCA;;;;;;;;;;;;;;;;EAkFU,gBAAA;EACA,gBAAA;AjBmlCV;AiBtqCA;;;;;;;;;;;;;;;;EAuFU,cAAA;EACA,eAAA;AjBimCV;AiB/lCU;;;;;;;;;;;;;;;;EACE,cAAA;AjBgnCZ;AiB3sCA;;;;;;;;;;;;;;;;EAgGU,iBAAA;EACA,cAAA;AjB6nCV;AiB1nCY;;;;;;;;;;;;;;;;EACE,aAAA;AjB2oCd;AiBvoCc;;;;;;;;;;;;;;;;EACE,aAAA;AjBwpChB;AiBlwCA;;;;;;;;EAmHU,mBAAA;AjBypCV;AiBvpCU;;;;;;;;EACE,gBAAA;AjBgqCZ;AiBtxCA;;;;;;;;EA4HQ,mBAAA;AjBoqCR;AiBhyCA;;;;;;;;EA+HU,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AjB2qCV;AiB7yCA;;;;;;;;EAsIU,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AjBirCV;AiB7qCU;;;;;;;;EACE,cAAA;EACA,gBAAA;AjBsrCZ;AiBxrCU;;;;;;;;EAKI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,+CAAA;EACA,gBAAA;AjB6rCd;AiBtsCU;;;;;;;;EAaI,yBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AjBmsCd;AiBn2CA;;;;;;;;EAuKQ,WAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AjBssCR;AiBpsCQ;;;;;;;;EACE,cAAA;EACA,0BAAA;AjB6sCV;AiBvsCA;EAEI,cAAA;AjBwsCJ;AiBpsCA;EAEI,eAAA;EACA,YAAA;AjBqsCJ;AiBxsCA;EAOI,iBAAA;EACA,kDAAA;AjBosCJ;AiB5sCA;EAWM,UAAA;AjBosCN;AiB/sCA;EAcQ,aAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;AjBosCR;AiBlsCQ;EACE,mBAAA;AjBosCV;AiBxtCA;EAwBU,aAAA;AjBmsCV;AiB/rCU;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AjBisCZ;AiBhuCA;EAqCQ,kBAAA;EACA,mBAAA;AjB8rCR;AiBpuCA;EAyCU,WAAA;AjB8rCV;AiB1rCU;EACE,WAAA;AjB4rCZ;AiBxrCQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oEAAA;AjB0rCV;AiBpvCA;EAgEQ,cAAA;AjBurCR;AiBvvCA;EAoEQ,cAAA;EACA,kBAAA;AjBsrCR;AiBhrCA;EACE,iBAAA;EACA,gBAAA;AjBkrCF;AiBprCA;EAKI,yBAAA;AjBkrCJ;AiBvrCA;EAQM,cAAA;AjBkrCN;AiB1rCA;EAaI,YAAA;AjBgrCJ;AiB7rCA;EAgBM,0BAAA;EACA,kBAAA;AjBgrCN;AiBjsCA;EAoBQ,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AjBgrCR;AiB1sCA;EA8BQ,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AjB+qCR;AiBntCA;EAwCQ,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AjB8qCR;AiB1tCA;EA+CU,aAAA;EACA,mBAAA;EACA,uBAAA;AjB8qCV;AiB1qCU;EACE,gBAAA;EACA,WAAA;EACA,WAAA;AjB4qCZ;AiBpqCA;EAGM,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EjBoqCJ,UAAU;EACV,WAAW;AACb;AiBrqCM;EACE,UAAA;EACA,mBAAA;AjBuqCR;AiBpqCM;EACE,mBAAA;AjBsqCR;AiBnqCM;EACE,mBAAA;EACA,mBAAA;AjBqqCR;AiBvrCA;EAsBU,eAAA;AjBoqCV;AiB1rCA;EAwBY,kBAAA;EACA,uBAAA;AjBqqCZ;AiB7pCA;EAEI,YAAA;EACA,gBAAA;AjB8pCJ;AkBz7EA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;AlB27EF;AkB97EA;EAMI,kBAAA;AlB27EJ;AkBj8EA;EAUI,kBAAA;EACA,YAAA;EACA,WAAA;AlB07EJ;AkBt8EA;EAgBI,qBAAA;AlBy7EJ;AkBz8EA;EAkBM,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AlB07EN;AkBx7EM;EACE,0BAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AlB07ER;AkBz9EA;EAmCQ,iBAAA;AlBy7ER;AkB59EA;EAuCQ,kBAAA;EACA,eAAA;EACA,iBAAA;AlBw7ER;AkBj+EA;EA6CM,gBAAA;AlBu7EN;AkBp+EA;EA+CQ,gBAAA;AlBw7ER;AkBv+EA;EAiDU,yBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AlBy7EV;AkBv7EU;EACE,yBAAA;AlBy7EZ;AkBh/EA;EA2DY,iBAAA;AlBw7EZ;AkBr7EU;EACE,6DAAA;EAEA,0BAAA;EACA,qBAAA;AlBs7EZ;AkBx/EA;EA2EM,eAAA;EACA,iBAAA;EACA,gBAAA;AlBg7EN;AkB7/EA;EAiFM,WAAA;EACA,YAAA;EACA,mBAAA;AlB+6EN;AkBlgFA;EAwFI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;AlB66EJ;AkBzgFA;EA+FM,UAAA;AlB66EN;AkB36EM;EACE,cAAA;AlB66ER;AkB36EM;EACE,cAAA;AlB66ER;AkB36EM;EACE,cAAA;AlB66ER;AkBrhFA;EA4GQ,qBAAA;EACA,eAAA;AlB46ER;AkB16EQ;EACE,cAAA;AlB46EV;AkB5hFA;EAsHM,kBAAA;AlBy6EN;AkB/hFA;EA4HM,qBAAA;EACA,kBAAA;EACA,kBAAA;AlBs6EN;AkBpiFA;EAkIU,eAAA;AlBq6EV;AkB95EI;EACE,oBAAA;AlBg6EN;AkB1iFA;EA+II,yBAAA;EACA,mBAAA;AlB85EJ;AkB9iFA;EAoJI,UAAA;EACA,gBAAA;EACA,kBAAA;AlB65EJ;AkBnjFA;EAwJM,gBAAA;AlB85EN;AkBtjFA;EA4JM,iBAAA;AlB65EN;AkBzjFA;EAiKI,UAAA;AlB25EJ;AkBv5EA;EAEI,WAAA;AlBw5EJ;AkB15EA;EAMI,UAAA;AlBu5EJ;AkBp5EE;EAEI,aAAA;AlBq5EN;AkBj5EE;EACE,YAAA;AlBm5EJ;AkBn6EA;EAoBI,SAAA;EACA,gBAAA;AlBk5EJ;AkBv6EA;EAyBI,UAAA;EACA,gBAAA;AlBi5EJ;AkB36EA;EA8BI,UAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AlBg5EJ;AkB54EA;EACE,cAAA;EACA,YAAA;EACA,oCAAA;AlB84EF;AkB34EA;EACE,aAAA;AlB64EF;AkB94EA;EAII,eAAA;AlB64EJ;AkBj5EA;EAQI,aAAA;EACA,SAAA;EACA,eAAA;AlB44EJ;AkBx4EA;EACE,UAAA;AlB04EF;AkBv4EA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AlBy4EF;AkB74EA;EAUM,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlBs4EN;AkBn5EA;EAgBQ,YAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AlBq4ER;AkB75EA;EA8BQ,gBAAA;EACA,gBAAA;AlBk4ER;AkB93EY;EAEI,SAAA;EACA,iBAAA;EACA,iBAAA;AlB+3EhB;AkBt6EA;EAiDI,WAAA;EACA,WAAA;EACA,WAAA;AlBw3EJ;AkB36EA;EA0DU,WAAA;AlBo3EV;AkB96EA;EA8DU,WAAA;AlBm3EV;AkBj7EA;EAsEM,kBAAA;EACA,sBAAA;AlB82EN;AkBr7EA;EAyEQ,WAAA;EACA,aAAA;EACA,mBAAA;AlB+2ER;AkB17EA;EA8EU,uBAAA;AlB+2EV;AkB77EA;EAiFU,cAAA;EACA,yBAAA;EACA,mBAAA;AlB+2EV;AkBl8EA;EAuFU,cAAA;AlB82EV;AkBr8EA;EA6FM,kBAAA;EACA,UAAA;EACA,WAAA;AlB22EN;AkB18EA;EAkGQ,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AlB22ER;AkBh9EA;EAwGU,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AlB22EV;AkBv9EA;EAkHM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AlBw2EN;AkB79EA;EA2HU,iBAAA;EACA,kBAAA;AlBq2EV;AkBj+EA;EAmII,WAAA;AlBi2EJ;AkBp+EA;EAsIM,mBAAA;AlBi2EN;AkB/1EM;EACE,kBAAA;EACA,mBAAA;AlBi2ER;AkB91EM;EACE,mBAAA;AlBg2ER;AkB9+EA;EAmJM,kBAAA;EACA,iBAAA;AlB81EN;AkBl/EA;EAuJQ,mBAAA;EACA,cAAA;EACA,uBAAA;AlB81ER;AkB11EQ;EACE,oBAAA;EACA,gCAAA;AlB41EV;AkBx1EU;EACE,gBAAA;AlB01EZ;AkBp1EQ;EACE,iBAAA;AlBs1EV;AkBl1EM;EAEI,SAAA;AlBm1EV;AkBpgFA;EAuLU,eAAA;EACA,kBAAA;AlBg1EV;AkBxgFA;EA6LQ,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AlB80ER;AkB9gFA;EAmMU,cAAA;AlB80EV;AkB50EU;EACE,cAAA;AlB80EZ;AkBphFA;EA4MQ,gBAAA;AlB20ER;AkBvhFA;EAgNQ,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yHAAA;AlB00ER;AkBx0EQ;EACE,eAAA;AlB00EV;AkBjiFA;EA4NQ,kBAAA;EACA,eAAA;EACA,WAAA;AlBw0ER;AkBtiFA;EAiOU,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AlBw0EV;AkB7iFA;EAyOU,kBAAA;EACA,WAAA;EACA,SAAA;AlBu0EV;AkBljFA;EAgPQ,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AlBq0ER;AkBn0EQ;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AlBq0EV;AkBj0EM;EAEI,cAAA;AlBk0EV;AkB3zEC;EACC,YAAA;AlB6zEF;AkB1zEA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AlB4zEF;AkBzzEA;EACE,WAAA;EACA,WAAA;AlB2zEF;AkB7zEA;EAKI,gBAAA;EACA,4BAAA;EACA,gBAAA;AlB2zEJ;AkBl0EA;EAWI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AlB0zEJ;AkBtzEA;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sFAAA;AlBwzEF;AkB7zEA;;EAcI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AlBmzEJ;AkBr0EA;;EAqBM,kBAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;AlBozEN;AkBh1EA;;EA+BQ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AlBqzER;AkBnzEQ;;EACE,UAAA;AlBszEV;AkB91EA;;EA6CQ,gBAAA;AlBqzER;AkBl2EA;;EAkDM,aAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlBozEN;AkB32EA;;EA2DM,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AlBozEN;AkBp3EA;;EAmEQ,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,iBAAA;AlBqzER;AkB/3EA;;;;EAiFI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AlBozEJ;AkB14EA;;;;;;;;EA0FM,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;ELzaJ,wBAAA;EACK,mBAAA;EACG,gBAAA;AbouFV;AkB1zEM;;;;;;;;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,oCAAA;EACA,WAAA;AlBm0ER;AkBh0EM;;;;;;;;EACE,mBAAA;AlBy0ER;AkBn0EA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AlBq0EF;AkBn0EE;EACE,WAAA;AlBq0EJ;AkB70EA;EAYI,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AlBo0EJ;AkBl0EI;EACE,kBAAA;AlBo0EN;AkBj0EI;EACE,yBAAA;EACA,mDAAA;AlBm0EN;AkB9zEA;;EAGI,WAAA;EACA,YAAA;AlB+zEJ;AkB3zEQ;;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AlB8zEV;AkB3zEQ;;EACE,YAAA;AlB8zEV;AkB5zEU;;EACE,WAAA;AlB+zEZ;AkBl1EA;;EA0BM,UAAA;EACA,SAAA;EACA,4CAAA;AlB4zEN;AkBx1EA;;EAgCU,eAAA;EACA,cAAA;AlB4zEV;AkB1zEU;;EACE,mBAAA;AlB6zEZ;AkB3zEY;;EACE,8BAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AlB8zEd;AkBx2EA;;EAkDM,SAAA;AlB0zEN;AkB52EA;;EAqDQ,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AlB2zER;AkBzzEQ;;EACE,yBAAA;AlB4zEV;AkBzzEQ;;EACE,yBAAA;EACA,mDAAA;AlB4zEV;AkBxzEU;;EACE,YAAA;AlB2zEZ;AkBj4EA;;EA4EY,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AlByzEZ;AkBvzEY;;EACE,mBAAA;AlB0zEd;AkBvzEY;;EACE,cAAA;AlB0zEd;AkBn5EA;;EA6Fc,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AlB0zEd;AkBxzEc;;EACE,mBAAA;AlB2zEhB;AkBlzEE;EACE,kBAAA;AlBozEJ;AkBrzEE;EAII,kBAAA;EACA,SAAA;AlBozEN;AkBlzEM;EACE,yBAAA;EACA,mDAAA;EACA,eAAA;AlBozER;AkBl7EA;EAoII,gBAAA;AlBizEJ;AkBr7EA;EAuIM,iBAAA;AlBizEN;AkBx7EA;EA4II,gBAAA;AlB+yEJ;AkB37EA;EAgJI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AlB8yEJ;AkBl8EA;EAwJI,gBAAA;EACA,kBAAA;EACA,UAAA;AlB6yEJ;AkBv8EA;EA8JI,eAAA;AlB4yEJ;AkB18EA;EAkKI,kBAAA;EACA,UAAA;AlB2yEJ;AkB98EA;EAuKI,kBAAA;EACA,UAAA;EACA,SAAA;AlB0yEJ;AkBvyEE;;;;;;EAOI,kBAAA;EACA,UAAA;AlBwyEN;AkBpyEE;;;;;;EAOI,kBAAA;EACA,UAAA;AlBqyEN;AmBjoGA;EAEI,kBAAA;EACA,qBAAA;AnBkoGJ;AmBroGA;EAMM,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AnBkoGN;AoB7oGA;EACE,WAAA;ApB+oGF;AoB7oGE;EACE,YAAA;ApB+oGJ;AoBnpGA;EAQI,OAAA;EACA,WAAA;ApB8oGJ;AoBvpGA;EAaI,oBAAA;ApB6oGJ;AoBzoGA;EACE,yBAAA;EACA,cAAA;EACA,SAAA;ApB2oGF;AoB9oGA;EAMI,cAAA;ApB2oGJ;AoBjpGA;;EAWI,iBAAA;ApB0oGJ;AoBtoGA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;ApBwoGF;AqB9qGA;EACE,WAAA;ArBgrGF;AqBjrGA;EAII,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;ArBgrGJ;AqBvrGA;EAYM,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;ArB8qGN;AqBhsGA;EAqBM,aAAA;EACA,6BAAA;ArB8qGN;AqB5qGM;EAEI,eAAA;EACA,gBAAA;ArB6qGV;AqBhrGM;EAMI,eAAA;EACA,iBAAA;EACA,cAAA;ArB6qGV;AqBzqGM;;EAEE,eAAA;EACA,gBAAA;ArB2qGR;AqBxqGM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;ArB0qGR;AqBxqGQ;EACE,cAAA;ArB0qGV;AqBvqGQ;EACE,cAAA;ArByqGV;AqBlqGA;EACE,WAAA;ArBoqGF;AqBrqGA;EAII,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;ArBoqGJ;AqB3qGA;EAYM,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;ArBkqGN;AqBprGA;EAqBM,aAAA;EACA,6BAAA;ArBkqGN;AqBhqGM;EAEI,eAAA;EACA,gBAAA;ArBiqGV;AqBpqGM;EAMI,eAAA;EACA,iBAAA;EACA,cAAA;ArBiqGV;AqB7pGM;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ArB+pGR;AqB5pGM;EACE,iBAAA;ArB8pGR;AsBrwGA;EACE;;IAEE,YAAA;IACA,aAAA;EtBuwGF;EsBpwGA;IAEI,UAAA;EtBqwGJ;EsBvwGA;IAMI,UAAA;EtBowGJ;EsB1wGA;IAUI,wBAAA;EtBmwGJ;EsB7wGA;IAaI,MAAA;IACA,UAAA;IACA,aAAA;IACA,iBAAA;EtBmwGJ;EsBnxGA;IAmBM,UAAA;EtBmwGN;EsBtxGA;IAuBM,sBAAA;IACA,4BAAA;IACA,gBAAA;EtBkwGN;EsB3xGA;IA4BQ,gBAAA;EtBkwGR;EsB9xGA;IAgCQ,gBAAA;EtBiwGR;EsBjyGA;IAoCQ,WAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;EtBgwGR;EsBvyGA;IA2CQ,aAAA;EtB+vGR;EsB1yGA;IA+CQ,aAAA;EtB8vGR;AACF;AsBxvGA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;ET2HA,wBAAA;EACK,mBAAA;EACG,gBAAA;AbgoGV;AsBrwGA;EAYI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AtB4vGJ;AsB3wGA;EAkBM,kBAAA;AtB4vGN;AsB9wGA;EAsBM,aAAA;AtB2vGN;AsBjxGA;EA2BI,kBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AtByvGJ;AsBvvGI;EACE,+FAAA;AtByvGN;AsBhvGI;EACE,YAAA;AtBkvGN;AsB/uGI;EACE,mBAAA;EACA,qBAAA;AtBivGN;AsB9uGI;EACE,4CAAA;AtBgvGN;AsBpyGA;EAwDM,4BAAA;AtB+uGN;AsB3uGM;EACE,cAAA;EACA,eAAA;AtB6uGR;AsB3yGA;EAmEM,oBAAA;AtB2uGN;AsB9yGA;EAqEQ,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AtB4uGR;AsBxzGA;EAgFQ,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AtB2uGR;AsBp0GA;EA8FM,yBAAA;AtByuGN;AsBv0GA;EAgGQ,iBAAA;EACA,6BAAA;AtB0uGR;AsB30GA;EAmGU,iBAAA;AtB2uGV;AsB90GA;EAuGU,iBAAA;EACA,WAAA;AtB0uGV;AsBl1GA;EA4GU,eAAA;EACA,cAAA;AtByuGV;AsBvuGU;EACE,cAAA;EACA,0BAAA;AtByuGZ;AsB11GA;EAsHU,eAAA;EACA,iBAAA;AtBuuGV;AsB91GA;EA8HQ,cAAA;EACA,iBAAA;AtBmuGR;AsBjuGQ;EACE,cAAA;AtBmuGV;AsBr2GA;EAuIQ,mBAAA;AtBiuGR;AsBx2GA;EA2IY,WAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AtBguGZ;AsB9tGY;;EAEE,mBAAA;EACA,cAAA;AtBguGd;AsB7tGY;EACE,yBAAA;AtB+tGd;AsBz3GA;EAkKM,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AtB0tGN;AsBxtGM;EACE,cAAA;EACA,0BAAA;AtB0tGR;AsBn4GA;EA6KQ,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AtBytGR;AsB34GA;EAuLM,kBAAA;EACA,WAAA;EACA,SAAA;AtButGN;AsBh5GA;;EA6LQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AtButGR;AsBz5GA;EAsMQ,mBAAA;AtBstGR;AsB55GA;EA0MQ,mBAAA;AtBqtGR;AsB/5GA;EA8MQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AtBotGR;AsBjtGM;EAEI,qCAAA;AtBktGV;AsB/6GA;EAoOQ,qBAAA;AtB8sGR;AsBl7GA;EAyOM,kBAAA;AtB4sGN;AsBr7GA;EA6OM,aAAA;AtB2sGN;AsBx7GA;EAiPM,kBAAA;AtB0sGN;AsB37GA;EAmPQ,eAAA;EACA,mBAAA;AtB2sGR;AsB/7GA;EAyPM,WAAA;EACA,YAAA;EACA,eAAA;AtBysGN;AsBp8GA;EA8PQ,eAAA;EACA,iBAAA;AtBysGR;AsBx8GA;EAkQU,WAAA;EACA,YAAA;EACA,mBAAA;AtBysGV;AsB78GA;EAyQQ,4BAAA;EACA,eAAA;EACA,iBAAA;AtBusGR;AsBrsGQ;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AtBusGV;AsBx9GA;EAuRM,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AtBosGN;AsB/9GA;EA+RM,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AtBmsGN;AsB/rGA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AtBisGF;AsB/rGE;EACE,kBAAA;AtBisGJ;AsBzsGA;EAWI,kBAAA;AtBisGJ;AsB9rGA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AtBgsGF;AuBpjHA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AvBsjHF;AuBzjHA;EAMI,cAAA;EACA,iBAAA;AvBsjHJ;AuBpjHI;EACE,eAAA;EACA,cAAA;AvBsjHN;AuBjkHA;;EAiBI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AvBojHJ;AwBzkHA;EAGM,WAAA;EACA,WAAA;AxBykHN;AwB7kHA;EAOQ,UAAA;EACA,WAAA;EACA,mBAAA;AxBykHR;AwBllHA;EAaQ,sBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AxBwkHR;AwBlkHA;EACE,eAAA;EACA,WAAA;EACA,WAAA;AxBokHF;AwBvkHA;EAMI,WAAA;EACA,qBAAA;EACA,6BAAA;AxBokHJ;AwB5kHA;EAYQ,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AxBmkHR;AwB/jHI;EAEI,gBAAA;AxBgkHR;AwBrlHA;EA2BQ,gBAAA;EACA,gBAAA;EACA,kBAAA;AxB6jHR;AwB1lHA;EAiCQ,gBAAA;EACA,cAAA;EACA,mCAAA;AxB4jHR;AwB/lHA;EAsCU,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AxB4jHV;AwB1jHU;EACE,mBAAA;AxB4jHZ;AwB/mHA;EA0DM,mBAAA;EACA,WAAA;AxBwjHN;AwBnnHA;EA8DQ,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AxBwjHR;AwB1nHA;EAsEQ,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;AxBujHR;AwBjoHA;EA4EU,WAAA;EACA,YAAA;AxBwjHV;AwBroHA;EAgFY,eAAA;EACA,kBAAA;EACA,gBAAA;AxBwjHZ;AwB1oHA;EAwFQ,kBAAA;EACA,kBAAA;EACA,gBAAA;AxBqjHR;AwB/oHA;EA8FQ,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;AxBojHR;AwBvpHA;EAsGU,gBAAA;AxBojHV;AwB1pHA;EA0GU,mBAAA;EACA,sBAAA;AxBmjHV;AwBjjHU;EACE,gBAAA;EACA,iBAAA;AxBmjHZ;AwB5iHU;EACE,aAAA;AxB8iHZ;AwB3iHU;EACE,WAAA;AxB6iHZ;AwBxqHA;EAiIQ,qBAAA;AxB0iHR;AwB3qHA;EAoIU,WAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AxB0iHV;AwBxiHU;EACE,aAAA;EACA,cAAA;AxB0iHZ;AwBtiHQ;EAEI,aAAA;AxBuiHZ;AwBriHY;EACE,cAAA;AxBuiHd;AwB9hHA;EAEI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AxB+hHJ;AyB5tHA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AzB8tHF;AyBluHA;EAOI,gBAAA;EACA,gCAAA;EACA,mBAAA;AzB8tHJ;AyBvuHA;EAaI,gBAAA;AzB6tHJ;AyBztHA;EAEI,kBAAA;AzB0tHJ;AyB5tHA;EAMI,kBAAA;EACA,+CAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AzBytHJ;AyBpuHA;EAcM,kBAAA;EACA,SAAA;EACA,WAAA;AzBytHN;AyBzuHA;EAmBQ,WAAA;EACA,cAAA;AzBytHR;AyB7uHA;EA0BI,SAAA;EACA,WAAA;AzBstHJ;AyBjtHA;EAEI,kBAAA;AzBktHJ;AyBptHA;EAKM,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AzBktHN;AyB1tHA;EAaI,aAAA;EACA,SAAA;AzBgtHJ;AyB9tHA;EAkBI,gBAAA;AzB+sHJ;AyB5sHM;EACE,yDAAA;AzB8sHR;AyB1sHQ;EACE,YAAA;AzB4sHV;AyBxsHM;EACE,qBAAA;AzB0sHR;AyB1uHA;EAqCM,kBAAA;AzBwsHN;AyB7uHA;EA0CI,sBAAA;AzBssHJ;AyBhvHA;EA6CM,cAAA;EACA,gBAAA;AzBssHN;AyBpvHA;EAkDM,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AzBqsHN;AyB1vHA;EAwDQ,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AzBqsHR;AyB/rHI;EACE,mBAAA;AzBisHN;AyB9rHI;EACE,mBAAA;AzBgsHN;AyB7rHI;EACE,kBAAA;AzB+rHN;AyBhsHI;EAII,cAAA;AzB+rHR;AyB7wHA;EAoFI,cAAA;AzB4rHJ;AyBhxHA;EAuFM,yBAAA;EACA,+CAAA;AzB4rHN;AyBpxHA;EA6FI,iBAAA;AzB0rHJ;AyBtrHI;EACE,6BAAA;AzBwrHN;AyB1xHA;EAuGI,cAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;AzBsrHJ;AyBprHI;EACE,cAAA;AzBsrHN;AyBprHM;EACE,WAAA;AzBsrHR;AyBtyHA;EvBxBE,2BAAA;EuB+IE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AzBmrHJ;AyB9yHA;E1B5CE,aAAA;EAoDA,8BAAA;EAhCA,mBAAA;E0B0JE,qBAAA;AzBkrHJ;AyBpzHA;EAqIM,OAAA;EACA,YAAA;AzBkrHN;AyBxzHA;EA0IM,gBAAA;AzBirHN;AyB3zHA;EA8IM,cAAA;AzBgrHN;AyB9zHA;EAkJM,aAAA;AzB+qHN;AyBj0HA;EAuJQ,gBAAA;AzB6qHR;AyBp0HA;EA4JM,sCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AzB2qHN;AyB10HA;;;EAsKI,eAAA;EACA,cAAA;EACA,iBAAA;AzByqHJ;AyBj1HA;EA4KI,aAAA;AzBwqHJ;AyBtqHI;EACE,cAAA;AzBwqHN;AyBv1HA;EAoLI,cAAA;EACA,iBAAA;AzBsqHJ;AyBpqHI;EACE,sBAAA;EACA,gBAAA;AzBsqHN;AyB/1HA;;EA+LI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AzBoqHJ;AyBt2HA;EAsMI,OAAA;EACA,mBAAA;AzBmqHJ;AyB12HA;EA0MM,sCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AzBmqHN;AyBh3HA;;;;EAqNI,YAAA;AzBiqHJ;AyBt3HA;EAyNI,gBAAA;AzBgqHJ;AyBz3HA;EA6NI,iBAAA;EACA,kBAAA;AzB+pHJ;AGn6HE;EACE,eAAA;AHq6HJ;AyB/pHI;EACE,mBAAA;AzBiqHN;AGv5HE;EACE,eAAA;AHy5HJ;AyBrqHI;EAKI,aAAA;AzBmqHR;AyBz4HA;;;;EA+OI,eAAA;AzBgqHJ;AyB/4HA;EAmPI,iBAAA;AzB+pHJ;AyBl5HA;EAsPM,SAAA;EACA,eAAA;EACA,kBAAA;AzB+pHN;AyB7pHM;EACE,cAAA;EACA,UAAA;EzB+pHN,YAAY;AACd;AyB55HA;EvBpCE,2BAAA;EuBwSE,eAAA;EACA,iBAAA;EACA,cAAA;AzB4pHJ;AyBl6HA;EvBpCE,2BAAA;EuB+SE,eAAA;EACA,cAAA;AzB2pHJ;AyBv6HA;EAiRM,gBAAA;EACA,UAAA;AzBypHN;AyB36HA;EAqRQ,mBAAA;AzBypHR;AyB96HA;EvBpCE,2BAAA;EuB+SE,eAAA;EACA,cAAA;EAaM,iBAAA;AzB2pHV;AyBp7HA;EA8RQ,cAAA;EACA,eAAA;EvBnUN,2BAAA;AF69HF;AyBz7HA;EvBpCE,2BAAA;EuB+SE,eAAA;EACA,cAAA;EA4BE,mBAAA;AzBupHN;AyBrpHM;EACE,WAAA;AzBupHR;AyB9oHM;;;EACE,YAAA;EACA,kBAAA;AzBkpHR;AyBx8HA;EA4TI,SAAA;AzB+oHJ;AyB38HA;EAkUQ,cAAA;AzB4oHR;AyB1oHQ;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AzB4oHV;AyBn9HA;EA8UI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AzBwoHJ;AyBtoHI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iCAAA;AzBwoHN;AyBr+HA;EAkWI,kBAAA;EACA,YAAA;AzBsoHJ;AyBz+HA;EAsWM,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AzBsoHN;AyBp/HA;EAkXM,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AzBqoHN;AyBjgIA;EA+XQ,iBAAA;EACA,sBAAA;AzBqoHR;AyBrgIA;EAoYQ,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AzBooHR;AyB7gIA;EA6YQ,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AzBmoHR;AyBnhIA;EAqZM,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AzBioHN;AyBzhIA;EA6ZI,wBAAA;AzB+nHJ;AyB5hIA;EAkaM,aAAA;AzB6nHN;AyB3nHM;EACE,yBAAA;EACA,eAAA;AzB6nHR;AyBniIA;EA2aM,kBAAA;EACA,yBAAA;AzB2nHN;AyBviIA;EA+aQ,WAAA;AzB2nHR;AyBrnHI;EAEI,yBAAA;AzBsnHR;AyB7iIA;EA6bI,aAAA;EACA,yBAAA;EACA,kBAAA;AzBmnHJ;AyBljIA;EAmcI,mBAAA;AzBknHJ;AyBrjIA;;EAwcI,gBAAA;AzBinHJ;AyB7mHI;EACE,uBAAA;AzB+mHN;AyBzmHA;;EAEE,gBAAA;EACA,cAAA;AzB2mHF;AyBvmHI;;;;EACE,sBAAA;EACA,cAAA;AzB4mHN;AyBrnHA;;EAcI,eAAA;EACA,gBAAA;EACA,kBAAA;AzB2mHJ;AyB3nHA;;EAoBI,eAAA;EACA,yBAAA;AzB2mHJ;AyBhoHA;;EAyBI,eAAA;EACA,6BAAA;AzB2mHJ;AyBroHA;;EA6BM,gBAAA;EACA,eAAA;EACA,kBAAA;AzB4mHN;AyB3oHA;;EAmCM,eAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AzB4mHN;AyBnpHA;;EA4CI,gBAAA;AzB2mHJ;AyBvpHA;;EA+CM,WAAA;EACA,kBAAA;AzB4mHN;AyB5pHA;;EAmDQ,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AzB6mHR;AyBpqHA;;EA4DM,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AzB4mHN;AyB3qHA;;EAkEQ,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AzB6mHR;AyBprHA;;EA2EQ,gBAAA;EACA,eAAA;AzB6mHR;AyBzrHA;;EAgFQ,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AzB6mHR;AyBhsHA;;EA0FM,mBAAA;AzB0mHN;AyBpsHA;;EA+FQ,iBAAA;AzBymHR;AyBvmHQ;;EACE,eAAA;AzB0mHV;AyBvmHQ;;EACE,kBAAA;AzB0mHV;AyBhtHA;;EA0GU,cAAA;AzB0mHV;AyBxmHU;;EACE,qBAAA;EACA,cAAA;AzB2mHZ;AyBztHA;;EAqHM,yBAAA;EACA,SAAA;AzBwmHN;AyB9tHA;;EAyHQ,mBAAA;AzBymHR;AyBluHA;;EA4HU,YAAA;EACA,mBAAA;AzB0mHV;AyBvuHA;;EAiIU,gBAAA;AzB0mHV;AyB3uHA;;EAqIU,gBAAA;EACA,SAAA;AzB0mHV;AyBpmHY;;;;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AzBymHd;AyB3vHA;;EAwJU,mBAAA;AzBumHV;AyB/vHA;;;;;;EAgKc,gBAAA;AzBumHd;AyBrmHc;;;;;;EACE,SAAA;EACA,cAAA;AzB4mHhB;AyBjmHkB;;EACE,0BAAA;AzBomHpB;AyBzlHU;;EACE,cAAA;AzB4lHZ;AyBxxHA;;EAkMQ,iBAAA;AzB0lHR;AyB5xHA;;EAyMU,kBAAA;EACA,YAAA;EACA,kBAAA;AzBulHV;AyBrlHU;;EACE,6BAAA;AzBwlHZ;AyBtlHY;;EACE,YAAA;AzBylHd;AyB7lHU;;EAQI,mBAAA;EACA,gBAAA;AzBylHd;AyB/yHA;;EA+NI,eAAA;AzBolHJ;AyBnzHA;;EAmOI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AzBolHJ;AyBhlHA;EAEI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AzBilHJ;AyBzlHA;EAYI,qBAAA;AzBglHJ;AyB5lHA;EAgBI,oBAAA;EACA,kBAAA;AzB+kHJ;AyBhmHA;EAoBM,oBAAA;EACA,cAAA;EACA,cAAA;AzB+kHN;AyBrmHA;EA4BM,oBAAA;AzB4kHN;AyBzkHQ;EACE,sBAAA;EACA,cAAA;AzB2kHV;AyB5mHA;EAwCQ,YAAA;EACA,gBAAA;AzBukHR;AyBhnHA;EA4CU,iBAAA;AzBukHV;AyBpkHQ;EACE,SAAA;EACA,cAAA;AzBskHV;AyBvnHA;EAsDQ,WAAA;AzBokHR;AyB1nHA;EA0DY,kBAAA;EACA,YAAA;EACA,kBAAA;AzBmkHZ;AyB/nHA;EAmEM,kBAAA;EACA,aAAA;EACA,2BAAA;AzB+jHN;AyBpoHA;EA0EI,0BAAA;AzB6jHJ;AyB3jHI;EAEI,mBAAA;EACA,mBAAA;AzB4jHR;AyB3oHA;EAoFM,mBAAA;EACA,mBAAA;AzB0jHN;AyB/oHA;EAyFM,SAAA;EACA,SAAA;AzByjHN;AyBpjHA;EACE;;IAEE,SAAA;EzBsjHF;EyBnjHA;IACE,cAAA;EzBqjHF;AACF;AyBljHA;EACE,aAAA;AzBojHF;AyBjjHA;EAEI,gBAAA;AzBkjHJ;AyBpjHA;EAKM,eAAA;EACA,cAAA;AzBkjHN;AyB/iHI;EAEI,cAAA;EACA,iBAAA;AzBgjHR;AyB5iHI;EAEI,cAAA;EACA,iBAAA;AzB6iHR;A0B55IA;EACE,iBAAA;A1B85IF;A0Bx5IU;EAEI,gBAAA;A1By5Id;A0B35IU;EAMI,gBAAA;EACA,yBAAA;A1Bw5Id;A0Bt6IA;EAuBI,kBAAA;EACA,eAAA;A1Bk5IJ;A0Bh5II;EACE,gBAAA;A1Bk5IN;A0B76IA;EA+BM,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;A1Bi5IN;A0Bt7IA;EAwCQ,YAAA;A1Bi5IR;AACA;;;EAGE;A2B77ID;;ECOD,2BAAA;EACA,6CAAA;EACA,yBAAA;EACA,sBAAA;EACC,kBAAA;EACD,qBAAA;EACA,sBAAA;EACC,iBAAA;EACD,2BAAA;EACC,sBAAA;A5B07ID;A2B18IC;ECmBA,kBAAA;A5B07ID;A2B78IC;;ECuBA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;A5B07ID;AACA;EACE;A2Bt9ID;EC+BA,gBAAA;EACA,UAAA;A5B07ID;A2B19IC;;ECoCA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;A5B07ID;AACA;EACE;A2B3+ID;ECqDA,OAAA;EACA,WAAA;A5By7ID;AACA;;EAEE;A2Bl/ID;EC6DA,UAAA;EACA,QAAA;A5Bw7ID;A2Bt/IC;ECiEA,SAAA;A5Bw7ID;A2Bz/IC;ECoED,mCAAA;EACC,2BAAA;EACA,kBAAA;A5Bw7ID;A2B9/IC;ECyEA,YAAA;EACA,WAAA;A5Bw7ID;A2BlgJC;;EC8ED,kCAAA;EACC,0BAAA;A5Bw7ID;A2BvgJC;ECkFA,0BAAA;A5Bw7ID;AACA;EACE;A2B5gJD;ECwFA,YAAA;A5Bu7ID;A2B/gJC;EC2FA,WAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;A5Bu7ID;A2BrhJC;ECiGA,WAAA;A5Bu7ID;A2BxhJC;ECoGA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A5Bu7ID;A2B9hJC;EC0GA,WAAA;EACA,WAAA;A5Bu7ID;AACA;;EAEE;A2BriJD;ECkHA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wDAAA;A5Bs7ID;A2B3iJC;ECwHA,kBAAA;A5Bs7ID;A2B9iJC;EC2HA,mBAAA;A5Bs7ID;AACA;EACE;A2BnjJD;ECiIA,iBAAA;A5Bq7ID;A2BtjJC;ECoIA,iBAAA;A5Bq7ID;A2BzjJC;ECuIA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;A5Bq7ID;A2BhkJC;ECgJA,yEAAA;A5Bm7ID;AACA;EACE;A2BrkJD;;ECyJA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;A5Bg7ID;A2BhlJC;ECmKA,UAAA;A5Bg7ID;A2BnlJC;;ECuKA,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;A5Bg7ID;A2B1lJC;EC6KA,SAAA;A5Bg7ID;AACA;EACE;A2B/lJD;ECoLA,mBAAA;A5B86ID;A2BlmJC;;;ECyLA,mBAAA;A5B86ID;AACA;;EAEE;A2B1mJD;;EEMD,2BAAA;EACC,sBAAA;A7BwmJD;A2B/mJC;EEUA,kBAAA;EACA,WAAA;A7BwmJD;AACA;;EAEE;A2BtnJD;EEkBA,kBAAA;EACA,mBAAA;EACA,kBAAA;A7BumJD;A2B3nJC;EEuBA,WAAA;EACA,eAAA;A7BumJD;AACA;;EAEE;A2BloJD;EE+BA,kBAAA;EACA,gBAAA;A7BsmJD;A2BtoJC;EEmCA,gBAAA;A7BsmJD;A2BzoJC;EEsCA,gBAAA;A7BsmJD;AACA;;EAEE;A2B/oJD;EE6CA,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;A7BqmJD;A2BtpJC;EEoDA,uCAAA;EACA,+BAAA;A7BqmJD;A2B1pJC;EEwDC,sCAAA;EACA,8BAAA;A7BqmJF;A2B9pJC;EE8DA,iBAAA;EACA,UAAA;EACA,WAAA;A7BmmJD;A2BnqJC;EEmEA,YAAA;A7BmmJD;A2BtqJC;EEsEA,YAAA;A7BmmJD;AACA;;EAEE;A2B5qJD;EE6EA,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;A7BkmJD;A2BlrJC;EEmFA,qCAAA;EACA,6BAAA;EACA,kBAAA;A7BkmJD;A2BvrJC;EEwFC,oCAAA;EACA,4BAAA;A7BkmJF;A2B3rJC;EE8FA,UAAA;EACA,WAAA;EACA,gBAAA;A7BgmJD;A2BhsJC;EEmGA,WAAA;A7BgmJD;A2BnsJC;EEsGA,WAAA;A7BgmJD;A2BtsJC;EGCA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A9BwsJD;A2BjtJC;EGYD,qCAAA;EACI,6BAAA;EACA,SAAA;EACA,YAAA;A9BwsJJ;A2BvtJC;EGkBD,qCAAA;EACI,6BAAA;EACA,QAAA;EACA,WAAA;A9BwsJJ;A2B7tJC;EGwBA,oCAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;A9BwsJD;A2BnuJC;EG8BA,sCAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;A9BwsJD;A+BvuJA;EAEI,cAAA;A/BwuJJ;A+B1uJA;EAMI,kBAAA;A/BuuJJ;A+B7uJA;EAUI,aAAA;A/BsuJJ;A+BhvJA;EAcI,UAAA;EACA,cAAA;A/BquJJ;A+BpvJA;EAoBM,iBAAA;EACA,gBAAA;EACA,kBAAA;A/BmuJN;A+BzvJA;EA0BU,eAAA;A/BkuJV;A+B5vJA;EA4BY,kBAAA;EACA,uBAAA;A/BmuJZ;A+B3tJI;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;A/B6tJN;A+BzwJA;EAgDM,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;A/B4tJN;A+B1tJM;EACE,eAAA;EACA,0BAAA;A/B4tJR;A+BztJM;EACE,eAAA;EACA,0BAAA;A/B2tJR;A+BxtJM;;EAEE,aAAA;A/B0tJR;AgC9xJA;EAEI,aAAA;AhC+xJJ;AgCjyJA;EAKM,kBAAA;AhC+xJN;AgC1xJA;EAEI,2BAAA;EACA,gBAAA;AhC2xJJ;AgC9xJA;EAMM,gBAAA;AhC2xJN;AgCvxJM;EACE,WAAA;EACA,eAAA;AhCyxJR;AgCryJA;EAkBI,aAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AhCqxJJ;AgC7yJA;EA2BM,eAAA;EACA,cAAA;EACA,YAAA;AhCqxJN;AgClzJA;EAiCM,OAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AhCoxJN;AgClxJM;EACE,aAAA;AhCoxJR;AgCjxJM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AhCmxJR;AgCl0JA;EAoDM,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AhCixJN;AgCz0JA;EA2DQ,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AhCixJR;AgC/wJQ;EACE,gBAAA;EACA,cAAA;AhCixJV;AgCr1JA;EAwEU,SAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AhCgxJV;AgC51JA;EAiFQ,gBAAA;AhC8wJR;AgC/1JA;EAyFQ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AhCywJR;AgCr2JA;EAgGQ,mBAAA;EACA,gBAAA;EACA,YAAA;AhCwwJR;AgCtwJQ;EACE,eAAA;AhCwwJV;AgCrwJQ;EACE,6BAAA;AhCuwJV;AgCpwJQ;EACE,gBAAA;AhCswJV;AgCn3JA;EAkHY,gBAAA;EACA,sBAAA;EACA,gCAAA;EACA,YAAA;EACA,SAAA;AhCowJZ;AgC13JA;EAyHc,iBAAA;EACA,WAAA;AhCowJd;AgC93JA;EA8Hc,gBAAA;EACA,YAAA;AhCmwJd;AgCl4JA;EAmIc,gBAAA;AhCkwJd;AgCr4JA;EAuIc,gBAAA;AhCiwJd;AgCx4JA;EA2Ic,kBAAA;AhCgwJd;AgC5vJc;;;EAGE,yBAAA;EACA,kBAAA;EACA,mBAAA;AhC8vJhB;AgCnwJc;;;EAQI,mBAAA;AhCgwJlB;AgCv5JA;EAgKQ,gBAAA;EACA,sBAAA;EACA,gCAAA;EACA,YAAA;EACA,SAAA;EAEA,kBAAA;AhCyvJR;AgC/5JA;EAyKU,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AhCyvJV;AgCvvJU;EACE,cAAA;AhCyvJZ;AgCtvJU;EACE,YAAA;AhCwvJZ;AgCpvJQ;EACE,eAAA;AhCsvJV;AgCnvJQ;EACE,6BAAA;AhCqvJV;AgClvJQ;EACE,mBAAA;EACA,yBAAA;AhCovJV;AgClvJU;;;EAGE,mBAAA;EACA,mBAAA;EACA,yBAAA;AhCovJZ;AgCzvJU;;;EAQI,aAAA;AhCsvJd;AgClvJU;EACE,WAAA;EACA,6DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AhCmvJZ;AgC58JA;EA8NU,kBAAA;AhCivJV;AgC9uJQ;;;EAGE,yBAAA;EACA,kBAAA;EACA,mBAAA;AhCgvJV;AgCrvJQ;;;EAQI,eAAA;EACA,mBAAA;AhCkvJZ;AgC59JA;EA+OU,gBAAA;EACA,YAAA;AhCgvJV;AgCh+JA;EAoPU,cAAA;EACA,eAAA;EACA,YAAA;AhC+uJV;AgC3uJU;EACE,iBAAA;EACA,gBAAA;AhC6uJZ;AgCz+JA;EAqQM,MAAA;AhCuuJN;AiCr/JE;EAEI,kBAAA;AjCs/JN;AiCj/JA;EAEI,iBAAA;AjCk/JJ;AiCp/JA;EAMI,yBAAA;EACA,qDAAA;EACA,kBAAA;AjCi/JJ;AiCz/JA;EAYI,eAAA;EACA,cAAA;E/BIF,2BAAA;AF6+JF;AiC9/JA;EAkBI,cAAA;AjC++JJ;AkCzgKA;EACE,4BAAA;EAEA,kBAAA;EACA,yBAAA;EACA,kBAAA;AlC0gKF;AkC/gKA;EAQI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AlC0gKJ;AkCxgKI;EACE,cAAA;AlC0gKN;AkCzhKA;EAoBI,kBAAA;EACA,UAAA;EACA,SAAA;AlCwgKJ;AkC9hKA;EA0BI,gBAAA;EACA,sBAAA;AlCugKJ;AkCliKA;EA+BI,gBAAA;EACA,cAAA;AlCsgKJ;AkClgKA;EAKU,MAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AlCggKV;AkC9/JU;EACE,gBAAA;AlCggKZ;AkC3gKA;EAiBQ,MAAA;EACA,SAAA;EACA,YAAA;AlC6/JR;AmCpjKA;EACE,YAAA;EACA,iBAAA;AnCsjKF;AoCliKA;EAEI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;ApCmiKJ;AoCjiKI;EACE,UAAA;ApCmiKN;AoChiKI;EACE,oBAAA;ApCkiKN;AoC7hKA;EAEI,cAAA;EACA,eAAA;ApC8hKJ;AoC1hKA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ApC4hKF;AoCliKA;EASI,gBAAA;EACA,WAAA;EACA,eAAA;ApC4hKJ;AqCllKA;EACE;IACE,6BAAA;IACA,UAAA;ErColKF;EqCllKA;IACE,UAAA;ErColKF;EqCllKA;IACE,0BAAA;IACA,UAAA;ErColKF;AACF;AqCjlKA;EACE;IACE,6BAAA;IACA,UAAA;ErCmlKF;EqCjlKA;IACE,YAAA;ErCmlKF;EqCjlKA;IACE,6BAAA;IACA,UAAA;ErCmlKF;AACF;AqChlKA;EACE;IACE,yBAAA;ErCklKF;EqChlKA;IACE,4BAAA;ErCklKF;EqChlKA;IACE,yBAAA;ErCklKF;AACF;AqC/kKA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mCAAA;ArCilKF;AqC1lKA;EAYI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;ArCilKJ;AqCjmKA;EAoBI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;ArCglKJ;AqCvmKA;EA2BI,YAAA;ArC+kKJ;AqC1mKA;EA+BI,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;ArC8kKJ;AqC5kKI;EACE,eAAA;ArC8kKN;AqCpnKA;EA0CM,6BAAA;ArC6kKN;AqC3kKM;EACE,mBAAA;ArC6kKR;AqC1nKA;EAkDM,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;ArC2kKN;AqCzoKA;EAiEQ,kBAAA;EACA,QAAA;EACA,MAAA;ArC2kKR;AqCxkKM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;ArC0kKR;AqCrpKA;EA+EQ,iBAAA;EACA,cAAA;EACA,gBAAA;ArCykKR;AqCtkKM;EACE,mBAAA;ArCwkKR;AqCtkKM;EACE,mBAAA;ArCwkKR;AqChqKA;EA8FI,mBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;ArCqkKJ;AqCnkKI;EACE,4BAAA;EACA,sBAAA;ArCqkKN;AqCnkKM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,iEAAA;EAEA,sBAAA;EACA,2BAAA;EACA,sBAAA;ArCokKR;AqCjkKM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,iEAAA;EAEA,sBAAA;EACA,4BAAA;EACA,sBAAA;ArCkkKR;AqC1sKA;EA6IM,kBAAA;EACA,WAAA;EACA,SAAA;ArCgkKN;AqC/sKA;EAmJM,kBAAA;EACA,UAAA;EACA,SAAA;ArC+jKN;AqCptKA;EAyJM,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArC8jKN;AqC1tKA;EAgKM,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ArC6jKN;AqCjuKA;EAuKQ,cAAA;ArC6jKR;AqC3jKQ;EACE,cAAA;ArC6jKV;AqCvuKA;EAgLM,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ArC0jKN;AqC7uKA;EAuLM,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ArCyjKN;AqCrvKA;EA+LQ,kBAAA;EACA,OAAA;EACA,QAAA;ArCyjKR;AqC1vKA;EAqMQ,cAAA;ArCwjKR;AqCvjKQ;EACE,cAAA;ArCyjKV;AqCljKI;EACE,eAAA;ArCojKN;AqCnwKA;EAoNI,cAAA;EACA,aAAA;EACA,eAAA;ArCkjKJ;AqCxwKA;EAyNI,cAAA;EACA,eAAA;ArCkjKJ;AqC5wKA;EA6NI,cAAA;EACA,eAAA;ArCkjKJ;AqChxKA;EAmOM,iBAAA;ArCgjKN;AqC9iKM;EACE,mBAAA;EACA,eAAA;ArCgjKR;AqC1iKA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;ArC4iKF;AqC1iKE;EACE,WAAA;ArC4iKJ;AqCrjKA;EAaI,gBAAA;ArC2iKJ;AqCziKM;EAGM,2BAAA;EACA,oCAAA;EACA,4BAAA;ArCyiKZ;AqCpiKM;EACE,gBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,gCAAA;ArCsiKR;AqCrkKA;EAoCQ,oBAAA;EACA,QAAA;ArCoiKR;AqCzkKA;EA6FM,eAAA;ArC++JN;AqCliKM;EACE,UAAA;ArCoiKR;AqCjiKM;EACE,UAAA;ArCmiKR;AqChiKM;EACE,UAAA;ArCkiKR;AqC/hKM;EACE,UAAA;ArCiiKR;AqC9hKM;EACE,UAAA;ArCgiKR;AqC7hKM;EACE,OAAA;EACA,gBAAA;ArC+hKR;AqC5hKM;EACE,WAAA;ArC8hKR;AqClmKA;EAwEQ,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;ArC6hKR;AqCxmKA;EA8EU,UAAA;EACA,WAAA;ArC6hKV;AqC1hKQ;EAEI,UAAA;ArC2hKZ;AqCvhKQ;EACE,aAAA;ArCyhKV;AqClnKA;EAgGQ,cAAA;EACA,aAAA;ArCqhKR;AqCnhKQ;EAEI,UAAA;ArCohKZ;AqCznKA;EA0GU,mBAAA;ArCkhKV;AqC5nKA;EA+GQ,cAAA;ArCghKR;AqC9gKQ;EAEI,UAAA;ArC+gKZ;AqCloKA;EAyHQ,cAAA;ArC4gKR;AqC1gKQ;EAEI,UAAA;ArC2gKZ;AqCxoKA;EAkIU,mBAAA;ArCygKV;AqC3oKA;EAuIQ,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;ArCugKR;AqCrgKQ;EACE,mBAAA;ArCugKV;AqCpgKQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAEA,iCAAA;EACA,qCAAA;EACA,4BAAA;ArCqgKV;AqChgKQ;EACE,YAAA;EACA,UAAA;EACA,yBAAA;ArCkgKV;AqC7/JQ;EACE,mBAAA;EACA,aAAA;ArC+/JV;AqCjgKQ;EAKI,YAAA;EACA,iBAAA;EACA,QAAA;ArC+/JZ;AqCtgKQ;EAWI,iBAAA;ArC8/JZ;AqC3/JU;EAEI,aAAA;ArC4/Jd;AqC5gKQ;EAqBI,mBAAA;ArC0/JZ;AqChhKM;;EA6BM,gBAAA;ArCu/JZ;AqCl/JM;EACE,iBAAA;ArCo/JR;AqCxsKA;EA4NY,aAAA;EACA,cAAA;ArC++JZ;AqCz+JI;EAEI;IACE,UAAA;ErC0+JR;EqCv+JM;IACE,UAAA;ErCy+JR;EqCt+JM;IACE,UAAA;ErCw+JR;EqCr+JM;IACE,UAAA;ErCu+JR;EqCp+JM;IACE,aAAA;ErCs+JR;AACF;AqC7tKA;EA6PI,mBAAA;ArCm+JJ;AqChuKA;EAiQI,qBAAA;EACA,WAAA;ArCk+JJ;AqCpuKA;EAqQM,qBAAA;ArCk+JN;AqC59JM;EAEI,gBAAA;ArC69JV;AqC1uKA;EAoRI,aAAA;EACA,mBAAA;EACA,8BAAA;ArCy9JJ;AqC/uKA;EAwRM,mBAAA;EACA,gBAAA;EACA,uBAAA;ArC09JN;AqCn9JE;;EACE,UAAA;ArCs9JJ;AqCn9JE;;EACE,UAAA;ArCs9JJ;AqC79JA;;EAcU,cAAA;ArCm9JV;AqC58JA;;EAGI,iBAAA;EACA,cAAA;ArC68JJ;AqC38JI;;EACE,cAAA;ArC88JN;AqC38JI;;EACE,kBAAA;ArC88JN;AqC38JI;;EACE,yBAAA;EACA,mCAAA;EACA,kBAAA;ArC88JN;AsCziLI;EAEI,gBAAA;EACA,YAAA;AtC0iLR;AsCpiLA;EAEI,oBAAA;AtCqiLJ;AsCviLA;EAMI,UAAA;EACA,gBAAA;AtCoiLJ;AsC3iLA;EAWI,SAAA;AtCmiLJ;AsC9iLA;EAcM,YAAA;EACA,cAAA;EACA,aAAA;AtCmiLN;AsCnjLA;EAqBI,aAAA;AtCiiLJ;AsC7hLI;EACE,eAAA;EACA,UAAA;AtC+hLN;AsC1jLA;EAiCM,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AtC4hLN;AsChkLA;EAuCM,mBAAA;AtC4hLN;AsCnkLA;EA2CM,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AtC2hLN;AsCzhLM;EACE,eAAA;AtC2hLR;AsC7kLA;EAuDM,iBAAA;AtCyhLN;AsChlLA;EA2DM,kBAAA;EACA,QAAA;EACA,QAAA;AtCwhLN;AsCrlLA;EAkEI,YAAA;EACA,WAAA;EACA,aAAA;AtCshLJ;AsCphLI;EACE,cAAA;AtCshLN;AsCnhLI;EACE,cAAA;AtCqhLN;AsClhLI;EACE,cAAA;AtCohLN;AsCnmLA;EAoFI,aAAA;EACA,mBAAA;EACA,QAAA;AtCkhLJ;AsCxmLA;EA0FI,WAAA;EACA,cAAA;AtCihLJ;AsC5mLA;EA+FI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AtCghLJ;AsC9gLI;EACE,cAAA;EACA,gBAAA;AtCghLN;AsCxnLA;EA6GI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AtC8gLJ;AsC5gLI;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AtC8gLN;AsChpLA;EAuII,kBAAA;AtC4gLJ;AsC1gLI;EACE,mBAAA;EACA,YAAA;AtC4gLN;AsC9gLI;EAKI,cAAA;AtC4gLR;AsC1pLA;EAoJI,kBAAA;AtCygLJ;AsC7pLA;EAwJI,YAAA;AtCwgLJ;AsChqLA;EA4JI,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AtCugLJ;AsCrgLI;EACE,aAAA;EACA,yBAAA;AtCugLN;AsCzgLI;EAKI,cAAA;AtCugLR;AsC7qLA;EA4KI,cAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AtCogLJ;AsCrrLA;EAqLI,yBAAA;AtCmgLJ;AsCxrLA;EAyLI,mBAAA;AtCkgLJ;AsC3rLA;EA6LI,yBAAA;AtCigLJ;AsC9rLA;EAiMI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AtCggLJ;AsC9/KI;EACE,qBAAA;AtCggLN;AsC3sLA;EAgNI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AtC8/KJ;AsCjtLA;EAsNM,kBAAA;EACA,SAAA;EACA,QAAA;AtC8/KN;AsCttLA;EA6NI,kBAAA;EACA,SAAA;EACA,WAAA;AtC4/KJ;AsC3tLA;EAqOQ,cAAA;AtCy/KR;AsCv/KQ;EAGM,WAAA;AtCu/Kd;AsC1/KQ;EAOM,YAAA;EACA,eAAA;AtCs/Kd;AsC9/KQ;EAYU,kBAAA;EACA,mBAAA;AtCq/KlB;AsClgLQ;EAiBU,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AtCo/KlB;AsCxgLQ;EAyBQ,WAAA;EACA,YAAA;AtCk/KhB;AsC5gLQ;EA8BQ,iBAAA;AtCi/KhB;AsC/gLQ;EAkCQ,cAAA;EACA,aAAA;AtCg/KhB;AsCnhLQ;EAuCQ,cAAA;AtC++KhB;AsCthLQ;EA2CQ,cAAA;AtC8+KhB;AsCzhLQ;EA+CQ,gBAAA;AtC6+KhB;AsCnwLA;EA+RM,WAAA;EACA,cAAA;EACA,SAAA;AtCu+KN;AsCxwLA;EAuSM,mBAAA;AtCo+KN;AsC3wLA;EA4SM,gBAAA;AtCk+KN;AsC9wLA;EAgTM,gBAAA;EACA,cAAA;AtCi+KN;AsClxLA;EAqTM,gBAAA;AtCg+KN;AsCrxLA;EAwTQ,YAAA;EACA,iBAAA;EACA,cAAA;AtCg+KR;AsC1xLA;EA8TQ,qBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AtC+9KR;AsC59KU;EACE,eAAA;AtC89KZ;AsCtyLA;EA8UQ,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AtC29KR;AsCv9KY;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AtCy9Kd;AsClzLA;EAkWI,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AtCm9KJ;AsCj9KI;EACE,cAAA;EACA,gBAAA;AtCm9KN;AsC7zLA;EAgXM,iBAAA;AtCg9KN;AsCh0LA;EAqXI,oBAAA;EACA,6BAAA;EACA,kBAAA;AtC88KJ;AsC58KI;EACE,YAAA;AtC88KN;AsCx0LA;EA8XM,gBAAA;EACA,YAAA;EACA,cAAA;AtC68KN;AsC70LA;EAoYM,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AtC48KN;AsC18KM;EACE,mBAAA;AtC48KR;AsCz8KM;EACE,mBAAA;AtC28KR;AsC51LA;EAuZI,+BAAA;EACA,oBAAA;EACA,cAAA;EtCw8KF,gBAAgB;EsCt8Kd,cAAA;AtCw8KJ;AuCh3LA;EAGM,uBAAA;AvCg3LN;AuCn3LA;EASM,YAAA;AvC62LN;AuCt3LA;EAYQ,gBAAA;AvC62LR;AuC32LQ;EAEI,gBAAA;AvC42LZ;AuC53LA;EAqBU,gBAAA;AvC02LV;AuC/3LA;EA6BM,YAAA;AvCq2LN;AuCl4LA;EAmCM,UAAA;AvCk2LN;AuCr4LA;EA0CQ,eAAA;EACA,gBAAA;AvC81LR;AuCz4LA;EAiDY,YAAA;EACA,eAAA;AvC21LZ;AuCx1LU;EAEI,gBAAA;AvCy1Ld;AuCp1LQ;EAGM,gBAAA;AvCo1Ld;AwCn5LA;EACE,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,yBAAA;AxCq5LF;AwC55LA;EAUI,gBAAA;EACA,mBAAA;EACA,cAAA;AxCq5LJ;AwCj6LA;EAeM,WAAA;AxCq5LN;AwCp6LA;EAkBQ,aAAA;EACA,mBAAA;EACA,YAAA;AxCq5LR;AwCl5LU;EACE,mBAAA;AxCo5LZ;AwC56LA;EA8BQ,eAAA;AxCi5LR;AwC/4LQ;EACE,kBAAA;AxCi5LV;AwCl7LA;EAsCQ,iBAAA;EACA,eAAA;AxC+4LR;AwC74LQ;EACE,cAAA;AxC+4LV;AwCz7LA;EA+CQ,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AxC64LR;AwC34LQ;EACE,aAAA;AxC64LV;AwCl8LA;EAyDU,eAAA;EACA,gBAAA;AxC44LV;AwCt8LA;EA6DY,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;AxC44LZ;AwC14LY;EAEI,gBAAA;AxC24LhB;AwCv4LY;EACE,cAAA;AxCy4Ld;AwCv4LY;EACE,cAAA;AxCy4Ld;AwCv4LY;EACE,cAAA;AxCy4Ld;AyCx9LA;EAEI,2BAAA;AzCy9LJ;AyC39LA;EAKM,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AzCy9LN;AyCj+LA;EAWQ,gBAAA;EACA,gBAAA;EACA,WAAA;AzCy9LR;AyCt+LA;EAiBQ,kBAAA;EACA,OAAA;EACA,MAAA;AzCw9LR;AyC3+LA;EAwBM,8BAAA;EACA,iBAAA;EACA,wBAAA;AzCs9LN;AyCh/LA;EA6BQ,gBAAA;EACA,gBAAA;AzCs9LR;AyCp/LA;EAkCQ,eAAA;EACA,oBAAA;AzCq9LR;AyCx/LA;EAuCQ,eAAA;AzCo9LR;AyC3/LA;EA0CU,eAAA;AzCo9LV;AyC9/LA;EA8CU,kBAAA;EACA,aAAA;EACA,mBAAA;AzCm9LV;A0CngMA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;A1CqgMF;A0CngME;EACE,mBAAA;A1CqgMJ;A0ClgME;EACE,mBAAA;A1CogMJ;A0CjgME;EACE,mBAAA;A1CmgMJ;A2CphMA;EACE,qBAAA;A3CshMF;A4C1hMA;;EAEE,iBAAA;EACA,gBAAA;A5C4hMF;A4CzhMA;EACE,sBAAA;EACA,gBAAA;A5C2hMF;A4CxhMA;EACE,qBAAA;A5C0hMF;A4CvhMA;EACE,gDAAA;EACA,sBAAA;A5CyhMF;A4CvhMA;EACE,uBAAA;A5CyhMF;A4CthMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5CwhMF;A4CrhMA;EACE,gDAAA;EACA,sBAAA;A5CuhMF;A4CphMA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;A5CshMF;A4CzhMA;EAMI,2BAAA;A5CshMJ;A4ClhMA;EAGM,iBAAA;EACA,gBAAA;EACA,kBAAA;A5CkhMN;A4CvhMA;EAOQ,iBAAA;A5CmhMR;A4C1hMA;EAUQ,qBAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;A5CmhMR;A4ChhMQ;EACE,WAAA;EACA,WAAA;A5CkhMV;A4C/gMQ;EACE,yBAAA;EACA,mBAAA;A5CihMV;A4C9gMQ;EACE,gBAAA;A5CghMV;A4C7iMA;EAmCI,aAAA;EACA,mBAAA;A5C6gMJ;A4CjjMA;EAwCI,iBAAA;A5C4gMJ;A4CpjMA;EA4CI,mBAAA;EACA,eAAA;A5C2gMJ;A4CxjMA;EA4CI,mBAAA;EACA,eAAA;A5C+gMJ;A4C5jMA;EAqDI,2BAAA;EAEA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,gCAAA;A5CwgMJ;A4CpkMA;EAgEI,eAAA;EAEA,cAAA;EACA,gBAAA;A5CsgMJ;A4CzkMA;EAuEI,aAAA;EACA,mBAAA;A5CqgMJ;A4C7kMA;EA2EI,eAAA;A5CqgMJ;A4ChlMA;EA+EI,gBAAA;EACA,6BAAA;A5CogMJ;A4CplMA;EAoFM,kBAAA;EACA,eAAA;A5CmgMN;A4CxlMA;EAuFQ,YAAA;EACA,cAAA;A5CogMR;A4C5lMA;EA2FQ,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;A5CogMR;A4ClmMA;EAiGQ,eAAA;A5CogMR;A4C9/LA;EAEI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;A5C+/LJ;A4C7/LI;EACE,mBAAA;A5C+/LN;A4ChgMI;EAII,cAAA;A5C+/LR;A4CngMI;EAQI,cAAA;A5C8/LR;A4CtgMI;EAYI,gBAAA;A5C6/LR;A4ChhMA;EAwBM,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;A5C2/LN;A4Cz/LM;EACE,cAAA;A5C2/LR;A4C1hMA;EAoCM,aAAA;A5Cy/LN;A4C7hMA;EAwCM,gBAAA;A5Cw/LN;A4ChiMA;EA2CM,YAAA;A5Cw/LN;A4CniMA;EA+CM,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;A5Cu/LN;A4Cr/LM;EACE,cAAA;A5Cu/LR;A4Cp/LM;EACE,YAAA;A5Cs/LR;A4CjjMA;EAgEM,kBAAA;EACA,UAAA;EACA,SAAA;A5Co/LN;A4CtjMA;EAuEI,kBAAA;A5Ck/LJ;A4C9+LA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;A5Cg/LF;A4Cn/LA;EAMI,WAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;A5Cg/LJ;A4C9+LI;EACE,gCAAA;A5Cg/LN;A4C7+LI;EACE,gCAAA;A5C++LN;A4ChgMA;EAqBM,cAAA;EACA,eAAA;A5C8+LN;A4CpgMA;EA0BM,gBAAA;EACA,gBAAA;A5C6+LN;A4CxgMA;EA+BM,gBAAA;EACA,cAAA;A5C4+LN;A4Cv+LA;EAGE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;A5Cu+LF;A4C7+LA;EASI,kBAAA;EACA,UAAA;EACA,WAAA;A5Cu+LJ;A4Cl/LA;EAgBM,kBAAA;A5Cq+LN;A4Cr/LA;EAqBI,gBAAA;EACA,kBAAA;EACA,gBAAA;A5Cm+LJ;A4Cj+LI;EAEI,aAAA;A5Ck+LR;A4Cp+LI;EAMI,aAAA;A5Ci+LR;A4ChgMA;EAoCM,kBAAA;EACA,WAAA;EACA,SAAA;A5C+9LN;A4CrgMA;EAwCQ,cAAA;A5Cg+LR;A4CxgMA;EA6CM,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;A5C89LN;A4C/gMA;EAoDQ,kBAAA;EACA,UAAA;EACA,SAAA;A5C89LR;A4C39LM;EACE,mBAAA;EACA,2BAAA;A5C69LR;A4C19LM;EACE,mBAAA;A5C49LR;A4C3hMA;EAqEQ,gBAAA;A5Cy9LR;A4C9hMA;EA0EM,cAAA;EACA,cAAA;EACA,eAAA;A5Cu9LN;A4Cr9LM;EACE,cAAA;A5Cu9LR;A4CtiMA;EAmFQ,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;A5Cs9LR;A4ChjMA;EA+FM,cAAA;EACA,gBAAA;A5Co9LN;A4CpjMA;EAoGM,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A5Cm9LN;A4C7jMA;EA8GM,kBAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,6BAAA;A5Ck9LN;A4CrkMA;EAsHQ,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;A5Ck9LR;A4C3kMA;EA6HQ,YAAA;EACA,mBAAA;EACA,mBAAA;A5Ci9LR;A4C/8LQ;EACE,mBAAA;A5Ci9LV;A4C98LQ;EACE,mBAAA;A5Cg9LV;A4Cz8LA;EAEI,QAAA;EACA,YAAA;EACA,iBAAA;A5C08LJ;A4C98LA;EASM,YAAA;EACA,iBAAA;A5Cw8LN;A4Cl9LA;EAeQ,YAAA;EACA,iBAAA;EACA,cAAA;A5Cs8LR;A4Cp8LQ;EACE,SAAA;EACA,cAAA;EACA,0BAAA;A5Cs8LV;A4C59LA;EA2BQ,SAAA;A5Co8LR;A4C/9LA;EAgCM,aAAA;A5Ck8LN;A4Cl+LA;EAsCM,gBAAA;A5C+7LN;A4Cr+LA;EAyCQ,YAAA;A5C+7LR;A4Cz7LE;EAEI,mBAAA;EACA,mBAAA;A5C07LN;A4Cr7LA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;A5Cu7LF;A4C97LA;EAUI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;A5Cu7LJ;A4Cv8LA;EAmBI,YAAA;A5Cu7LJ;A4C18LA;EAsBI,uBAAA;EACA,+BAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;A5Cu7LJ;A4Cr9LA;EAiCI,gCAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;A5Cu7LJ;A4C79LA;EA0CM,gBAAA;A5Cs7LN;A4Cr7LM;;;EAII,YAAA;A5Cs7LV;A4Cr+LA;EAoDM,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;A5Co7LN;A4C7+LA;EA+DM,cAAA;A5Ci7LN;A4Cp7LM;EACE,mBAAA;A5Cs7LR;A4Cn/LA;EAkEM,cAAA;A5Co7LN;A4Ct/LA;EAqEM,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;A5Co7LN;A4Cl7LM;EACE,mBAAA;A5Co7LR;A4Cl7LM;EACE,mBAAA;A5Co7LR;A4CpgMA;EAqFI,mBAAA;EACA,kBAAA;A5Ck7LJ;A4CxgMA;EAyFI,kBAAA;A5Ck7LJ;A4C3gMA;EA4FI,kBAAA;A5Ck7LJ;A4C9gMA;EAgGI,YAAA;EACA,aAAA;EACA,mBAAA;A5Ci7LJ;A4CnhMA;EAsGI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;A5Cg7LJ;A4C96LI;EACE,UAAA;A5Cg7LN;A4C76LI;EACE,mBAAA;A5C+6LN;A4C56LI;EACE,mBAAA;A5C86LN;A4CniMA;EAyHI,mBAAA;A5C66LJ;A4CtiMA;EA4HI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,gCAAA;A5C66LJ;A4C56LI;EACE,4CAAA;EACA,UAAA;A5C86LN;A4CpjMA;EA2II,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;A5C46LJ;A4C7jMA;EAqJI,gCAAA;EACA,YAAA;A5C26LJ;A4C16LI;EAEI,iBAAA;A5C26LR;A4CpkMA;EA+JI,kBAAA;A5Cw6LJ;A4CvkMA;EAiKM,WAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;A5Cy6LN;A4C7kMA;EAyKI,aAAA;A5Cu6LJ;A4ChlMA;EA6KI,WAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;A5Cs6LJ;A4CtlMA;EAoLI,0FAAA;EAOA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5C+5LJ;A6CpiNA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;A7CsiNF;A6C1iNA;EAMI,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;A7CuiNJ;A6ChjNA;EAaI,gBAAA;EACA,cAAA;A7CsiNJ;A6CpjNA;EAkBI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;A7CqiNJ;A6C1jNA;EA0BM,6BAAA;A7CmiNN;A6C7jNA;EAgCM,mBAAA;A7CgiNN;A6ChkNA;EAqCI,gCAAA;EACA,gBAAA;EACA,cAAA;E7C8hNF,UAAU;EACV,WAAW;AACb;A6CvkNA;EA0CM,UAAA;EACA,WAAA;EACA,mBAAA;A7CgiNN;A6C5kNA;EAiDM,gBAAA;A7C8hNN;A6C/kNA;EAsDM,mBAAA;EACA,mBAAA;A7C4hNN;A6CnlNA;EA2DM,eAAA;A7C2hNN;A6CtlNA;EA+DM,gBAAA;EACA,YAAA;EACA,0BAAA;A7C0hNN;A6C3lNA;EAsEI,0BAAA;A7CwhNJ;A6C9lNA;EA0EI,wBAAA;A7CuhNJ;A6CjmNA;EA8EI,cAAA;A7CshNJ;A6CpmNA;EAiFM,gBAAA;EACA,aAAA;EACA,kBAAA;A7CshNN;A6CzmNA;EAqFQ,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;A7CuhNR;A6C/mNA;EA6FM,gBAAA;A7CqhNN;A8CjnNA;EAEI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A9CknNJ;A8CvnNA;EAUM,6BAAA;A9CgnNN;A8C1nNA;EAaM,gCAAA;EACA,eAAA;A9CgnNN;A8C9nNA;EAiBM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A9CgnNN;A8CtoNA;EAyBM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;A9CgnNN;A8C9oNA;EAkCM,0BAAA;A9C+mNN;A8CjpNA;EAsCM,wBAAA;A9C8mNN;A8CppNA;EA0CM,UAAA;A9C6mNN;A8CvpNA;EA6CQ,eAAA;A9C6mNR;A8C1pNA;EAgDU,SAAA;A9C6mNV;A8C7pNA;EAsDM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;A9C0mNN;A8CpqNA;EA8DM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A9CymNN;A8C3qNA;EAsEM,gBAAA;A9CwmNN;A8C9qNA;EA0EM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A9CumNN;A8CprNA;EA0EM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAKA,cAAA;A9CymNN;A8C3rNA;EAuFQ,gCAAA;A9CumNR;A8C9rNA;EA4FM,cAAA;A9CqmNN;A8CjsNA;EA4FM,cAAA;EAlBA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A9C2nNN;A8CxsNA;EAsGI,oBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;A9CqmNJ;A8C9sNA;EA6GI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;A9ComNJ;A8CptNA;EAmHM,0BAAA;A9ComNN;A8CnmNM;EACE,cAAA;A9CqmNR;A+C7tNA;EACE,gCAAA;EACA,iBAAA;A/C+tNF;A+CjuNA;EAKI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;A/C+tNJ;A+CzuNA;EAaM,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;A/C+tNN;A+C/uNA;EAqBI,oBAAA;A/C6tNJ;A+CztNI;EACE,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;A/C2tNN;A+CzvNA;EAoCM,SAAA;A/CwtNN;A+C5vNA;EA2CQ,UAAA;A/CotNR;A+C/vNA;EA6CU,WAAA;EACA,aAAA;A/CqtNV;A+C7sNM;EACE,wBAAA;A/C+sNR;AgDtwNA;EACE,iBAAA;AhDwwNF;AgDrwNA;EACE,gBAAA;AhDuwNF;AgDpwNA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AhDswNF;AgDnwNA;EACE,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AhDqwNF;AgD3wNA;EASI,kBAAA;AhDqwNJ;AgD9wNA;EAWM,WAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AhDswNN;AgDpwNM;;EAEE,mBAAA;EACA,cAAA;AhDswNR;AgDnwNM;EACE,yBAAA;AhDqwNR;AgDlwNM;EACE,aAAA;EACA,0BAAA;AhDowNR;AgDnyNA;EAoCM,aAAA;AhDkwNN;AgD5vNA;EACE,eAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;AhD8vNF;AgD5vNE;EACE,UAAA;AhD8vNJ;AgD3vNE;;EAEE,2BAAA;AhD6vNJ;AgDxvNA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AhD0vNF;AgD/vNA;EAQI,gBAAA;EACA,gBAAA;EACA,8BAAA;AhD0vNJ;AgDpwNA;EAcI,kBAAA;EACA,YAAA;EACA,SAAA;AhDyvNJ;AgDrvNA;EACE,gBAAA;EACA,8BAAA;EACA,eAAA;AhDuvNF;AgDpvNA;;;;EAIE,mBAAA;EACA,YAAA;EACA,eAAA;AhDsvNF;AgDnvNA;EACE,MAAA;EACA,OAAA;EACA,WAAA;AhDqvNF;AgDlvNA;EACE,SAAA;EACA,OAAA;EACA,WAAA;AhDovNF;AgDjvNA;EACE,OAAA;AhDmvNF;AgDhvNA;EACE,QAAA;AhDkvNF;AgD/uNA;EACE,eAAA;EACA,wCAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EnCkDA,wBAAA;EACK,mBAAA;EACG,gBAAA;AbgsNV;AgD7vNA;EAaI,cAAA;EACA,cAAA;EACA,gBAAA;AhDmvNJ;AgDlwNA;EAmBI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AhDkvNJ;AgD1wNA;EA2BM,kBAAA;EACA,OAAA;EACA,QAAA;AhDkvNN;AgD7uNA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AhD+uNF;AgD7uNE;;EAEE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AhD+uNJ;AgD5uNE;;EAEE,mBAAA;EACA,cAAA;AhD8uNJ;AgD3uNE;;;EAGE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EnCnIF,iDAAA;EACQ,yCAAA;Abi3NV;AgD5uNI;;;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AhDgvNN;AgD5uNE;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EnC5JF,iDAAA;EACQ,yCAAA;Ab24NV;AgD7uNI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;AhD+uNN;AgD1uNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AhD4uNF;AgDjvNA;EAQI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AhD4uNJ;AgDxvNA;EAeM,aAAA;AhD4uNN;AgD3vNA;EAkBQ,gBAAA;EACA,cAAA;EACA,eAAA;AhD4uNR;AgD1uNQ;EACE,0BAAA;AhD4uNV;AgDzuNQ;EACE,0BAAA;AhD2uNV;AgDxuNQ;EACE,eAAA;EACA,mBAAA;AhD0uNV;AgD1wNA;EAsCM,YAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;AhDuuNN;AgDruNM;EACE,gBAAA;AhDuuNR;AgDpuNM;EACE,WAAA;AhDsuNR;AgDnuNM;;EAGI,WAAA;EACA,YAAA;AhDouNV;AgDxuNM;EAQI,4BAAA;EACA,+BAAA;AhDmuNV;AgD5uNM;EAaI,2BAAA;EACA,8BAAA;AhDkuNV;AgDhvNM;EAkBI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AhDiuNV;AgD3tNU;;;EACE,oFAAA;AhD+tNZ;AgD9yNA;EAuFM,6BAAA;EACA,gBAAA;EACA,eAAA;AhD0tNN;AgDxtNM;EACE,yBAAA;AhD0tNR;AgDvtNM;;EAEE,SAAA;EACA,mBAAA;EACA,qDAAA;AhDytNR;AgDttNM;EACE,yBAAA;EACA,wEAAA;AhDwtNR;AgDh0NA;;EA+GI,YAAA;AhDqtNJ;AgDntNI;;EACE,gBAAA;AhDstNN;AgDjtNI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AhDmtNN;AgDp1NA;EAsII,cAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AhDitNJ;AgD91NA;EAkJM,WAAA;EACA,YAAA;AhD+sNN;AgDl2NA;EAwJI,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AhD6sNJ;AgDx2NA;EA+JI,aAAA;AhD4sNJ;AgD1sNI;EACE,YAAA;EACA,YAAA;AhD4sNN;AgD/2NA;EAwKI,aAAA;EACA,eAAA;EACA,8CAAA;EACA,aAAA;AhD0sNJ;AgDxsNI;EACE,YAAA;EACA,YAAA;AhD0sNN;AgDz3NA;EAqLM,8BAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AhDusNN;AgDpsNI;EACE,8BAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AhDssNN;AgDx4NA;EAwMM,UAAA;EACA,eAAA;EACA,iBAAA;AhDmsNN;AgD74NA;EA8MM,UAAA;AhDksNN;AgD9rNM;EAEI,iBAAA;EACA,eAAA;AhD+rNV;AgD3rNM;EACE,YAAA;AhD6rNR;AgDv5NA;;EAgOM,eAAA;EACA,uCAAA;EACA,sBAAA;EACA,aAAA;AhD2rNN;AgDzrNM;;EACE,eAAA;EACA,aAAA;AhD4rNR;AgDn6NA;EA6OQ,eAAA;EACA,aAAA;AhDyrNR;AgDv6NA;EAkPQ,eAAA;EACA,iBAAA;E9CzdN,2BAAA;E8C2dM,aAAA;AhDwrNR;AgDrrNM;EACE,YAAA;AhDurNR;AgDh7NA;EA6PQ,eAAA;EACA,WAAA;AhDsrNR;AgDp7NA;EAgQU,gBAAA;AhDurNV;AgDnrNM;EAGM,aAAA;EACA,gBAAA;AhDmrNZ;AgDjrNY;EACE,aAAA;AhDmrNd;AgD97NA;;EAmRQ,aAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EhD+qNN,4BAA4B;EgD9qNtB,4BAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;AhDgrNR;AgD9qNQ;;EACE,eAAA;EACA,aAAA;EACA,0BAAA;AhDirNV;AgDl9NA;EAuSU,gBAAA;AhD8qNV;AgDr9NA;EA6SU,gBAAA;AhD2qNV;AgDx9NA;EAmTU,aAAA;EACA,uBAAA;EACA,gDAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AhDwqNV;AgDtqNU;EACE,eAAA;EACA,aAAA;AhDwqNZ;AgDp+NA;EAiUU,eAAA;EACA,WAAA;EACA,UAAA;AhDsqNV;AgDpqNU;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;AhDsqNZ;AgDjqNM;EAEI,iBAAA;EACA,eAAA;AhDkqNV;AgD9pNM;EAEI,iBAAA;EACA,mBAAA;AhD+pNV;AgDlqNM;EAOI,aAAA;AhD8pNV;AgD1pNM;EACE,YAAA;AhD4pNR;AgDzpNM;EAEI,eAAA;EACA,iBAAA;AhD0pNV;AgDjgOA;EA6WU,WAAA;EACA,YAAA;AhDupNV;AgDrgOA;EAmXY,aAAA;EACA,aAAA;AhDqpNZ;AgDzgOA;EAwXY,cAAA;EACA,YAAA;EACA,WAAA;AhDopNZ;AgDjpNU;EAEI,cAAA;AhDkpNd;AgDjhOA;EAqYU,YAAA;AhD+oNV;AgDphOA;EA2YU,aAAA;EACA,YAAA;AhD4oNV;AgDxhOA;EAgZU,aAAA;AhD2oNV;AgD3hOA;EAoZU,gCAAA;EACA,aAAA;EACA,aAAA;AhD0oNV;AgDvoNQ;EAEI,cAAA;AhDwoNZ;AgDloNI;EAEI,eAAA;EACA,iBAAA;AhDmoNR;AgDtoNI;;;;;;;;EAcM,aAAA;AhDkoNV;AgD/nNQ;;EAGI,kBAAA;AhDgoNZ;AgDrjOA;EA6bI,UAAA;EACA,eAAA;EACA,iBAAA;AhD2nNJ;AgD1jOA;EAmcI,eAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;AhD0nNJ;AgDxnNI;EACE,eAAA;AhD0nNN;AgDtnNE;EACE;IACE,sBAAA;EhDwnNJ;EgDtnNE;IACE,uBAAA;EhDwnNJ;AACF;AgD3kOA;EAudI,eAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,2CAAA;EACA,mCAAA;AhDunNJ;AgDnlOA;EAieM,cAAA;AhDqnNN;AgDtlOA;EAqeM,cAAA;AhDonNN;AgDzlOA;EA2eQ,aAAA;AhDinNR;AgD5lOA;EAkfQ,aAAA;AhD6mNR;AgD/lOA;EAwfI,eAAA;EACA,aAAA;AhD0mNJ;AgDnmOA;EA6fI,eAAA;EACA,gDAAA;EACA,aAAA;AhDymNJ;AgDxmNI;EACE,UAAA;EACA,eAAA;AhD0mNN;AgD5mOA;EAugBI,eAAA;EACA,iBAAA;AhDwmNJ;AgDhnOA;EA6gBM,mEAAA;AhDsmNN;AgDlmNM;EACE,eAAA;EACA,YAAA;AhDomNR;AgDvnOA;EAuhBQ,eAAA;AhDmmNR;AgD1nOA;;EA4hBQ,aAAA;EACA,aAAA;AhDkmNR;AgD/nOA;EAiiBQ,aAAA;EACA,YAAA;AhDimNR;AgD9lNM;EACE,cAAA;AhDgmNR;AgD7lNM;EAEI,cAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AhD8lNV;AgDnmNM;;EAUI,UAAA;AhD6lNV;AgDzlNM;EACE,aAAA;AhD2lNR;AgDnlNI;;EAGI,SAAA;AhDolNR;AgDzlNA;EAUM,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AhDklNN;AgDjmNA;EAkBQ,gBAAA;AhDklNR;AgDpmNA;EAuBM,2BAAA;EACA,gBAAA;AhDglNN;AgD1kNU;EAEI,gBAAA;AhD2kNd;AgD7kNU;EAKM,aAAA;EACA,YAAA;EACA,gCAAA;AhD2kNhB;AgDllNU;EAWQ,aAAA;EACA,cAAA;AhD0kNlB;AgDxkNkB;EACE,gBAAA;AhD0kNpB;AgDzlNU;EAoBU,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;AhDwkNpB;AgDlmNU;EA6BY,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AhDwkNtB;AgD3mNU;EAuCY,WAAA;EACA,YAAA;AhDukNtB;AgDpkNoB;;EAGI,cAAA;AhDqkNxB;AgDjkNoB;EACE,qBAAA;AhDmkNtB;AgDhkNoB;EACE,mBAAA;EACA,qDAAA;EACA,mBAAA;AhDkkNtB;AgD/jNoB;EACE,wEAAA;EAEA,yBAAA;AhDgkNtB;AgD/nNU;EAwEI,kBAAA;EACA,mBAAA;AhD0jNd;AgDljNE;EAEI,WAAA;AhDmjNN;AgDrjNE;EAOM,kCAAA;AhDijNR;AgD5iNE;EAGM,OAAA;AhD4iNR;AgDtiNA;EACE,cAAA;EACA,YAAA;AhDwiNF;AgDpiNA;EACE;IACE,sDAAA;EhDsiNF;EgDpiNA;IACE,sDAAA;EhDsiNF;AACF;AgDniNA;EACE,qBAAA;AhDqiNF;AgDtiNA;EAII,mBAAA;EACA,YAAA;EACA,kBAAA;AhDqiNJ;AgD3iNA;EAUI,YAAA;EACA,mBAAA;AhDoiNJ;AgDjiNE;EAEI,yBAAA;AhDkiNN;AiDt/OA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AjDw/OF;AiD3/OA;EAMI,YAAA;AjDw/OJ;AiD9/OA;EAUI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iDAAA;AjDu/OJ;AiDr/OI;EACE,yCAAA;AjDu/ON;AiDp/OI;EACE,+FAAA;AjDs/ON;AiD7+OI;EACE,2BAAA;EACA,4BAAA;AjD++ON;AiD5+OI;EACE,8BAAA;EACA,0CAAA;AjD8+ON;AiD3+OI;EACE,2BAAA;AjD6+ON;AiD1+OI;EACE,8BAAA;EACA,+BAAA;AjD4+ON;AiD7hPA;EAqDM,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AjD2+ON;AiDviPA;EAgEQ,cAAA;EACA,eAAA;AjD0+OR;AiD3iPA;EAoEQ,YAAA;EACA,SAAA;EACA,WAAA;AjD0+OR;AiDhjPA;EAwEU,eAAA;EACA,YAAA;AjD2+OV;AiD1+OU;EACE,yBAAA;AjD4+OZ;AiD1+OU;EACE,cAAA;AjD4+OZ;AiD1+OU;EACE,6BAAA;AjD4+OZ;AiD1+OU;EACE,gCAAA;AjD4+OZ;AiDhkPA;EA0FM,eAAA;EACA,gBAAA;AjDy+ON;AiDpkPA;EA8FM,gBAAA;EACA,iBAAA;AjDy+ON;AiDxkPA;EAkGQ,aAAA;AjDy+OR;AiD3kPA;EAqGQ,mBAAA;EACA,iBAAA;AjDy+OR;AiD/kPA;EA0GQ,eAAA;EACA,eAAA;AjDw+OR;AiDnlPA;EA+GQ,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AjDu+OR;AiDr+OQ;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AjDu+OV;AiDlmPA;;EAiIQ,eAAA;EACA,iBAAA;AjDq+OR;AiDvmPA;;EAqIU,WAAA;EACA,YAAA;EACA,mBAAA;AjDs+OV;AiD7mPA;;EA2IU,eAAA;AjDs+OV;AiDjnPA;EAiJM,eAAA;EACA,cAAA;AjDm+ON;AiDl+OM;EACE,cAAA;AjDo+OR;AiDxnPA;EAyJM,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EAIA,eAAA;AjD+9ON;AiDl+OM;EACE,yBAAA;AjDo+OR;AiDxoPA;EAwKQ,WAAA;EACA,eAAA;AjDm+OR;AiDh+OI;EAGM,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AjDg+OV;AiD3+OI;EAeQ,yBAAA;AjD+9OZ;AiD9+OI;EAoBQ,yBAAA;AjD69OZ;AiDj/OI;EAyBQ,yBAAA;AjD29OZ;AiDn9OA;EACE;IAGM,gBAAA;EjDm9ON;EiDt9OA;IAMQ,eAAA;EjDm9OR;EiDz9OA;IAUU,YAAA;EjDk9OV;AACF;AiD38OA;EACE;IAGM,gBAAA;EjD28ON;EiD98OA;IAKQ,cAAA;EjD48OR;EiDj9OA;IAQQ,aAAA;EjD48OR;EiDp9OA;IAWQ,eAAA;EjD48OR;EiDv9OA;;IAeQ,eAAA;IACA,iBAAA;EjD48OR;AACF;AiDt8OE;EACE,gBAAA;AjDw8OJ;AAjrPA;EAGM,iBAAA;AAirPN","sourcesContent":["@import (reference)\n  \"packages/webapp/src/less/themes/default/color/theme-colors.less\";\n.metric-indicator-container {\n  width: 1025px;\n\n  @media all and (max-width: 1025px) {\n    width: 95vw;\n  }\n}\n\n#metric-preview {\n  #dynamic-metric-wizard {\n    width: 100%;\n    max-width: unset;\n  }\n\n  .metric-content-container {\n    max-width: 1025px;\n\n    .metric-content-sub-container {\n      min-width: 469px;\n      padding: 0px 15px;\n    }\n\n    .gh-siv-top-bar.modal-top {\n      .gh-siv-top-bar-labels {\n        ui-button {\n          width: 32px;\n          color: @ink-100-v3;\n        }\n      }\n\n      #gh-modal-view-in-alignment-button {\n        margin-right: 10px;\n        width: 32px;\n        color: @ink-100-v3;\n      }\n    }\n  }\n\n  .scrollable-with-left-overflow {\n    margin-left: -200px;\n    padding-left: 200px;\n    overflow-y: auto;\n  }\n\n  .custom-fields-two-columns.confidence-shown {\n    position: absolute;\n    margin-top: 180px;\n  }\n\n  .helper-quotes {\n    position: relative;\n    &::before {\n      position: relative;\n      top: 0;\n      right: 0;\n      content: '\"';\n    }\n    &::after {\n      position: relative;\n      top: 0;\n      left: 0;\n      content: '\"';\n    }\n  }\n\n  .helper-mr-5 {\n    margin-right: 5px;\n  }\n\n  .helper-d-inline-block {\n    display: inline-block;\n  }\n\n  .helper-word-break {\n    word-break: break-word;\n  }\n\n  .width-100 {\n    width: 100%;\n  }\n\n  .gh-fe.validation {\n    font-size: 0.9em;\n    margin: 0px 0px 10px 0px;\n  }\n\n  .row {\n    padding: 33px 10px 33px 40px;\n    margin: 0px;\n  }\n\n  .gh-empty-module {\n    margin-top: 50px;\n  }\n\n  .gh-siv-section {\n    margin-top: 60px;\n    margin-bottom: 0;\n\n    &.kr-details {\n      margin-top: 0px;\n    }\n\n    .gh-siv-row-name,\n    .gh-siv-row-content {\n      word-break: break-word;\n\n      &.readonly {\n        flex: none;\n        cursor: not-allowed;\n      }\n    }\n\n    .dynamic-kr-details {\n      margin-bottom: 20px;\n      span.with-more-items {\n        align-items: center;\n        margin: 7px 0px;\n      }\n\n      .dynamic-kr-details-header {\n        color: @black-60;\n        font-size: 13px;\n        line-height: 18px;\n      }\n\n      .gh-siv-item-details {\n        background-color: @indigo-10;\n        border-radius: 7px;\n        color: @brand-grey2;\n        font-size: 13px;\n        line-height: 18px;\n        padding: 10px;\n\n        .filters {\n          margin: 0px;\n        }\n\n        .insight-usage {\n          margin: 10px 0px 0px 0px;\n        }\n\n        .filters,\n        .insight-usage {\n          p {\n            margin: 0px;\n          }\n\n          ul {\n            li {\n              margin-left: 20px;\n              list-style: disc;\n              padding: 2px 0px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .task-due-date {\n    width: 22%;\n\n    .due-date {\n      display: flex;\n      padding: 2px 5px;\n      align-items: center;\n    }\n\n    .remove {\n      position: relative;\n      display: inline-block;\n      margin: 0 0 0 10px;\n    }\n  }\n\n  .kr-header {\n    display: flex;\n    position: relative;\n    padding: 0px 15px;\n    margin-bottom: 20px;\n\n    .kr-title {\n      width: 650px;\n      input {\n        text-overflow: ellipsis;\n      }\n\n      input[readonly] {\n        color: @gray-color-7;\n        background-color: @gray-color-2;\n        cursor: not-allowed;\n      }\n\n      input[readonly]::placeholder {\n        color: @gray-color-5;\n      }\n    }\n\n    .gh-fe.validation {\n      margin-left: 6px;\n    }\n\n    .kr-btn-group {\n      margin: 0 30px auto auto;\n\n      ui-button:first-of-type {\n        margin-right: 10px;\n      }\n    }\n  }\n\n  .gh-box .comments {\n    .gh-box-section {\n      position: relative;\n      padding-left: 48px;\n\n      .date {\n        font-weight: 700;\n      }\n    }\n  }\n  .line {\n    border-left: 3px solid @brand-light;\n    padding-left: 30px;\n  }\n  .gh-box {\n    position: relative;\n\n    &:before {\n      content: \"\";\n      width: 14px;\n      height: 14px;\n      background: @brand-light;\n      border: 4px solid @brand-white;\n      border-radius: 7px;\n      position: absolute;\n      left: -40px;\n      top: 15px;\n    }\n\n    .gh-box-section {\n      padding: 10px 10px 5px 10px;\n    }\n  }\n\n  .date {\n    padding-left: 5px;\n    font-weight: @medium;\n    font-size: 0.85em;\n    color: @brand-dark;\n\n    .late {\n      font-size: 1em;\n      color: @brand-danger;\n    }\n  }\n\n  .gh-siv-clickable {\n    span {\n      color: @black-70;\n      font-size: 13px;\n      line-height: 18px;\n    }\n\n    .section-toggle {\n      display: inline-block;\n      color: @black-70;\n      margin-right: 5px;\n\n      span {\n        font-size: 10px;\n      }\n    }\n  }\n\n  .session-title {\n    color: @black-60;\n  }\n\n  .filters,\n  .insight-usage {\n    margin-top: 20px;\n  }\n\n  dropdown-actions-menu {\n    .gh-actions-menu {\n      min-width: 180px;\n    }\n  }\n\n  .insight-details {\n    .assignee-picture {\n      position: absolute;\n    }\n  }\n\n  a {\n    &.insight-name {\n      display: block;\n      margin-left: 20px;\n      cursor: pointer;\n    }\n  }\n\n  .jreactions-comment-wrapper {\n    &.gh-ml-4 {\n      margin-left: 0;\n    }\n\n    .dropdown-menu {\n      left: -200px;\n    }\n  }\n\n  .no-permissions {\n    display: flex;\n    position: relative;\n    background: @blue-5;\n    border-radius: 10px;\n    padding: 10px;\n    align-items: center;\n    margin-left: -10px;\n\n    span {\n      font-family: \"SF Pro Text\", \"Helvetica Neue\", \"SegoeUI\", sans-serif;\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 18px;\n      color: @ink-100-v2;\n    }\n  }\n\n  .gh-siv-editable-markdown-preview {\n    &.disabled {\n      background-color: inherit;\n\n      &:hover {\n        border: 1px solid transparent;\n        box-shadow: none;\n      }\n    }\n  }\n\n  // to do: move this button to a component https://gtmhub.atlassian.net/browse/GVS-13472\n  .view-in-alignment {\n    margin-right: 24px;\n    height: 24px;\n    width: 24px;\n    border-radius: 4px;\n    color: fade(@brand-dark, 30%);\n    cursor: pointer;\n\n    &:after {\n      content: \"\";\n      &:extend(.pos-abs-full-size);\n      border-radius: 4px;\n    }\n\n    &:focus {\n      box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1), 0px 0px 0px 2px @blue-5;\n\n      &:after {\n        border: 1px solid @blue-40-v2;\n      }\n    }\n\n    &:active {\n      box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1);\n\n      &:after {\n        border: 2px solid #9bbeff;\n      }\n    }\n  }\n\n  rich-text-editor {\n    &.in-metric-view {\n      width: 100%;\n      min-height: 34px;\n      margin-top: -6px;\n      margin-bottom: 10px;\n    }\n  }\n\n  .parent-info {\n    padding-left: 12px;\n  }\n\n  .tracked-automatically {\n    margin-left: 13px;\n  }\n}\n",".d-block {\n  display: block;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.d-grid {\n  display: grid;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-inline-flex {\n  display: inline-flex;\n}\n\n.d-none {\n  display: none;\n}\n\n.align-items-c {\n  align-items: center;\n}\n\n.align-items-st {\n  align-items: flex-start;\n}\n\n.align-items-e {\n  align-items: flex-end;\n}\n\n.align-items-s {\n  align-items: stretch;\n}\n\n.align-self-c {\n  align-self: center;\n}\n\n.align-self-st {\n  align-self: flex-start;\n}\n\n.align-self-end {\n  align-self: flex-end;\n}\n\n.justify-cont-c {\n  justify-content: center;\n}\n\n.justify-cont-sb {\n  justify-content: space-between;\n}\n\n.justify-cont-fe {\n  justify-content: flex-end;\n}\n\n.flex-w-w {\n  flex-wrap: wrap;\n}\n\n.flex-d-c {\n  flex-direction: column;\n}\n\n.flex-d-r {\n  flex-direction: row;\n}\n\n.centered-vert {\n  &:extend(.d-flex,\n  .align-items-c);\n}\n\n.vert-start {\n  &:extend(.d-flex,\n  .align-items-st);\n}\n\n.centered-horiz {\n  &:extend(.d-flex,\n  .justify-cont-c);\n}\n\n.centered-content {\n  &:extend(.d-flex,\n  .align-items-c,\n  .justify-cont-c);\n}\n\n.space-between-horiz {\n  &:extend(.d-flex,\n  .justify-cont-sb);\n}\n\n.space-between-vert {\n  &:extend(.d-flex,\n  .flex-d-c,\n  .justify-cont-sb);\n}\n\n.align-start-vert {\n  &:extend(.d-flex,\n  .flex-d-c,\n  .align-items-st);\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-2 {\n  flex: 2;\n}\n\n.flex-3 {\n  flex: 3;\n}\n\n.flex-4 {\n  flex: 4;\n}\n\n.flex-a {\n  flex: auto;\n}\n\n.flex-n {\n  flex: none;\n}\n\n.flex-w {\n  flex-wrap: wrap;\n}\n\n.p-rel {\n  position: relative;\n}\n\n.p-abs {\n  position: absolute;\n}\n\n.p-fixed {\n  position: fixed;\n}\n\n.pos-abs-full-size {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.vh-100 {\n  height: 100vh;\n}\n","@import (reference) \"../../../../node_modules/bootstrap/less/variables.less\";\n@import (reference) \"../../less/_variables.less\";\n@import (reference) \"../../less/common/font-formatting.less\";\n@import (reference) \"../../less/common/displaying.less\";\n@import (reference) \"../../less/common/positioning.less\";\n@import (reference)\n  \"../../../../node_modules/bootstrap/less/mixins/vendor-prefixes.less\";\n\n@import \"./components/clone-okrs/clone-okrs.less\";\n@import \"./metrics/module.less\";\n@import \"../goals/goals.module.less\";\n@import \"../tasks/tasks.module.less\";\n@import \"../workflow/module.less\";\n@import \"../sessions/sessions.module.less\";\n@import \"./alignment-tree/module.less\";\n\n.modal-overflow-x-unset {\n  .modal-dialog {\n    .modal-content {\n      overflow-x: unset;\n    }\n  }\n}\n",".modal.medium.clone .modal-dialog {\n  width: 500px;\n}\n\n.modal.clone .modal-dialog .modal-content {\n  padding: 38px 50px;\n}\n\n#clone {\n  .clone-p {\n    padding: 9px 10px;\n  }\n\n  .grey-border {\n    border: 1px solid @grey-60-v2;\n    box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n    border-radius: 4px;\n  }\n\n  .title {\n    font-size: 30px;\n    color: @ink-90-v2;\n    .fw-700;\n  }\n\n  .gh-font-icon-help {\n    color: @ink-50-v2;\n  }\n\n  .gh-select {\n    .dropdown-menu {\n      ul {\n        li {\n          &.disabled {\n            .hov-cursor-na;\n          }\n        }\n      }\n    }\n  }\n\n  ui-checkbox label {\n    margin: 0;\n    font-weight: inherit;\n  }\n}\n\n.accordion-info {\n  font-weight: @regular;\n  font-size: 12px;\n  line-height: 18px;\n  color: @ink-60-v2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* number of lines to show */\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.additional-info-position {\n  flex-basis: 100%;\n}\n",".fw-100 {\n  font-weight: @thin !important;\n}\n\n.fw-200 {\n  font-weight: @extralight !important;\n}\n\n.fw-300 {\n  font-weight: @light !important;\n}\n\n.fw-400 {\n  font-weight: @regular !important;\n}\n\n.fw-500 {\n  font-weight: @medium !important;\n}\n\n.fw-600 {\n  font-weight: @mediumbold !important;\n}\n\n.fw-700 {\n  font-weight: @bold !important;\n}\n\n.fw-800 {\n  font-weight: @extrabold !important;\n}\n\n.fw-900 {\n  font-weight: @ultrabold !important;\n}\n\n.ellipsis {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.t-align-l {\n  text-align: left;\n}\n\n.t-align-r {\n  text-align: right;\n}\n\n.t-align-c {\n  text-align: center;\n}\n\n.t-d-underline {\n  text-decoration: underline;\n}\n\n.t-d-line-through {\n  text-decoration: line-through;\n}\n\n.w-s-normal {\n  white-space: normal;\n}\n\n.tt-capitalize {\n  text-transform: capitalize;\n}\n\n.tt-uppercase {\n  text-transform: uppercase;\n}\n",".o-hidden {\n  overflow: hidden;\n}\n\n.hov-cursor-g {\n  &:hover {\n    cursor: grab;\n  }\n}\n\n.hov-cursor-p {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.hov-cursor-h {\n  &:hover {\n    cursor: help;\n  }\n}\n\n.hov-cursor-na {\n  &:hover {\n    cursor: not-allowed;\n  }\n}\n\n.hov-cursor-i {\n  &:hover {\n    cursor: initial;\n  }\n}\n\n.no-pointer-events {\n  pointer-events: none;\n}\n","cascading-metric-form {\n  .bg-red-20 {\n    background: @red-20-v2;\n  }\n\n  .cascading-kr {\n    background: @grey-20-v2;\n\n    .title {\n      margin-right: 38px;\n      min-width: 218px;\n      max-width: 218px;\n      color: @ink-90-v2;\n      .ellipsis;\n    }\n  }\n\n  .gh-input-text-v2 {\n    &.w-154px {\n      &:extend(.w-154px);\n    }\n\n    &.w-536px {\n      &:extend(.w-536px);\n    }\n\n    &.pl-32px {\n      &:extend(.pl-32px);\n    }\n  }\n\n  .all-child-mr-24px {\n    > * {\n      margin-right: 24px;\n    }\n\n    > :last-child {\n      margin-right: 0;\n    }\n  }\n\n  .grid-cell {\n    padding: 8px 9px;\n    border: 1px solid @grey-60-v2;\n    border-radius: 4px;\n    box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1);\n  }\n\n  .total-contribution {\n    background: @blue-10-v3;\n    width: 416px;\n\n    &.good {\n      background: @teal-10-v2;\n    }\n  }\n\n  .bolder {\n    font-weight: @bold;\n    color: @ink-100-v3;\n  }\n\n  .user-selector-dropdown {\n    width: 390px;\n\n    .autocomplete {\n      margin-top: 0px;\n    }\n  }\n}\n","cascading-metric-contributor {\n  .p-abs-icon {\n    position: absolute;\n    // grid cell left offset\n    left: 9px;\n    top: 11px;\n  }\n\n  input[name=\"metricName\"] {\n    padding-left: 32px;\n  }\n\n  .dropdown-menu {\n    max-height: 332px;\n    overflow: auto;\n\n    li {\n      padding: 9px 12px 9px 8px;\n      cursor: pointer;\n\n      &:hover {\n        background: @grey-20-v2;\n      }\n\n      &.disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      &.b-top {\n        border-top: 1px solid @grey-10-v3;\n      }\n\n      &.group-title {\n        color: @ink-10-v3;\n        text-transform: uppercase;\n        cursor: auto;\n        font-weight: 600;\n        font-size: 11px;\n        line-height: 13px;\n        user-select: none;\n        height: 38px;\n\n        &:hover {\n          background: transparent;\n        }\n      }\n\n      &.metric-item {\n        padding-left: 40px;\n      }\n    }\n  }\n\n  .empty-owner {\n    background-color: @grey-5;\n    color: @ink-60-v2;\n  }\n}\n",".affix-input {\n  .gh-dynamic-input-group {\n    height: 38px;\n  }\n\n  .gh-dynamic-input-group .gh-dynamic-suffix,\n  .gh-dynamic-input-group .gh-dynamic-prefix {\n    border: 1px solid @grey-20;\n    color: @ink-70-v2;\n  }\n\n  .gh-dynamic-input-group {\n    .gh-dynamic-suffix {\n      border-left: none;\n      line-height: 38px;\n    }\n\n    .gh-dynamic-prefix {\n      border-right: none;\n      line-height: 38px;\n    }\n\n    .dynamic-format {\n      background: @grey-5;\n    }\n  }\n\n  .gh-input-text-v2 {\n    &.with-error {\n      border-color: @red-80-v2;\n    }\n\n    .dynamic-prefix {\n      border-radius: 0 4px 4px 0;\n    }\n\n    .dynamic-suffix {\n      border-radius: 4px 0 0 4px;\n    }\n  }\n}\n",".snapshot-comment {\n  font-size: 1.04em;\n  color: desaturate(lighten(@brand-dark, 25%), 15%);\n  line-height: 1.6em;\n\n  .snapshot-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: @brand-dark;\n    font-weight: @medium;\n\n    .update-value {\n      font-weight: @bold;\n    }\n\n    .gh-badge {\n      position: relative;\n      top: -5px;\n      left: 5px;\n      padding: 4px 4px 2px 3px;\n      line-height: 0.8em;\n      font-size: 0.7em;\n      font-style: italic;\n      font-weight: @bold;\n      cursor: help;\n\n      &.locked {\n        &::before {\n          content: \"+\";\n          font-style: italic;\n        }\n      }\n    }\n  }\n}\n\n.gh-box-section.box-header {\n  padding: 0px;\n\n  .assignee-date-container {\n    display: inline-block;\n    padding: 10px;\n\n    .gh-icon {\n      vertical-align: middle;\n    }\n  }\n\n  .confidence-attainment-container {\n    float: right;\n\n    .current-attainment,\n    .confidence-value {\n      display: inline-block;\n      padding: 10px 10px;\n    }\n\n    .current-attainment {\n      font-weight: @bold;\n      border-left: 1px solid @brand-border;\n    }\n\n    .confidence-overflow {\n      display: block;\n      padding: 0px;\n      text-align: right;\n    }\n\n    .attainment-border {\n      border-left: none;\n    }\n  }\n\n  @media (min-width: 980px) {\n    .confidence-attainment-container {\n      max-width: 220px;\n    }\n  }\n\n  @media (max-width: 980px) {\n    .confidence-attainment-container {\n      max-width: 400px;\n    }\n  }\n}\n\n.delete-checkin-update,\n.edit-checkin-update {\n  color: lighten(@brand-subtler, 20%);\n  margin-left: auto;\n\n  &:hover {\n    color: @brand-subtler;\n    cursor: pointer;\n  }\n}\n\n.checkin-update-note-container {\n  position: relative;\n  border-top: 1px solid @brand-light;\n  padding-top: 10px;\n  padding-bottom: 3px;\n  display: flex;\n  align-items: center;\n  .nc-icon-mini.icon {\n    vertical-align: top;\n    padding-top: 5px;\n  }\n  .checkin-update-note {\n    width: 80%;\n    display: inline-block;\n    padding-left: 15px;\n\n    p {\n      font-weight: @regular;\n    }\n  }\n\n  .gh-icon {\n    position: absolute;\n  }\n\n  rich-text-editor {\n    margin: 0;\n\n    .ql-editor {\n      padding-top: 0;\n    }\n  }\n}\n",".badges-text-confidence {\n  .gh-clickable {\n    margin: 15px;\n    opacity: 0.5;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    &.twa-3x {\n      opacity: 1;\n    }\n  }\n\n  .gh-badge.text-confidence {\n    color: #fff;\n    padding: 8px 15px;\n    font-weight: @bold !important;\n    margin: 15px 8px;\n    border-radius: 15px;\n    border: 10px solid #fff;\n\n    &.gh-active-range {\n      opacity: 1;\n      border: 10px solid @brand-light;\n    }\n  }\n}\n","@import \"./components/cascading-metric-form/cascading-metric-form.less\";\n@import \"./components/cascading-metric-form/cascading-metric-contributor.less\";\n@import \"./components/cascading-metric-values-affix-input/cascading-metric-values-affix-input.less\";\n@import \"./components/metric-snapshot-preview/metric-snapshot-preview.component.less\";\n@import \"./less/metric.less\";\n@import \"./less/slider.less\";\n\nbody .bad {\n  .metric-trend-chart {\n    .ct-series-b {\n      .ct-area {\n        fill: @brand-danger;\n      }\n\n      .ct-line {\n        stroke: @brand-danger;\n      }\n    }\n\n    .ct-series-c {\n      .ct-point {\n        stroke: @brand-danger;\n      }\n\n      .ct-line {\n        stroke: @brand-danger;\n      }\n    }\n  }\n}\n\nbody .metric-trend-chart {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n\n  .ct-grid {\n    stroke-dasharray: 3px;\n    stroke: rgba(0, 0, 0, 0.1);\n  }\n\n  .ct-label {\n    white-space: nowrap !important;\n    font-size: 0.8em;\n    font-weight: @regular;\n    color: @brand-dark;\n  }\n\n  .ct-series-a {\n    .ct-point {\n      stroke-width: 6px;\n      stroke: @gray-color-5;\n    }\n\n    .ct-line {\n      stroke: #ddd;\n      stroke-dasharray: 5px;\n      stroke-width: 2px;\n\n      &.ct-line-anti-kr {\n        stroke: @brand-jira;\n        stroke-dasharray: none;\n        stroke-width: 2px;\n      }\n    }\n  }\n\n  .ct-series-b {\n    .ct-area {\n      fill: @brand-primary;\n    }\n\n    .ct-point {\n      stroke-width: 8px;\n    }\n\n    .ct-line {\n      stroke: @brand-primary;\n      stroke-width: 1px;\n      stroke-dasharray: 5px;\n    }\n  }\n\n  .ct-series-c {\n    .ct-point {\n      stroke-width: 0;\n      stroke: @brand-primary;\n\n      &:last-child {\n        stroke-width: 8px;\n      }\n    }\n\n    .ct-line {\n      stroke: @brand-primary;\n      stroke-width: 2px;\n    }\n  }\n\n  .ct-chart-line {\n    .hard-deadline {\n      stroke: @brand-info;\n      stroke-width: 2px;\n      stroke-dasharray: 5px;\n      stroke-dashoffset: 5px;\n    }\n  }\n\n  .soft-deadline {\n    stroke: @brand-warning;\n    stroke-width: 2px;\n    stroke-dasharray: 5px;\n    stroke-dashoffset: 5px;\n  }\n\n  .hard-deadline-label,\n  .soft-deadline-label,\n  .hard-deadline-position-label,\n  .soft-deadline-position-label {\n    position: absolute;\n    display: block;\n    font-size: 11px;\n    text-shadow: 0 0px 1px @brand-light;\n    padding-left: 50px;\n  }\n\n  .hard-deadline-label {\n    font-weight: @medium;\n    top: 50px;\n    color: @brand-jira;\n  }\n\n  .hard-deadline-position-label {\n    top: 64px;\n    color: @brand-jira;\n  }\n\n  .soft-deadline-label {\n    font-weight: @medium;\n    top: 20px;\n    color: @brand-warning;\n  }\n\n  .soft-deadline-position-label {\n    top: 34px;\n    color: @brand-warning;\n  }\n\n  .chartist-tooltip-meta {\n    margin-left: 5px;\n    padding: 4px 4px 2px 3px;\n    line-height: 0.8em;\n    font-size: 0.7em;\n    font-style: italic;\n    font-weight: 700;\n  }\n}\n\n@media all and (max-width: 991px) {\n  #metric-preview .confidence-level-trend-chart-title {\n    width: 100%;\n  }\n\n  #metric-preview .custom-fields-two-columns.confidence-shown {\n    position: relative;\n    margin-top: 180px;\n  }\n}\n\n#metric-preview .confidence-level-trend-chart {\n  position: relative;\n}\n\n.confidence-level-trend-chart-title {\n  margin-left: 40%;\n  margin-top: 20px;\n  color: @brand-grey;\n}\n\n.update-history-comments-title {\n  text-align: center;\n  margin-bottom: 16px;\n  color: @brand-grey;\n}\n\n.metric-confidence-level-trend-chart {\n  width: 100%;\n  height: 150px;\n\n  .ct-area,\n  .ct-line {\n    pointer-events: none;\n  }\n\n  .ct-series-a {\n    .ct-line {\n      stroke: #ddd;\n      stroke-width: 2px;\n    }\n\n    .ct-point {\n      stroke: #ddd;\n      stroke-width: 5px;\n      stroke-linecap: round;\n    }\n  }\n\n  .ct-series-b {\n    .ct-line {\n      stroke: @brand-primary;\n      stroke-width: 2px;\n    }\n\n    .ct-point {\n      stroke: @brand-primary;\n      stroke-width: 5px;\n      stroke-linecap: round;\n    }\n  }\n\n  .ct-label {\n    white-space: nowrap !important;\n    font-size: 0.8em;\n    font-weight: @regular;\n  }\n\n  .ct-grids .ct-grid {\n    stroke: #ddd;\n  }\n}\n",".goals-bulk-actions.sidebar-modal.modal {\n  width: 40%;\n  right: 0;\n  left: auto;\n}\n\n.goals-bulk-actions + .modal-backdrop.in {\n  display: none;\n}\n\n.create-dnd-tag-error {\n  color: @red-80-v2;\n}\n","okr-workflow {\n  display: block;\n  margin-top: -1px; // to cover the 1px bottom border of the title\n\n  .workflow-bar {\n    padding: 0 40px;\n    height: 46px;\n\n    .workflow-btn {\n      margin-left: 10px;\n      margin-right: 0px;\n    }\n\n    &.draft {\n      background: @black-10;\n    }\n\n    &.in-review {\n      background: @purple-30;\n    }\n\n    &.approved {\n      background: @teal-10;\n    }\n\n    &.needs-reviewers {\n      background: @orange-50;\n    }\n\n    .workflow-status-label {\n      font-size: 12px;\n      font-weight: @medium;\n\n      .draft {\n        color: @black-70;\n      }\n\n      .in-review {\n        color: @purple-100;\n      }\n\n      .approved {\n        color: @teal-100;\n      }\n\n      .needs-reviewers {\n        color: @yellow-300;\n      }\n\n      .draft,\n      .in-review,\n      .needs-reviewers {\n        margin-right: 5px;\n      }\n\n      .draft-tooltip {\n        background: @black-30;\n      }\n\n      .in-review-tooltip {\n        background: @purple-50;\n      }\n\n      .needs-reviewers-tooltip {\n        background: @yellow-100;\n      }\n\n      .draft-tooltip,\n      .in-review-tooltip,\n      .needs-reviewers-tooltip {\n        display: inline-block;\n        height: 10px;\n        width: 10px;\n        padding-right: 0.5px;\n        border-radius: 50%;\n        font-size: 8px;\n        text-align: center;\n        color: @brand-white;\n        cursor: help;\n      }\n\n      .df-aic {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .workflow-reviewers {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      max-width: 375px;\n      cursor: pointer;\n\n      > * {\n        margin-right: 5px;\n      }\n\n      > :last-child {\n        margin-right: 0px;\n      }\n\n      .fake-reviewer {\n        .icon {\n          font-size: 10px;\n          padding: 4px;\n          border-radius: 50%;\n          border: 1px solid @brand-black;\n        }\n      }\n\n      .gh-siv-owner-icon {\n        position: relative;\n      }\n    }\n\n    .show-hide-reviewers {\n      font-size: 12px;\n      line-height: 14px;\n    }\n\n    .gh-b {\n      &.needs-reviewers {\n        color: @brand-white;\n        background: @orange-200;\n      }\n    }\n  }\n}\n",".timeline {\n  float: left;\n  width: 100%;\n  padding-left: 30px;\n\n  .strong {\n    font-weight: @semibold;\n    color: @black-90;\n  }\n}\n\n.mention-container {\n  position: relative;\n  top: 15px;\n  left: 4%;\n  width: 92%;\n\n  [ui-mention] {\n    min-height: 100px;\n    width: 100%;\n    background: none;\n    position: relative;\n    margin-bottom: 20px;\n    z-index: 2;\n    box-sizing: content-box; // Prevent scrollbar for autogrow\n  }\n  .mention-highlight {\n    white-space: pre-wrap;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    font-weight: @light;\n    color: rgba(0, 0, 0, 0);\n    font-size: 15px;\n    line-height: 24px;\n    z-index: 1;\n\n    span {\n      border-radius: 5px;\n      background-color: fade(@brand-info, 10%);\n      padding: 2px;\n      margin-left: -2px;\n    }\n  }\n}\n\n.mentioned {\n  .dropdown {\n    display: inline-block;\n    position: relative;\n\n    .dropdown-toggle {\n      color: @brand-jira;\n\n      &:before {\n        content: \"@\";\n      }\n\n      &:hover {\n        color: darken(@brand-jira, 5%);\n        cursor: pointer;\n      }\n    }\n\n    .dropdown-menu {\n      padding: 20px 20px 20px 70px;\n      min-width: 340px;\n      margin-left: -30px;\n      text-align: left;\n\n      h3 {\n        margin-top: 0 !important;\n        font-size: 18px !important;\n        font-weight: @semibold !important;\n        margin-bottom: 8px !important;\n        color: @brand-dark;\n      }\n\n      h4 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n        font-size: 13px !important;\n        font-weight: @semibold !important;\n        color: @brand-subtle;\n      }\n    }\n  }\n}\n\n.moments {\n  position: relative;\n\n  &:before {\n    content: \"Now\";\n    position: absolute;\n    left: -12px;\n    width: 22px;\n    height: 22px;\n    border-radius: 15px;\n    top: -25px;\n    text-transform: uppercase;\n    opacity: 0.2;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .moment {\n    width: 100%;\n    float: left;\n    position: relative;\n    padding: 0 0 0 60px;\n    .transition(0.3s);\n\n    .content {\n      border-bottom: 1px solid #eee;\n      padding: 0 0 30px 0;\n      color: desaturate(lighten(@brand-dark, 20%), 10%);\n      font-size: 1em;\n\n      a {\n        cursor: pointer;\n      }\n\n      strong {\n        font-weight: @medium;\n        color: lighten(@brand-dark, 10%);\n      }\n\n      .status {\n        display: inline-block;\n        display: inline-block;\n        padding: 2px 6px;\n        font-weight: 500;\n        font-size: 10px;\n        text-transform: uppercase;\n        border-radius: 3px;\n        background: @brand-light;\n        color: @brand-dark;\n\n        &.inprogress {\n          background: @brand-jira;\n          color: #fff;\n        }\n\n        &.done {\n          background: @brand-primary;\n          color: #fff;\n        }\n      }\n\n      .gh-tag-label:hover {\n        background: inherit;\n        cursor: default;\n        color: inherit;\n      }\n      .gh-tags .tag {\n        margin-bottom: -5px;\n        height: auto;\n        padding-left: 8px;\n        float: none;\n      }\n    }\n\n    &:before {\n      display: block;\n      content: \"\";\n      left: 0%;\n      height: 100%;\n      position: absolute;\n      width: 3px;\n      background: @brand-light;\n    }\n\n    .owner-and-time {\n      padding-top: 40px;\n      position: relative;\n\n      .dot {\n        position: absolute;\n        left: -69px;\n        width: 22px;\n        height: 22px;\n        border-radius: 15px;\n        background: @brand-light;\n        border: 4px solid #fff;\n        top: 55px;\n      }\n\n      &.goal {\n        .dot {\n          background: lighten(@brand-info, 20%);\n        }\n      }\n\n      &.task {\n        .dot {\n          background: lighten(@brand-primary, 20%);\n        }\n      }\n\n      &.metric {\n        .dot {\n          background: lighten(@brand-warning, 20%);\n        }\n      }\n\n      .owner {\n        display: inline-block;\n        font-size: 18px;\n        font-weight: @medium;\n        margin-right: 10px;\n      }\n\n      .time {\n        display: inline-block;\n        color: fade(@brand-dark, 25%);\n        font-size: 0.8em;\n      }\n    }\n\n    .linked-objectives-modified {\n      .previous-current-p {\n        margin: 10px 0 0;\n        font-weight: 500;\n      }\n\n      .timeline-toggle-details-btn {\n        display: block;\n        border: none;\n        font-size: 0.85em;\n        padding: 0;\n        font-weight: @regular;\n        color: @brand-jira;\n      }\n\n      .gh-icon {\n        &.tiny {\n          top: 2.5px;\n        }\n      }\n\n      .linked-goal-name {\n        margin-left: 3px;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .assignee {\n      margin-top: 3px;\n    }\n  }\n}\n\n.load-more-moments {\n  position: relative;\n  border-left: 3px solid @brand-light;\n  width: 75%;\n  padding: 20px 0 0px 60px;\n  float: left;\n\n  .stop {\n    position: absolute;\n    left: -15px;\n    width: 30px;\n    height: 3px;\n    background: @brand-light;\n    bottom: 0;\n  }\n\n  .link {\n    font-weight: @medium;\n    font-size: 1.1em;\n  }\n\n  .icon {\n    position: absolute;\n    left: -20px;\n    bottom: -10px;\n    background: @brand-light;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    text-align: center;\n    line-height: 40px;\n  }\n}\n","// stylelint-disable indentation, property-no-vendor-prefix, selector-no-vendor-prefix\n\n// Vendor Prefixes\n//\n// All vendor mixins are deprecated as of v3.2.0 due to the introduction of\n// Autoprefixer in our Gruntfile. They have been removed in v4.\n\n// - Animations\n// - Backface visibility\n// - Box shadow\n// - Box sizing\n// - Content columns\n// - Hyphens\n// - Placeholder text\n// - Transformations\n// - Transitions\n// - User Select\n\n\n// Animations\n.animation(@animation) {\n  -webkit-animation: @animation;\n       -o-animation: @animation;\n          animation: @animation;\n}\n.animation-name(@name) {\n  -webkit-animation-name: @name;\n          animation-name: @name;\n}\n.animation-duration(@duration) {\n  -webkit-animation-duration: @duration;\n          animation-duration: @duration;\n}\n.animation-timing-function(@timing-function) {\n  -webkit-animation-timing-function: @timing-function;\n          animation-timing-function: @timing-function;\n}\n.animation-delay(@delay) {\n  -webkit-animation-delay: @delay;\n          animation-delay: @delay;\n}\n.animation-iteration-count(@iteration-count) {\n  -webkit-animation-iteration-count: @iteration-count;\n          animation-iteration-count: @iteration-count;\n}\n.animation-direction(@direction) {\n  -webkit-animation-direction: @direction;\n          animation-direction: @direction;\n}\n.animation-fill-mode(@fill-mode) {\n  -webkit-animation-fill-mode: @fill-mode;\n          animation-fill-mode: @fill-mode;\n}\n\n// Backface visibility\n// Prevent browsers from flickering when using CSS 3D transforms.\n// Default value is `visible`, but can be changed to `hidden`\n\n.backface-visibility(@visibility) {\n  -webkit-backface-visibility: @visibility;\n     -moz-backface-visibility: @visibility;\n          backface-visibility: @visibility;\n}\n\n// Drop shadows\n//\n// Note: Deprecated `.box-shadow()` as of v3.1.0 since all of Bootstrap's\n// supported browsers that have box shadow capabilities now support it.\n\n.box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow; // iOS <4.3 & Android <4.1\n          box-shadow: @shadow;\n}\n\n// Box sizing\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n     -moz-box-sizing: @boxmodel;\n          box-sizing: @boxmodel;\n}\n\n// CSS3 Content Columns\n.content-columns(@column-count; @column-gap: @grid-gutter-width) {\n  -webkit-column-count: @column-count;\n     -moz-column-count: @column-count;\n          column-count: @column-count;\n  -webkit-column-gap: @column-gap;\n     -moz-column-gap: @column-gap;\n          column-gap: @column-gap;\n}\n\n// Optional hyphenation\n.hyphens(@mode: auto) {\n  -webkit-hyphens: @mode;\n     -moz-hyphens: @mode;\n      -ms-hyphens: @mode; // IE10+\n       -o-hyphens: @mode;\n          hyphens: @mode;\n  word-wrap: break-word;\n}\n\n// Placeholder text\n.placeholder(@color: @input-color-placeholder) {\n  // Firefox\n  &::-moz-placeholder {\n    color: @color;\n    opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526\n  }\n  &:-ms-input-placeholder { color: @color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Transformations\n.scale(@ratio) {\n  -webkit-transform: scale(@ratio);\n      -ms-transform: scale(@ratio); // IE9 only\n       -o-transform: scale(@ratio);\n          transform: scale(@ratio);\n}\n.scale(@ratioX; @ratioY) {\n  -webkit-transform: scale(@ratioX, @ratioY);\n      -ms-transform: scale(@ratioX, @ratioY); // IE9 only\n       -o-transform: scale(@ratioX, @ratioY);\n          transform: scale(@ratioX, @ratioY);\n}\n.scaleX(@ratio) {\n  -webkit-transform: scaleX(@ratio);\n      -ms-transform: scaleX(@ratio); // IE9 only\n       -o-transform: scaleX(@ratio);\n          transform: scaleX(@ratio);\n}\n.scaleY(@ratio) {\n  -webkit-transform: scaleY(@ratio);\n      -ms-transform: scaleY(@ratio); // IE9 only\n       -o-transform: scaleY(@ratio);\n          transform: scaleY(@ratio);\n}\n.skew(@x; @y) {\n  -webkit-transform: skewX(@x) skewY(@y);\n      -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n       -o-transform: skewX(@x) skewY(@y);\n          transform: skewX(@x) skewY(@y);\n}\n.translate(@x; @y) {\n  -webkit-transform: translate(@x, @y);\n      -ms-transform: translate(@x, @y); // IE9 only\n       -o-transform: translate(@x, @y);\n          transform: translate(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n  -webkit-transform: translate3d(@x, @y, @z);\n          transform: translate3d(@x, @y, @z);\n}\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees); // IE9 only\n       -o-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n.rotateX(@degrees) {\n  -webkit-transform: rotateX(@degrees);\n      -ms-transform: rotateX(@degrees); // IE9 only\n       -o-transform: rotateX(@degrees);\n          transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n  -webkit-transform: rotateY(@degrees);\n      -ms-transform: rotateY(@degrees); // IE9 only\n       -o-transform: rotateY(@degrees);\n          transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n  -webkit-perspective: @perspective;\n     -moz-perspective: @perspective;\n          perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n  -webkit-perspective-origin: @perspective;\n     -moz-perspective-origin: @perspective;\n          perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n  -webkit-transform-origin: @origin;\n     -moz-transform-origin: @origin;\n      -ms-transform-origin: @origin; // IE9 only\n          transform-origin: @origin;\n}\n\n\n// Transitions\n\n.transition(@transition) {\n  -webkit-transition: @transition;\n       -o-transition: @transition;\n          transition: @transition;\n}\n.transition-property(@transition-property) {\n  -webkit-transition-property: @transition-property;\n          transition-property: @transition-property;\n}\n.transition-delay(@transition-delay) {\n  -webkit-transition-delay: @transition-delay;\n          transition-delay: @transition-delay;\n}\n.transition-duration(@transition-duration) {\n  -webkit-transition-duration: @transition-duration;\n          transition-duration: @transition-duration;\n}\n.transition-timing-function(@timing-function) {\n  -webkit-transition-timing-function: @timing-function;\n          transition-timing-function: @timing-function;\n}\n.transition-transform(@transition) {\n  -webkit-transition: -webkit-transform @transition;\n     -moz-transition: -moz-transform @transition;\n       -o-transition: -o-transform @transition;\n          transition: transform @transition;\n}\n\n\n// User select\n// For selecting text on the page\n\n.user-select(@select) {\n  -webkit-user-select: @select;\n     -moz-user-select: @select;\n      -ms-user-select: @select; // IE10+\n          user-select: @select;\n}\n","#cloned-or-moved-metric-success {\n  .gh-empty-module-title {\n    .checkmark {\n      background: @brand-white;\n\n      .icon {\n        color: @brand-primary;\n        font-size: 55px;\n      }\n    }\n\n    .done {\n      color: @brand-black;\n    }\n  }\n  .success-msg {\n    opacity: 0.5;\n    font-size: 15px;\n  }\n\n  .gh-empty-module {\n    &.goal {\n      cursor: pointer;\n      display: table;\n      border: 2px solid @brand-light;\n      border-radius: 5px;\n      margin-top: 20px;\n      padding: 8px 15px;\n\n      .goal-wrapper {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n\n        .goal {\n          min-width: 80px;\n          display: flex;\n        }\n\n        .gh-icon {\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n}\n","#confirm-clone-or-move {\n  .gh-empty-module {\n    img {\n      display: inline-block;\n      margin-top: 10px;\n      margin-bottom: 30px;\n    }\n  }\n}\n","#submission {\n  .goal {\n    background: lighten(@brand-info, 37%);\n    padding: 40px;\n\n    .goal-title {\n      font-size: 1.4em;\n      position: relative;\n      padding-left: 25px;\n      display: flex;\n      justify-content: space-between;\n\n      .gh-icon {\n        position: absolute;\n        left: 0;\n        top: 5px;\n      }\n    }\n\n    .metric {\n      font-size: 1.2em;\n      position: relative;\n      padding-left: 25px;\n      margin-top: 10px;\n      display: flex;\n      justify-content: space-between;\n\n      .gh-icon {\n        position: absolute;\n        left: 0;\n        top: 5px;\n      }\n    }\n\n    .name {\n      padding: 5px;\n      position: relative;\n      bottom: 5px;\n      background: none;\n      border: 1px solid transparent;\n      width: 95%;\n\n      &:hover {\n        border: 1px solid @brand-grey;\n        border-radius: 3px;\n      }\n    }\n\n    .edit-icon {\n      cursor: pointer;\n\n      .nc-icon-outline {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .conditions {\n    margin-bottom: 40px;\n\n    .condition {\n      margin-top: 20px;\n      position: relative;\n      padding-left: 20px;\n\n      .description {\n        font-size: 0.9em;\n        color: @brand-subtler;\n      }\n      input {\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n\n      ui-checkbox {\n        position: relative;\n        left: -20px;\n\n        &.required {\n          &:before {\n            content: \"*\";\n            position: absolute;\n            left: -15px;\n            top: 3px;\n            font-size: 25px;\n            color: @brand-jira;\n          }\n        }\n      }\n    }\n  }\n}\n","#stat-view-tags {\n  padding: 5px 40px;\n  background: rgba(255, 255, 255, 0.5);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.compact-tags {\n  & * {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n\n  .autocomplete {\n    max-width: 300px;\n    font-family: @font-family-sans-serif;\n    padding: 10px;\n    border: 0;\n    box-shadow: 0px 4px 22px fade(@brand-subtle, 50%) !important;\n\n    .suggestion-list {\n      .suggestion-item {\n        font-size: 14px;\n        padding: 7px 15px;\n        color: @brand-subtle;\n\n        &.selected {\n          color: #fff;\n          background: @brand-primary;\n        }\n      }\n    }\n  }\n\n  .tags {\n    background: none;\n    padding: 0;\n    border: none;\n    box-shadow: none;\n\n    .input {\n      background: none;\n      border: 2px solid lighten(@brand-subtle, 20%);\n      border-radius: 4px;\n      min-width: 180px;\n      color: @brand-dark;\n      font-size: 12px;\n      height: 30px;\n      background: #fff;\n\n      &::placeholder {\n        color: @brand-subtle;\n        font-style: italic;\n      }\n\n      &:focus {\n        border-color: @brand-jira;\n      }\n    }\n\n    .tag-item {\n      background: @brand-jira;\n      color: #fff;\n      font-size: 12px;\n      padding: 0 22px 0 10px;\n      border: 0;\n      position: relative;\n      position: relative;\n      height: 30px;\n      line-height: 30px;\n\n      &.selected {\n        background: @brand-danger;\n      }\n\n      .icon {\n        color: #fff;\n      }\n\n      .ui-1_simple-remove {\n        position: absolute;\n        right: 5px;\n        top: 9px;\n        cursor: pointer;\n\n        &:hover {\n          opacity: 0.6;\n        }\n      }\n    }\n  }\n}\n\n#update-metric,\n#update-metric-note {\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n  margin: 0 auto;\n\n  @media all and (min-width: @screen-lg) {\n    max-height: fit-content;\n  }\n\n  .title {\n    color: @ink-100-v3;\n    margin-bottom: 36px;\n\n    .metric-name-container {\n      display: flex;\n      margin-top: 8px;\n\n      gh-icon {\n        display: flex;\n        align-items: center;\n      }\n\n      .metric-name {\n        display: inline-block;\n        width: 100%;\n        word-wrap: break-word;\n      }\n    }\n\n    .owners {\n      margin-top: 10px;\n    }\n\n    .info {\n      margin-top: 10px;\n      font-size: 14px;\n      color: @ink-40-v3;\n    }\n  }\n\n  .alerts {\n    display: flex;\n    flex-direction: column;\n    row-gap: 10px;\n    margin-bottom: 36px;\n\n    &:empty {\n      display: none;\n    }\n  }\n\n  .overflow-visible {\n    overflow: visible !important;\n  }\n\n  .form {\n    @media all and (min-width: @screen-lg) {\n      flex-grow: 1;\n      min-height: 30vh;\n      overflow-y: auto;\n      overflow-x: hidden; // Prevents horizontal scrollbar\n    }\n\n    // Move the vertical scrollbar\n    @scrollbar-offset: 24px;\n    margin-right: -@scrollbar-offset;\n    padding-right: @scrollbar-offset;\n\n    .form-row {\n      margin-bottom: 16px;\n\n      .section-name {\n        display: flex;\n\n        &.center {\n          align-items: center;\n        }\n      }\n\n      .section-field {\n        &.current-value-field {\n          display: flex;\n          align-items: center;\n\n          .current-value {\n            font-size: 16px;\n            font-weight: @mediumbold;\n          }\n\n          .info-popover {\n            margin-left: 5px;\n            opacity: 0.75;\n          }\n        }\n\n        &.target-value {\n          height: 36px;\n        }\n\n        &.rich-text-editor {\n          .remove-mention-btn {\n            color: @blue-80-v3;\n            cursor: pointer;\n          }\n\n          .mentioned {\n            font-size: 12px;\n\n            ui-avatar {\n              background: @ink-10-v3;\n              margin-left: -2px;\n              box-shadow: 0 0 0 2px #fff;\n              border-radius: 50%;\n              cursor: pointer;\n            }\n\n            .gh-mention {\n              margin-left: -2px;\n              padding-left: 4px;\n            }\n\n            .show-more-mentions {\n              margin-left: 0;\n            }\n          }\n        }\n      }\n\n      // TODO all these should be invalid when the entire custom fields component is migrated\n      &.custom-fields editable-custom-fields {\n        width: 100%;\n\n        .gh-siv-row {\n          .gh-siv-row-name {\n            width: 33.33%;\n\n            .cf-name {\n              font-size: 14px;\n            }\n          }\n        }\n\n        .gh-siv-row-content {\n          margin-left: 12px;\n        }\n      }\n\n      &.update-date {\n        margin-bottom: 0;\n\n        .section-name {\n          padding-top: 9px;\n        }\n      }\n    }\n  }\n\n  .button-row {\n    margin-top: 36px;\n\n    .buttons {\n      display: flex;\n      column-gap: 10px;\n    }\n  }\n\n  &.update-kr-note-form {\n    .title {\n      .description-row {\n        display: flex;\n        align-items: center;\n        margin-top: 18px;\n        margin-bottom: 18px;\n\n        .kr-description {\n          margin-left: 10px;\n        }\n      }\n    }\n\n    .mentioned {\n      .remove-mention-btn {\n        color: @blue-80-v3;\n        cursor: pointer;\n      }\n    }\n\n    .button-row {\n      display: flex;\n      column-gap: 10px;\n      margin-top: 36px;\n    }\n  }\n\n  .mentioned {\n    margin-top: 5px;\n    line-height: 20px;\n    color: @brand-subtler;\n    text-align: left;\n\n    .gh-mention {\n      width: 20px;\n      height: 20px;\n      display: inline-block;\n      position: relative;\n      margin-left: 5px;\n      margin-bottom: 5px;\n\n      .tooltip {\n        min-width: 150px;\n      }\n\n      img {\n        max-width: 100%;\n        border-radius: 20px;\n      }\n\n      &.removable {\n        &:hover {\n          cursor: pointer;\n\n          &:before {\n            position: absolute;\n            left: 0px;\n            top: 2px;\n            width: 20px;\n            height: 20px;\n            border-radius: 15px;\n            content: \"\\ea5c\";\n            background: fade(@brand-subtle, 30%);\n            color: #fff;\n            text-align: center;\n            display: block;\n            font: normal normal normal 11px/1 \"Nucleo Mini\";\n            line-height: 20px;\n            speak: none;\n            text-transform: none;\n            -webkit-font-smoothing: antialiased;\n          }\n        }\n      }\n    }\n\n    .pointer {\n      cursor: pointer;\n    }\n  }\n\n  .kr-current-value {\n    font-size: 1.2em;\n    font-weight: @medium;\n    padding: 40px 0;\n\n    .non-manual-kr-update {\n      font-size: 0.8em;\n      font-weight: @regular;\n    }\n\n    .format {\n      font-weight: @medium;\n      font-size: 1.1em;\n    }\n  }\n\n  .kr-update-lead {\n    position: relative;\n    display: flex;\n    margin-bottom: 30px;\n\n    .kr-description {\n      margin-top: 5px;\n      color: @brand-subtler;\n      font-size: 1em;\n    }\n\n    .kr-title {\n      font-size: 1.4em;\n      font-weight: @medium;\n      letter-spacing: -0.02em;\n      overflow-wrap: anywhere;\n    }\n\n    .picture {\n      position: absolute;\n      left: 0;\n      top: 0;\n\n      img {\n        max-width: 40px;\n        border-radius: 5px;\n      }\n    }\n  }\n\n  .custom-fields-section {\n    @fakeHeight: 59px;\n\n    p {\n      margin-bottom: 25px;\n    }\n\n    .textarea-wrapper {\n      min-height: @fakeHeight;\n\n      textarea {\n        min-height: @fakeHeight;\n        margin-bottom: 20px;\n      }\n    }\n  }\n}\n\n.create-goal {\n  background: rgba(46, 67, 84, 0.2);\n\n  .modal-body {\n    min-width: 370px;\n  }\n  .modal-dialog .modal-content {\n    overflow: visible;\n  }\n\n  .modal-dialog {\n    display: flex;\n    justify-content: center;\n\n    .modal-content {\n      max-width: 1054px;\n      min-height: initial;\n      padding: 0;\n      overflow: visible;\n      box-shadow: unset;\n    }\n  }\n}\n\n.create-goal-form-container {\n  position: relative;\n  box-shadow: 0px 4px 10px rgba(68, 85, 115, 0.3);\n  z-index: 1;\n\n  width: 662px;\n  background-color: @brand-white;\n\n  .effectiveness-indicator-wrapper {\n    top: 15px;\n    right: 60px;\n  }\n}\n\n#goal-form {\n  max-width: 660px;\n  margin: 0 auto;\n\n  .gh-selected-artefact {\n    display: flex;\n    flex-direction: column;\n\n    .gh-icon {\n      top: 12px;\n    }\n\n    .remove {\n      top: 12px;\n    }\n  }\n\n  .gh-typeahead.okr {\n    ul {\n      width: 100%;\n    }\n  }\n\n  .mask {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.5);\n    z-index: 4;\n\n    &.limit {\n      text-align: center;\n      color: #fff;\n      font-size: 16px;\n      line-height: 30px;\n      padding: 100px 60px 0 60px;\n      font-weight: @light;\n      background: fade(@brand-dark, 80%);\n    }\n  }\n\n  .timeframe {\n    border-bottom: 1px solid #eee;\n    padding-top: 20px;\n    position: relative;\n    height: 100px;\n    margin-bottom: 20px;\n\n    input {\n      position: absolute;\n      right: 0;\n      opacity: 0;\n      width: 40px;\n      height: 60px;\n      z-index: 2;\n      top: 20px;\n      cursor: pointer;\n    }\n\n    .cal {\n      position: absolute;\n      right: 0;\n      font-size: 24px;\n      color: @brand-dark;\n      top: 40px;\n      cursor: pointer;\n    }\n\n    .datebox {\n      position: relative;\n      padding-left: 45px;\n      width: 50%;\n      float: left;\n      padding-top: 20px;\n      height: 80px;\n    }\n\n    .sep {\n      position: absolute;\n      left: 50%;\n      margin-left: -30px;\n      color: #ccc;\n      top: 40px;\n    }\n\n    .label {\n      font-size: 11px;\n      position: absolute;\n      left: 0;\n      top: 0;\n      text-transform: uppercase;\n      color: fade(@brand-dark, 30%);\n    }\n\n    .day {\n      font-size: 30px;\n      font-weight: @thin;\n      color: @brand-primary;\n      position: absolute;\n      top: 16px;\n      left: 5px;\n    }\n\n    .month-year {\n      font-size: 13px;\n      font-weight: @regular;\n      color: fade(@brand-dark, 50%);\n    }\n\n    .weekday {\n      font-size: 11px;\n      font-weight: @light;\n      color: fade(@brand-dark, 50%);\n    }\n  }\n\n  .form-actions {\n    margin-top: 30px;\n\n    .btn {\n      margin-right: 20px;\n    }\n  }\n\n  .goal-form {\n    .form {\n      .gh-fg {\n        border: 0;\n      }\n\n      .team-assignee-forbidden-msg {\n        font-size: 0.9em;\n        color: @brand-warning;\n      }\n    }\n\n    .progress-calculation {\n      .default-label {\n        color: @brand-grey;\n        font-style: italic;\n        margin-left: 10px;\n      }\n    }\n\n    .edit-session {\n      .gh-select {\n        .sessions-list {\n          ul {\n            li {\n              .gh-icon {\n                top: 5px;\n                left: 2px;\n              }\n\n              .option-title {\n                display: inline-block;\n                margin-left: 18px;\n                font-weight: 400;\n              }\n\n              .subtitle {\n                margin-left: 38px;\n                margin-top: 5px;\n                color: @brand-subtler;\n              }\n            }\n          }\n        }\n      }\n\n      .gh-selected-artefact {\n        min-height: 69px;\n\n        &::before {\n          top: 25px;\n          color: lighten(@brand-grey, 15%);\n        }\n      }\n\n      .alert {\n        margin-top: 80px;\n      }\n    }\n\n    .form-actions {\n      padding-top: 40px;\n      padding-bottom: 40px;\n      border-top: 2px solid @brand-border;\n    }\n\n    .privacy-container {\n      display: flex;\n      justify-content: flex-end;\n\n      .privacy-wrapper {\n        display: flex;\n\n        .no-border {\n          border-bottom: none;\n          padding-top: 10px !important;\n          flex: 1;\n        }\n      }\n    }\n  }\n\n  // when we switch the forms to inline these css will be deleted\n  .editable-custom-fields {\n    padding-top: 30px;\n    margin-top: 30px;\n    border-top: 2px solid @brand-light;\n    .gh-siv-row-name {\n      font-size: 1.2em;\n      color: @brand-dark;\n      width: 33.33%;\n    }\n  }\n\n  &.simple-form {\n    .gh-f-title {\n      font-size: 30px;\n      line-height: 34px;\n    }\n\n    .gh-fg {\n      padding-top: 10px;\n      padding-left: 7px;\n    }\n\n    .gh-input-info {\n      // there is a .gh-input-info padding-right: 40px !important; which needs to be overridden\n      padding-right: 0px !important;\n    }\n\n    .section-name {\n      top: 0;\n      margin-bottom: 5px;\n\n      span.label-text {\n        display: inline-block;\n        position: relative;\n        font-family: \"SF Pro Text\", \"Helvetica Neue\", \"SegoeUI\", sans-serif;\n        color: @black-80;\n        font-weight: @semibold;\n        font-size: 12px;\n\n        .gh-b-input-info {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          position: absolute;\n          right: -18px;\n          top: 50%;\n          transform: translateY(-50%);\n          width: 14px;\n          height: 14px;\n          border-radius: 9px;\n          line-height: 18px;\n          border: 1px solid #9dabc5;\n          text-align: center;\n          color: #9dabc5;\n          font-size: 9px;\n          font-weight: 700;\n          cursor: help;\n\n          &.green {\n            background-color: @brand-green;\n            border-color: @brand-green;\n            color: @brand-white;\n          }\n        }\n      }\n    }\n\n    input {\n      border-radius: 4px;\n      border: 1px solid #c0cbdd;\n      box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n      font-family: \"SF Pro Text\", \"Helvetica Neue\", \"SegoeUI\", sans-serif;\n      font-size: 14px;\n      color: @ink-100;\n      transition: 0.3s all ease-in-out;\n\n      &::placeholder {\n        font-family: \"SF Pro Text\", \"Helvetica Neue\", \"SegoeUI\", sans-serif;\n        font-size: 14px;\n        color: #8393ae;\n      }\n\n      &:focus {\n        border: 1px solid #75a2f7;\n        box-shadow: 0px 0px 0px 2px #d3eaff,\n          inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n      }\n    }\n\n    .gh-fe {\n      text-align: left;\n    }\n\n    .form-actions {\n      margin-top: 0;\n      border-top: 0;\n      padding-top: 0px;\n      padding-bottom: 0px;\n\n      .gh-b {\n        border-radius: 38px;\n        padding: 7px 25px;\n        margin-left: 5px;\n      }\n    }\n  }\n}\n\n.workflow-stats {\n  padding: 0 40px;\n\n  .stat-row {\n    .stat-card {\n      margin: 15px 15px;\n      padding: 40px;\n      border-radius: 5px;\n      box-shadow: 1px 1px 2px 2px @brand-border;\n      background: #fff;\n\n      .header {\n        margin-bottom: 50px;\n\n        .title {\n          margin-bottom: 10px;\n          padding-right: 15px;\n          font-size: 25px;\n          font-weight: @medium;\n        }\n\n        .percentage {\n          text-align: right;\n\n          .value {\n            padding-left: 15px;\n            font-size: 60px;\n            line-height: 60px;\n            color: @brand-primary;\n            font-weight: @semibold;\n          }\n        }\n\n        .description {\n          color: @brand-grey;\n          font-size: 16px;\n          letter-spacing: 0.03em;\n        }\n      }\n\n      .clickable-stats {\n        padding: 15px 0px;\n        border-bottom: 2px solid @brand-border;\n\n        &:last-child {\n          border: 0;\n        }\n\n        .stat-description {\n          font-size: 16px;\n          color: @brand-dark;\n\n          &.clickable {\n            cursor: pointer;\n            color: @brand-jira;\n\n            &:hover {\n              color: @brand-info;\n              text-decoration: underline;\n            }\n          }\n        }\n\n        .value {\n          text-align: right;\n          font-size: 25px;\n          line-height: 25px;\n        }\n\n        &.approved {\n          .value {\n            color: @brand-primary;\n          }\n        }\n\n        &.pending {\n          .value {\n            color: @brand-navy;\n          }\n        }\n\n        &.draft {\n          .value {\n            color: @brand-grey;\n          }\n        }\n      }\n    }\n\n    &.goals {\n      .stat-card {\n        min-height: 385px;\n      }\n    }\n\n    &.users {\n      .stat-card {\n        min-height: 310px;\n\n        .header {\n          margin-bottom: 25px;\n          padding-bottom: 25px;\n          border-bottom: 2px solid @brand-border;\n          line-height: 60px;\n          font-size: 60px;\n          font-weight: @semibold;\n        }\n\n        .sub-title {\n          margin-bottom: 10px;\n          font-size: 16px;\n          font-weight: @semibold;\n        }\n\n        .description {\n          color: @brand-grey;\n          font-size: 16px;\n          letter-spacing: 0.03em;\n        }\n\n        .go-to-link {\n          margin-top: 20px;\n          font-size: 16px;\n          color: @brand-jira;\n          cursor: pointer;\n\n          &:hover {\n            color: @brand-info;\n            text-decoration: underline;\n          }\n        }\n\n        &.reviewers-pending,\n        &.owners-draft {\n          .header {\n            color: @brand-warning;\n          }\n        }\n\n        &.average-speed {\n          .header {\n            color: @brand-grey;\n\n            .units {\n              color: lighten(@brand-grey, 10%);\n              font-size: 30px;\n              font-weight: @regular;\n              letter-spacing: 0.03em;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.workflow-review-actions {\n  .gh-fa {\n    padding-top: 40px;\n    border-top: 2px solid @brand-border;\n  }\n\n  rich-text-editor ul.ql-mention-list {\n    width: 100%;\n  }\n}\n\n.inspect-goals-workflow {\n  .title {\n    margin-bottom: 40px;\n  }\n}\n\n.inspect-assignees-workflow {\n  .title {\n    margin-bottom: 20px;\n  }\n\n  .nudge-people {\n    margin-bottom: 40px;\n  }\n}\n\n.inspect-goals-workflow,\n.inspect-assignees-workflow {\n  padding-bottom: 20px;\n\n  .title {\n    font-size: 2em;\n    font-weight: @regular;\n  }\n\n  .gh-empty-module {\n    .gh-empty-module-title {\n      margin-bottom: 40px;\n    }\n  }\n\n  table {\n    width: 100%;\n\n    tr {\n      border-bottom: 1px solid @brand-border;\n      border-top: 1px solid @brand-border;\n\n      &:first-child {\n        font-size: 1.2em;\n        border: 0;\n\n        th {\n          padding-left: 15px;\n          padding-bottom: 10px;\n          font-weight: @medium;\n\n          &:first-child {\n            padding-left: 0px;\n          }\n        }\n      }\n\n      td {\n        vertical-align: top;\n        padding: 10px 15px 10px 10px;\n        border-right: 1px solid @brand-border;\n\n        &:first-child {\n          padding-left: 0px;\n        }\n\n        &:last-child {\n          border-right: 0;\n        }\n      }\n    }\n  }\n\n  .goals-reviewers-list,\n  .assignees-goals-list {\n    width: 100%;\n\n    .header {\n      .okrs {\n        width: 70%;\n      }\n\n      .approval-status {\n        width: 30%;\n      }\n\n      .assignee-header {\n        width: 40%;\n      }\n\n      .goals-header {\n        width: 60%;\n      }\n    }\n\n    .goal-reviewers,\n    .assignee-details {\n      .goal-info,\n      .assignee-info {\n        position: relative;\n\n        .goal-name {\n          margin-left: 4px;\n          font-size: 1.2em;\n        }\n\n        .goal-name {\n          color: @brand-jira;\n          cursor: pointer;\n\n          &:hover {\n            color: @brand-info;\n          }\n        }\n\n        .owner-name {\n          margin-left: 24px;\n          color: lighten(@brand-grey, 10%);\n\n          .owner-full-name {\n            &::before {\n              content: \", \";\n            }\n\n            &:first-of-type {\n              &::before {\n                content: none;\n              }\n            }\n          }\n        }\n      }\n\n      .goal-info {\n        .goal {\n          margin-bottom: 10px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n\n      .reviewers-status {\n        padding-bottom: 0px;\n\n        .reviewers-inline {\n          position: relative;\n          float: left;\n          margin-right: 15px;\n          margin-bottom: 10px;\n        }\n\n        .icon {\n          font-size: 12px;\n          padding: 5px;\n          width: 24px;\n          height: 24px;\n          border-radius: 50%;\n          border: 1px solid @brand-black;\n        }\n\n        .tooltip {\n          &.top {\n            padding: 7px 0;\n            margin-top: -6px;\n\n            .tooltip-inner {\n              background-color: @ink-80-v2;\n              padding: 4px 8px;\n              font-size: 14px;\n              box-shadow: 0px 4px 12px rgba(63, 87, 110, 0.2);\n              border-radius: 0;\n            }\n\n            .tooltip-arrow {\n              border-top-color: @ink-80-v2;\n              border-width: 7px 7px 0;\n              bottom: 0;\n              left: 50%;\n              margin-left: -7px;\n            }\n          }\n        }\n      }\n\n      .show-hide-reviewers {\n        float: left;\n        width: 100%;\n        text-align: left;\n        color: @brand-jira;\n        font-size: 0.9em;\n        cursor: pointer;\n\n        &:hover {\n          color: @brand-info;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n.goals-container {\n  .gh-ui-actions-dd .toggle {\n    color: @ink-80;\n  }\n}\n\n#session-tree-selector {\n  .session-tree-selector {\n    margin-top: 1px;\n    padding: 4px;\n  }\n\n  tree-selector {\n    max-height: 200px;\n    box-shadow: 0px 5px 10px 0px rgba(9, 30, 66, 0.25);\n\n    .branch {\n      padding: 0;\n\n      .leading-node {\n        margin-top: 0;\n        padding: 8px 24px 8px 18px;\n        cursor: pointer;\n        border-radius: 2px;\n\n        &:hover {\n          background: @blue-10-v3;\n        }\n\n        .expand-collapse {\n          display: none;\n        }\n\n        label {\n          &.title {\n            font-weight: 300;\n            color: @ink-100-v3;\n            width: 100%;\n          }\n        }\n      }\n\n      .leading-node.active {\n        position: relative;\n        background: @blue-80-v3;\n\n        .session-title {\n          color: @brand-white;\n        }\n\n        label {\n          &.title {\n            color: @brand-white;\n          }\n        }\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          right: 8px;\n          top: 0;\n          bottom: 0;\n          width: 12px;\n          height: 100%;\n          background: url(\"../../../../../wwwroot/fe/img/icons/check-white.svg\")\n            no-repeat center;\n        }\n      }\n\n      .sub-tree {\n        margin-left: 0;\n      }\n\n      .branch {\n        margin-left: 0;\n        border-radius: 2px;\n      }\n    }\n  }\n}\n\n#session-search-results {\n  max-height: 200px;\n  overflow-y: auto;\n\n  .session-not-found {\n    padding: 8px 4px 8px 14px;\n\n    .error-message {\n      color: @ink-100-v3;\n    }\n  }\n\n  .session-list {\n    padding: 4px;\n\n    .session-item {\n      padding: 8px 32px 8px 14px;\n      border-radius: 2px;\n\n      .session-color {\n        display: inline-block;\n        margin-right: 5px;\n        height: 10px;\n        width: 10px;\n        background-color: @yellow-80-v2;\n        border-radius: 5px;\n        vertical-align: middle;\n      }\n\n      .session-title {\n        display: inline-block;\n        vertical-align: middle;\n        max-width: 340px;\n        width: 100%;\n        overflow: hidden;\n        font-weight: 300;\n        color: @ink-100-v2;\n      }\n\n      .session-active {\n        display: inline-block;\n        position: absolute;\n        right: 8px;\n        top: auto;\n        bottom: auto;\n\n        .gh-icon-check-white {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n\n        .gh-icon.small {\n          &:before {\n            position: static;\n            width: 12px;\n            height: 9px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.editable-custom-fields {\n  .cf-dropdown {\n    .dropdown-menu {\n      max-width: 400px;\n      max-height: 230px; // displays 5 items: 5px margin-top, 30px li height, 5x margin between lis, 5px margin-bottom\n      overflow-y: auto;\n      overflow-x: hidden;\n      &::-webkit-scrollbar {\n        width: 7px;\n        border-radius: 10px;\n      }\n      /* Track */\n      &::-webkit-scrollbar-track {\n        background: @grey-10-v2;\n      }\n      /* Handle */\n      &::-webkit-scrollbar-thumb {\n        background: @grey-20;\n        border-radius: 10px;\n      }\n      li {\n        .cf-dropdown-btn {\n          max-width: 100%;\n          span {\n            overflow-x: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n    }\n  }\n}\n\n.modal-top {\n  .ui-label {\n    opacity: 0.9;\n    font-weight: @mediumbold;\n  }\n}\n","@import (reference)\n  \"packages/webapp/src/less/themes/default/color/theme-colors.less\";\n#goal-details {\n  display: flex;\n  flex-direction: column;\n  padding: 0 67px 0 40px;\n\n  .gh-siv-row {\n    position: relative;\n  }\n\n  .contextual-button {\n    position: absolute;\n    bottom: 18px;\n    left: 120px;\n  }\n\n  .goal-privacy {\n    flex: none !important;\n    .gh-select-toggle {\n      display: flex;\n      height: 24px;\n      border: none;\n      background: @ink-10;\n      border-radius: 20px;\n      padding: 4px 30px 4px 8px;\n\n      &:before {\n        font-family: \"Nucleo Mini\";\n        content: \"\\e926\";\n        top: 9px;\n        right: 25px;\n        color: @black-70;\n        font-size: 8px;\n      }\n\n      .gh-icon {\n        margin-right: 6px;\n      }\n\n      .selected-item-text {\n        align-self: center;\n        font-size: 12px;\n        line-height: 16px;\n      }\n    }\n    .dropdown-menu {\n      min-width: 125px;\n      ul {\n        padding: 3px 0px;\n        li {\n          padding: 8px 0px 8px 13px;\n          border: 0;\n          font-size: 12px;\n          line-height: 16px;\n\n          &:hover {\n            background-color: @royal-10;\n          }\n\n          .gh-icon {\n            margin-right: 6px;\n          }\n\n          &.active {\n            background: url(\"../../../../../wwwroot/fe/img/icons/check.svg\")\n              no-repeat;\n            background-position: 100px;\n            background-size: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  .goal-attainment {\n    .number {\n      font-size: 24px;\n      line-height: 24px;\n      font-weight: @medium;\n    }\n\n    .color {\n      width: 24px;\n      height: 24px;\n      border-radius: 15px;\n    }\n  }\n\n  .task-due-date {\n    color: @black-50;\n    font-size: 12px;\n    line-height: 20px;\n    width: 15%;\n    cursor: pointer;\n\n    .due-date {\n      padding: 0;\n\n      &.grey {\n        color: @black-50;\n      }\n      &.green {\n        color: @brand-green;\n      }\n      &.red {\n        color: @brand-red;\n      }\n\n      .remove {\n        display: inline-block;\n        margin-top: 4px;\n\n        &.grey {\n          color: @black-50;\n        }\n      }\n    }\n\n    .uib-datepicker-popup {\n      left: 0 !important;\n    }\n  }\n\n  .okr-task-section {\n    .task-due-date {\n      width: 17% !important;\n      position: relative;\n      margin-right: 40px;\n\n      .due-date {\n        .remove {\n          margin-top: 6px;\n        }\n      }\n    }\n  }\n\n  .dropdown-menu {\n    &.white-space-init {\n      white-space: initial;\n    }\n  }\n\n  tags-input[disabled] .tags .input {\n    background-color: inherit;\n    cursor: not-allowed;\n  }\n\n  parent-okr-selector {\n    width: 75%;\n    margin-top: -9px;\n    margin-left: -12px;\n    .tags .tag-item {\n      background: none;\n    }\n\n    .tag-list {\n      padding-left: 3px;\n    }\n  }\n\n  .parent-selector-container {\n    width: 75%;\n  }\n}\n\n.contributor {\n  .contributor-pad {\n    fill: white;\n  }\n\n  .contributor-separator {\n    fill: #eee;\n  }\n\n  &.matched {\n    .contributor-separator {\n      fill: #ffc25f;\n    }\n  }\n\n  &.unmatched {\n    opacity: 0.5;\n  }\n\n  .contributor-progress-bar {\n    width: 9%;\n    padding-top: 7px;\n  }\n\n  .contributor-attainment {\n    width: 10%;\n    text-align: left;\n  }\n\n  .kr-a11y-description {\n    opacity: 0;\n    background: transparent;\n    width: 0;\n    height: 0;\n  }\n}\n\n.separator {\n  margin: 40px 0;\n  height: 10px;\n  background: fade(@brand-light, 50%);\n}\n\n.single-goal-skeleton {\n  padding: 30px;\n\n  > ui-skeleton {\n    padding: 30px 0;\n  }\n\n  .single-goal-skeleton-row {\n    display: flex;\n    gap: 10px;\n    padding: 50px 0;\n  }\n}\n\n.modal-left-close-button {\n  left: 30px;\n}\n\n.single-goal {\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .available-actions {\n    // to do: move this button to a component https://gtmhub.atlassian.net/browse/GVS-13472\n\n    #view-in-alignment-button {\n      margin-right: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .view-in-alignment {\n        height: 24px;\n        width: 24px;\n        border-radius: 4px;\n        color: fade(@brand-dark, 90%);\n        cursor: pointer;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    dropdown-actions-menu {\n      .gh-actions-menu {\n        min-width: 250px;\n        max-width: 300px;\n\n        .actions {\n          .action {\n            &.to-marketplace {\n              .gh-b {\n                margin: 0;\n                padding: 5px 10px;\n                letter-spacing: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .indicator-holder {\n    clear: both;\n    width: 100%;\n    float: left;\n  }\n\n  .gh-siv-section {\n    .gh-siv-section-item {\n      .contributor-action-button {\n        .fake-update-button {\n          width: 78px;\n        }\n\n        .fake-update-btn {\n          width: 67px;\n        }\n      }\n    }\n  }\n\n  .goal-main-info {\n    ui-input-text-field {\n      margin-left: -10px;\n      flex-direction: column;\n      .ui-input-text-field {\n        width: 100%;\n        display: flex;\n        align-items: center;\n\n        input {\n          text-overflow: ellipsis;\n        }\n        input[readonly] {\n          color: @gray-color-7;\n          background-color: @gray-color-2;\n          cursor: not-allowed;\n        }\n\n        input[readonly]::placeholder {\n          color: @gray-color-5;\n        }\n      }\n    }\n\n    .session-selector-container {\n      position: relative;\n      width: 75%;\n      bottom: 8px;\n\n      .session-disabled-for-edit {\n        position: relative;\n        width: 100%;\n        top: 8px;\n        left: 5px;\n\n        .session-color {\n          display: inline-block;\n          width: 10px;\n          height: 10px;\n          border-radius: 10px;\n          margin-right: 4px;\n        }\n      }\n    }\n\n    .parent-selector-container {\n      position: relative;\n      width: 100%;\n      height: 36px;\n      bottom: 8px;\n    }\n\n    goal-tags {\n      .host {\n        .tags {\n          padding-left: 9px;\n          margin-right: 12px;\n        }\n      }\n    }\n  }\n\n  .goal-metrics {\n    width: 100%;\n\n    td {\n      vertical-align: top;\n\n      &.metric-confidence {\n        padding-left: 15px;\n        padding-right: 15px;\n      }\n\n      &.metric-owner {\n        padding-right: 10px;\n      }\n    }\n\n    .goal-metric {\n      position: relative;\n      padding: 12px 0 0;\n\n      .gh-b {\n        border-radius: 15px;\n        padding: 0 5px;\n        letter-spacing: -0.02em;\n      }\n\n      &.bottom-row {\n        & > td {\n          padding-bottom: 10px;\n          border-bottom: 1px solid @brand-light;\n        }\n\n        &:last-child {\n          & > td {\n            border-bottom: 0;\n          }\n        }\n      }\n\n      &.top-row {\n        & > td {\n          padding-top: 20px;\n        }\n      }\n\n      &.type-boolean {\n        .metric-attainment {\n          top: 18px;\n        }\n      }\n\n      .picture {\n        img {\n          max-width: 20px;\n          border-radius: 3px;\n        }\n      }\n\n      .metric-title {\n        font-size: 1.18em;\n        letter-spacing: -0.02em;\n        line-height: 1.32em;\n        padding-bottom: 12px;\n\n        a {\n          color: @brand-link;\n\n          &:hover {\n            color: @brand-jira;\n          }\n        }\n      }\n\n      .gh-custom-fields {\n        margin-top: 10px;\n      }\n\n      .metric-description {\n        padding-bottom: 10px;\n        font-size: 0.9em;\n        word-break: break-word;\n        color: @brand-subtler;\n        font-family: Arial, @font-family-sans-serif;\n\n        & + .gh-custom-fields {\n          margin-top: 0px;\n        }\n      }\n\n      .metric-progress {\n        position: relative;\n        margin-top: 9px;\n        width: 100%;\n\n        .metric-target {\n          font-size: 13px;\n          margin-bottom: 6px;\n          color: @brand-grey;\n          float: left;\n          width: 100%;\n        }\n\n        .gh-b {\n          position: absolute;\n          right: 10px;\n          top: 15px;\n        }\n      }\n\n      .metric-attainment {\n        color: @brand-dark;\n        font-size: 1em;\n        font-weight: @medium;\n        padding-left: 5px;\n\n        &.coloring {\n          right: 135px;\n          width: 10px;\n          height: 10px;\n          top: 17px;\n          border-radius: 20px;\n        }\n      }\n\n      &:hover {\n        .metric-bar-holder .time-progress-holder .pointer-label {\n          display: block;\n        }\n      }\n    }\n  }\n}\n\n&.single-goal-content-container {\n  width: 800px;\n}\n\n.scrollable-with-left-overflow {\n  margin-left: -200px;\n  padding-left: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.metric-target-and-timeleft {\n  float: left;\n  width: 100%;\n\n  .timeleft {\n    font-size: 0.9em;\n    color: fade(@brand-dark, 60%);\n    font-weight: @regular;\n  }\n\n  .metric-bar-target {\n    font-size: 12px;\n    display: block;\n    text-align: left;\n    color: @black-70;\n    max-width: 250px;\n  }\n}\n\n.metric-bar-holder,\n.goal-bar-holder {\n  position: relative;\n  width: 100%;\n  float: left;\n  background: repeating-linear-gradient(\n    45deg,\n    #fff,\n    #fff 4px,\n    #f9f9f9 3px,\n    #f3f3f3 7px\n  );\n\n  .time-progress-holder {\n    position: absolute;\n    left: 0;\n    top: 0px;\n    height: 6px;\n    width: 100%;\n\n    .soft-deadline {\n      position: absolute;\n      top: 0px;\n      left: 0;\n      min-width: 10px;\n      height: 6px;\n      background: fade(@brand-warning, 20%);\n      border-radius: 8px;\n      z-index: 4;\n\n      .drop {\n        position: absolute;\n        right: 2px;\n        top: -1px;\n        width: 8px;\n        height: 8px;\n        background: lighten(@brand-warning, 10%);\n        border-radius: 5px;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n      .tooltip {\n        min-width: 150px;\n      }\n    }\n\n    .pointer-label {\n      display: none;\n      position: absolute;\n      top: -24px;\n      font-size: 11px;\n      font-weight: @regular;\n      color: darken(@brand-light, 35%);\n    }\n\n    .time-progress {\n      position: absolute;\n      left: 0;\n      top: -9px;\n      width: 100%;\n      height: 6px;\n      overflow: hidden;\n\n      .pointer {\n        position: absolute;\n        top: 0px;\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-top: 6px solid darken(@brand-light, 5%);\n        margin-left: -1px;\n      }\n    }\n  }\n\n  .metric-bar,\n  .goal-bar {\n    height: 6px;\n    background: #eee;\n    border-radius: 3px;\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n\n    .metric-bar-progress,\n    .goal-bar-progress {\n      height: 6px;\n      position: absolute;\n      max-width: 100%;\n      border-radius: 3px;\n      left: 0;\n      top: 0;\n      background: darken(@brand-jira, 5%);\n      .transition(0.3s);\n\n      &:before {\n        position: absolute;\n        right: 2px;\n        top: 0;\n        height: 6px;\n        border-radius: 10px;\n        width: 6px;\n        background: fade(#fff, 40%);\n        content: \"\";\n      }\n\n      &.negative {\n        background: @brand-danger;\n      }\n    }\n  }\n}\n\n.gh-siv-editable-markdown {\n  margin-top: -6px;\n  margin-bottom: 10px;\n  width: 100%;\n  position: relative;\n  min-height: 40px;\n\n  &.width-60 {\n    width: 60px;\n  }\n\n  .gh-siv-editable-markdown-preview {\n    padding: 6px 12px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    cursor: text;\n    min-height: inherit;\n    line-height: 26px;\n\n    &.not-focused {\n      visibility: hidden;\n    }\n\n    &:hover {\n      border: 1px solid @grey-100-v2;\n      box-shadow: inset 0 1px 3px fade(@ink-70, 10%);\n    }\n  }\n}\n\n.gh-siv-row-content {\n  goal-tags,\n  .tags-input-container {\n    width: 100%;\n    height: 100%;\n\n    &.ng-empty {\n      .host .tags {\n        &:before {\n          position: absolute;\n          content: \"-\";\n          left: 1px;\n          top: 8px;\n        }\n\n        &.focused {\n          padding: 6px;\n\n          &:before {\n            content: \"\";\n          }\n        }\n      }\n    }\n\n    .autocomplete {\n      padding: 0;\n      border: 0;\n      box-shadow: 0 2px 15px fade(@ink-90, 25%);\n\n      .suggestion-list {\n        .suggestion-item {\n          font-size: 14px;\n          color: @ink-90;\n\n          &.selected {\n            background: @black-10;\n\n            &:after {\n              content: \"Press Tab to select\";\n              color: @ink-50;\n              font-size: 12px;\n              float: right;\n            }\n          }\n        }\n      }\n    }\n\n    .host {\n      margin: 0;\n\n      .tags {\n        box-shadow: none;\n        margin: -8px 0 0 -12px;\n        padding: 6px;\n        border-radius: 4px;\n        border: 1px solid transparent;\n\n        &.focused {\n          border: 1px solid @blue-80;\n        }\n\n        &:hover {\n          border: 1px solid @ink-50;\n          box-shadow: inset 0 1px 3px fade(@ink-70, 10%);\n        }\n\n        .input {\n          &:before {\n            content: \"+\";\n          }\n        }\n\n        .tag-list {\n          .tag-item {\n            border: 0;\n            border-radius: 20px;\n            padding: 0px 10px;\n            position: relative;\n            color: @black-70;\n            font-size: 13px;\n            background: @black-20;\n\n            &.selected {\n              background: @royal-20;\n            }\n\n            &:hover .remove-button {\n              display: block;\n            }\n\n            .remove-button {\n              position: absolute;\n              right: -3px;\n              top: -3px;\n              width: 15px;\n              height: 15px;\n              text-align: center;\n              line-height: 17px;\n              display: none;\n              border-radius: 10px;\n              font-size: 8px;\n              background: @black-50;\n              color: #fff;\n\n              &:hover {\n                background: @black-70;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.session-selector-dropdown-wrapper {\n    position: relative;\n\n    .dropdown-container {\n      position: absolute;\n      top: -6px;\n\n      &:hover {\n        border: 1px solid @ink-50;\n        box-shadow: inset 0 1px 3px fade(@ink-70, 10%);\n        cursor: pointer;\n      }\n    }\n  }\n\n  user-selector {\n    margin-top: -6px;\n\n    .tags {\n      padding-left: 7px;\n    }\n  }\n\n  people-selector {\n    margin-top: -9px;\n  }\n\n  rich-text-editor {\n    display: block;\n    width: 100%;\n    min-height: 40px;\n    margin-top: -10px;\n    margin-bottom: 12px;\n  }\n\n  goal-privacy-button {\n    margin-top: -7px;\n    position: relative;\n    left: -3px;\n  }\n\n  okr-design-score {\n    margin-top: 2px;\n  }\n\n  date-picker-legacy {\n    position: relative;\n    top: -12px;\n  }\n\n  goal-tags {\n    position: relative;\n    top: -13px;\n    left: 1px;\n  }\n\n  &.suggestion-card-description {\n    pi-text-card,\n    pi-loading-card,\n    pi-error-card,\n    pi-feedback-card,\n    pi-loading-card-v2,\n    pi-clickable-error-card {\n      position: relative;\n      top: -10px;\n    }\n  }\n\n  &.suggestion-card-tags {\n    pi-loading-card,\n    quantive-plus-suggestion-card-tags,\n    pi-error-card,\n    pi-feedback-card,\n    pi-loading-card-v2,\n    pi-clickable-error-card {\n      position: relative;\n      top: -13px;\n    }\n  }\n}\n","#goal-timeline {\n  .title {\n    position: relative;\n    display: inline-block;\n\n    h1 {\n      position: relative;\n      margin-bottom: 15px;\n      line-height: 1.4em;\n      font-size: 2.6em;\n      font-weight: 500;\n      color: #2e4354;\n    }\n  }\n}\n","#goals {\n  width: 100%;\n\n  &.loading {\n    opacity: 0.6;\n  }\n\n  .dropdown-menu-right {\n    left: 0;\n    right: auto;\n  }\n\n  .checkbox-disabled {\n    pointer-events: none;\n  }\n}\n\n.bulk-delete-warning-banner {\n  background-color: @blue-5;\n  color: @ink-100-v2;\n  gap: 10px;\n\n  .banner-icon {\n    color: @blue-80-v2;\n  }\n\n  .text-base,\n  .text-xs {\n    line-height: 19px;\n  }\n}\n\n.empty-module-v2 {\n  margin-top: 160px;\n  width: 352px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n","#metrics-in-danger {\n  width: 100%;\n\n  .color-dot {\n    width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    display: inline-block;\n  }\n\n  tr {\n    th {\n      text-transform: uppercase;\n      font-size: 10px;\n      font-weight: @regular;\n      letter-spacing: 1px;\n      color: @brand-subtle;\n      padding: 10px;\n      border-bottom: 1px solid #eee;\n    }\n    td {\n      padding: 10px;\n      border-bottom: 1px solid #eee;\n\n      &.metric-title {\n        a {\n          font-size: 16px;\n          font-weight: @regular;\n        }\n        .metric-type {\n          font-size: 11px;\n          line-height: 18px;\n          color: @brand-subtle;\n        }\n      }\n\n      &.target,\n      &.actual {\n        font-size: 16px;\n        font-weight: @light;\n      }\n\n      &.metric-attainment {\n        text-align: right;\n        font-size: 20px;\n        font-weight: @bold;\n\n        &.bad {\n          color: @brand-danger;\n        }\n\n        &.good {\n          color: @brand-primary;\n        }\n      }\n    }\n  }\n}\n\n#inspect-stats-goals {\n  width: 100%;\n\n  .color-dot {\n    width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    display: inline-block;\n  }\n\n  tr {\n    th {\n      text-transform: uppercase;\n      font-size: 10px;\n      font-weight: @regular;\n      letter-spacing: 1px;\n      color: @brand-subtle;\n      padding: 10px;\n      border-bottom: 1px solid #eee;\n    }\n    td {\n      padding: 10px;\n      border-bottom: 1px solid #eee;\n\n      &.goal-name-and-due {\n        a {\n          font-size: 16px;\n          font-weight: @regular;\n        }\n        .due {\n          font-size: 11px;\n          line-height: 18px;\n          color: @brand-subtle;\n        }\n      }\n\n      &.goal-progress {\n        text-align: right;\n        font-size: 20px;\n        color: @brand-primary;\n        font-weight: @bold;\n      }\n\n      &.metrics {\n        text-align: right;\n      }\n    }\n  }\n}\n","@media print {\n  html,\n  body {\n    width: 210mm;\n    height: 297mm;\n  }\n\n  body {\n    #main {\n      padding: 0;\n    }\n\n    .master-container {\n      padding: 0;\n    }\n\n    .navigation {\n      display: none !important;\n    }\n    #goals-nested {\n      top: 0;\n      padding: 0;\n      margin-top: 0;\n      overflow: visible;\n\n      .root-level {\n        width: 98%;\n      }\n\n      .goal {\n        border: 1px solid #ddd;\n        padding: 10px 10px 10px 55px;\n        min-height: 80px;\n\n        .goal-attainment {\n          font-weight: @bold;\n        }\n\n        .goal-name {\n          font-weight: @bold;\n        }\n\n        .goal-avatar {\n          width: 30px;\n          height: 30px;\n          top: 15px;\n          left: 10px;\n        }\n\n        .dropdown {\n          display: none;\n        }\n\n        .toggle-goal {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n#goals-nested {\n  position: fixed;\n  top: 65px;\n  bottom: 0;\n  left: var(--left-nav-width);\n  right: 0;\n  padding-top: 60px;\n  overflow: scroll;\n  padding-bottom: 100px;\n  .transition(0.3s);\n\n  .root-level {\n    padding-left: 0;\n    max-width: 900px;\n    margin: 0 auto;\n    position: relative;\n\n    .tree-level {\n      padding-left: 30px;\n    }\n\n    .top > goal-list-node > #goal-node > .goal {\n      display: none;\n    }\n  }\n\n  .goal {\n    border-radius: 7px;\n    box-shadow: 0 2px 5px fade(@brand-dark, 15%);\n    background: @brand-white;\n    margin-bottom: 5px;\n\n    &.obfuscated {\n      background-image: repeating-linear-gradient(\n        45deg,\n        lighten(@brand-light, 2%),\n        lighten(@brand-light, 2%) 10px,\n        @brand-white 10px,\n        @brand-white 20px\n      );\n    }\n\n    &.grayout {\n      opacity: 0.4;\n    }\n\n    &.matched {\n      border-style: solid;\n      border-color: #ffc25f;\n    }\n\n    &:hover {\n      box-shadow: 0 2px 5px fade(@brand-dark, 25%);\n    }\n\n    .goal-content {\n      padding: 12px 22px 12px 15px;\n    }\n\n    .goal-metrics {\n      &:hover {\n        color: @brand-dark;\n        cursor: pointer;\n      }\n    }\n\n    .goal-tags {\n      display: inline-flex;\n      .tag {\n        background: @grey-5;\n        color: @ink-80-v2;\n        padding: 2px 10px 4px;\n        border-radius: 20px;\n        margin-right: 2px;\n        font-size: 13px;\n        line-height: 18px;\n        font-weight: @regular;\n      }\n\n      .tag-badge {\n        background: @grey-40;\n        color: @brand-white;\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        text-align: center;\n        font-size: 11px;\n        line-height: 20px;\n        font-weight: @bold;\n        align-self: center;\n      }\n    }\n\n    .metrics {\n      margin: 0px 22px 0px 45px;\n      .metric {\n        padding: 11px 0px;\n        border-top: 1px solid @grey-10;\n        .metric-icon {\n          margin-right: 6px;\n        }\n\n        .metric-attainment {\n          text-align: right;\n          width: 65px;\n        }\n\n        .metric-name {\n          font-size: 13px;\n          color: @ink-100-v2;\n\n          &:hover {\n            color: @blue-100-v2;\n            text-decoration: underline;\n          }\n        }\n\n        .metric-attainment {\n          font-size: 12px;\n          line-height: 16px;\n        }\n      }\n    }\n\n    .dropdown {\n      .dropdown-toggle {\n        color: @grey-30;\n        margin-left: 10px;\n\n        &:hover {\n          color: @brand-dark;\n        }\n      }\n\n      .dropdown-menu {\n        margin-left: -130px;\n\n        ul {\n          li {\n            width: 100%;\n            display: block;\n            margin: 2px 0px;\n            padding: 0px 10px 0px 23px;\n            cursor: pointer;\n            font-size: 13px;\n            line-height: 2.5em;\n\n            &:hover,\n            :active {\n              background: @brand-lighter-blue;\n              color: @brand-dark;\n            }\n\n            &.warn {\n              color: @brand-danger !important;\n            }\n          }\n        }\n      }\n    }\n\n    .goal-name {\n      color: @ink-100-v2;\n      font-size: 15px;\n      line-height: 16px;\n      display: block;\n\n      &:hover {\n        color: @blue-100-v2;\n        text-decoration: underline;\n      }\n\n      .gh-badge {\n        padding: 2px 5px;\n        line-height: 15px;\n        font-size: 12px;\n        position: relative;\n        top: -4px;\n        margin-right: 8px;\n      }\n    }\n\n    .toggle-goal {\n      position: absolute;\n      left: -35px;\n      top: 18px;\n\n      .icon-expand-goal,\n      .icon-collapse-goal {\n        width: 24px;\n        height: 24px;\n        text-align: center;\n        color: @brand-white;\n        border-radius: 100%;\n        font-size: 16px;\n      }\n\n      .icon-collapse-goal {\n        background: @grey-20;\n      }\n\n      .icon-expand-goal {\n        background: @blue-40-v2;\n      }\n\n      .count {\n        position: absolute;\n        top: 13px;\n        right: -7px;\n        text-align: center;\n        line-height: 14px;\n        background: @blue-100-v2;\n        color: @brand-white;\n        font-size: 11px;\n        padding: 1px 4px;\n        min-width: 16px;\n        border-radius: 100%;\n      }\n\n      &:hover {\n        .icon {\n          background: fade(@brand-subtle, 25%);\n        }\n      }\n    }\n\n    avatars {\n      img {\n        vertical-align: unset;\n      }\n    }\n\n    .goal-icon {\n      margin-right: 10px;\n    }\n\n    .upload-icon {\n      margin: 0 8px;\n    }\n\n    .goal-avatar {\n      margin-right: 10px;\n      img {\n        max-width: 35px;\n        border-radius: 100%;\n      }\n    }\n\n    .attainment {\n      width: 65px;\n      height: 36px;\n      text-align: end;\n\n      .goal-attainment {\n        font-size: 16px;\n        line-height: 20px;\n\n        .color {\n          width: 25px;\n          height: 25px;\n          border-radius: 30px;\n        }\n      }\n\n      .goal-aggregated-progress {\n        color: fade(@brand-dark, 50%);\n        font-size: 12px;\n        line-height: 16px;\n\n        &.color {\n          width: 16px;\n          border-radius: 8px;\n          margin-right: 5px;\n          height: 16px;\n        }\n      }\n    }\n\n    .goal-assignee {\n      color: @brand-grey;\n      display: inline-block;\n      font-size: 12px;\n      line-height: 16px;\n      color: @ink-80-v2;\n    }\n\n    .metrics-count {\n      font-size: 12px;\n      line-height: 16px;\n      font-weight: @regular;\n      color: @ink-60-v2;\n    }\n  }\n}\n#nested-view-tree {\n  height: 100%;\n  width: 100%;\n  padding: 10px 20px;\n  max-width: 1400px;\n  margin: auto;\n\n  &.with-expand-icon {\n    padding-left: 80px;\n  }\n  ul {\n    margin-bottom: 0px;\n  }\n}\n.alignment-nested-indicator-container {\n  position: absolute;\n  top: 60px;\n  right: 100px;\n}\n","#tasks-switch-view {\n  position: relative;\n  width: 100%;\n  padding: 0 40px;\n\n  a {\n    color: @brand-subtler;\n    margin-left: 15px;\n\n    &:hover {\n      cursor: pointer;\n      color: @brand-jira;\n    }\n  }\n\n  [class^=\"gh-font-icon-\"],\n  [class*=\" gh-font-icon-\"] {\n    position: relative;\n    top: 0.5px;\n    margin-right: 4px;\n    opacity: 0.6;\n    font-size: 12px;\n  }\n}\n",".custom-fields-two-columns {\n  .gh-custom-fields {\n    .gh-custom-field {\n      width: 100%;\n      float: left;\n\n      .gh-custom-field-title {\n        width: 35%;\n        float: left;\n        padding-right: 20px;\n      }\n\n      .gh-custom-field-content {\n        word-break: break-word;\n        float: left;\n        width: 65%;\n        padding: 0;\n      }\n    }\n  }\n}\n\n.gh-custom-fields {\n  font-size: 16px;\n  width: 100%;\n  clear: both;\n\n  .gh-custom-field {\n    width: 100%;\n    padding: 10px 0 5px 0;\n    border-top: 1px solid @brand-light;\n\n    .gh-input-info {\n      .gh-b-input-info {\n        display: inline-block;\n        position: relative;\n        top: -2px;\n        right: 0;\n      }\n    }\n\n    &:last-child {\n      td {\n        border-bottom: 0;\n      }\n    }\n\n    .gh-custom-field-title {\n      h3 {\n        font-size: 0.9em;\n        font-weight: @medium;\n        line-height: 1.3em;\n      }\n\n      p {\n        font-size: 0.8em;\n        color: @brand-grey;\n        -webkit-font-smoothing: antialiased;\n\n        .help-tip {\n          width: 16px;\n          height: 16px;\n          background: @brand-light;\n          border-radius: 100%;\n          font-size: 0.9em;\n          line-height: 16px;\n          text-align: center;\n          color: @brand-subtle;\n          display: inline-block;\n          font-weight: @bold;\n          cursor: help;\n\n          &:hover {\n            background: darken(@brand-light, 10%);\n          }\n        }\n      }\n    }\n\n    .gh-custom-field-content {\n      padding: 10px 0 0 0;\n      width: 100%;\n\n      .not-entered {\n        font-size: 0.9em;\n        font-weight: 400;\n        color: #96a1a9;\n        position: relative;\n        display: inline-block;\n      }\n\n      .custom-field-assignee {\n        width: 20px;\n        height: 20px;\n        display: inline-block;\n        padding: 0;\n        margin: 0 6px 6px 0;\n        .picture {\n          width: 20px;\n          height: 20px;\n\n          img {\n            max-width: 100%;\n            border-radius: 3px;\n            margin-top: -2px;\n          }\n        }\n      }\n\n      .objective {\n        position: relative;\n        padding-left: 30px;\n        font-size: 0.9em;\n      }\n\n      .details-wrapper {\n        font-size: 0.9em;\n        font-weight: 400;\n        color: @brand-grey;\n        position: relative;\n        display: inline-block;\n        -webkit-font-smoothing: antialiased;\n\n        .form-group label {\n          font-weight: @medium;\n        }\n\n        p {\n          margin-bottom: 10px;\n          word-break: break-word;\n\n          &:last-child {\n            margin-bottom: 0;\n            padding-top: 10px;\n          }\n        }\n      }\n\n      .multiselect {\n        .item {\n          &:after {\n            content: \", \";\n          }\n\n          &:last-child:after {\n            content: \"\";\n          }\n        }\n      }\n\n      .field-checkbox {\n        display: inline-block;\n\n        .icon {\n          width: 16px;\n          display: inline-block;\n          height: 16px;\n          font-size: 16px;\n          text-align: center;\n          line-height: 16px;\n          color: @brand-primary;\n          border-radius: 100%;\n\n          & + .icon {\n            display: none;\n            color: @brand-subtler;\n          }\n        }\n\n        &.negative {\n          .icon {\n            display: none;\n\n            & + .icon {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n#custom-field {\n  .gh-font-icon-help {\n    position: absolute;\n    top: 10px;\n    right: 5px;\n    color: white;\n    font-size: 1.5em;\n  }\n}\n","#metrics-limit-reached {\n  text-align: center;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: @light;\n\n  .main-icon {\n    font-size: 100px;\n    color: fade(@brand-subtle, 15%);\n    margin-bottom: 20px;\n  }\n\n  .btn {\n    margin-top: 20px;\n  }\n}\n\n.create-metric {\n  .modal-dialog {\n    overflow-y: hidden;\n  }\n\n  .create-metric-form-container {\n    position: relative;\n    box-shadow: 0px 4px 10px rgba(68, 85, 115, 0.3);\n    z-index: 1;\n    width: 662px;\n    min-height: 320px;\n    background-color: #fff;\n\n    .close-btn-wrapper {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n\n      ui-button {\n        width: 32px;\n        color: @ink-70-v2;\n      }\n    }\n  }\n\n  .effectiveness-indicator-wrapper {\n    top: 15px;\n    right: 60px;\n  }\n}\n\n// unify with create session form\n#create-form {\n  .milestones-info {\n    position: relative;\n\n    .milestones-popover {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      transform: translate(0%, -50%);\n    }\n  }\n\n  .button-wrapper {\n    display: flex;\n    gap: @margin-sm;\n  }\n\n  .form-actions {\n    margin-top: 17px;\n\n    button {\n      &:focus {\n        box-shadow: 0px 0px 0px 1px @brand-white, 0px 0px 0px 2px @blue-80-v3;\n      }\n\n      &.gh-accent {\n        &:focus {\n          border: none;\n        }\n      }\n\n      &.secondary {\n        border-color: @blue-80-v3;\n      }\n    }\n\n    ui-button {\n      margin-right: 10px;\n    }\n  }\n\n  #parent-selector-content {\n    flex-direction: column;\n\n    .parent-selector-container {\n      width: inherit;\n      max-height: 40px;\n    }\n\n    #alignment-attention-info {\n      margin-top: 8px;\n      padding: 5px 4px 5px 4px;\n      background: #d3eaff;\n      border-radius: 4px;\n\n      .gh-font-icon-info {\n        color: #0057d7 !important;\n        font-size: 18px;\n        align-items: center;\n        margin-left: 6px !important;\n        margin-right: 4px;\n      }\n    }\n  }\n\n  .critical-slider {\n    &:not(.gh-no-padding) {\n      padding-right: 27px;\n    }\n\n    &:not(.gh-no-margin) {\n      margin-bottom: 18px;\n    }\n\n    &.disabled {\n      margin-bottom: 0px;\n\n      .slider-label {\n        color: @ink-50-v2;\n      }\n    }\n  }\n\n  .session-selector-container {\n    width: inherit;\n\n    .ant-select-selector {\n      border: 1px solid @grey-60-v2;\n      box-shadow: 0px 1px 1px rgba(90, 128, 158, 0.1);\n    }\n  }\n\n  .back {\n    margin-left: 20px;\n  }\n\n  .row {\n    &.gh-mb-0 {\n      margin-bottom: 0px !important;\n    }\n  }\n\n  .percentage {\n    color: @gray-light;\n    margin-top: 3px;\n    font-size: 12px;\n    font-family: Arial, sans-serif;\n\n    &.negative {\n      color: @brand-danger;\n\n      &:before {\n        content: \"\";\n      }\n    }\n  }\n\n  .gh-f-title-medium {\n    .fw-700;\n    font-size: 30px;\n    line-height: 30px;\n    letter-spacing: 0.005em;\n    color: @ink-100-v2;\n    margin-bottom: 26px;\n  }\n\n  .gh-input-info {\n    .d-flex;\n    .justify-cont-sb;\n    .align-items-c;\n    padding: 0 !important;\n\n    > :first-child {\n      flex: 1;\n      min-width: 0;\n    }\n\n    > .dropdown {\n      min-height: 40px;\n    }\n\n    .unit-format-container {\n      overflow: auto;\n    }\n\n    .gh-select-v2 .dropdown-menu ul li p {\n      opacity: 0.75;\n    }\n\n    people-selector {\n      .ant-select {\n        min-height: 40px;\n      }\n    }\n\n    .helper-text {\n      font-family: \"SF Pro Text\", sans-serif;\n      color: @ink-70-v2;\n      font-size: @font-size-sm;\n      padding-top: 4px;\n    }\n  }\n\n  .ant-select-selection-placeholder,\n  .gh-input-text::placeholder,\n  .mentioned-placeholder {\n    font-size: 14px;\n    color: @ink-40-v3;\n    font-style: unset;\n  }\n\n  .gh-input-text {\n    padding: 10px;\n\n    &::placeholder {\n      color: @ink-40-v3;\n    }\n  }\n\n  .gh-font-icon-help {\n    color: @grey-80-v2;\n    margin-left: 10px;\n\n    &.metric-deadline-help {\n      align-self: flex-start;\n      margin-top: 12px;\n    }\n  }\n\n  .gh-font-icon-info,\n  icon-with-popover {\n    color: @grey-80-v2;\n    font-size: 17px;\n    margin-left: 9px;\n    margin-right: -2px;\n  }\n\n  .info-text {\n    flex: 1;\n    align-items: center;\n\n    p {\n      font-family: \"SF Pro Text\", sans-serif;\n      font-size: 12px;\n      color: @ink-80-v2;\n      margin-bottom: 0;\n    }\n  }\n\n  .gh-input-text,\n  .gh-input-text-v2,\n  .gh-select,\n  .gh-dynamic-group {\n    height: 36px;\n  }\n\n  .alignment {\n    min-height: 36px;\n  }\n\n  .gh-select {\n    padding: 0px 15px;\n    border-radius: 4px;\n    .hov-cursor-p;\n\n    &.disabled {\n      background: @brand-light;\n      .hov-cursor-i;\n\n      .gh-font-icon-arrow-down-small {\n        display: none;\n      }\n    }\n  }\n\n  .gh-input-text,\n  .gh-select,\n  .selected-insight,\n  user-selector .tags {\n    font-size: 15px;\n  }\n\n  user-selector .tags {\n    padding-left: 7px;\n\n    .input {\n      margin: 0;\n      padding-left: 0;\n      font-size: inherit;\n\n      &::placeholder {\n        color: @ink-20-v3;\n        opacity: 1;\n        /* Firefox */\n      }\n    }\n  }\n\n  .required-fields {\n    .fw-400;\n    font-size: 14px;\n    line-height: 160%;\n    color: @ink-70-v2;\n  }\n\n  .format-subtitles {\n    .fw-400;\n    font-size: 14px;\n    color: @ink-100-v2;\n  }\n\n  .gh-f-large {\n    .gh-fg {\n      border-bottom: 0;\n      padding: 0;\n\n      .row {\n        margin-bottom: 17px;\n\n        .section-name {\n          .format-subtitles;\n          line-height: 36px;\n        }\n      }\n\n      .gh-checkbox + label {\n        color: @ink-100-v2;\n        font-size: 15px;\n        .fw-400;\n      }\n    }\n  }\n\n  .gh-siv-row {\n    .gh-siv-row-name {\n      .format-subtitles;\n      padding-right: 10px;\n\n      &:before {\n        content: \"\";\n      }\n    }\n  }\n\n  .section-name,\n  .metric-title,\n  .gh-siv-row-name {\n    &.required {\n      &:after {\n        content: \"*\";\n        position: absolute;\n      }\n    }\n  }\n\n  .gh-fe {\n    margin: 0;\n  }\n\n  .parent-goal {\n    .align {\n      span {\n        color: @blue-80-v2;\n\n        &:hover {\n          border-bottom: none;\n          color: @blue-100-v2;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .mask {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.5);\n    z-index: 4;\n\n    &.limit {\n      text-align: center;\n      color: @brand-white;\n      font-size: 16px;\n      line-height: 30px;\n      padding: 100px 60px 0 60px;\n      font-weight: @light;\n      background: fade(@brand-dark, 80%);\n    }\n  }\n\n  .current-session-wrapper {\n    position: relative;\n    padding: 1px;\n\n    .dropdown-close-trigger {\n      z-index: 1;\n      position: absolute;\n      left: 0;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n    }\n\n    .current-session {\n      display: flex;\n      padding: 2px;\n      flex-direction: row;\n      justify-content: flex-start;\n      justify-items: center;\n      margin: 1px;\n      padding-right: 10px;\n      padding-left: 10px;\n      line-height: 24px;\n      font-size: 14px;\n      color: @ink-100;\n\n      .gh-icon-wrapper {\n        margin-right: 5px;\n        vertical-align: middle;\n      }\n\n      .current-session-color {\n        display: inline-block;\n        margin-right: 4px;\n        width: 10px;\n        height: 10px;\n        border-radius: 5px;\n        vertical-align: middle;\n      }\n\n      .current-session-title {\n        display: inline-block;\n        vertical-align: middle;\n        overflow: hidden;\n        max-width: 350px;\n      }\n    }\n\n    input {\n      padding: 0px 10px;\n      width: 100%;\n      height: 100%;\n      border: none;\n    }\n  }\n\n  .dropdown-menu-with-tooltip {\n    width: calc(100% - 24px);\n  }\n\n  .dropdown-menu-sessions {\n    li {\n      padding: 10px;\n\n      &:hover {\n        background-color: @blue-10-v3;\n        cursor: pointer;\n      }\n    }\n\n    li.active {\n      position: relative;\n      background-color: @blue-80-v2;\n\n      .session-title {\n        color: #fff;\n      }\n    }\n  }\n\n  user-selector {\n    &.invalid {\n      .tags {\n        border: 1px solid @red-80-v2;\n      }\n    }\n  }\n\n  .critical-value-error {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 25px;\n  }\n\n  div.insight-selector {\n    padding-right: 25px;\n  }\n\n  .automation-section,\n  .description-section {\n    margin-top: 17px;\n  }\n\n  .col-md-9 {\n    &.no-tooltip {\n      width: calc(75% - 26px);\n    }\n  }\n}\n\n// remove once we release the cadence\n#session-form,\n.goal-form {\n  max-width: 660px;\n  margin: 0 auto;\n\n  input,\n  textarea {\n    &::placeholder {\n      letter-spacing: 0.02em;\n      color: @brand-grey;\n    }\n  }\n\n  h2 {\n    font-size: 30px;\n    font-weight: @light;\n    margin-bottom: 5px;\n  }\n\n  h2 + p {\n    font-size: 14px;\n    color: fade(#000, 50%);\n  }\n\n  .form-row {\n    padding: 15px 0;\n    border-bottom: 1px solid @brand-border;\n\n    .input-lg {\n      box-shadow: none;\n      font-size: 14px;\n      padding: 15px 15px;\n    }\n\n    .info {\n      font-size: 12px;\n      line-height: 20px;\n      color: #999;\n      font-family: Arial, sans-serif;\n      margin-top: 20px;\n    }\n  }\n\n  .reminder {\n    margin-top: 15px;\n\n    .calendar-holder {\n      float: left;\n      margin-right: 40px;\n\n      h5 {\n        margin-top: 20px;\n        font-size: 14px;\n        font-weight: @regular;\n        margin-bottom: 15px;\n        text-align: center;\n      }\n    }\n\n    .asignee {\n      position: relative;\n      padding-left: 45px;\n      margin-top: 15px;\n      height: 60px;\n\n      img {\n        width: 30px;\n        height: 30px;\n        border-radius: 15px;\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n\n      h4 {\n        font-weight: @light;\n        font-size: 16px;\n      }\n\n      h5 {\n        font-size: 12px;\n        font-weight: @regular;\n        color: fade(#000, 50%);\n        margin-top: 5px;\n      }\n    }\n  }\n\n  .gh-f-large {\n    .gh-f-title-medium {\n      margin-bottom: 15px;\n    }\n\n    .gh-f-description {\n      p {\n        margin: 0 0 5px 0;\n\n        &:first-child {\n          margin-top: 0px;\n        }\n\n        &:last-child {\n          margin-bottom: 0px;\n        }\n\n        a {\n          color: @brand-link;\n\n          &:hover {\n            text-decoration: none;\n            color: @brand-info;\n          }\n        }\n      }\n    }\n\n    .gh-fg {\n      padding: 20px 0px 0px 0px;\n      border: 0;\n\n      .row {\n        margin-bottom: 20px;\n\n        .tooltip {\n          width: 200px;\n          white-space: normal;\n        }\n\n        .gh-input-text {\n          min-width: 150px;\n        }\n\n        .section-name {\n          font-size: 1.2em;\n          top: 10px;\n        }\n\n        .section-name,\n        .metric-title {\n          &.required {\n            &:before {\n              position: absolute;\n              left: -20px;\n              top: -4px;\n              font-size: 25px;\n              content: \"*\";\n              color: @brand-jira;\n            }\n          }\n        }\n\n        .critical-slider {\n          padding-right: 40px;\n        }\n\n        .metric-deadline,\n        .metric-type,\n        .metric-format {\n          .gh-select {\n            .gh-select-toggle {\n              min-height: 40px;\n\n              &::before {\n                top: 15px;\n                color: lighten(@brand-grey, 15%);\n              }\n            }\n          }\n        }\n\n        .metric-format {\n          .gh-select {\n            .dropdown-menu {\n              ul {\n                li {\n                  &:last-child {\n                    border-top: 1px solid @brand-border;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .metric-title {\n        .gh-input-text {\n          &::placeholder {\n            font-size: 1em;\n          }\n        }\n      }\n\n      .gh-fe {\n        text-align: right;\n      }\n    }\n\n    .dropdown-menu {\n      ul {\n        li {\n          padding: 10px 15px;\n          border: none;\n          line-height: 1.4em;\n\n          &.deadline-option {\n            border-bottom: 1px solid @brand-border;\n\n            &:last-child {\n              border: none;\n            }\n\n            .option-title {\n              padding-bottom: 5px;\n              font-size: 1.1em;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .gh-selected-artefact {\n    font-size: 16px;\n  }\n\n  .warning-msg-cascaded-kr {\n    color: @brand-fog;\n    font-size: 0.95em;\n    margin-left: 2px;\n    margin-top: 4px;\n  }\n}\n\n.format-metric-container {\n  .title {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 34px;\n    letter-spacing: 0.005em;\n    color: @ink-90-v2;\n    margin-bottom: 30px;\n  }\n\n  .preview-format {\n    word-break: break-all;\n  }\n\n  .preview-container {\n    padding-bottom: 40px;\n    text-align: center;\n\n    .description {\n      padding-bottom: 15px;\n      font-size: 1em;\n      color: @ink-70-v2;\n    }\n  }\n\n  .insert-format-container {\n    .insert-text-unit {\n      padding-bottom: 20px;\n\n      input {\n        &::placeholder {\n          letter-spacing: 0.02em;\n          color: @brand-grey;\n        }\n      }\n    }\n\n    .gh-select {\n      .gh-select-toggle {\n        height: 40px;\n        font-size: 1.1em;\n\n        .current-selection {\n          line-height: 23px;\n        }\n\n        &::before {\n          top: 15px;\n          color: @brand-dark;\n        }\n      }\n\n      .dropdown-menu {\n        width: 100%;\n\n        ul {\n          li {\n            padding: 12px 20px;\n            border: none;\n            line-height: 1.4em;\n          }\n        }\n      }\n    }\n\n    .gh-fa {\n      position: relative;\n      display: flex;\n      justify-content: flex-start;\n    }\n  }\n\n  .gh-radio-list-border .item {\n    padding: 9px 35px 9px 20px;\n\n    &.checked {\n      .title {\n        font-weight: normal;\n        margin-bottom: 10px;\n      }\n    }\n\n    .title {\n      font-weight: normal;\n      margin-bottom: 10px;\n    }\n\n    .radio {\n      top: 10px;\n      left: 2px;\n    }\n  }\n}\n\n@media screen and (max-width: 980px) {\n  #create-form .gh-f-large .gh-fg .row .section-name,\n  .goal-form .gh-f-large .gh-fg .row .section-name {\n    top: -5px;\n  }\n\n  .modal.large .modal-dialog {\n    max-width: 95%;\n  }\n}\n\n.form-help-popover {\n  z-index: 1500;\n}\n\n#update-metric {\n  .ui-toggle-wrapper {\n    margin-top: 10px;\n\n    .slider-label {\n      font-size: 14px;\n      color: @ink-70-v2;\n    }\n\n    &.true {\n      .toggle-label-right {\n        color: @ink-100-v2;\n        font-weight: bold;\n      }\n    }\n\n    &.false {\n      .toggle-label-left {\n        color: @ink-100-v2;\n        font-weight: bold;\n      }\n    }\n  }\n}\n",".send-for-approval {\n  margin: 10px 20px;\n\n  .gh-two-column {\n    .gh-content-col {\n      &.multiple-users {\n        .users-list {\n          &.invalid {\n            .gh-fe {\n              margin-top: 40px;\n            }\n\n            .users-wrapper {\n              margin-top: 20px;\n              border: 2px solid @brand-danger;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .users-wrapper {\n    position: relative;\n    cursor: pointer;\n\n    &:hover {\n      background: @brand-border;\n    }\n\n    .users-selector-wrapper {\n      z-index: 1;\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      opacity: 0;\n\n      .select-users {\n        height: 100%;\n      }\n    }\n  }\n}\n","/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.tinyColorMixin() {\n@functions: ~`(function() {\n// TinyColor v1.4.1\n// https://github.com/bgrins/TinyColor\n// 2016-07-07, Brian Grinstead, MIT License\nvar trimLeft = /^\\s+/,\n    trimRight = /\\s+$/,\n    tinyCounter = 0,\n    mathRound = Math.round,\n    mathMin = Math.min,\n    mathMax = Math.max,\n    mathRandom = Math.random;\n\nfunction tinycolor (color, opts) {\n\n    color = (color) ? color : '';\n    opts = opts || { };\n\n    // If input is already a tinycolor, return itself\n    if (color instanceof tinycolor) {\n       return color;\n    }\n    // If we are called as a function, call using new instead\n    if (!(this instanceof tinycolor)) {\n        return new tinycolor(color, opts);\n    }\n\n    var rgb = inputToRGB(color);\n    this._originalInput = color,\n    this._r = rgb.r,\n    this._g = rgb.g,\n    this._b = rgb.b,\n    this._a = rgb.a,\n    this._roundA = mathRound(100*this._a) / 100,\n    this._format = opts.format || rgb.format;\n    this._gradientType = opts.gradientType;\n\n    // Don't let the range of [0,255] come back in [0,1].\n    // Potentially lose a little bit of precision here, but will fix issues where\n    // .5 gets interpreted as half of the total, instead of half of 1\n    // If it was supposed to be 128, this was already taken care of by inputToRgb\n    if (this._r < 1) { this._r = mathRound(this._r); }\n    if (this._g < 1) { this._g = mathRound(this._g); }\n    if (this._b < 1) { this._b = mathRound(this._b); }\n\n    this._ok = rgb.ok;\n    this._tc_id = tinyCounter++;\n}\n\ntinycolor.prototype = {\n    isDark: function() {\n        return this.getBrightness() < 128;\n    },\n    isLight: function() {\n        return !this.isDark();\n    },\n    isValid: function() {\n        return this._ok;\n    },\n    getOriginalInput: function() {\n      return this._originalInput;\n    },\n    getFormat: function() {\n        return this._format;\n    },\n    getAlpha: function() {\n        return this._a;\n    },\n    getBrightness: function() {\n        //http://www.w3.org/TR/AERT#color-contrast\n        var rgb = this.toRgb();\n        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;\n    },\n    getLuminance: function() {\n        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef\n        var rgb = this.toRgb();\n        var RsRGB, GsRGB, BsRGB, R, G, B;\n        RsRGB = rgb.r/255;\n        GsRGB = rgb.g/255;\n        BsRGB = rgb.b/255;\n\n        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}\n        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}\n        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}\n        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);\n    },\n    setAlpha: function(value) {\n        this._a = boundAlpha(value);\n        this._roundA = mathRound(100*this._a) / 100;\n        return this;\n    },\n    toHsv: function() {\n        var hsv = rgbToHsv(this._r, this._g, this._b);\n        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };\n    },\n    toHsvString: function() {\n        var hsv = rgbToHsv(this._r, this._g, this._b);\n        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);\n        return (this._a == 1) ?\n          \"hsv(\"  + h + \", \" + s + \"%, \" + v + \"%)\" :\n          \"hsva(\" + h + \", \" + s + \"%, \" + v + \"%, \"+ this._roundA + \")\";\n    },\n    toHsl: function() {\n        var hsl = rgbToHsl(this._r, this._g, this._b);\n        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };\n    },\n    toHslString: function() {\n        var hsl = rgbToHsl(this._r, this._g, this._b);\n        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);\n        return (this._a == 1) ?\n          \"hsl(\"  + h + \", \" + s + \"%, \" + l + \"%)\" :\n          \"hsla(\" + h + \", \" + s + \"%, \" + l + \"%, \"+ this._roundA + \")\";\n    },\n    toHex: function(allow3Char) {\n        return rgbToHex(this._r, this._g, this._b, allow3Char);\n    },\n    toHexString: function(allow3Char) {\n        return '#' + this.toHex(allow3Char);\n    },\n    toHex8: function(allow4Char) {\n        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);\n    },\n    toHex8String: function(allow4Char) {\n        return '#' + this.toHex8(allow4Char);\n    },\n    toRgb: function() {\n        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };\n    },\n    toRgbString: function() {\n        return (this._a == 1) ?\n          \"rgb(\"  + mathRound(this._r) + \", \" + mathRound(this._g) + \", \" + mathRound(this._b) + \")\" :\n          \"rgba(\" + mathRound(this._r) + \", \" + mathRound(this._g) + \", \" + mathRound(this._b) + \", \" + this._roundA + \")\";\n    },\n    toPercentageRgb: function() {\n        return { r: mathRound(bound01(this._r, 255) * 100) + \"%\", g: mathRound(bound01(this._g, 255) * 100) + \"%\", b: mathRound(bound01(this._b, 255) * 100) + \"%\", a: this._a };\n    },\n    toPercentageRgbString: function() {\n        return (this._a == 1) ?\n          \"rgb(\"  + mathRound(bound01(this._r, 255) * 100) + \"%, \" + mathRound(bound01(this._g, 255) * 100) + \"%, \" + mathRound(bound01(this._b, 255) * 100) + \"%)\" :\n          \"rgba(\" + mathRound(bound01(this._r, 255) * 100) + \"%, \" + mathRound(bound01(this._g, 255) * 100) + \"%, \" + mathRound(bound01(this._b, 255) * 100) + \"%, \" + this._roundA + \")\";\n    },\n    toName: function() {\n        if (this._a === 0) {\n            return \"transparent\";\n        }\n\n        if (this._a < 1) {\n            return false;\n        }\n\n        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;\n    },\n    toFilter: function(secondColor) {\n        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);\n        var secondHex8String = hex8String;\n        var gradientType = this._gradientType ? \"GradientType = 1, \" : \"\";\n\n        if (secondColor) {\n            var s = tinycolor(secondColor);\n            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);\n        }\n\n        return \"progid:DXImageTransform.Microsoft.gradient(\"+gradientType+\"startColorstr=\"+hex8String+\",endColorstr=\"+secondHex8String+\")\";\n    },\n    toString: function(format) {\n        var formatSet = !!format;\n        format = format || this._format;\n\n        var formattedString = false;\n        var hasAlpha = this._a < 1 && this._a >= 0;\n        var needsAlphaFormat = !formatSet && hasAlpha && (format === \"hex\" || format === \"hex6\" || format === \"hex3\" || format === \"hex4\" || format === \"hex8\" || format === \"name\");\n\n        if (needsAlphaFormat) {\n            // Special case for \"transparent\", all other non-alpha formats\n            // will return rgba when there is transparency.\n            if (format === \"name\" && this._a === 0) {\n                return this.toName();\n            }\n            return this.toRgbString();\n        }\n        if (format === \"rgb\") {\n            formattedString = this.toRgbString();\n        }\n        if (format === \"prgb\") {\n            formattedString = this.toPercentageRgbString();\n        }\n        if (format === \"hex\" || format === \"hex6\") {\n            formattedString = this.toHexString();\n        }\n        if (format === \"hex3\") {\n            formattedString = this.toHexString(true);\n        }\n        if (format === \"hex4\") {\n            formattedString = this.toHex8String(true);\n        }\n        if (format === \"hex8\") {\n            formattedString = this.toHex8String();\n        }\n        if (format === \"name\") {\n            formattedString = this.toName();\n        }\n        if (format === \"hsl\") {\n            formattedString = this.toHslString();\n        }\n        if (format === \"hsv\") {\n            formattedString = this.toHsvString();\n        }\n\n        return formattedString || this.toHexString();\n    },\n    clone: function() {\n        return tinycolor(this.toString());\n    },\n\n    _applyModification: function(fn, args) {\n        var color = fn.apply(null, [this].concat([].slice.call(args)));\n        this._r = color._r;\n        this._g = color._g;\n        this._b = color._b;\n        this.setAlpha(color._a);\n        return this;\n    },\n    lighten: function() {\n        return this._applyModification(lighten, arguments);\n    },\n    brighten: function() {\n        return this._applyModification(brighten, arguments);\n    },\n    darken: function() {\n        return this._applyModification(darken, arguments);\n    },\n    desaturate: function() {\n        return this._applyModification(desaturate, arguments);\n    },\n    saturate: function() {\n        return this._applyModification(saturate, arguments);\n    },\n    greyscale: function() {\n        return this._applyModification(greyscale, arguments);\n    },\n    spin: function() {\n        return this._applyModification(spin, arguments);\n    },\n\n    _applyCombination: function(fn, args) {\n        return fn.apply(null, [this].concat([].slice.call(args)));\n    },\n    analogous: function() {\n        return this._applyCombination(analogous, arguments);\n    },\n    complement: function() {\n        return this._applyCombination(complement, arguments);\n    },\n    monochromatic: function() {\n        return this._applyCombination(monochromatic, arguments);\n    },\n    splitcomplement: function() {\n        return this._applyCombination(splitcomplement, arguments);\n    },\n    triad: function() {\n        return this._applyCombination(triad, arguments);\n    },\n    tetrad: function() {\n        return this._applyCombination(tetrad, arguments);\n    }\n};\n\n// If input is an object, force 1 into \"1.0\" to handle ratios properly\n// String input requires \"1.0\" as input, so 1 will be treated as 1\ntinycolor.fromRatio = function(color, opts) {\n    if (typeof color == \"object\") {\n        var newColor = {};\n        for (var i in color) {\n            if (color.hasOwnProperty(i)) {\n                if (i === \"a\") {\n                    newColor[i] = color[i];\n                }\n                else {\n                    newColor[i] = convertToPercentage(color[i]);\n                }\n            }\n        }\n        color = newColor;\n    }\n\n    return tinycolor(color, opts);\n};\n\n// Given a string or object, convert that input to RGB\n// Possible string inputs:\n//\n//     \"red\"\n//     \"#f00\" or \"f00\"\n//     \"#ff0000\" or \"ff0000\"\n//     \"#ff000000\" or \"ff000000\"\n//     \"rgb 255 0 0\" or \"rgb (255, 0, 0)\"\n//     \"rgb 1.0 0 0\" or \"rgb (1, 0, 0)\"\n//     \"rgba (255, 0, 0, 1)\" or \"rgba 255, 0, 0, 1\"\n//     \"rgba (1.0, 0, 0, 1)\" or \"rgba 1.0, 0, 0, 1\"\n//     \"hsl(0, 100%, 50%)\" or \"hsl 0 100% 50%\"\n//     \"hsla(0, 100%, 50%, 1)\" or \"hsla 0 100% 50%, 1\"\n//     \"hsv(0, 100%, 100%)\" or \"hsv 0 100% 100%\"\n//\nfunction inputToRGB(color) {\n\n    var rgb = { r: 0, g: 0, b: 0 };\n    var a = 1;\n    var s = null;\n    var v = null;\n    var l = null;\n    var ok = false;\n    var format = false;\n\n    if (typeof color == \"string\") {\n        color = stringInputToObject(color);\n    }\n\n    if (typeof color == \"object\") {\n        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {\n            rgb = rgbToRgb(color.r, color.g, color.b);\n            ok = true;\n            format = String(color.r).substr(-1) === \"%\" ? \"prgb\" : \"rgb\";\n        }\n        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {\n            s = convertToPercentage(color.s);\n            v = convertToPercentage(color.v);\n            rgb = hsvToRgb(color.h, s, v);\n            ok = true;\n            format = \"hsv\";\n        }\n        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {\n            s = convertToPercentage(color.s);\n            l = convertToPercentage(color.l);\n            rgb = hslToRgb(color.h, s, l);\n            ok = true;\n            format = \"hsl\";\n        }\n\n        if (color.hasOwnProperty(\"a\")) {\n            a = color.a;\n        }\n    }\n\n    a = boundAlpha(a);\n\n    return {\n        ok: ok,\n        format: color.format || format,\n        r: mathMin(255, mathMax(rgb.r, 0)),\n        g: mathMin(255, mathMax(rgb.g, 0)),\n        b: mathMin(255, mathMax(rgb.b, 0)),\n        a: a\n    };\n}\n\n// Conversion Functions\n// --------------------\n\n// rgbToHsl, rgbToHsv, hslToRgb, hsvToRgb modified from:\n// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>\n\n// rgbToRgb\n// Handle bounds / percentage checking to conform to CSS color spec\n// <http://www.w3.org/TR/css3-color/>\n// *Assumes:* r, g, b in [0, 255] or [0, 1]\n// *Returns:* { r, g, b } in [0, 255]\nfunction rgbToRgb(r, g, b){\n    return {\n        r: bound01(r, 255) * 255,\n        g: bound01(g, 255) * 255,\n        b: bound01(b, 255) * 255\n    };\n}\n\n// rgbToHsl\n// Converts an RGB color value to HSL.\n// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]\n// *Returns:* { h, s, l } in [0,1]\nfunction rgbToHsl(r, g, b) {\n\n    r = bound01(r, 255);\n    g = bound01(g, 255);\n    b = bound01(b, 255);\n\n    var max = mathMax(r, g, b), min = mathMin(r, g, b);\n    var h, s, l = (max + min) / 2;\n\n    if(max == min) {\n        h = s = 0; // achromatic\n    }\n    else {\n        var d = max - min;\n        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);\n        switch(max) {\n            case r: h = (g - b) / d + (g < b ? 6 : 0); break;\n            case g: h = (b - r) / d + 2; break;\n            case b: h = (r - g) / d + 4; break;\n        }\n\n        h /= 6;\n    }\n\n    return { h: h, s: s, l: l };\n}\n\n// hslToRgb\n// Converts an HSL color value to RGB.\n// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]\n// *Returns:* { r, g, b } in the set [0, 255]\nfunction hslToRgb(h, s, l) {\n    var r, g, b;\n\n    h = bound01(h, 360);\n    s = bound01(s, 100);\n    l = bound01(l, 100);\n\n    function hue2rgb(p, q, t) {\n        if(t < 0) t += 1;\n        if(t > 1) t -= 1;\n        if(t < 1/6) return p + (q - p) * 6 * t;\n        if(t < 1/2) return q;\n        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;\n        return p;\n    }\n\n    if(s === 0) {\n        r = g = b = l; // achromatic\n    }\n    else {\n        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;\n        var p = 2 * l - q;\n        r = hue2rgb(p, q, h + 1/3);\n        g = hue2rgb(p, q, h);\n        b = hue2rgb(p, q, h - 1/3);\n    }\n\n    return { r: r * 255, g: g * 255, b: b * 255 };\n}\n\n// rgbToHsv\n// Converts an RGB color value to HSV\n// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]\n// *Returns:* { h, s, v } in [0,1]\nfunction rgbToHsv(r, g, b) {\n\n    r = bound01(r, 255);\n    g = bound01(g, 255);\n    b = bound01(b, 255);\n\n    var max = mathMax(r, g, b), min = mathMin(r, g, b);\n    var h, s, v = max;\n\n    var d = max - min;\n    s = max === 0 ? 0 : d / max;\n\n    if(max == min) {\n        h = 0; // achromatic\n    }\n    else {\n        switch(max) {\n            case r: h = (g - b) / d + (g < b ? 6 : 0); break;\n            case g: h = (b - r) / d + 2; break;\n            case b: h = (r - g) / d + 4; break;\n        }\n        h /= 6;\n    }\n    return { h: h, s: s, v: v };\n}\n\n// hsvToRgb\n// Converts an HSV color value to RGB.\n// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]\n// *Returns:* { r, g, b } in the set [0, 255]\n function hsvToRgb(h, s, v) {\n\n    h = bound01(h, 360) * 6;\n    s = bound01(s, 100);\n    v = bound01(v, 100);\n\n    var i = Math.floor(h),\n        f = h - i,\n        p = v * (1 - s),\n        q = v * (1 - f * s),\n        t = v * (1 - (1 - f) * s),\n        mod = i % 6,\n        r = [v, q, p, p, t, v][mod],\n        g = [t, v, v, q, p, p][mod],\n        b = [p, p, t, v, v, q][mod];\n\n    return { r: r * 255, g: g * 255, b: b * 255 };\n}\n\n// rgbToHex\n// Converts an RGB color to hex\n// Assumes r, g, and b are contained in the set [0, 255]\n// Returns a 3 or 6 character hex\nfunction rgbToHex(r, g, b, allow3Char) {\n\n    var hex = [\n        pad2(mathRound(r).toString(16)),\n        pad2(mathRound(g).toString(16)),\n        pad2(mathRound(b).toString(16))\n    ];\n\n    // Return a 3 character hex if possible\n    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {\n        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);\n    }\n\n    return hex.join(\"\");\n}\n\n// rgbaToHex\n// Converts an RGBA color plus alpha transparency to hex\n// Assumes r, g, b are contained in the set [0, 255] and\n// a in [0, 1]. Returns a 4 or 8 character rgba hex\nfunction rgbaToHex(r, g, b, a, allow4Char) {\n\n    var hex = [\n        pad2(mathRound(r).toString(16)),\n        pad2(mathRound(g).toString(16)),\n        pad2(mathRound(b).toString(16)),\n        pad2(convertDecimalToHex(a))\n    ];\n\n    // Return a 4 character hex if possible\n    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {\n        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);\n    }\n\n    return hex.join(\"\");\n}\n\n// rgbaToArgbHex\n// Converts an RGBA color to an ARGB Hex8 string\n// Rarely used, but required for \"toFilter()\"\nfunction rgbaToArgbHex(r, g, b, a) {\n\n    var hex = [\n        pad2(convertDecimalToHex(a)),\n        pad2(mathRound(r).toString(16)),\n        pad2(mathRound(g).toString(16)),\n        pad2(mathRound(b).toString(16))\n    ];\n\n    return hex.join(\"\");\n}\n\n// equals\n// Can be called with any tinycolor input\ntinycolor.equals = function (color1, color2) {\n    if (!color1 || !color2) { return false; }\n    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();\n};\n\ntinycolor.random = function() {\n    return tinycolor.fromRatio({\n        r: mathRandom(),\n        g: mathRandom(),\n        b: mathRandom()\n    });\n};\n\n// Modification Functions\n// ----------------------\n// Thanks to less.js for some of the basics here\n// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>\n\nfunction desaturate(color, amount) {\n    amount = (amount === 0) ? 0 : (amount || 10);\n    var hsl = tinycolor(color).toHsl();\n    hsl.s -= amount / 100;\n    hsl.s = clamp01(hsl.s);\n    return tinycolor(hsl);\n}\n\nfunction saturate(color, amount) {\n    amount = (amount === 0) ? 0 : (amount || 10);\n    var hsl = tinycolor(color).toHsl();\n    hsl.s += amount / 100;\n    hsl.s = clamp01(hsl.s);\n    return tinycolor(hsl);\n}\n\nfunction greyscale(color) {\n    return tinycolor(color).desaturate(100);\n}\n\nfunction lighten (color, amount) {\n    amount = (amount === 0) ? 0 : (amount || 10);\n    var hsl = tinycolor(color).toHsl();\n    hsl.l += amount / 100;\n    hsl.l = clamp01(hsl.l);\n    return tinycolor(hsl);\n}\n\nfunction brighten(color, amount) {\n    amount = (amount === 0) ? 0 : (amount || 10);\n    var rgb = tinycolor(color).toRgb();\n    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));\n    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));\n    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));\n    return tinycolor(rgb);\n}\n\nfunction darken (color, amount) {\n    amount = (amount === 0) ? 0 : (amount || 10);\n    var hsl = tinycolor(color).toHsl();\n    hsl.l -= amount / 100;\n    hsl.l = clamp01(hsl.l);\n    return tinycolor(hsl);\n}\n\n// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.\n// Values outside of this range will be wrapped into this range.\nfunction spin(color, amount) {\n    var hsl = tinycolor(color).toHsl();\n    var hue = (hsl.h + amount) % 360;\n    hsl.h = hue < 0 ? 360 + hue : hue;\n    return tinycolor(hsl);\n}\n\n// Combination Functions\n// ---------------------\n// Thanks to jQuery xColor for some of the ideas behind these\n// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>\n\nfunction complement(color) {\n    var hsl = tinycolor(color).toHsl();\n    hsl.h = (hsl.h + 180) % 360;\n    return tinycolor(hsl);\n}\n\nfunction triad(color) {\n    var hsl = tinycolor(color).toHsl();\n    var h = hsl.h;\n    return [\n        tinycolor(color),\n        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),\n        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })\n    ];\n}\n\nfunction tetrad(color) {\n    var hsl = tinycolor(color).toHsl();\n    var h = hsl.h;\n    return [\n        tinycolor(color),\n        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),\n        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),\n        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })\n    ];\n}\n\nfunction splitcomplement(color) {\n    var hsl = tinycolor(color).toHsl();\n    var h = hsl.h;\n    return [\n        tinycolor(color),\n        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),\n        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})\n    ];\n}\n\nfunction analogous(color, results, slices) {\n    results = results || 6;\n    slices = slices || 30;\n\n    var hsl = tinycolor(color).toHsl();\n    var part = 360 / slices;\n    var ret = [tinycolor(color)];\n\n    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {\n        hsl.h = (hsl.h + part) % 360;\n        ret.push(tinycolor(hsl));\n    }\n    return ret;\n}\n\nfunction monochromatic(color, results) {\n    results = results || 6;\n    var hsv = tinycolor(color).toHsv();\n    var h = hsv.h, s = hsv.s, v = hsv.v;\n    var ret = [];\n    var modification = 1 / results;\n\n    while (results--) {\n        ret.push(tinycolor({ h: h, s: s, v: v}));\n        v = (v + modification) % 1;\n    }\n\n    return ret;\n}\n\n// Utility Functions\n// ---------------------\n\ntinycolor.mix = function(color1, color2, amount) {\n    amount = (amount === 0) ? 0 : (amount || 50);\n\n    var rgb1 = tinycolor(color1).toRgb();\n    var rgb2 = tinycolor(color2).toRgb();\n\n    var p = amount / 100;\n\n    var rgba = {\n        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,\n        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,\n        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,\n        a: ((rgb2.a - rgb1.a) * p) + rgb1.a\n    };\n\n    return tinycolor(rgba);\n};\n\n// Readability Functions\n// ---------------------\n// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)\n\n// contrast\n// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)\ntinycolor.readability = function(color1, color2) {\n    var c1 = tinycolor(color1);\n    var c2 = tinycolor(color2);\n    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);\n};\n\n// isReadable\n// Ensure that foreground and background color combinations meet WCAG2 guidelines.\n// The third argument is an optional Object.\n//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';\n//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.\n// If the entire object is absent, isReadable defaults to {level:\"AA\",size:\"small\"}.\n\n// *Example*\n//    tinycolor.isReadable(\"#000\", \"#111\") => false\n//    tinycolor.isReadable(\"#000\", \"#111\",{level:\"AA\",size:\"large\"}) => false\ntinycolor.isReadable = function(color1, color2, wcag2) {\n    var readability = tinycolor.readability(color1, color2);\n    var wcag2Parms, out;\n\n    out = false;\n\n    wcag2Parms = validateWCAG2Parms(wcag2);\n    switch (wcag2Parms.level + wcag2Parms.size) {\n        case \"AAsmall\":\n        case \"AAAlarge\":\n            out = readability >= 4.5;\n            break;\n        case \"AAlarge\":\n            out = readability >= 3;\n            break;\n        case \"AAAsmall\":\n            out = readability >= 7;\n            break;\n    }\n    return out;\n\n};\n\n// mostReadable\n// Given a base color and a list of possible foreground or background\n// colors for that base, returns the most readable color.\n// Optionally returns Black or White if the most readable color is unreadable.\n// *Example*\n//    tinycolor.mostReadable(tinycolor.mostReadable(\"#123\", [\"#124\", \"#125\"],{includeFallbackColors:false}).toHexString(); // \"#112255\"\n//    tinycolor.mostReadable(tinycolor.mostReadable(\"#123\", [\"#124\", \"#125\"],{includeFallbackColors:true}).toHexString();  // \"#ffffff\"\n//    tinycolor.mostReadable(\"#a8015a\", [\"#faf3f3\"],{includeFallbackColors:true,level:\"AAA\",size:\"large\"}).toHexString(); // \"#faf3f3\"\n//    tinycolor.mostReadable(\"#a8015a\", [\"#faf3f3\"],{includeFallbackColors:true,level:\"AAA\",size:\"small\"}).toHexString(); // \"#ffffff\"\ntinycolor.mostReadable = function(baseColor, colorList, args) {\n    var bestColor = null;\n    var bestScore = 0;\n    var readability;\n    var includeFallbackColors, level, size ;\n    args = args || {};\n    includeFallbackColors = args.includeFallbackColors ;\n    level = args.level;\n    size = args.size;\n\n    for (var i= 0; i < colorList.length ; i++) {\n        readability = tinycolor.readability(baseColor, colorList[i]);\n        if (readability > bestScore) {\n            bestScore = readability;\n            bestColor = tinycolor(colorList[i]);\n        }\n    }\n\n    if (tinycolor.isReadable(baseColor, bestColor, {\"level\":level,\"size\":size}) || !includeFallbackColors) {\n        return bestColor;\n    }\n    else {\n        args.includeFallbackColors=false;\n        return tinycolor.mostReadable(baseColor,[\"#fff\", \"#000\"],args);\n    }\n};\n\n// Big List of Colors\n// ------------------\n// <http://www.w3.org/TR/css3-color/#svg-color>\nvar names = tinycolor.names = {\n    aliceblue: \"f0f8ff\",\n    antiquewhite: \"faebd7\",\n    aqua: \"0ff\",\n    aquamarine: \"7fffd4\",\n    azure: \"f0ffff\",\n    beige: \"f5f5dc\",\n    bisque: \"ffe4c4\",\n    black: \"000\",\n    blanchedalmond: \"ffebcd\",\n    blue: \"00f\",\n    blueviolet: \"8a2be2\",\n    brown: \"a52a2a\",\n    burlywood: \"deb887\",\n    burntsienna: \"ea7e5d\",\n    cadetblue: \"5f9ea0\",\n    chartreuse: \"7fff00\",\n    chocolate: \"d2691e\",\n    coral: \"ff7f50\",\n    cornflowerblue: \"6495ed\",\n    cornsilk: \"fff8dc\",\n    crimson: \"dc143c\",\n    cyan: \"0ff\",\n    darkblue: \"00008b\",\n    darkcyan: \"008b8b\",\n    darkgoldenrod: \"b8860b\",\n    darkgray: \"a9a9a9\",\n    darkgreen: \"006400\",\n    darkgrey: \"a9a9a9\",\n    darkkhaki: \"bdb76b\",\n    darkmagenta: \"8b008b\",\n    darkolivegreen: \"556b2f\",\n    darkorange: \"ff8c00\",\n    darkorchid: \"9932cc\",\n    darkred: \"8b0000\",\n    darksalmon: \"e9967a\",\n    darkseagreen: \"8fbc8f\",\n    darkslateblue: \"483d8b\",\n    darkslategray: \"2f4f4f\",\n    darkslategrey: \"2f4f4f\",\n    darkturquoise: \"00ced1\",\n    darkviolet: \"9400d3\",\n    deeppink: \"ff1493\",\n    deepskyblue: \"00bfff\",\n    dimgray: \"696969\",\n    dimgrey: \"696969\",\n    dodgerblue: \"1e90ff\",\n    firebrick: \"b22222\",\n    floralwhite: \"fffaf0\",\n    forestgreen: \"228b22\",\n    fuchsia: \"f0f\",\n    gainsboro: \"dcdcdc\",\n    ghostwhite: \"f8f8ff\",\n    gold: \"ffd700\",\n    goldenrod: \"daa520\",\n    gray: \"808080\",\n    green: \"008000\",\n    greenyellow: \"adff2f\",\n    grey: \"808080\",\n    honeydew: \"f0fff0\",\n    hotpink: \"ff69b4\",\n    indianred: \"cd5c5c\",\n    indigo: \"4b0082\",\n    ivory: \"fffff0\",\n    khaki: \"f0e68c\",\n    lavender: \"e6e6fa\",\n    lavenderblush: \"fff0f5\",\n    lawngreen: \"7cfc00\",\n    lemonchiffon: \"fffacd\",\n    lightblue: \"add8e6\",\n    lightcoral: \"f08080\",\n    lightcyan: \"e0ffff\",\n    lightgoldenrodyellow: \"fafad2\",\n    lightgray: \"d3d3d3\",\n    lightgreen: \"90ee90\",\n    lightgrey: \"d3d3d3\",\n    lightpink: \"ffb6c1\",\n    lightsalmon: \"ffa07a\",\n    lightseagreen: \"20b2aa\",\n    lightskyblue: \"87cefa\",\n    lightslategray: \"789\",\n    lightslategrey: \"789\",\n    lightsteelblue: \"b0c4de\",\n    lightyellow: \"ffffe0\",\n    lime: \"0f0\",\n    limegreen: \"32cd32\",\n    linen: \"faf0e6\",\n    magenta: \"f0f\",\n    maroon: \"800000\",\n    mediumaquamarine: \"66cdaa\",\n    mediumblue: \"0000cd\",\n    mediumorchid: \"ba55d3\",\n    mediumpurple: \"9370db\",\n    mediumseagreen: \"3cb371\",\n    mediumslateblue: \"7b68ee\",\n    mediumspringgreen: \"00fa9a\",\n    mediumturquoise: \"48d1cc\",\n    mediumvioletred: \"c71585\",\n    midnightblue: \"191970\",\n    mintcream: \"f5fffa\",\n    mistyrose: \"ffe4e1\",\n    moccasin: \"ffe4b5\",\n    navajowhite: \"ffdead\",\n    navy: \"000080\",\n    oldlace: \"fdf5e6\",\n    olive: \"808000\",\n    olivedrab: \"6b8e23\",\n    orange: \"ffa500\",\n    orangered: \"ff4500\",\n    orchid: \"da70d6\",\n    palegoldenrod: \"eee8aa\",\n    palegreen: \"98fb98\",\n    paleturquoise: \"afeeee\",\n    palevioletred: \"db7093\",\n    papayawhip: \"ffefd5\",\n    peachpuff: \"ffdab9\",\n    peru: \"cd853f\",\n    pink: \"ffc0cb\",\n    plum: \"dda0dd\",\n    powderblue: \"b0e0e6\",\n    purple: \"800080\",\n    rebeccapurple: \"663399\",\n    red: \"f00\",\n    rosybrown: \"bc8f8f\",\n    royalblue: \"4169e1\",\n    saddlebrown: \"8b4513\",\n    salmon: \"fa8072\",\n    sandybrown: \"f4a460\",\n    seagreen: \"2e8b57\",\n    seashell: \"fff5ee\",\n    sienna: \"a0522d\",\n    silver: \"c0c0c0\",\n    skyblue: \"87ceeb\",\n    slateblue: \"6a5acd\",\n    slategray: \"708090\",\n    slategrey: \"708090\",\n    snow: \"fffafa\",\n    springgreen: \"00ff7f\",\n    steelblue: \"4682b4\",\n    tan: \"d2b48c\",\n    teal: \"008080\",\n    thistle: \"d8bfd8\",\n    tomato: \"ff6347\",\n    turquoise: \"40e0d0\",\n    violet: \"ee82ee\",\n    wheat: \"f5deb3\",\n    white: \"fff\",\n    whitesmoke: \"f5f5f5\",\n    yellow: \"ff0\",\n    yellowgreen: \"9acd32\"\n};\n\n// Make it easy to access colors via hexNames[hex]\nvar hexNames = tinycolor.hexNames = flip(names);\n\n// Utilities\n// ---------\n\n// { 'name1': 'val1' } becomes { 'val1': 'name1' }\nfunction flip(o) {\n    var flipped = { };\n    for (var i in o) {\n        if (o.hasOwnProperty(i)) {\n            flipped[o[i]] = i;\n        }\n    }\n    return flipped;\n}\n\n// Return a valid alpha value [0,1] with all invalid values being set to 1\nfunction boundAlpha(a) {\n    a = parseFloat(a);\n\n    if (isNaN(a) || a < 0 || a > 1) {\n        a = 1;\n    }\n\n    return a;\n}\n\n// Take input from [0, n] and return it as [0, 1]\nfunction bound01(n, max) {\n    if (isOnePointZero(n)) { n = \"100%\"; }\n\n    var processPercent = isPercentage(n);\n    n = mathMin(max, mathMax(0, parseFloat(n)));\n\n    // Automatically convert percentage into number\n    if (processPercent) {\n        n = parseInt(n * max, 10) / 100;\n    }\n\n    // Handle floating point rounding errors\n    if ((Math.abs(n - max) < 0.000001)) {\n        return 1;\n    }\n\n    // Convert into [0, 1] range if it isn't already\n    return (n % max) / parseFloat(max);\n}\n\n// Force a number between 0 and 1\nfunction clamp01(val) {\n    return mathMin(1, mathMax(0, val));\n}\n\n// Parse a base-16 hex value into a base-10 integer\nfunction parseIntFromHex(val) {\n    return parseInt(val, 16);\n}\n\n// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1\n// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>\nfunction isOnePointZero(n) {\n    return typeof n == \"string\" && n.indexOf('.') != -1 && parseFloat(n) === 1;\n}\n\n// Check to see if string passed in is a percentage\nfunction isPercentage(n) {\n    return typeof n === \"string\" && n.indexOf('%') != -1;\n}\n\n// Force a hex value to have 2 characters\nfunction pad2(c) {\n    return c.length == 1 ? '0' + c : '' + c;\n}\n\n// Replace a decimal with it's percentage value\nfunction convertToPercentage(n) {\n    if (n <= 1) {\n        n = (n * 100) + \"%\";\n    }\n\n    return n;\n}\n\n// Converts a decimal to a hex value\nfunction convertDecimalToHex(d) {\n    return Math.round(parseFloat(d) * 255).toString(16);\n}\n// Converts a hex value to a decimal\nfunction convertHexToDecimal(h) {\n    return (parseIntFromHex(h) / 255);\n}\n\nvar matchers = (function() {\n\n    // <http://www.w3.org/TR/css3-values/#integers>\n    var CSS_INTEGER = \"[-\\\\+]?\\\\d+%?\";\n\n    // <http://www.w3.org/TR/css3-values/#number-value>\n    var CSS_NUMBER = \"[-\\\\+]?\\\\d*\\\\.\\\\d+%?\";\n\n    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.\n    var CSS_UNIT = \"(?:\" + CSS_NUMBER + \")|(?:\" + CSS_INTEGER + \")\";\n\n    // Actual matching.\n    // Parentheses and commas are optional, but not required.\n    // Whitespace can take the place of commas or opening paren\n    var PERMISSIVE_MATCH3 = \"[\\\\s|\\\\(]+(\" + CSS_UNIT + \")[,|\\\\s]+(\" + CSS_UNIT + \")[,|\\\\s]+(\" + CSS_UNIT + \")\\\\s*\\\\)?\";\n    var PERMISSIVE_MATCH4 = \"[\\\\s|\\\\(]+(\" + CSS_UNIT + \")[,|\\\\s]+(\" + CSS_UNIT + \")[,|\\\\s]+(\" + CSS_UNIT + \")[,|\\\\s]+(\" + CSS_UNIT + \")\\\\s*\\\\)?\";\n\n    return {\n        CSS_UNIT: new RegExp(CSS_UNIT),\n        rgb: new RegExp(\"rgb\" + PERMISSIVE_MATCH3),\n        rgba: new RegExp(\"rgba\" + PERMISSIVE_MATCH4),\n        hsl: new RegExp(\"hsl\" + PERMISSIVE_MATCH3),\n        hsla: new RegExp(\"hsla\" + PERMISSIVE_MATCH4),\n        hsv: new RegExp(\"hsv\" + PERMISSIVE_MATCH3),\n        hsva: new RegExp(\"hsva\" + PERMISSIVE_MATCH4),\n        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,\n        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,\n        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,\n        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/\n    };\n})();\n\n// isValidCSSUnit\n// Take in a single string / number and check to see if it looks like a CSS unit\n// (see matchers above for definition).\nfunction isValidCSSUnit(color) {\n    return !!matchers.CSS_UNIT.exec(color);\n}\n\n// stringInputToObject\n// Permissive string parsing.  Take in a number of formats, and output an object\n// based on detected format.  Returns { r, g, b } or { h, s, l } or { h, s, v}\nfunction stringInputToObject(color) {\n\n    color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();\n    var named = false;\n    if (names[color]) {\n        color = names[color];\n        named = true;\n    }\n    else if (color == 'transparent') {\n        return { r: 0, g: 0, b: 0, a: 0, format: \"name\" };\n    }\n\n    // Try to match string input using regular expressions.\n    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]\n    // Just return an object and let the conversion functions handle that.\n    // This way the result will be the same whether the tinycolor is initialized with string or object.\n    var match;\n    if ((match = matchers.rgb.exec(color))) {\n        return { r: match[1], g: match[2], b: match[3] };\n    }\n    if ((match = matchers.rgba.exec(color))) {\n        return { r: match[1], g: match[2], b: match[3], a: match[4] };\n    }\n    if ((match = matchers.hsl.exec(color))) {\n        return { h: match[1], s: match[2], l: match[3] };\n    }\n    if ((match = matchers.hsla.exec(color))) {\n        return { h: match[1], s: match[2], l: match[3], a: match[4] };\n    }\n    if ((match = matchers.hsv.exec(color))) {\n        return { h: match[1], s: match[2], v: match[3] };\n    }\n    if ((match = matchers.hsva.exec(color))) {\n        return { h: match[1], s: match[2], v: match[3], a: match[4] };\n    }\n    if ((match = matchers.hex8.exec(color))) {\n        return {\n            r: parseIntFromHex(match[1]),\n            g: parseIntFromHex(match[2]),\n            b: parseIntFromHex(match[3]),\n            a: convertHexToDecimal(match[4]),\n            format: named ? \"name\" : \"hex8\"\n        };\n    }\n    if ((match = matchers.hex6.exec(color))) {\n        return {\n            r: parseIntFromHex(match[1]),\n            g: parseIntFromHex(match[2]),\n            b: parseIntFromHex(match[3]),\n            format: named ? \"name\" : \"hex\"\n        };\n    }\n    if ((match = matchers.hex4.exec(color))) {\n        return {\n            r: parseIntFromHex(match[1] + '' + match[1]),\n            g: parseIntFromHex(match[2] + '' + match[2]),\n            b: parseIntFromHex(match[3] + '' + match[3]),\n            a: convertHexToDecimal(match[4] + '' + match[4]),\n            format: named ? \"name\" : \"hex8\"\n        };\n    }\n    if ((match = matchers.hex3.exec(color))) {\n        return {\n            r: parseIntFromHex(match[1] + '' + match[1]),\n            g: parseIntFromHex(match[2] + '' + match[2]),\n            b: parseIntFromHex(match[3] + '' + match[3]),\n            format: named ? \"name\" : \"hex\"\n        };\n    }\n\n    return false;\n}\n\nfunction validateWCAG2Parms(parms) {\n    // return valid WCAG2 parms for isReadable.\n    // If input parms are invalid, return {\"level\":\"AA\", \"size\":\"small\"}\n    var level, size;\n    parms = parms || {\"level\":\"AA\", \"size\":\"small\"};\n    level = (parms.level || \"AA\").toUpperCase();\n    size = (parms.size || \"small\").toLowerCase();\n    if (level !== \"AA\" && level !== \"AAA\") {\n        level = \"AA\";\n    }\n    if (size !== \"small\" && size !== \"large\") {\n        size = \"small\";\n    }\n    return {\"level\":level, \"size\":size};\n}\n\nthis.tinycolor = tinycolor;\n\n})()`;\n}\n// It is hacky way to make this function will be compiled preferentially by less\n// resolve error: `ReferenceError: colorPalette is not defined`\n// https://github.com/ant-design/ant-motion/issues/44\n.tinyColorMixin();\n","\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.@{noUi-css-prefix}-target,\n.@{noUi-css-prefix}-target * {\n-webkit-touch-callout: none;\n-webkit-tap-highlight-color: rgba(0,0,0,0);\n-webkit-user-select: none;\n-ms-touch-action: none;\n\ttouch-action: none;\n-ms-user-select: none;\n-moz-user-select: none;\n\tuser-select: none;\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.@{noUi-css-prefix}-target {\n\tposition: relative;\n}\n.@{noUi-css-prefix}-base,\n.@{noUi-css-prefix}-connects {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.@{noUi-css-prefix}-connects {\n\toverflow: hidden;\n\tz-index: 0;\n}\n.@{noUi-css-prefix}-connect,\n.@{noUi-css-prefix}-origin {\n\twill-change: transform;\n\tposition: absolute;\n\tz-index: 1;\n\ttop: 0;\n\tright: 0;\n\theight: 100%;\n\twidth: 100%;\n\t-ms-transform-origin: 0 0;\n\t-webkit-transform-origin: 0 0;\n\t-webkit-transform-style: preserve-3d;\n\ttransform-origin: 0 0;\n\ttransform-style: flat;\n}\n\n/* Offset direction\n */\n.@{noUi-css-prefix}-txt-dir-rtl.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-origin {\n\tleft: 0;\n\tright: auto;\n}\n\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-origin {\n\ttop: -100%;\n\twidth: 0;\n}\n.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-origin {\n\theight: 0;\n}\n.@{noUi-css-prefix}-handle {\n-webkit-backface-visibility: hidden;\n\tbackface-visibility: hidden;\n\tposition: absolute;\n}\n.@{noUi-css-prefix}-touch-area {\n\theight: 100%;\n\twidth: 100%;\n}\n.@{noUi-css-prefix}-state-tap .@{noUi-css-prefix}-connect,\n.@{noUi-css-prefix}-state-tap .@{noUi-css-prefix}-origin {\n-webkit-transition: transform 0.3s;\n\ttransition: transform 0.3s;\n}\n.@{noUi-css-prefix}-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Slider size and handle placement;\n */\n.@{noUi-css-prefix}-horizontal {\n\theight: 18px;\n}\n.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-handle {\n\twidth: 34px;\n\theight: 28px;\n\tright: -17px;\n\ttop: -6px;\n}\n.@{noUi-css-prefix}-vertical {\n\twidth: 18px;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-handle {\n\twidth: 28px;\n\theight: 34px;\n\tright: -6px;\n\tbottom: -17px;\n}\n.@{noUi-css-prefix}-txt-dir-rtl.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-handle {\n\tleft: -17px;\n\tright: auto;\n}\n\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.@{noUi-css-prefix}-target {\n\tbackground: #FAFAFA;\n\tborder-radius: 4px;\n\tborder: 1px solid #D3D3D3;\n\tbox-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.@{noUi-css-prefix}-connects {\n\tborder-radius: 3px;\n}\n.@{noUi-css-prefix}-connect {\n\tbackground: #3FB8AF;\n}\n\n/* Handles and cursors;\n */\n.@{noUi-css-prefix}-draggable {\n\tcursor: ew-resize;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-draggable {\n\tcursor: ns-resize;\n}\n.@{noUi-css-prefix}-handle {\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #FFF;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #EBEBEB,\n\t\t\t\t0 3px 6px -3px #BBB;\n}\n.@{noUi-css-prefix}-active {\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #DDD,\n\t\t\t\t0 3px 6px -3px #BBB;\n}\n\n/* Handle stripes;\n */\n.@{noUi-css-prefix}-handle:before,\n.@{noUi-css-prefix}-handle:after {\n\tcontent: \"\";\n\tdisplay: block;\n\tposition: absolute;\n\theight: 14px;\n\twidth: 1px;\n\tbackground: #E8E7E6;\n\tleft: 14px;\n\ttop: 6px;\n}\n.@{noUi-css-prefix}-handle:after {\n\tleft: 17px;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-handle:before,\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-handle:after {\n\twidth: 14px;\n\theight: 1px;\n\tleft: 6px;\n\ttop: 14px;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-handle:after {\n\ttop: 17px;\n}\n\n/* Disabled state;\n */\n\n[disabled] .@{noUi-css-prefix}-connect {\n\tbackground: #B8B8B8;\n}\n[disabled].@{noUi-css-prefix}-target,\n[disabled].@{noUi-css-prefix}-handle,\n[disabled] .@{noUi-css-prefix}-handle {\n\tcursor: not-allowed;\n}\n","\n/* Base;\n *\n */\n.@{noUi-css-prefix}-pips,\n.@{noUi-css-prefix}-pips * {\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.@{noUi-css-prefix}-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n *\n */\n.@{noUi-css-prefix}-value {\n\tposition: absolute;\n\twhite-space: nowrap;\n\ttext-align: center;\n}\n.@{noUi-css-prefix}-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n *\n */\n.@{noUi-css-prefix}-marker {\n\tposition: absolute;\n\tbackground: #CCC;\n}\n.@{noUi-css-prefix}-marker-sub {\n\tbackground: #AAA;\n}\n.@{noUi-css-prefix}-marker-large {\n\tbackground: #AAA;\n}\n\n/* Horizontal layout;\n *\n */\n.@{noUi-css-prefix}-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n.@{noUi-css-prefix}-value-horizontal {\n\t-webkit-transform: translate(-50%, 50%);\n\ttransform: translate(-50%, 50%);\n\n\t.@{noUi-css-prefix}-rtl & {\n\t\t-webkit-transform: translate(50%, 50%);\n\t\ttransform: translate(50%, 50%);\n\t}\n}\n\n.@{noUi-css-prefix}-marker-horizontal.@{noUi-css-prefix}-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n.@{noUi-css-prefix}-marker-horizontal.@{noUi-css-prefix}-marker-sub {\n\theight: 10px;\n}\n.@{noUi-css-prefix}-marker-horizontal.@{noUi-css-prefix}-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.@{noUi-css-prefix}-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n.@{noUi-css-prefix}-value-vertical {\n\t-webkit-transform: translate(0, -50%);\n\ttransform: translate(0, -50%);\n\tpadding-left: 25px;\n\n\t.@{noUi-css-prefix}-rtl & {\n\t\t-webkit-transform: translate(0, 50%);\n\t\ttransform: translate(0, 50%);\n\t}\n}\n\n.@{noUi-css-prefix}-marker-vertical.@{noUi-css-prefix}-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n.@{noUi-css-prefix}-marker-vertical.@{noUi-css-prefix}-marker-sub {\n\twidth: 10px;\n}\n.@{noUi-css-prefix}-marker-vertical.@{noUi-css-prefix}-marker-large {\n\twidth: 15px;\n}\n",".@{noUi-css-prefix}-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n\twhite-space: nowrap;\n}\n.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-tooltip {\n-webkit-transform: translate(-50%, 0);\n    transform: translate(-50%, 0);\n    left: 50%;\n    bottom: 120%;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-tooltip {\n-webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    right: 120%;\n}\n.@{noUi-css-prefix}-horizontal .@{noUi-css-prefix}-origin > .@{noUi-css-prefix}-tooltip {\n\t-webkit-transform: translate(50%, 0);\n\ttransform: translate(50%, 0);\n\tleft: auto;\n\tbottom: 10px;\n}\n.@{noUi-css-prefix}-vertical .@{noUi-css-prefix}-origin > .@{noUi-css-prefix}-tooltip {\n\t-webkit-transform: translate(0, -18px);\n\ttransform: translate(0, -18px);\n\ttop: auto;\n\tright: 28px;\n}\n","@import \"../../../../../node_modules/nouislider/src/nouislider.less\";\n\n#kr-update-box > form {\n  .gh-box-section > span {\n    color: @brand-grey;\n  }\n\n  .gh-fg-description {\n    margin-right: 90px;\n  }\n\n  .gh-border-top-0 {\n    border-top: 0;\n  }\n\n  .gh-siv-row-name {\n    width: 40%;\n    color: @brand-dark;\n  }\n\n  .cf-dropdown {\n    .dropdown-menu {\n      max-height: 200px;\n      max-width: 420px;\n      overflow-y: scroll;\n\n      li {\n        .cf-dropdown-btn {\n          max-width: 100%;\n          span {\n            overflow-x: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n    }\n  }\n\n  #slider {\n    &.noUi-target {\n      border-radius: unset;\n      border: unset;\n      box-shadow: unset;\n      height: 4px;\n      margin: 0 10px;\n      margin-top: 2em;\n      background: #eef0f4;\n    }\n\n    .noUi-handle {\n      width: 26px;\n      height: 26px;\n      top: -12px;\n      border: 4px solid #87a6bc;\n      border-radius: 50%;\n\n      &.noUi-active {\n        cursor: pointer;\n        border: 13px solid #87a6bc;\n      }\n\n      &:hover {\n        cursor: pointer;\n        border: 13px solid #87a6bc;\n      }\n\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n}\n",".single-goal-selector-modal {\n  .modal-dialog {\n    width: 1000px;\n\n    .modal-content {\n      padding: 40px 47px;\n    }\n  }\n}\n\n#single-goal-selector {\n  .gh-modal-header {\n    padding: 30px 40px 0px 40px;\n    background: @brand-white;\n\n    .gh-modal-title {\n      font-size: 1.5em;\n    }\n\n    .gh-modal-close-button {\n      &.selector-close-btn {\n        right: 30px;\n        font-size: 28px;\n      }\n    }\n  }\n\n  .gh-modal-search {\n    display: flex;\n    align-items: center;\n\n    height: 45px;\n    margin-bottom: 25px;\n    border-radius: 4px;\n    border: 1px solid @blue-90;\n\n    .icon {\n      font-size: 18px;\n      margin: 0 13px;\n      opacity: 0.8;\n    }\n\n    .search-text {\n      flex: 1;\n      font-size: 16px;\n      line-height: 24px;\n      border: none;\n      opacity: 0.7;\n      margin-right: 5px;\n\n      &:focus {\n        outline: none;\n      }\n\n      &:valid {\n        font-size: 18px;\n        font-weight: @medium;\n        color: @brand-black;\n      }\n    }\n\n    .gh-dropdown-wrapper {\n      height: 100%;\n      display: flex;\n      align-items: center;\n      border-left: 1px solid @brand-list-grey;\n      margin-right: 10px;\n\n      .dropdown-toggle {\n        padding: 3px 7px;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        color: @black-70;\n\n        &:hover {\n          background: none;\n          color: @brand-dark;\n        }\n\n        .icon {\n          margin: 0;\n          font-size: 8px;\n          position: relative;\n          top: 1px;\n          left: 3px;\n        }\n      }\n\n      .dropdown-menu {\n        min-width: 115px;\n      }\n    }\n  }\n\n  .gh-sessions {\n    .section {\n      .section-title {\n        font-size: 13px;\n        font-weight: @medium;\n        color: @black-70;\n        text-transform: uppercase;\n      }\n\n      .gh-session {\n        border-bottom: none;\n        min-height: 35px;\n        padding: 0px;\n\n        &.margin-top {\n          margin-top: 5px;\n        }\n\n        &.border-top {\n          border-top: 1px solid @brand-light;\n        }\n\n        &:hover {\n          background: none;\n        }\n\n        .session-wrapper {\n          .session {\n            min-height: 48px;\n            border: 1px solid @brand-white;\n            border-bottom: 1px solid @brand-light;\n            padding: 4px;\n            gap: 12px;\n\n            .gh-icon-wrapper {\n              position: initial;\n              width: 16px;\n            }\n\n            .gh-session-title {\n              font-weight: 500;\n              width: 250px;\n            }\n\n            .gh-session-range {\n              max-width: 300px;\n            }\n\n            .gh-icon {\n              position: sticky;\n            }\n\n            .select-btn {\n              visibility: hidden;\n            }\n\n            &:not(.inactive) {\n              &:hover,\n              &:active,\n              &:focus {\n                border: 1px solid #b1daff;\n                border-radius: 4px;\n                background: #f0fcff;\n\n                .select-btn {\n                  visibility: visible;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .gh-goal {\n        min-height: 48px;\n        border: 1px solid @brand-white;\n        border-bottom: 1px solid @brand-light;\n        padding: 4px;\n        gap: 12px;\n\n        position: relative;\n\n        .toggler {\n          position: absolute;\n          left: -20px;\n          cursor: pointer;\n          top: 15px;\n          font-size: 10px;\n          color: @brand-jira;\n\n          &.minus {\n            color: @brand-subtler;\n          }\n\n          &:hover {\n            opacity: 0.6;\n          }\n        }\n\n        &.margin-top {\n          margin-top: 5px;\n        }\n\n        &.border-top {\n          border-top: 1px solid @brand-light;\n        }\n\n        &.unselectable {\n          background: #effdf9;\n          border: 1px solid @teal-80;\n\n          &:hover,\n          &:active,\n          &:focus {\n            cursor: not-allowed;\n            background: #effdf9;\n            border: 1px solid @teal-80;\n\n            .select {\n              display: none;\n            }\n          }\n\n          &:after {\n            content: \"\";\n            background: url(../../../../../wwwroot/fe/img/icons/check.svg)\n              no-repeat;\n            position: absolute;\n            top: 14px;\n            right: 15px;\n            height: 15px;\n            width: 20px;\n          }\n        }\n\n        .select-btn {\n          visibility: hidden;\n        }\n\n        &:hover,\n        &:active,\n        &:focus {\n          border: 1px solid #b1daff;\n          border-radius: 4px;\n          background: #f0fcff;\n\n          .select-btn {\n            cursor: pointer;\n            visibility: visible;\n          }\n        }\n\n        .gh-goal-title {\n          font-weight: @medium;\n          width: 300px;\n        }\n\n        .gh-goal-session {\n          color: #9aa3a9;\n          font-size: 13px;\n          width: 150px;\n        }\n\n        .gh-badge {\n          &.open {\n            margin-right: 0px;\n            margin-left: 5px;\n          }\n        }\n      }\n    }\n  }\n\n  .gh-empty-row {\n    .icon {\n      top: 0;\n    }\n  }\n}\n",".modal {\n  &.move-okr {\n    .modal-content {\n      padding: 38px 50px;\n    }\n  }\n}\n\n#move-objective {\n  .clone-p {\n    padding: 9px 10px;\n  }\n\n  .grey-border {\n    border: 1px solid @grey-60-v2;\n    box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n    border-radius: 4px;\n  }\n\n  .title {\n    font-size: 30px;\n    color: @ink-90-v2;\n    .fw-700;\n  }\n\n  .gh-font-icon-help {\n    color: @ink-50-v2;\n  }\n}\n",".gh-selected-artefact {\n  padding: 10px 40px 10px 50px;\n\n  position: relative;\n  border: 2px solid @brand-light;\n  border-radius: 4px;\n\n  .remove {\n    position: absolute;\n    right: 15px;\n    top: 20px;\n    color: @brand-subtler;\n    cursor: pointer;\n\n    &:hover {\n      color: @brand-danger;\n    }\n  }\n\n  .gh-icon {\n    position: absolute;\n    left: 15px;\n    top: 15px;\n  }\n\n  .title {\n    font-size: 1.1em;\n    word-break: break-word;\n  }\n\n  .subtitle {\n    font-size: 0.9em;\n    color: @brand-subtler;\n  }\n}\n\n#create-form {\n  .alignment {\n    .gh-selected-artefact {\n      .gh-icon-wrapper {\n        .gh-icon {\n          top: 0;\n          display: flex;\n          align-items: center;\n          height: 100%;\n\n          &:before {\n            position: static;\n          }\n        }\n      }\n\n      .remove {\n        top: 0;\n        margin: 0;\n        height: 100%;\n      }\n    }\n  }\n}\n",".fixed-width-task-status {\n  width: 140px;\n  text-align: right;\n}\n","@import \"./components/bulk-tag/bulk-tag.component.less\";\n@import \"./components/okr-workflow/ork-workflow.component.less\";\n@import \"./less/timeline.less\";\n@import \"./less/cloned-or-moved-metric-success.less\";\n@import \"./less/confirm-clone-or-move.less\";\n@import \"./less/submit-to-marketplace.less\";\n@import \"./less/goals.less\";\n@import \"./less/single-goal.less\";\n@import \"./less/goal-timeline.less\";\n@import \"./less/all-goals.less\";\n@import \"./less/overview.less\";\n@import \"./less/nested.less\";\n@import \"./less/tasks.less\";\n@import \"./less/custom-fields.less\";\n@import \"./less/metric-form.less\";\n@import \"./less/send-for-approval.less\";\n@import \"./less/update-manual-metric.less\";\n@import \"./less/single-goal-selector.less\";\n@import \"./less/move-objective.less\";\n@import \"./less/selected-artefact.less\";\n@import \"./less/task-status.less\";\n\n.grid-expanded {\n  .grid {\n    position: absolute;\n    min-width: 100%;\n    border: 0;\n    bottom: 0;\n    top: 89px;\n    padding-bottom: 0;\n\n    &.bulk-delete-warning-banner-displayed {\n      top: 165px;\n    }\n\n    &.pb-75 {\n      padding-bottom: 75px;\n    }\n  }\n}\n\n.container-fluid {\n  .grid-expanded {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.checkmark {\n  text-align: center;\n  background: @brand-primary;\n  border-radius: 100px;\n  width: 70px;\n  height: 70px;\n  margin: 20px 0 10px 42%;\n\n  .nc-icon-outline {\n    margin-top: 13px;\n    color: @brand-white;\n    font-size: 50px;\n  }\n}\n","@import (reference) \"../../../less/_variables.less\";\n@import (reference) \"../../../../../wwwroot/fe/fonts/gh-font/variables.less\";\n\n@column-title-height: 60px;\n\n@keyframes celebration {\n  0% {\n    background-position: 0 -150px;\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    background-position: 0 -0px;\n    opacity: 0;\n  }\n}\n\n@keyframes celebration2 {\n  0% {\n    background-position: 0 -200px;\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    background-position: 0 -100px;\n    opacity: 0;\n  }\n}\n\n@keyframes celebration3 {\n  0% {\n    box-shadow: 0 0 0 lighten(@brand-primary, 35%);\n  }\n  50% {\n    box-shadow: 0 0 20px lighten(@brand-primary, 20%);\n  }\n  0% {\n    box-shadow: 0 0 0 lighten(@brand-primary, 35%);\n  }\n}\n\n#tasks-kanban {\n  position: fixed;\n  left: 260px;\n  right: 40px;\n  top: 100px;\n  bottom: 0;\n  overflow: auto;\n  display: flex;\n  justify-content: space-between;\n  -webkit-font-smoothing: antialiased;\n\n  .content-wrapper {\n    position: absolute;\n    height: auto;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .dndPlaceholder {\n    width: 100%;\n    height: 60px;\n    background: darken(@brand-light, 4%);\n    border: 1px dashed darken(@brand-light, 8%);\n  }\n\n  .dndDraggingSource {\n    opacity: 0.5;\n  }\n\n  .tasks-column {\n    margin-right: 30px;\n    padding: 0px 40px 40px;\n    flex: 1 1;\n    background: lighten(@brand-light, 4%);\n    border-radius: 4px;\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n\n    ul {\n      min-height: calc(100% - @column-title-height);\n\n      &.dndDragover {\n        background: lighten(@brand-light, 1%);\n      }\n    }\n\n    .column-title {\n      position: relative; // IE, our friend\n      position: sticky;\n      top: 0;\n      left: 0;\n      height: @column-title-height;\n      margin: 0 -10px;\n      padding-left: 10px;\n      display: flex;\n      align-items: center;\n      background: lighten(@brand-light, 4%);\n      z-index: 1;\n      font-weight: @semibold;\n      color: @brand-dark;\n\n      .newtask {\n        position: absolute;\n        right: 0;\n        top: 0;\n      }\n\n      &:before {\n        content: \"\";\n        height: 3px;\n        width: 20px;\n        margin-right: 10px;\n        background: @brand-subtle;\n      }\n\n      .count {\n        margin-left: 10px;\n        color: @brand-subtle;\n        font-weight: @regular;\n      }\n\n      &.inprogress:before {\n        background: @brand-jira;\n      }\n      &.done:before {\n        background: @brand-primary;\n      }\n    }\n  }\n\n  .task {\n    margin-bottom: 10px;\n    padding: 15px;\n    width: 100%;\n    border-radius: 5px;\n    position: relative;\n    box-shadow: 0 3px 10px fade(@brand-dark, 5%);\n    background: #fff;\n    border: 1px solid @brand-light;\n    display: flex;\n    flex-direction: column;\n\n    &.celebration {\n      animation-name: celebration3;\n      animation-duration: 1s;\n\n      &:before {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: red;\n        content: \"\";\n        top: 0;\n        left: 0;\n        background: url(\"../../../../../wwwroot/fe/img/celebration.jpg\")\n          no-repeat 0 0;\n        background-size: cover;\n        animation-name: celebration;\n        animation-duration: 1s;\n      }\n\n      &:after {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: red;\n        content: \"\";\n        top: 0;\n        left: 0;\n        background: url(\"../../../../../wwwroot/fe/img/celebration.jpg\")\n          no-repeat 0 0;\n        background-size: cover;\n        animation-name: celebration2;\n        animation-duration: 3s;\n      }\n    }\n\n    dropdown-actions-menu {\n      position: absolute;\n      right: 15px;\n      top: 15px;\n    }\n\n    .gh-icon-task {\n      position: absolute;\n      left: 15px;\n      top: 17px;\n    }\n\n    .task-assignee {\n      color: @brand-subtler;\n      position: relative;\n      display: inline-block;\n      margin: 10px 0;\n    }\n\n    .task-name {\n      min-height: 20px;\n      margin-bottom: 5px;\n      padding-left: 30px;\n      padding-right: 30px;\n      font-weight: @semibold;\n\n      a {\n        color: @brand-dark;\n\n        &:hover {\n          color: @brand-jira;\n        }\n      }\n    }\n\n    .task-description {\n      color: @brand-subtler;\n      font-size: 13px;\n      margin-top: 5px;\n      padding-left: 30px;\n    }\n\n    .task-goal {\n      padding-top: 8px;\n      border-top: 1px solid @brand-light;\n      position: relative;\n      padding-left: 30px;\n      margin-top: 8px;\n      font-size: 0.9em;\n\n      .gh-icon {\n        position: absolute;\n        left: 0;\n        top: 8px;\n      }\n\n      a {\n        color: @brand-subtler;\n        &:hover {\n          color: @brand-jira;\n        }\n      }\n    }\n  }\n\n  .date {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .grey {\n    color: @brand-dark-grey;\n    opacity: 0.64;\n    font-size: 13px;\n  }\n  .green {\n    color: @brand-green;\n    font-size: 13px;\n  }\n  .red {\n    color: @brand-red;\n    font-size: 13px;\n  }\n\n  .gh-typeahead {\n    .uib-typeahead-match {\n      padding-left: 5px;\n\n      &.active {\n        background: @black-10;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n#tasks-list {\n  position: fixed;\n  left: 260px;\n  right: 40px;\n  top: 100px;\n  bottom: 80px;\n  overflow: auto;\n\n  &.sidebar-collapsed {\n    left: 100px;\n  }\n\n  #task-grid {\n    margin-bottom: 0;\n    .gh-row {\n      &.task-skeleton-row {\n        .gh-row-columns {\n          .gh-cell {\n            padding: 10px 20px 10px 6px;\n            background: rgba(227, 232, 242, 0.5);\n            background-clip: content-box;\n          }\n        }\n      }\n\n      &.gh-row-header {\n        position: sticky;\n        top: 0;\n        left: 0;\n        z-index: 3;\n        background: @brand-white;\n        border-bottom: 1px solid @brand-lighter-grey;\n      }\n\n      // to do: unify styles in grid when replacing dd menu and other components in lists\n      .gh-row-actions {\n        display: inline-flex;\n        top: 9px;\n      }\n    }\n\n    .gh-cell {\n      &:nth-child(1) {\n        width: 24%;\n      }\n\n      &:nth-child(2) {\n        width: 10%;\n      }\n\n      &:nth-child(3) {\n        width: 10%;\n      }\n\n      &:nth-child(4) {\n        width: 23%;\n      }\n\n      &:nth-child(5) {\n        width: 12%;\n      }\n\n      &:nth-child(6) {\n        flex: 1;\n        overflow: hidden;\n      }\n\n      &:nth-child(7) {\n        width: 40px;\n      }\n\n      .gh-select-toggle {\n        border: none;\n        padding: 0;\n        font-size: 14px;\n        display: block;\n\n        img.system-logo {\n          opacity: 0;\n          width: 20px;\n        }\n\n        &:hover {\n          .system-logo {\n            opacity: 1;\n          }\n        }\n\n        &:before {\n          content: none;\n        }\n      }\n\n      cursor: pointer;\n\n      .grey {\n        color: @brand-dark-grey;\n        opacity: 0.64;\n\n        &:hover {\n          .remove {\n            opacity: 1;\n          }\n        }\n\n        .remove {\n          background: @brand-dark-grey;\n        }\n      }\n\n      .green {\n        color: @brand-green;\n\n        &:hover {\n          .remove {\n            opacity: 1;\n          }\n        }\n      }\n\n      .red {\n        color: @brand-red;\n\n        &:hover {\n          .remove {\n            opacity: 1;\n          }\n        }\n\n        .remove {\n          background: @brand-red;\n        }\n      }\n\n      .remove {\n        float: right;\n        width: 12px;\n        min-width: 12px;\n        height: 12px;\n        min-height: 12px;\n        background: @brand-green;\n        border-radius: 30px;\n        margin-top: 13px;\n        color: #fff;\n        line-height: 8px;\n        text-align: center;\n        position: relative;\n        opacity: 0;\n        transform: rotate(45deg);\n\n        &.red {\n          background: @brand-red;\n        }\n\n        &:after {\n          content: \"\";\n          position: absolute;\n          left: 1px;\n          top: 1px;\n          width: 12px;\n          height: 12px;\n          background-image: linear-gradient(@grey-10-v2, @grey-10-v2),\n            linear-gradient(@grey-10-v2, @grey-10-v2);\n          background-size: 8px 2px, 2px 8px;\n          background-position: 1px 4px, 4px 1px;\n          background-repeat: no-repeat;\n        }\n      }\n\n      .dropdown {\n        &.calendar {\n          width: 255px;\n          z-index: 1;\n          border: 1px solid @brand-light;\n        }\n      }\n\n      &.with-icon {\n        &.task-parent-okr {\n          padding-right: 40px;\n          display: flex;\n\n          .grid-icon {\n            height: 20px;\n            line-height: 20px;\n            top: 9px;\n          }\n\n          .clip-text {\n            padding-left: 5px;\n          }\n\n          &:hover {\n            .remove {\n              opacity: 0.64;\n            }\n          }\n\n          .remove {\n            background: @brand-dark-grey;\n          }\n        }\n\n        .open {\n          [class^=\"gh-font-icon-\"],\n          [class*=\" gh-font-icon-\"] {\n            font-size: 0.9em;\n          }\n        }\n      }\n\n      &.overflow-visible {\n        overflow: visible;\n      }\n    }\n\n    .grid-input {\n      .users-input-container {\n        .host {\n          .tags {\n            display: flex;\n            overflow: clip;\n          }\n        }\n      }\n    }\n\n    @media all and (max-width: 1280px) {\n      .gh-cell {\n        &:nth-child(1) {\n          width: 30%;\n        }\n\n        &:nth-child(2) {\n          width: 10%;\n        }\n\n        &:nth-child(3) {\n          width: 10%;\n        }\n\n        &:nth-child(4) {\n          width: 25%;\n        }\n\n        &:nth-child(5) {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .dropdown-menu {\n    will-change: filter;\n  }\n\n  .date-text {\n    display: inline-block;\n    width: 100%;\n\n    .remove {\n      display: inline-block;\n    }\n  }\n\n  user-selector {\n    tags-input {\n      &.users-input-container {\n        .autocomplete {\n          min-width: 200px;\n        }\n      }\n    }\n  }\n\n  .f-c-sb {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    span {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n#tasks-kanban,\n#tasks-list {\n  &.with-demo {\n    top: 150px;\n  }\n\n  &.with-banner {\n    top: 170px;\n  }\n\n  .gh-row {\n    .gh-cell {\n      .clip-text {\n        .deleted-user {\n          font-size: 90%;\n        }\n      }\n    }\n  }\n}\n\n#tasks-list #task-grid .gh-row.gh-row-header .create-task-inline,\n#tasks-kanban .column-title.todo {\n  .gh-font-icon-plus {\n    margin-right: 7px;\n    color: #616e7a;\n\n    &.color-black {\n      color: @brand-black;\n    }\n\n    &.mr-28 {\n      margin-right: 28px;\n    }\n\n    &:hover {\n      color: #0457d7 !important;\n      background: rgba(10, 119, 227, 0.1);\n      border-radius: 3px;\n    }\n  }\n}\n","@import (reference) \"../../../less/_variables.less\";\n\n.task-form-modal {\n  &.modal {\n    &.sidebar-modal {\n      .modal-dialog {\n        min-width: 550px;\n        width: 550px;\n      }\n    }\n  }\n}\n\n#single-task-view {\n  .pointer-events-none {\n    pointer-events: none;\n  }\n\n  .gh-siv-row-name {\n    width: 34%;\n    margin-top: 10px;\n  }\n\n  .gh-siv-editable-markdown {\n    margin: 0;\n\n    .gh-siv-editable-markdown-preview {\n      padding: 8px;\n      color: @brand-dark-grey;\n      opacity: 0.64;\n    }\n  }\n\n  .display-none {\n    display: none;\n  }\n\n  .no-update-permissions {\n    &:hover {\n      cursor: initial;\n      opacity: 1;\n    }\n  }\n\n  .parent-goal {\n    .goal-wrapper {\n      display: flex;\n      flex-direction: row;\n      justify-items: center;\n      width: 100%;\n    }\n    .gh-icon-wrapper {\n      vertical-align: top;\n    }\n\n    .goal-name {\n      display: inline-block;\n      width: auto;\n      margin-left: 0px;\n      margin-top: 1px;\n      word-break: break-word;\n\n      &.internal {\n        cursor: pointer;\n      }\n    }\n\n    .placeholder-text {\n      margin-left: 10px;\n    }\n\n    .remove-field {\n      position: absolute;\n      top: 1px;\n      right: 0;\n    }\n  }\n\n  input:not([type=\"checkbox\"]) {\n    border: none;\n    width: 100%;\n    outline: none;\n\n    &::placeholder {\n      color: desaturate(lighten(@brand-info, 20%), 25%);\n    }\n\n    &:-ms-input-placeholder {\n      color: desaturate(lighten(@brand-info, 20%), 25%);\n    }\n\n    &::-ms-input-placeholder {\n      color: desaturate(lighten(@brand-info, 20%), 25%);\n    }\n  }\n\n  .external-system {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .placeholder-text {\n    width: 100%;\n    color: darken(@brand-light, 5%);\n  }\n\n  .remove-field {\n    height: 14px;\n    width: 14px;\n    margin-right: 5px;\n    font-size: 13px;\n    color: @brand-grey;\n    cursor: pointer;\n\n    &:hover {\n      color: darken(@brand-grey, 10%);\n      font-weight: @ultrabold;\n    }\n  }\n\n  .inline-remove {\n    position: absolute;\n    display: none;\n    top: 50%;\n    right: 10px;\n    width: 12px;\n    height: 12px;\n    margin-top: -6px;\n    background: @brand-grey;\n    border-radius: 30px;\n    color: #fff;\n    text-align: center;\n    z-index: 4;\n    cursor: pointer;\n\n    &:after {\n      content: \"\\eaa3\";\n      line-height: 6px;\n      color: #fff;\n      font: normal normal 15px/1 \"Nucleo Mini\";\n      position: absolute;\n      left: -2px;\n      top: -1px;\n    }\n  }\n\n  .inline-editable {\n    position: relative;\n\n    &:hover {\n      background: lighten(@brand-info, 36%);\n      opacity: 0.5;\n\n      .inline-remove {\n        display: block;\n      }\n    }\n  }\n\n  .inline-editable-no-hover {\n    position: relative;\n  }\n\n  .multiline-non-editable {\n    padding: 5px;\n  }\n\n  .multiline-editable {\n    position: relative;\n    border: 1px solid @brand-white;\n    padding: 5px;\n    word-break: break-word;\n\n    &:hover {\n      outline: none;\n      border: 1px solid @brand-light;\n\n      .multiline-remove {\n        display: block;\n      }\n    }\n  }\n\n  .title {\n    font-size: 2em;\n    font-weight: @semibold;\n    outline: none;\n    margin: 0px;\n    padding: 5px;\n    overflow-wrap: anywhere;\n  }\n\n  .with-border {\n    border: 1px solid @brand-light;\n  }\n\n  .with-background {\n    background: lighten(@brand-info, 37%);\n  }\n\n  .important {\n    background-color: @brand-danger;\n  }\n\n  .close-modal-btn {\n    width: 20px;\n    height: 20px;\n    border: 1px solid @brand-light;\n    border-radius: 5px;\n    background: none;\n    font-size: 20px;\n    color: @brand-subtle;\n    cursor: pointer;\n\n    &:hover {\n      border-color: darken(@brand-light, 10%);\n    }\n  }\n\n  .task-title {\n    position: relative;\n    min-height: 40px;\n    margin: 30px 0px;\n    padding-left: 0px;\n\n    .gh-icon-wrapper {\n      position: absolute;\n      left: 0px;\n      top: 5px;\n    }\n  }\n\n  .task-options-trigger {\n    position: absolute;\n    top: 40px;\n    right: 40px;\n  }\n\n  .task-details {\n    .gh-box-section {\n      .section {\n        margin: 10px 0;\n\n        &.status-and-due-date {\n          .gh-fg-content {\n            .status {\n              float: left;\n            }\n\n            .due-date-container {\n              float: right;\n              margin-top: 3px;\n\n              .edit-due-date {\n                .select-toggle {\n                  position: relative;\n                  background: lighten(@brand-info, 36%);\n                }\n\n                .dropdown-menu {\n                  min-width: unset;\n                  padding: 0px;\n                  top: 20px !important;\n                  left: -135px !important;\n                }\n              }\n\n              .system-logo {\n                width: 20px;\n                height: 20px;\n              }\n\n              span.placeholder-text {\n                padding-left: 5px;\n              }\n\n              .grey {\n                color: @brand-dark-grey;\n                opacity: 0.64;\n              }\n\n              .green {\n                color: @brand-green;\n              }\n\n              .red {\n                color: @brand-red;\n              }\n\n              .remove-field {\n                margin-left: 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    rich-text-editor {\n      width: 100%;\n      display: block;\n      margin: 0;\n    }\n  }\n\n  .gh-box-section {\n    .section:last-child {\n      border-bottom: none;\n    }\n\n    .gh-fg {\n      // border-bottom: 1px solid @brand-light;\n      border-bottom: 0;\n    }\n\n    .gh-box-section-header {\n      font-weight: 400;\n      color: @brand-subtler;\n    }\n\n    .section {\n      min-height: 40px;\n\n      .gh-select-toggle {\n        height: 30px;\n        line-height: 30px;\n        font-size: 1em;\n      }\n\n      .gh-fg-title {\n        display: inline-block;\n        width: 34%;\n        color: @black-80;\n        font-size: 13px;\n        line-height: 16px;\n        font-weight: 400;\n        vertical-align: top;\n\n        &.hover {\n          &:hover {\n            cursor: pointer;\n          }\n        }\n      }\n\n      .gh-fg-content {\n        position: relative;\n        display: inline-block;\n        width: 66%;\n        min-height: 22px;\n        vertical-align: top;\n\n        &.single-select {\n          .gh-input-select {\n            &.gh-select-toggle {\n              height: 32px;\n              padding-top: 2px;\n              padding-bottom: 2px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .timeline-toggle {\n    margin-left: 5px;\n    vertical-align: bottom;\n    font-size: 16px;\n    color: @brand-dark;\n    cursor: pointer;\n\n    &:hover {\n      color: darken(@brand-grey, 10%);\n      font-weight: @ultrabold;\n    }\n  }\n\n  .task-timeline {\n    .placeholder-text {\n      padding-left: 6px;\n    }\n  }\n\n  .snapshot {\n    padding: 5px 0 4px 0;\n    border-top: 1px solid @brand-light;\n    position: relative;\n\n    &:first-child {\n      border: none;\n    }\n\n    .date {\n      font-size: 0.8em;\n      float: right;\n      color: @brand-subtler;\n    }\n\n    .status {\n      padding: 3px 5px;\n      background: @brand-subtle;\n      color: #fff;\n      border-radius: 2px;\n      font-size: 11px;\n      font-weight: @bold;\n      margin-right: 5px;\n\n      &.inprogress {\n        background: @brand-jira;\n      }\n\n      &.done {\n        background: @brand-primary;\n      }\n    }\n  }\n\n  [contenteditable=\"true\"]:empty:before {\n    content: attr(data-placeholder);\n    pointer-events: none;\n    display: block;\n    /* For Firefox */\n    color: desaturate(lighten(@brand-info, 20%), 25%);\n  }\n}\n",".create-task-form {\n  .task-title {\n    input {\n      height: 40px !important;\n    }\n  }\n\n  .task-owner {\n    tags-input {\n      height: 40px;\n\n      .tags {\n        padding-top: 3px;\n\n        &.focused {\n          input {\n            padding-top: 6px;\n          }\n        }\n\n        .tag-list {\n          max-width: 360px;\n        }\n      }\n    }\n  }\n\n  .task-status {\n    .dropdown {\n      height: 40px;\n    }\n  }\n\n  .task-due-date {\n    .ant-picker-clear {\n      right: 8px;\n    }\n  }\n\n  .task-linked-item {\n    parent-okr-selector {\n      tags-input.parent-input-container .host .tags .tag-list .tag-item {\n        margin-top: 5px;\n        margin-left: 5px;\n      }\n\n      tags-input {\n        .tags {\n          input {\n            height: 32px;\n            max-width: 40px;\n          }\n\n          &.focused {\n            input {\n              max-width: 400px;\n            }\n          }\n        }\n\n        &.empty {\n          .tags {\n            input {\n              max-width: 400px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","create-kanban-task-form form {\n  margin: 10px 0;\n  padding: 15px;\n  width: 100%;\n  border-radius: 5px;\n  box-shadow: 0 3px 10px rgba(46, 67, 84, 0.05);\n  background: @brand-white;\n  border: 1px solid @brand-light;\n\n  .gh-row {\n    border-top: none;\n    background: lighten(@brand-light, 4%);\n    margin: 10px 0;\n\n    .gh-cell {\n      width: 100%;\n\n      .grid-icon {\n        display: flex;\n        align-items: center;\n        height: 100%;\n\n        .small {\n          &:before {\n            filter: grayscale();\n          }\n        }\n      }\n\n      .grid-input {\n        font-size: 17px;\n\n        &.task-name {\n          padding-left: 35px;\n        }\n      }\n\n      .clip-text {\n        padding-left: 5px;\n        font-size: 17px;\n\n        &.no-owner {\n          color: darken(@brand-light, 5%);\n        }\n      }\n\n      .gh-select-toggle {\n        border: none;\n        padding: 0;\n        font-size: 14px;\n        display: block;\n\n        &:before {\n          content: none;\n        }\n\n        .date-text {\n          font-size: 17px;\n          margin-left: 5px;\n\n          .remove {\n            position: absolute;\n            top: 2px;\n            right: -25px;\n            font-size: 1.25em;\n\n            &:hover {\n              .icon {\n                font-weight: @ultrabold;\n              }\n            }\n\n            &.grey {\n              color: @brand-dark-grey;\n            }\n            &.green {\n              color: @brand-green;\n            }\n            &.red {\n              color: @brand-red;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","#hub-workflow {\n  .gh-workflow-session {\n    margin: 30px 40px 30px 40px;\n\n    .header {\n      position: relative;\n      padding-left: 30px;\n      -webkit-user-select: none;\n      user-select: none;\n\n      .name {\n        font-size: 1.1em;\n        font-weight: @medium;\n        color: #000;\n      }\n\n      .gh-icon {\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n    }\n\n    .gh-workflow-section {\n      border-left: 3px solid #f9dfff;\n      margin: 0 0 0 9px;\n      padding: 15px 0 5px 30px;\n\n      .workflow-section-title {\n        font-weight: @bold;\n        font-size: 1.1em;\n      }\n\n      .gh-badge {\n        font-size: 10px;\n        padding: 4px 5px 2px;\n      }\n\n      .gh-dropdown {\n        max-width: 100%;\n\n        .toggle {\n          font-size: 14px;\n        }\n\n        .reviewer {\n          position: relative;\n          display: flex;\n          align-items: center;\n        }\n      }\n    }\n  }\n}\n",".status-icon-workflow {\n  position: absolute;\n  height: 9px;\n  width: 9px;\n  top: 15px;\n  right: 0px;\n  color: @brand-white;\n  border-radius: 50%;\n  font-size: 7px;\n  padding-left: 1px;\n\n  &.approved {\n    background: @teal-100;\n  }\n\n  &.declined {\n    background: @orange-80;\n  }\n\n  &.pending {\n    background: @purple-100;\n  }\n}\n","@import \"./less/hub.less\";\n@import \"./less/status-icon-workflow.less\";\n\n.status-badge {\n  display: inline-block;\n}\n",".add-favorite,\n.remove-favorite {\n  padding: 8px 10px;\n  max-height: 36px;\n}\n\n.add-favorite::before {\n  font-family: \"gh-font\";\n  content: @gh-font-icon-favorite;\n}\n\n.add-favorite.goal-favorite::before {\n  margin: 0 -2px 0 -5px;\n}\n\n.remove-favorite::before {\n  content: url(\"../../../../../wwwroot/fe/img/color-star-orangestroke.svg\");\n  vertical-align: middle;\n}\n.remove-favorite.goal-favorite::before {\n  margin: 2px -2px 0 -6px;\n}\n\n.okr-suggestion-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.okr-suggestion-item::before {\n  content: url(\"../../../../../wwwroot/fe/img/okr-suggestion.svg\");\n  margin: 7px -3px 0 3px;\n}\n\n.popover.cf-popover {\n  background-color: @ink-80-v2;\n  color: @brand-white;\n  border-radius: 3px;\n\n  > .arrow::after {\n    border-right-color: @ink-80-v2;\n  }\n}\n\n#clone-sessions {\n  .dropdown-menu {\n    .session-dropdown-wrapper {\n      max-height: 300px;\n      overflow-y: auto;\n      position: relative;\n      li:nth-child(3) {\n        padding-top: 41px;\n      }\n      .create-new-btn {\n        text-decoration: none;\n        border-bottom: 1px solid darken(@brand-light, 3%);\n        position: fixed;\n        background-color: @brand-white;\n        z-index: 2;\n        width: 65%;\n      }\n      &.scrollbar-styles {\n        &::-webkit-scrollbar {\n          width: 10px;\n          height: 7px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background-color: @brand-grey;\n          border-radius: 20px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: none;\n        }\n      }\n    }\n  }\n  .d-flex {\n    display: flex;\n    align-items: center;\n  }\n\n  li .d-flex {\n    padding: 7px 10px;\n  }\n\n  .focused {\n    background: @grey-5;\n    cursor: pointer;\n  }\n\n  li .d-flex:hover {\n    .focused;\n  }\n\n  .no-sessions {\n    padding: 50px 25px 25px 0px;\n\n    color: @brand-subtler;\n    white-space: nowrap;\n    text-align: center;\n    padding-bottom: 10px;\n\n    border-bottom: 1px solid @brand-light;\n  }\n\n  .no-sessions.icon {\n    font-size: 30px;\n\n    color: @brand-light;\n    margin-top: 20px;\n  }\n\n  .disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n  .gh-title-small {\n    font-size: 16px;\n  }\n\n  .border-top {\n    padding-top: 5px;\n    border-top: 1px solid darken(@brand-light, 3%);\n  }\n  .data-clone-options {\n    .gh-checkbox-list.gh-checkbox-list-small {\n      position: relative;\n      margin: 4px 0px;\n      .item {\n        font-size: 0;\n        padding: 4px 0;\n      }\n      .gh-font-icon-help {\n        color: @brand-grey;\n        font-size: 16px;\n        cursor: help;\n        margin-left: 7px;\n      }\n      .title {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.goal-selector-node {\n  .goal {\n    padding: 10px 0 10px 95px;\n    border-bottom: 1px solid #eee;\n    position: relative;\n    font-size: 1.1em;\n\n    &:hover {\n      background: @brand-light;\n\n      .gh-b.gh-xs {\n        display: block;\n      }\n\n      .goal-ui-button-display {\n        display: block;\n      }\n\n      .goal-title-max-width {\n        max-width: 550px;\n      }\n    }\n\n    .gh-b.gh-xs {\n      padding: 2px 5px;\n      position: absolute;\n      right: 10px;\n      top: 8px;\n      display: none;\n\n      &.edit-conflict-item {\n        display: block;\n      }\n    }\n\n    .goal-ui-button-display {\n      display: none;\n    }\n\n    .goal-title-max-width {\n      max-width: 635px;\n    }\n    .current {\n      opacity: 0.5;\n    }\n\n    .toggler {\n      position: absolute;\n      left: 10px;\n      cursor: pointer;\n      top: 15px;\n      font-size: 10px;\n      color: @brand-jira;\n\n      &.minus {\n        color: @brand-subtler;\n      }\n\n      &:hover {\n        opacity: 0.6;\n      }\n    }\n\n    .gh-icon {\n      position: absolute;\n      left: 65px;\n      top: 13px;\n    }\n  }\n\n  .child {\n    padding-left: 20px;\n  }\n}\n\n#parent-child-session-selector {\n  border-radius: 8px;\n  float: left;\n  width: 100%;\n\n  .session {\n    float: left;\n    width: 50%;\n    padding: 15px;\n    cursor: pointer;\n    border-bottom: 3px solid @brand-light;\n\n    &:hover {\n      border-bottom: 3px solid darken(@brand-light, 10%);\n    }\n\n    &.selected {\n      border-bottom: 3px solid @brand-primary;\n    }\n\n    .session-meta {\n      color: @brand-subtler;\n      display: inline;\n    }\n\n    .session-title {\n      font-weight: @medium;\n      font-size: 1.1em;\n    }\n\n    .session-time {\n      font-size: 0.9em;\n      color: @brand-subtler;\n    }\n  }\n}\n\n#manage-sessions-gantt {\n  @sidesOffset: 40px;\n\n  position: relative;\n  background: @brand-white;\n  padding: 0 @sidesOffset;\n  margin-top: 60px;\n\n  .toggle-archived-sessions {\n    position: absolute;\n    top: -40px;\n    right: 40px;\n  }\n\n  .session-level-holder {\n    .session.has-children {\n      position: relative;\n    }\n  }\n\n  .session {\n    padding: 0 0 0 0;\n    position: relative;\n    background: #fff;\n\n    &.child {\n      .session-info {\n        border-top: 0;\n      }\n\n      .time {\n        border-top: 0;\n      }\n    }\n\n    dropdown-actions-menu {\n      position: absolute;\n      right: 10px;\n      top: 12px;\n      .gh-ui-actions-dd .toggle {\n        color: @ink-80;\n      }\n    }\n\n    .session-info {\n      width: 450px;\n      min-height: 68px;\n      padding: 15px 0 15px 70px;\n      position: relative;\n      border-top: 1px solid @brand-light;\n\n      .session-icon {\n        position: absolute;\n        left: 12px;\n        top: 15px;\n      }\n\n      &:hover {\n        background: @brand-light;\n        border-right-color: @brand-light;\n      }\n\n      &:hover + .time {\n        background: lighten(@brand-light, 2%);\n      }\n    }\n\n    .session-info.depth-1 {\n      a.title {\n        font-weight: 600;\n      }\n    }\n\n    a.title {\n      color: @brand-dark;\n      font-size: 1em;\n      cursor: pointer;\n\n      &:hover {\n        color: @brand-jira;\n      }\n\n      .permission {\n        display: inline-block;\n        width: 6px;\n        height: 6px;\n        background: @brand-warning;\n        border-radius: 4px;\n        margin-left: 4px;\n        position: relative;\n        top: -3px;\n      }\n    }\n\n    .timeframe {\n      color: @brand-subtler;\n      font-size: 0.8em;\n    }\n\n    .gh-badge {\n      position: absolute;\n      right: 40px;\n      font-size: 0.75em;\n      top: 15px;\n      border-radius: 5px;\n      padding: 2px 5px;\n      font-weight: @medium;\n    }\n\n    .time {\n      position: absolute;\n      left: 450px;\n      right: 0px;\n      top: 0;\n      height: 68px;\n      border-top: 1px solid @brand-light;\n\n      .time-bar-wrapper {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        overflow: hidden;\n      }\n\n      .time-bar {\n        height: 20px;\n        border-radius: 13px;\n        background: @brand-jira;\n\n        &.locked {\n          background: @brand-primary;\n        }\n\n        &.closed {\n          background: @brand-subtle;\n        }\n      }\n    }\n  }\n}\n\n#session-form {\n  .session-color {\n    top: 2px;\n    height: 42px;\n    line-height: 38px;\n  }\n\n  .parent-session {\n    .section-name {\n      height: 62px;\n      line-height: 62px;\n    }\n\n    .gh-input-info {\n      .link {\n        height: 62px;\n        line-height: 62px;\n        color: @brand-link;\n\n        &:hover {\n          border: 0;\n          color: @brand-info;\n          text-decoration: underline;\n        }\n      }\n\n      .gh-b-input-info {\n        top: 22px;\n      }\n    }\n\n    .gh-icon-wrapper {\n      display: flex;\n    }\n  }\n\n  .gh-input-info {\n    .session-permissions {\n      margin-top: 20px;\n\n      .gh-note {\n        padding: 0px;\n      }\n    }\n  }\n}\n.session-clone-modal {\n  &.modal {\n    .modal-dialog .modal-content {\n      overflow-y: visible;\n      overflow-x: visible;\n    }\n  }\n}\n\n#manage-sessions-gantt .table-container {\n  background: #fff;\n  border: 1px solid @grey-10-v3;\n  border-radius: 3px;\n  display: flex;\n  position: relative;\n  overflow: auto;\n  max-height: calc(100vh - 140px);\n\n  .border-line {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 50px;\n    background: #fafbfc;\n    border-bottom: 1px solid @grey-10-v3;\n  }\n  .item-height {\n    height: 68px;\n  }\n  .sticky {\n    background-color: white;\n    border-right: 1px solid @grey-10-v3;\n    box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);\n    position: sticky;\n    z-index: 2;\n    left: 0;\n    width: 450px;\n    min-width: 450px;\n    height: fit-content;\n  }\n  .sticky-header {\n    border-bottom: 1px solid @grey-10-v3;\n    background-color: white;\n    height: 50px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n  .session {\n    .session-info {\n      border-top: none;\n      &.closed {\n        .title,\n        .timeframe,\n        .session-icon {\n          opacity: 0.5;\n        }\n      }\n    }\n    .title {\n      display: block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      margin-right: 80px;\n      color: @ink-100-v2;\n    }\n    dropdown-actions-menu .gh-ui-actions-dd .toggle {\n      &:hover {\n        background: inherit;\n      }\n      color: @ink-50-v2;\n    }\n    .timeframe {\n      color: @grey-40;\n    }\n    .gh-badge {\n      text-transform: uppercase;\n      background: @blue-10-v3;\n      border-radius: 3px;\n      color: @ink-100-v2;\n      font-weight: 700;\n      opacity: 0.7;\n\n      &.closed {\n        background: @grey-5;\n      }\n      &.locked {\n        background: @teal-10-v2;\n      }\n    }\n  }\n  .main-area {\n    height: fit-content;\n    position: relative;\n  }\n  .items {\n    position: relative;\n  }\n  .item {\n    position: relative;\n  }\n\n  .time-bar-wrapper {\n    height: 68px;\n    display: flex;\n    align-items: center;\n  }\n\n  .time-bar {\n    opacity: 0.8;\n    height: 18px;\n    border-radius: 9px;\n    background: @brand-jira;\n    transition: 0.4s ease-in-out all;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &.locked {\n      background: @brand-primary;\n    }\n\n    &.closed {\n      background: @brand-subtle;\n    }\n  }\n  .item:last-child {\n    border-bottom: none;\n  }\n  .today-marker {\n    position: absolute;\n    opacity: 0.5;\n    top: 50px;\n    bottom: 0;\n    width: 2px;\n    background: @purple-60-v2;\n    z-index: 1;\n    transition: 0.4s ease-in-out all;\n    &:hover {\n      box-shadow: 0 0 2px fade(@purple-60-v2, 60);\n      opacity: 1;\n    }\n  }\n\n  .timelines {\n    background: #fafbfc;\n    color: @ink-60-v2;\n    display: flex;\n    position: sticky;\n    width: fit-content;\n    top: 0;\n    z-index: 1;\n  }\n\n  .time-period {\n    border-bottom: 1px solid @grey-10-v3;\n    height: 50px;\n    &:first-child {\n      .time-period-label:first-child {\n        border-left: none;\n      }\n    }\n  }\n\n  .time-period-top {\n    position: relative;\n    .time-period-label {\n      width: auto;\n      display: inline-block;\n      left: 450px;\n      position: sticky;\n    }\n  }\n\n  .time-period-bottom {\n    display: flex;\n  }\n\n  .time-period-label {\n    width: 60px;\n    height: 25px;\n    padding: 0 5px;\n    border-left: 1px solid @grey-10-v3;\n  }\n\n  .stripes {\n    background: repeating-linear-gradient(\n      90deg,\n      #fff,\n      #fff 60px,\n      #fafbfc 60px,\n      #fafbfc 120px\n    );\n    display: flex;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n","@import (reference) \"../../../../less/_variables.less\";\n\n#approval-workflow-selection-form {\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .modal-title {\n    font-weight: @bold;\n    letter-spacing: 0.005em;\n    color: @ink-100-v2;\n    margin-bottom: 16px;\n  }\n\n  .selection-info {\n    font-weight: @regular;\n    color: @ink-70-v2;\n  }\n\n  .workflow-selection {\n    display: flex;\n    flex-direction: column;\n    max-height: 200px;\n    flex-wrap: wrap;\n  }\n\n  .accordion-top-border {\n    .accordion {\n      border-top: 1px solid @grey-10;\n    }\n  }\n\n  .accordion-margin-bottom {\n    .accordion {\n      margin-bottom: 30px;\n    }\n  }\n\n  .accordion {\n    border-bottom: 1px solid @grey-10;\n    font-weight: @regular;\n    color: @ink-70-v2;\n\n    ::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n      border-radius: 10px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: none;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n      background: @grey-20;\n      border-radius: 10px;\n    }\n\n    .accordion-name {\n      padding: 18px 0;\n    }\n\n    .workflow-selection {\n      overflow-x: auto;\n      padding: 8px;\n      margin: -8px -8px 8px -8px;\n    }\n  }\n\n  .arrow {\n    transition: transform 0.1s;\n  }\n\n  .arrow-opened {\n    transform: rotate(90deg);\n  }\n\n  .workflow-selection {\n    color: @ink-100-v2;\n\n    .field {\n      min-width: 265px;\n      display: flex;\n      margin-bottom: 8px;\n      label {\n        font-size: 14px;\n        line-height: 19px;\n        min-width: 215px;\n        margin-right: 10px;\n      }\n    }\n\n    .regular-font {\n      font-weight: @regular;\n    }\n  }\n}\n","@import (reference) \"../../../../less/_variables.less\";\n@import \"../approval-workflow-selection-form/approval-workflow-selection-form.less\";\n\n#create-s-form {\n  .required-fields {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 160%;\n    color: @ink-70-v2;\n  }\n\n  .workflow-approval-available-container {\n    .accordion:first-of-type {\n      border-top: 1px solid @grey-10-v3;\n    }\n    .accordion {\n      border-bottom: 1px solid @grey-10-v3;\n      padding: 18px 0;\n    }\n    .accordion-section-name {\n      font-weight: @medium;\n      font-size: 15px;\n      line-height: 20px;\n      user-select: none;\n      color: @ink-70-v2;\n      cursor: pointer;\n    }\n    .accordion-info {\n      font-weight: @regular;\n      font-size: 14px;\n      line-height: 18px;\n      color: @ink-60-v2;\n      padding-left: 30px;\n      margin-top: 2px;\n    }\n\n    .arrow {\n      transition: transform 0.1s;\n    }\n\n    .arrow-opened {\n      transform: rotate(90deg);\n    }\n\n    .gh-radio-list-border {\n      padding: 0;\n\n      .item {\n        margin: 0, -9px;\n\n        .radio {\n          left: 5px;\n        }\n      }\n    }\n\n    .radio-info {\n      font-weight: @regular;\n      font-size: 14px;\n      line-height: 19px;\n      color: @ink-50-v2;\n      max-width: 400px;\n    }\n\n    .modal-link {\n      font-weight: @medium;\n      font-size: 13px;\n      line-height: 18px;\n      color: @blue-80-v2;\n      cursor: pointer;\n    }\n\n    .self-approve-label {\n      font-weight: 400;\n    }\n\n    .people-selector-text {\n      font-weight: @regular;\n      font-size: 12px;\n      line-height: 16px;\n      max-width: 400px;\n    }\n\n    .people-selector-text-error {\n      .people-selector-text();\n      color: @red-100-v2;\n    }\n\n    .people-selector-error {\n      .ant-select-selector {\n        border-color: @red-80-v2 !important;\n      }\n    }\n\n    .info-icon-warning {\n      color: @yellow-100-v3;\n    }\n\n    .people-selector-text-warning {\n      .info-icon-warning();\n      .people-selector-text();\n    }\n  }\n\n  .gh-selected-artefact {\n    display: inline-flex;\n    width: 100%;\n    gap: 5px;\n    padding: 10px;\n  }\n\n  .gh-fg-description {\n    margin-top: 4px;\n    color: @ink-70-v2;\n    font-size: 12px;\n    line-height: 16px;\n\n    a {\n      text-decoration: underline;\n      &:focus {\n        color: @blue-80-v2;\n      }\n    }\n  }\n}\n","#accordion-section {\n  border-bottom: 1px solid @grey-10-v3;\n  margin-top: -20px;\n\n  .customized-label {\n    text-align: center;\n    padding-left: 6px;\n    padding-right: 6px;\n    background-color: @blue-10-v3;\n    text-transform: uppercase;\n    border-radius: 3px;\n\n    .value {\n      color: @ink-100-v3;\n      font-weight: 700;\n      font-size: 11px;\n      opacity: 0.7;\n    }\n  }\n\n  .section-name {\n    line-height: initial;\n  }\n\n  button {\n    &.default {\n      height: 100%;\n      background: inherit;\n      border: none;\n      text-align: left;\n      padding: 0;\n    }\n  }\n\n  .settings-desc {\n    p {\n      margin: 0;\n    }\n  }\n\n  .dropdown-menu {\n    ul {\n      li {\n        padding: 0;\n        button {\n          width: 100%;\n          padding: 10px;\n        }\n      }\n    }\n  }\n\n  .gh-font-icon-arrow-right-small {\n    &.arrow {\n      &.arrow-opened {\n        transform: rotate(90deg);\n      }\n    }\n  }\n}\n",".alignment-empty-module {\n  margin-top: 160px;\n}\n\n.alignment-empty-module-mt-80 {\n  margin-top: 80px;\n}\n\n.alignment-empty-module-v2 {\n  margin-top: 160px;\n  width: 352px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n#context-menu {\n  padding: 7px 0;\n  background: @brand-white;\n  box-shadow: 0 2px 10px fade(@brand-black, 10%);\n  position: absolute;\n  z-index: 8;\n  min-width: 220px;\n\n  ul {\n    margin-bottom: 0px;\n    li {\n      width: 100%;\n      display: block;\n      margin: 2px 0px;\n      padding: 0px 10px 0px 23px;\n      cursor: pointer;\n      font-size: 13px;\n      line-height: 2.5em;\n\n      &:hover,\n      :active {\n        background: @brand-lighter-blue;\n        color: @brand-dark;\n      }\n\n      &.warn {\n        color: @brand-danger !important;\n      }\n\n      &.dropdown-separator {\n        margin: 5px 0;\n        border-top: 1px solid #eee;\n      }\n    }\n\n    hr {\n      margin: 5px 0;\n    }\n  }\n}\n\n// TODO GVS-14505 - remove this when the new highlight is used everywhere\n#shareable-overlay {\n  position: fixed;\n  left: 0;\n  width: 100%;\n  z-index: 15;\n  top: 0;\n  height: 100%;\n\n  &.ng-hide {\n    opacity: 0;\n  }\n\n  &.ng-hide-add,\n  &.ng-hide-remove {\n    transition: all linear 0.5s;\n  }\n}\n\n//- TODO GVS-14505 - remove the old overlays when the new highlight is used everywhere\n#overlay-message {\n  position: fixed;\n  width: 330px;\n  color: @brand-white;\n  left: 50%;\n  bottom: 50%;\n\n  p {\n    font-size: 1.6em;\n    font-weight: @semibold;\n    text-shadow: 0 1px 2px @brand-black;\n  }\n\n  img {\n    position: absolute;\n    left: -130px;\n    top: 14px;\n  }\n}\n\n#overlay-glow {\n  background: none;\n  box-shadow: 0 6px 60px darken(@brand-info, 15%);\n  position: fixed;\n}\n\n#overlay-top,\n#overlay-bottom,\n#overlay-left,\n#overlay-right {\n  background: saturate(@brand-dark, 15%);\n  opacity: 0.7;\n  position: fixed;\n}\n\n#overlay-top {\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n#overlay-bottom {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n#overlay-left {\n  left: 0;\n}\n\n#overlay-right {\n  right: 0;\n}\n\n#pinned-item {\n  position: fixed;\n  left: calc(var(--left-nav-width) + 40px);\n  background: lighten(@brand-warning, 28%);\n  z-index: 5;\n  width: 400px;\n  bottom: 40px;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid lighten(@brand-warning, 15%);\n  .transition(0.5s);\n\n  .note {\n    font-size: 0.9;\n    color: darken(@brand-warning, 34%);\n    margin-top: 15px;\n  }\n\n  .name {\n    font-size: 1.1em;\n    font-weight: @medium;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .gh-icon {\n      position: absolute;\n      left: 0;\n      top: 4px;\n    }\n  }\n}\n\n.alignment-tree-tooltip {\n  position: absolute;\n  visibility: hidden;\n  pointer-events: none;\n  z-index: 10;\n\n  &.progress-tooltip,\n  &.goal-owner-name-tooltip {\n    visibility: visible;\n    background: black;\n    color: @brand-white;\n    padding: 3px 20px 3px 20px;\n    border-radius: 5px;\n    font-size: 0.9em;\n  }\n\n  &.assignee-name-tooltip,\n  &.contributor-owner-name-tooltip {\n    visibility: visible;\n    color: @brand-subtler;\n  }\n\n  &.item-title-tooltip,\n  &.owner-name-tooltip,\n  &.contributor-title-tooltip {\n    visibility: visible;\n    position: absolute;\n    padding: 5px 10px;\n    border-radius: 3px;\n    line-height: 20px;\n    background: @ink-80-v2;\n    text-align: center;\n    color: @brand-white;\n    font-size: 14px;\n    font-weight: @regular;\n    .box-shadow(0 5px 10px rgba(0,0,0,0.2));\n\n    &::after {\n      content: \" \";\n      width: 10px;\n      height: 10px;\n      transform: rotate(-45deg);\n      background: @ink-80-v2;\n      position: absolute;\n      top: -5px;\n      left: 50%;\n      margin-left: -5px;\n    }\n  }\n\n  &.contributor-name-tooltip {\n    visibility: visible;\n    position: absolute;\n    padding: 10px 5px;\n    border-radius: 5px;\n    line-height: 20px;\n    background: @brand-white;\n    text-align: center;\n    color: @brand-dark;\n    font-size: 14px;\n    .box-shadow(0 5px 10px rgba(0,0,0,0.2));\n\n    &::after {\n      content: \" \";\n      width: 10px;\n      height: 10px;\n      transform: rotate(-45deg);\n      background: @brand-white;\n      position: absolute;\n      bottom: -4px;\n      left: 50%;\n      margin-left: -5px;\n    }\n  }\n}\n\n#alignment-tree-holder {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 500px;\n  top: 40px;\n\n  .secondary-actions {\n    position: absolute;\n    top: auto;\n    bottom: 34px;\n    left: auto;\n    right: 90px;\n\n    .buttons-group {\n      display: flex;\n\n      button.action {\n        border-radius: 0;\n        margin-left: 0;\n        margin-right: 0;\n\n        &.first {\n          border-radius: 4px 0 0 4px;\n        }\n\n        &.last {\n          border-radius: 0 4px 4px 0;\n        }\n\n        &:focus {\n          border: inherit;\n          box-shadow: inherit;\n        }\n      }\n    }\n\n    .action {\n      height: 30px;\n      overflow: hidden;\n      box-shadow: 0px 1px 2px rgba(90, 127, 158, 0.2);\n      border-radius: 4px;\n\n      &:not(:first-child) {\n        margin-left: 8px;\n      }\n\n      &.single {\n        width: 36px;\n      }\n\n      &.zoom-bar {\n        .zoom-in,\n        .zoom-out {\n          width: 28px;\n          height: 100%;\n        }\n\n        .zoom-in {\n          border-top-right-radius: 4px;\n          border-bottom-right-radius: 4px;\n        }\n\n        .zoom-out {\n          border-top-left-radius: 4px;\n          border-bottom-left-radius: 4px;\n        }\n\n        .ratio {\n          width: 43px;\n          height: 100%;\n          font-size: 13px;\n          font-weight: @medium;\n        }\n\n        .zoom-in,\n        .zoom-out,\n        .ratio {\n          &:focus {\n            box-shadow: inset 0px 1px 1px rgba(90, 127, 158, 0.1),\n              inset 0px 0px 0px 2px @blue-5;\n          }\n        }\n      }\n    }\n\n    .clickable {\n      border: 1px solid transparent;\n      background: @brand-white;\n      cursor: pointer;\n\n      &:hover {\n        border: 1px solid @grey-40;\n      }\n\n      &:active,\n      &.toggled {\n        border: 0;\n        background: @grey-10;\n        box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n      }\n\n      &:focus {\n        border: 1px solid @blue-40-v2;\n        box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1), 0px 0px 0px 2px @blue-5;\n      }\n    }\n  }\n\n  .no-scrollbars,\n  &.draggable.no-scrollbars {\n    cursor: grab;\n\n    &:active {\n      cursor: grabbing;\n    }\n  }\n\n  &.updating {\n    &:after {\n      content: \"\";\n      display: block;\n      width: 100%;\n      background: @body-bg;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n      z-index: 3;\n      opacity: 0.5;\n    }\n  }\n\n  .alignment-tree-indicator {\n    display: block;\n    position: fixed;\n    width: 100px;\n    height: 45px;\n    bottom: 0px;\n    left: 280px;\n    z-index: 4;\n    padding-left: 10px;\n  }\n\n  .owner {\n    .team-owner {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .team-avatar {\n    display: block;\n    padding: 1px;\n    color: @brand-white;\n    position: static;\n  }\n\n  .handle {\n    display: none;\n\n    &:hover {\n      opacity: 0.5;\n      cursor: move;\n    }\n  }\n\n  .no-handle {\n    display: none;\n    font-size: 31px;\n    transform: translate(-5px, 19px) rotate(45deg);\n    fill: lighten(@brand-subtler, 10%);\n\n    &:hover {\n      opacity: 0.5;\n      cursor: move;\n    }\n  }\n\n  .dropzone {\n    circle {\n      fill: rgba(255, 255, 255, 0.1);\n      opacity: 0.5;\n      stroke: #57749e;\n      stroke-width: 2px;\n      stroke-dasharray: 10;\n      stroke-linecap: round;\n    }\n\n    &.active circle {\n      fill: rgba(255, 255, 255, 0.1);\n      opacity: 0.5;\n      stroke: #09b180;\n      stroke-width: 4px;\n      stroke-dasharray: 0;\n    }\n  }\n\n  .main {\n    .pad {\n      fill: @brand-white;\n      stroke: #e0e4ea;\n      stroke-width: 1px;\n    }\n\n    .item-pad {\n      fill: @brand-white;\n    }\n\n    .item {\n      &.matched {\n        .item-pad {\n          stroke-width: 3px;\n          stroke: #ffc25f;\n        }\n      }\n\n      &.unmatched {\n        opacity: 0.5;\n      }\n    }\n\n    .dropdown-toggler,\n    .contributor-dropdown-toggler {\n      font-size: 18px;\n      font-family: Georgia, Arial, sans-serif;\n      letter-spacing: 0.01em;\n      fill: @black-40;\n\n      &:hover {\n        cursor: pointer;\n        fill: @brand-jira;\n      }\n    }\n\n    .node {\n      .goal-owner-name {\n        font-size: 14px;\n        fill: @brand-grey;\n      }\n\n      .item-owners-names {\n        font-size: 12px;\n        line-height: 16px;\n        .fw-400;\n        fill: @ink-60-v2;\n      }\n\n      &.pinned {\n        opacity: 0.4;\n      }\n\n      .workflow-status-icon {\n        font-size: 12px;\n        color: @brand-white;\n        span {\n          position: static;\n        }\n      }\n\n      &.show-more {\n        .goal-title {\n          text.goal-title-text {\n            fill: @brand-subtler;\n            font-weight: 600;\n\n            &:hover {\n              fill: saturate(@brand-subtler, 30%);\n            }\n          }\n        }\n      }\n\n      .item-title-text,\n      .contributor-title-text {\n        fill: @ink-100;\n        height: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 2; /* number of lines to show */\n        -webkit-box-orient: vertical;\n        -webkit-hyphens: auto;\n        -ms-hyphens: auto;\n        hyphens: auto;\n\n        &:hover {\n          cursor: pointer;\n          fill: @blue-100-v2;\n          text-decoration: underline;\n        }\n      }\n\n      .contributor-title {\n        .contributor-title-text {\n          font-weight: @regular;\n        }\n      }\n\n      .item-title {\n        .item-title-text {\n          font-weight: @medium;\n        }\n      }\n\n      .goal-title {\n        .goal-title-text {\n          fill: @brand-dark;\n          letter-spacing: -0.02em;\n          font-family: \"SF Pro Display\", Arial, sans-serif;\n          height: 100%;\n          word-break: break-word;\n          overflow: hidden;\n\n          &:hover {\n            cursor: pointer;\n            fill: @brand-jira;\n          }\n        }\n\n        .goal-title-dots {\n          position: fixed;\n          bottom: 0px;\n          right: 0px;\n\n          &::after {\n            content: \"...\";\n            position: fixed;\n            bottom: 0px;\n            right: 0px;\n          }\n        }\n      }\n\n      &.matched {\n        .pad {\n          stroke-width: 3px;\n          stroke: #ffc25f;\n        }\n      }\n\n      &.highlighted {\n        .pad {\n          stroke-width: 5px;\n          stroke: transparent;\n        }\n\n        .session-color {\n          display: none;\n        }\n      }\n\n      &.unmatched {\n        opacity: 0.5;\n      }\n\n      &.shared {\n        .pad {\n          stroke: #e0e4ea;\n          stroke-width: 1px;\n        }\n      }\n\n      .contributors {\n        .team-owner {\n          width: 16px;\n          height: 16px;\n        }\n\n        .contributor-owner {\n          .contributor-owner-name {\n            fill: @brand-subtler;\n            display: none;\n          }\n\n          .team-avatar .icon {\n            display: block;\n            padding: 1px;\n            color: @brand-white;\n          }\n\n          &:hover {\n            .contributor-owner-name {\n              display: block;\n            }\n          }\n        }\n\n        .faded {\n          opacity: 0.5;\n        }\n      }\n\n      .private {\n        .private-dot {\n          fill: @brand-warning;\n          cursor: help;\n        }\n\n        .private-badge {\n          fill: @brand-subtler;\n        }\n\n        .private-text {\n          transform: translate(10px, -9px);\n          fill: @brand-subtler;\n          display: none;\n        }\n\n        &:hover {\n          .private-text {\n            display: block;\n          }\n        }\n      }\n    }\n\n    &.simplified {\n      .link {\n        stroke: #aeb6c0;\n        stroke-width: 8px;\n      }\n      .node {\n        .contributor > :not(.togglerEnter),\n        image,\n        .goal-title-text,\n        .item-title-text,\n        .contributor-title-text,\n        .aggregated-attainment,\n        .private-badge,\n        .owner {\n          display: none;\n        }\n\n        &.matched {\n          .pad,\n          .item-pad {\n            stroke-width: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  .link {\n    fill: none;\n    stroke: darken(#e0e7ee, 5%);\n    stroke-width: 3px;\n  }\n\n  .link2 {\n    stroke: #d500f9;\n    stroke-width: 2;\n    fill: none;\n    stroke-linecap: round;\n\n    &.link3 {\n      stroke-width: 4;\n    }\n  }\n\n  @keyframes dash {\n    from {\n      stroke-dashoffset: 400;\n    }\n    to {\n      stroke-dashoffset: 1000;\n    }\n  }\n\n  .dashed-link {\n    stroke: @ink-50-v2;\n    stroke-width: 3;\n    fill: none;\n    stroke-dasharray: 8;\n    -webkit-animation: dash 30s linear infinite;\n    animation: dash 30s linear infinite;\n  }\n\n  .enabledDrag {\n    .handle {\n      display: block;\n    }\n\n    .no-handle {\n      display: block;\n    }\n\n    // hide drag&drop no-handles for filtered out goals\n    .node.show-more {\n      .no-handle {\n        display: none;\n      }\n    }\n\n    // hide drag&drop handles for filtered out goals\n    .node.show-more {\n      .handle {\n        display: none;\n      }\n    }\n  }\n\n  text.contributor-owner-name {\n    font-size: 11px;\n    fill: @brand-grey;\n  }\n\n  text.contributor-name {\n    font-size: 14px;\n    font-family: \"SF Pro Display\", Arial, sans-serif;\n    fill: #57749e;\n    &:hover {\n      fill: #000;\n      cursor: pointer;\n    }\n  }\n\n  text.contributor-attainment {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .node {\n    text:not(.nc-icon-outline) {\n      font-family: \"SF Pro Text\", \"Helvetica Neue\", \"SegoeUI\", sans-serif;\n    }\n\n    .togglerEnter {\n      &:hover {\n        cursor: pointer;\n        opacity: 0.6;\n      }\n\n      text {\n        font-size: 20px;\n      }\n\n      .plus,\n      .minus {\n        display: none;\n        fill: #57749e;\n      }\n\n      .expander {\n        fill: #57749e;\n        opacity: 0.2;\n      }\n\n      &.expanded .minus {\n        display: block;\n      }\n\n      &.collapsed {\n        .plus {\n          display: block;\n          fill: #fff;\n          font-size: 13px;\n          font-weight: bold;\n        }\n\n        .expander,\n        circle {\n          opacity: 1;\n        }\n      }\n\n      &.hide {\n        display: none;\n      }\n    }\n  }\n}\n\nbody {\n  .alignment-container {\n    &.demo-included {\n      #alignment-filters,\n      #alignment-tree-holder {\n        top: 90px;\n      }\n    }\n\n    grid-filtering-bar {\n      position: relative;\n      z-index: 1;\n      width: fit-content;\n      width: -moz-fit-content;\n      background: @body-bg;\n      border-radius: 0 0 10px 0;\n\n      button.action {\n        background: @brand-white;\n      }\n    }\n\n    #alignment-tree-holder {\n      left: var(--left-nav-width);\n      padding-top: 5px;\n    }\n\n    grid-filtering-bar {\n      grid-settings {\n        &.custom-menu {\n          &.goals-alignment-view-mode {\n            ul.dropdown-menu {\n              min-width: 225px;\n\n              .view-modes {\n                display: flex;\n                padding: 5px;\n                border-bottom: 1px solid @grey-10;\n\n                li {\n                  &:extend(.centered-horiz);\n                  flex: 1 1 0px;\n                  min-width: 0px;\n\n                  &:not(:first-child) {\n                    margin-left: 6px;\n                  }\n\n                  button {\n                    &:extend(.centered-vert);\n                    flex-direction: column;\n                    justify-content: space-between;\n                    min-width: 100%;\n                    height: 102px;\n                    padding: 0 14px 10px;\n                    border: 1px solid transparent;\n                    border-radius: 4px;\n\n                    .text {\n                      margin-top: 7px;\n                      margin-bottom: 4px;\n                      line-height: 20px;\n                      font-size: 16px;\n                      font-weight: @mediumbold;\n                      white-space: nowrap;\n                      color: @ink-60-v2;\n                    }\n\n                    img {\n                      width: 75px;\n                      height: 60px;\n                    }\n\n                    &:hover,\n                    &:disabled {\n                      .text {\n                        color: @ink-100-v2;\n                      }\n                    }\n\n                    &:not(:disabled):hover {\n                      border-color: @grey-40;\n                    }\n\n                    &:disabled {\n                      background: @grey-5;\n                      box-shadow: inset 0px 1px 2px rgba(90, 127, 158, 0.2);\n                      cursor: not-allowed;\n                    }\n\n                    &:focus {\n                      box-shadow: 0px 1px 1px rgba(90, 127, 158, 0.1),\n                        0px 0px 0px 2px @blue-5;\n                      border: 1px solid @blue-40-v2;\n                    }\n                  }\n                }\n              }\n            }\n\n            li.include-metrics {\n              &:extend(.centered-vert);\n              padding: 12px 20px;\n              white-space: nowrap;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.hide-left-nav {\n    #alignment-tree-holder {\n      left: 340px;\n    }\n\n    .alignment-container {\n      #alignment-tree-holder {\n        left: var(--left-nav-hidden-width);\n      }\n    }\n  }\n\n  &.no-left-nav {\n    .alignment-container {\n      #alignment-tree-holder {\n        left: 0;\n      }\n    }\n  }\n}\n\n#alignment-tree-svg-holder {\n  overflow: auto;\n  height: 100%;\n}\n\n// used right after scrolling into located item in css text of inner animated div\n@keyframes located-item-glow {\n  0% {\n    box-shadow: 0px 0px 30px 10px rgba(172, 158, 242, 0.5);\n  }\n  100% {\n    box-shadow: 0px 0px 30px 40px rgba(172, 158, 242, 0.1);\n  }\n}\n\n.alignment-tooltip {\n  opacity: 1 !important;\n\n  strong {\n    background: @ink-70-v2;\n    padding: 2px;\n    border-radius: 2px;\n  }\n\n  .tooltip-inner {\n    padding: 4px;\n    background: @ink-80-v2;\n  }\n\n  &.top {\n    .tooltip-arrow {\n      border-top-color: @ink-80-v2;\n    }\n  }\n}\n",".okr-node-container {\n  width: 100%;\n  height: 45px;\n  min-width: 480px;\n\n  .p-0 {\n    padding: 0px;\n  }\n\n  .okr-node {\n    position: relative;\n    height: 100%;\n    background-color: @brand-white;\n    border: 1px solid @ink-30;\n    display: flex;\n    align-items: center;\n    padding: 5px 10px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n\n    &.highlighted {\n      box-shadow: 0px 0px 0px 2px #ffc25f inset;\n    }\n\n    &.obfuscated {\n      background-image: repeating-linear-gradient(\n        45deg,\n        lighten(@brand-light, 2%),\n        lighten(@brand-light, 2%) 10px,\n        @brand-white 10px,\n        @brand-white 20px\n      );\n    }\n\n    &.is-first-root {\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n    }\n\n    &.expanded {\n      border-bottom-left-radius: 4px;\n      border-bottom-right-radius: 0px !important;\n    }\n\n    &.previous-expanded {\n      border-top-left-radius: 4px;\n    }\n\n    &.last-expanded-node {\n      border-bottom-left-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n\n    .private-label {\n      background-color: #ffc25f;\n      border-radius: 25px;\n      font-size: 11px;\n      color: @brand-white;\n      text-align: center;\n      padding: 0px 10px;\n      line-height: 15px;\n      margin-top: 2px;\n    }\n    .dots-menu {\n      .gh-font-icon-menu {\n        color: @ink-60-v2;\n        font-size: 16px;\n      }\n      .dropdown-menu {\n        padding: 3px;\n        top: 13px;\n        left: -94px;\n        .dropdown-item {\n          cursor: pointer;\n          padding: 8px;\n          &:hover {\n            background-color: @ink-20;\n          }\n          &.warn {\n            color: @red-80-v2;\n          }\n          &.b-top {\n            border-top: 1px solid @ink-30;\n          }\n          &.b-bottom {\n            border-bottom: 1px solid @ink-30;\n          }\n        }\n      }\n    }\n    .gh-icon {\n      min-width: 16px;\n      min-height: 16px;\n    }\n    .info-container {\n      max-width: 370px;\n      margin-left: auto;\n\n      .avatars-two {\n        display: none;\n      }\n      .avatars-five {\n        padding-right: 10px;\n        padding-left: 0px;\n      }\n\n      .confidence-badge {\n        max-width: 82px;\n        cursor: pointer;\n      }\n\n      .goal-aggregated-progress {\n        color: fade(@brand-dark, 50%);\n        font-size: 10px;\n        line-height: 16px;\n        position: absolute;\n        top: 4px;\n        right: -10%;\n        cursor: pointer;\n\n        &.color {\n          width: 10px;\n          border-radius: 8px;\n          margin-right: 5px;\n          height: 10px;\n        }\n      }\n\n      .goal-attainment,\n      .metric-attainment {\n        font-size: 14px;\n        line-height: 20px;\n\n        .color {\n          width: 17px;\n          height: 17px;\n          border-radius: 30px;\n        }\n\n        .text {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .okr-name {\n      cursor: pointer;\n      color: @ink-100-v2;\n      &:hover {\n        color: @blue-100-v2;\n      }\n    }\n\n    .expand-icon {\n      position: absolute;\n      top: 11px;\n      left: -28px;\n      width: 20px;\n      height: 20px;\n      border-radius: 100px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: @grey-40;\n      &.collapsed {\n        background-color: @ink-70-v2;\n      }\n      cursor: pointer;\n      .icon {\n        color: @brand-white;\n        font-size: 16px;\n      }\n    }\n    &.goal-node {\n      .workflow {\n        .icon {\n          color: @brand-white;\n          border-radius: 50px;\n          width: 12px;\n          height: 12px;\n          outline: 2px solid @brand-white;\n          font-size: 9px;\n          position: absolute;\n          top: 8px;\n          left: 8px;\n        }\n        .approved {\n          .icon {\n            background-color: @teal-100;\n          }\n        }\n        .in-review {\n          .icon {\n            background-color: @purple-60-v2;\n          }\n        }\n        .draft {\n          .icon {\n            background-color: @ink-50-v2;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1290px) {\n  .okr-node-container {\n    .okr-node {\n      .info-container {\n        max-width: 310px;\n\n        .confidence-badge {\n          max-width: 72px;\n        }\n        .dots-menu {\n          .dropdown-menu {\n            left: -104px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 820px) {\n  .okr-node-container {\n    .okr-node {\n      .info-container {\n        max-width: 220px;\n        .avatars-two {\n          display: block;\n        }\n        .avatars-five {\n          display: none;\n        }\n        .confidence-badge {\n          max-width: 45px;\n        }\n        .goal-attainment,\n        .metric-attainment {\n          font-size: 12px;\n          line-height: 18px;\n        }\n      }\n    }\n  }\n}\n.ink-80-tooltip {\n  &.okr-name-tooltip {\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
